import * as i0 from '@angular/core';
import { InjectionToken, PLATFORM_ID, Injectable, Inject, EventEmitter, Output, Input, Component, Optional, HostListener, ViewChild, ViewChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, DatePipe, CommonModule } from '@angular/common';
import * as i3 from '@angular/router';
import { NavigationStart, NavigationEnd, GuardsCheckEnd, RouterModule } from '@angular/router';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@citi-gcg-173875/citi-utils';
import { WINDOW, IS_SSRENDERED_APP, NAVIGATOR, StorageService, Modal, CTA, Dropdown2, JAMP, QaCitiMobileModalModule, ValidationService } from '@citi-gcg-173875/citi-utils';
import * as i6 from '@citi-gcg-173875/citi-http';
import { BehaviorSubject, Subject, ReplaySubject, combineLatest, forkJoin, of, throwError, filter as filter$1 } from 'rxjs';
import * as jsonLogic from 'json-logic-js/logic';
import * as i3$1 from '@citi-gcg-173875/citi-security';
import { filter, pairwise, startWith, takeUntil, map, catchError } from 'rxjs/operators';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import * as i10 from '@citi-gcg-173875/citi-common-modules';
import * as i4 from '@citi-gcg-173875/citi-analytics';
import * as i3$2 from '@angular/platform-browser';
import { A11yModule } from '@angular/cdk/a11y';
import * as i3$3 from '@citi-gcg-173875/citi-common-ui-cds';
import { trigger, state, transition, style, animate } from '@angular/animations';

const SESSION_STORAGE = new InjectionToken('SessionStorageToken');
function sessionStorageFactory(platformId) {
    return isPlatformBrowser(platformId) ? sessionStorage : null;
}
const SESSION_STORAGE_PROVIDER = {
    provide: SESSION_STORAGE,
    useFactory: sessionStorageFactory,
    deps: [PLATFORM_ID]
};

const ssrnewbase = {
    "data": {
        "header": {
            "banner": {
                "show": true,
                "color": "blue",
                "logo": {
                    "defaultCust": true,
                    "show": true,
                    "image": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "fdicImage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                    "fdicSmallImage": "/CBOL/IA/Angular/assets/fdic_M2.svg",
                    "skelHeaderCitiLogoImgPath": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "gold": {
                        "desktopImage": "/CBOL/IA/Angular/assets/citigold_D2x.svg",
                        "mobileImage": "/CBOL/IA/Angular/assets/citigold_M2x.svg"
                    },
                    "cpc": {
                        "desktopImage": "/CBOL/IA/Angular/assets/cpc_M2x.svg",
                        "mobileImage": "/CBOL/IA/Angular/assets/cpc_M2x.svg"
                    },
                    "priority": {
                        "desktopImage": "/CBOL/IA/Angular/assets/priority_D2x.svg",
                        "mobileImage": "/CBOL/IA/Angular/assets/priority_M2x.svg"
                    },
                    "cpb": {
                        "desktopImage": "/CBOL/IA/Angular/assets/CPB_D.svg",
                        "mobileImage": "/CBOL/IA/Angular/assets/CPB_M.svg"
                    },
                    "privateCust": false,
                    "customer": "default",
                    "hovercolor": "default",
                    "url": "/"
                },
                "buttonsData": [
                    {
                        "title": "ATM / BRANCH",
                        "title_es_US": "ATM / SUCURSAL",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                        "url": "/citibank-location-finder",
                        "className": "ATMBranch",
                        "id": "butlerATM",
                        "domainMap": "csr"
                    },
                    {
                        "title": "ENGLISH",
                        "title_es_US": "ENGLISH",
                        "url": "",
                        "urlSuffix": "?locale=en_US",
                        "locale": "es_US",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                        "className": "espanolLink",
                        "id": "lang"
                    },
                    {
                        "title": "ESPAÑOL",
                        "title_es_US": "ENGLISH",
                        "url": "",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                        "className": "espanolLink",
                        "locale": "en_US",
                        "id": "lang",
                        "speedbump": {
                            "urlSuffix": "?locale=es_US",
                            "url": "/US/login.do?locale=es_US",
                            "header": "Important Information",
                            "header_es_US": "Notificación importante",
                            "buttonText": "<span lang='es'>Continuar</span>",
                            "buttonText_es_US": "<span lang='es'>Continuar</span>",
                            "buttonTarget": "_self",
                            "copy": "<p lang='es'><strong>Por favor, tenga en cuenta que es posible que las comunicaciones futuras del banco, ya sean verbales o escritas, sean únicamente en inglés. Estas comunicaciones podrían incluir, entre otras, contratos de cuentas, estados de cuenta y divulgaciones, así como cambios en términos o cargos o cualquier tipo de servicio para su cuenta. Además, es posible que algunas secciones de este website permanezcan en inglés.</strong></p><hr><p>Please be advised that future verbal and written communications from the bank may be in English only. These communications may include, but are not limited to, account agreements, statements and disclosures, changes in terms or fees; or any servicing of your account. Additionally, some sections of this site may remain in English. </p>",
                            "copy_es_US": "<p lang='es'><strong>Por favor, tenga en cuenta que es posible que las comunicaciones futuras del banco, ya sean verbales o escritas, sean únicamente en inglés. Estas comunicaciones podrían incluir, entre otras, contratos de cuentas, estados de cuenta y divulgaciones, así como cambios en términos o cargos o cualquier tipo de servicio para su cuenta. Además, es posible que algunas secciones de este website permanezcan en inglés.</strong></p><hr><p>Please be advised that future verbal and written communications from the bank may be in English only. These communications may include, but are not limited to, account agreements, statements and disclosures, changes in terms or fees; or any servicing of your account. Additionally, some sections of this site may remain in English. </p>"
                        }
                    }
                ],
                "contactUs": {
                    "show": false,
                    "ariaDescribedBy": "contact Us",
                    "ariaLabel": "contact Us",
                    "contactUsModal": [
                        {
                            "title": "Give us a call",
                            "title_es_US": "Give us a call",
                            "id": "banContactUs",
                            "items": [
                                {
                                    "title": "Mortgages and refinancing",
                                    "title_es_US": "Mortgages and refinancing",
                                    "id": "banMortgages&refinancing",
                                    "phone": "1-800-248-4638",
                                    "workingHours": "Mon-Fri: 8:00 AM to 10:00 PM ET <br> and Sat: 9:00 AM to 7:00 PM ET"
                                },
                                {
                                    "title": "Home equity lines or loans",
                                    "title_es_US": "Home equity lines or loans",
                                    "id": "banHomeequitylinesorloans",
                                    "phone": "1-877-362-9100",
                                    "workingHours": "Mon-Sun: 9:00 AM to 11:00 PM ET"
                                },
                                {
                                    "title": "For homeowner support",
                                    "title_es_US": "For homeowner support",
                                    "id": "banHomeownersupport",
                                    "phone": "1-866-272-4749"
                                }
                            ]
                        }
                    ]
                }
            },
            "navigation": {
                "show": true,
                "search": {
                    "show": true,
                    "action": "/US/JRS/globalsearch/Search.do",
                    "placeholder": "What can we help you with?",
                    "placeholder_es_US": "¿Qué podemos ayudarte?",
                    "submitButtonText": "Go",
                    "ariaDescribedBy": "Focus will shift to search input when pressed",
                    "ariaDescribedBy_es_US": "El enfoque cambiará a la entrada de búsqueda cuando se presione",
                    "ariaLabel": "Search",
                    "title": "Search",
                    "title_es_US": "Search",
                    "id": "banSearch"
                },
                "navigationItems": [
                    {
                        "title": "Credit Cards",
                        "title_es_US": "Tarjetas de Crédito",
                        "id": "navcreditCard",
                        "show": true,
                        "navigationItems": [
                            {
                                "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                                "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                                "items": [
                                    {
                                        "title": "View All Credit Cards",
                                        "title_es_US": "Ver Todas las Tarjetas de Crédito",
                                        "url": "https://www.citi.com/credit-cards/compare/view-all-credit-cards?intc=citihpmenu~creditcards~vac",
                                        "id": "navViewCrds",
                                        "show": true,
                                        "domainMap": "default"
                                    },
                                    {
                                        "title": "Balance Transfer Credit Cards",
                                        "title_es_US": "Tarjetas de Crédito para Transferencias de Saldo",
                                        "url": "https://www.citi.com/credit-cards/compare/balance-transfer-credit-cards?intc=citihpmenu~creditcards~bt",
                                        "id": "navBalTrans",
                                        "domainMap": "default",
                                        "show": true
                                    },
                                    {
                                        "title": "0% Intro APR Credit Cards",
                                        "title_es_US": "Tarjetas de Crédito con 0% APR Inicial",
                                        "url": "https://www.citi.com/credit-cards/compare/0-percent-intro-apr-credit-cards?intc=citihpmenu~creditcards~intro",
                                        "id": "navLowinterest",
                                        "domainMap": "default",
                                        "show": true
                                    },
                                    {
                                        "title": "Rewards Credit Cards",
                                        "title_es_US": "Tarjetas de Crédito con Recompensas",
                                        "url": "https://www.citi.com/credit-cards/compare/rewards-credit-cards?intc=citihpmenu~creditcards~rewards",
                                        "id": "navRewCred",
                                        "domainMap": "default",
                                        "show": true
                                    },
                                    {
                                        "title": "Cash Back Credit Cards",
                                        "title_es_US": "Tarjetas de Crédito con Reembolsos en Efectivo",
                                        "url": "https://www.citi.com/credit-cards/compare/savings-and-cash-back-credit-cards?intc=citihpmenu~creditcards~cash",
                                        "id": "navCashBackCre",
                                        "domainMap": "default",
                                        "show": true
                                    },
                                    {
                                        "title": "Travel Credit Cards",
                                        "title_es_US": "Tarjetas de Crédito para Viajes",
                                        "url": "https://www.citi.com/credit-cards/compare/travel-reward-credit-cards?intc=citihpmenu~creditcards~travel",
                                        "id": "navTravelCreds",
                                        "domainMap": "default",
                                        "show": true
                                    },
                                    {
                                        "title": "Retail Store Cards",
                                        "title_es_US": "Tarjetas de Tiendas Minoristas",
                                        "url": "https://www.citi.com/credit-cards/compare/retail-store-credit-cards?intc=citihpmenu~creditcards~crs",
                                        "id": "navRetailStoreCards",
                                        "domainMap": "default",
                                        "show": true
                                    },
                                    {
                                        "title": "Small Business Credit Cards",
                                        "title_es_US": "Tarjetas de Crédito para Pequeñas Empresas",
                                        "url": "https://www.citi.com/credit-cards/compare/business-credit-cards?intc=citihpmenu~creditcards~smallbus",
                                        "id": "navSmallBusinessCreditCards",
                                        "domainMap": "default",
                                        "show": true
                                    }
                                ],
                                "quickLinks": [
                                    {
                                        "linkId": "ktCenter",
                                        "linkText": "Citi<sup id='reg' aria-hidden='true'>&reg;</sup> Credit Knowledge Center",
                                        "linkText_es_US": "Centro de Información sobre Crédito de Citi<sup id='reg' aria-hidden='true'>&reg;</sup>",
                                        "url": "https://www.citi.com/credit-cards/knowledge-center",
                                        "domainMap": "default",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "mailOffer",
                                        "linkText": "Respond to Mail Offer",
                                        "linkText_es_US": "Responder a una Oferta Recibida por Correo",
                                        "url": "https://www.citicards.com/cards/credit/application/flow.action?isInvitation=Y",
                                        "domainMap": "default",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    }
                                ],
                                "show": true
                            }
                        ]
                    },
                    {
                        "title": "Banking",
                        "title_es_US": "Servicios Bancarios",
                        "id": "navbanking",
                        "show": true,
                        "navigationItems": [
                            {
                                "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                                "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                                "items": [
                                    {
                                        "title": "Checking",
                                        "title_es_US": "Cuenta de Cheques",
                                        "url": "/banking/checking-account?intc=citihpmenu_overview_checking",
                                        "id": "navchkin",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Savings",
                                        "title_es_US": "Cuenta de Ahorros",
                                        "url": "/banking/savings-account?intc=citihpmenu_overview_savings",
                                        "id": "navsavin",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Banking Overview ",
                                        "title_es_US": "Descripción General de Servicios Bancarios",
                                        "url": "/banking/bank-accounts?intc=citihpmenu_overview_banking",
                                        "id": "navbnkOvr",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Certificates of Deposit",
                                        "title_es_US": "Certificados de Depósito",
                                        "url": "/banking/cd-account?intc=citihpmenu_overview_CD",
                                        "id": "navCertificatesDeposit",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Banking IRAs",
                                        "title_es_US": "Cuentas IRA Bancarias",
                                        "url": "/banking/ira?intc=citihpmenu_overview_IRA",
                                        "id": "navBankingIRAs",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Rates",
                                        "title_es_US": "Tasas",
                                        "url": "/banking/current-interest-rates/savings-accounts?intc=citihpmenu_overview_rates",
                                        "id": "navRates",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Small Business Banking",
                                        "title_es_US": "Servicios Bancarios para Pequeñas Empresas",
                                        "url": "/small-business/banking?intc=citihpmenu_overview_smallbusiness",
                                        "id": "navSmlBusBank",
                                        "domainMap": "ssr",
                                        "show": true
                                    }
                                ],
                                "quickLinks": [
                                    {
                                        "linkId": "savingsMade",
                                        "linkText": "Savings Made Simple",
                                        "linkText_es_US": "Ahorros de Forma Sencilla",
                                        "url": "https://online.citi.com/US/JRS/portal/template.do?ID=your-savings-made-simple",
                                        "domainMap": "default",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "citiBonusOffers",
                                        "linkText": "Citi<sup id='reg'>&reg;</sup> Bonus Offers",
                                        "linkText_es_US": "Ofertas Adicionales de Citi<sup id='reg'>&reg;</sup>",
                                        "url": "/banking/special-offers?intc=citihpmenu_overview_special-offers",
                                        "domainMap": "csr",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    }
                                ],
                                "show": true
                            }
                        ]
                    },
                    {
                        "title": "Lending",
                        "title_es_US": "Préstamos",
                        "id": "navlending",
                        "show": true,
                        "navigationItems": [
                            {
                                "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                                "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                                "items": [
                                    {
                                        "title": "Personal Loans",
                                        "title_es_US": "Préstamos Personales",
                                        "url": "/installment-loan",
                                        "id": "navPerLoanCred",
                                        "domainMap": "csr",
                                        "show": true
                                    },
                                    {
                                        "title": "Overdraft Line of Credit",
                                        "title_es_US": "Línea de Crédito para Sobregiros",
                                        "url": "/US/JRS/pands/detail.do?ID=CheckingPlus",
                                        "id": "navOverdraftLineCredit",
                                        "domainMap": "legacy",
                                        "show": true
                                    },
                                    {
                                        "title": "Home Lending",
                                        "title_es_US": "Préstamos para Viviendas",
                                        "url": "/mortgage/home-mortgage",
                                        "id": "navHomeLending",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Buy a Home",
                                        "title_es_US": "Comprar una Vivienda",
                                        "url": "/mortgage/buying-a-home",
                                        "id": "navBuyaHome",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Refinance Your Home",
                                        "title_es_US": "Refinanciar Tu Vivienda",
                                        "url": "/mortgage/refinancing-your-home",
                                        "id": "navRefYourHome",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Use Your Home Equity",
                                        "title_es_US": "Usa Tu Préstamo con Garantía Hipotecaria",
                                        "url": "/home-equity/line-of-credit",
                                        "id": "navHmEqt",
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Small Business Lending",
                                        "title_es_US": "Préstamos para Pequeñas Empresas",
                                        "url": "/small-business/loans?intc=citihpmenu_lending_smallbusiness",
                                        "id": "navSmlBusLend",
                                        "domainMap": "ssr",
                                        "show": true
                                    }
                                ],
                                "quickLinks": [
                                    {
                                        "linkId": "mortCalc",
                                        "linkText": "Mortgage Calculators",
                                        "linkText_es_US": "Calculadoras para Hipotecas",
                                        "url": "/mortgage/refinance-and-mortgage-calculators",
                                        "domainMap": "ssr",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "hec",
                                        "linkText": "Home Equity Calculators",
                                        "linkText_es_US": "Calculadoras para Préstamos con Garantía Hipotecaria",
                                        "url": "/home-equity/calculators",
                                        "domainMap": "ssr",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "mlc",
                                        "linkText": "Mortgage Learning Center",
                                        "linkText_es_US": "Centro de Aprendizaje sobre Hipotecas",
                                        "url": "/mortgage/learning-center",
                                        "domainMap": "ssr",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "plc",
                                        "linkText": "Personal Loans Center",
                                        "linkText_es_US": "Centro para Préstamos Personales",
                                        "url": "/personal-loans/learning-center",
                                        "domainMap": "default",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    }
                                ],
                                "show": true
                            }
                        ]
                    },
                    {
                        "title": "Investing",
                        "title_es_US": "Inversiones",
                        "id": "investing",
                        "show": true,
                        "navigationItems": [
                            {
                                "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                                "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                                "items": [
                                    {
                                        "title": "Investing Overview",
                                        "title_es_US": "Panorama de Inversión",
                                        "url": "/investing/investingwithciti",
                                        "id": "navInvst",
                                        "domainMap": "csr",
                                        "show": true
                                    },
                                    {
                                        "title": "Self-Directed Investing",
                                        "title_es_US": "Inversión Autodirigida",
                                        "url": "/citi-self-invest",
                                        "id": "navSelfDirectedTrad",
                                        "domainMap": "csr",
                                        "show": true
                                    },
                                    {
                                        "title": "Guided Investing",
                                        "title_es_US": "Inversión Guiada",
                                        "url": "/cwb?entry=topnav",
                                        "id": "navCitiWealthBuild",
                                        "domainMap": "csr",
                                        "show": true
                                    },
                                    {
                                        "title": "Working with an Advisor",
                                        "title_es_US": "Trabajando con un Asesor",
                                        "url": "/mgp/cwamarketing",
                                        "id": "navWrkWithAdvs",
                                        "domainMap": "csr",
                                        "show": true
                                    }
                                ],
                                "quickLinks": [
                                    {
                                        "linkId": "finPlan",
                                        "linkText": "Planning Tools",
                                        "linkText_es_US": "Herramientas de Planificación",
                                        "url": "/US/JRS/pands/detail.do?ID=FinancialPlanningTools&JFP_TOKEN=PD3BPM40",
                                        "domainMap": "legacy",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "marketIns",
                                        "linkText": "Market Insights",
                                        "linkText_es_US": "Perspectivas del Mercado",
                                        "url": "https://marketinsights.citi.com/",
                                        "domainMap": "default",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "invIns",
                                        "linkText": "Investments & Insurance",
                                        "linkText_es_US": "Inversiones y Seguros",
                                        "url": "/US/JRS/pands/detail.do?ID=InvestingProducts&JFP_TOKEN=PZKYHT3Q",
                                        "domainMap": "legacy",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    }
                                ],
                                "show": true
                            }
                        ]
                    },
                    {
                        "title": "Wealth Management",
                        "title_es_US": "Gestión de Patrimonios",
                        "id": "wealthMgmnt",
                        "show": true,
                        "navigationItems": [
                            {
                                "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                                "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                                "items": [
                                    {
                                        "title": "Citigold",
                                        "title_es_US": "Citigold",
                                        "url": "/banking/citigold?intc=citihpmenu_overview_citigold",
                                        "id": "navCitGold",
                                        "image": false,
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Citigold<sup>&reg;</sup> Private Client",
                                        "title_es_US": "Citigold<sup>&reg;</sup> Private Client",
                                        "url": "/banking/citigold-private-client?intc=citihpmenu_overview_citigold-private-client",
                                        "id": "navCitiGoldPrivCli",
                                        "image": false,
                                        "domainMap": "ssr",
                                        "show": true
                                    },
                                    {
                                        "title": "Citi Priority",
                                        "title_es_US": "Citi Priority",
                                        "url": "/banking/citi-priority?intc=citihpmenu_overview_citi-priority",
                                        "id": "navCitiPriority",
                                        "image": false,
                                        "domainMap": "ssr",
                                        "show": true
                                    }
                                ],
                                "quickLinks": [
                                    {
                                        "linkId": "findRelMan",
                                        "linkText": "Find a Wealth Team",
                                        "linkText_es_US": "Buscar un Equipo de Gestión de Patrimonios",
                                        "url": "https://contactcitigold.citi.com/",
                                        "domainMap": "default",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    },
                                    {
                                        "linkId": "citiWelAdv",
                                        "linkText": "Planning Tools",
                                        "linkText_es_US": "Herramientas de Planificación",
                                        "url": "/US/JRS/pands/detail.do?ID=FinancialPlanningTools&JFP_TOKEN=PD3BPM40",
                                        "domainMap": "legacy",
                                        "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg"
                                    }
                                ],
                                "subDiv": {
                                    "image": "",
                                    "subNavItemsDivTitle": "Invest In Your Future With Citi",
                                    "subNavItemsDivDescription": "Open an Investment Account with Citi and take advantage of personalized guidance.",
                                    "subNavItemsDivLearnMore": "Learn more"
                                },
                                "show": true
                            }
                        ]
                    },
                    {
                        "title": "ATM / BRANCH",
                        "title_es_US": "ATM / SUCURSAL",
                        "url": "/citibank-location-finder",
                        "className": "ATMBranch",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                        "id": "butlerATM",
                        "show": true,
                        "domainMap": "csr"
                    },
                    {
                        "title": "ENGLISH",
                        "title_es_US": "ENGLISH",
                        "url": "",
                        "urlSuffix": "?locale=en_US",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                        "className": "espanolLink",
                        "id": "butlerEspanol",
                        "show": true,
                        "locale": "es_US"
                    },
                    {
                        "title": "ESPAÑOL",
                        "title_es_US": "ENGLISH",
                        "url": "",
                        "className": "espanolLink",
                        "id": "butlerEspanol",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v2.svg",
                        "show": true,
                        "speedbump": {
                            "urlSuffix": "?locale=es_US",
                            "url": "/US/login.do?locale=es_US",
                            "header": "Notificación importante",
                            "buttonText": "<span lang='es'>Continuar</span>",
                            "buttonTarget": "_self",
                            "copy": "<p lang='es'><strong>Por favor, tenga en cuenta que es posible que las comunicaciones futuras del banco, ya sean verbales o escritas, sean únicamente en inglés. Estas comunicaciones podrían incluir, entre otras, contratos de cuentas, estados de cuenta y divulgaciones, así como cambios en términos o cargos o cualquier tipo de servicio para su cuenta. Además, es posible que algunas secciones de este website permanezcan en inglés.</strong></p><hr><p>Please be advised that future verbal and written communications from the bank may be in English only. These communications may include, but are not limited to, account agreements, statements and disclosures, changes in terms or fees; or any servicing of your account. Additionally, some sections of this site may remain in English. </p>"
                        },
                        "locale": "en_US"
                    },
                    {
                        "title": "Open an Account",
                        "title_es_US": "Abrir una Cuenta",
                        "url": "/banking/bank-accounts?intc=citihpmenu_overview_bank-accounts",
                        "id": "navOpenAcc",
                        "show": true,
                        "domainMap": "ssr"
                    }
                ],
                "help": {
                    "title": "How can we help?",
                    "title_es_US": "¿Cómo podemos ayudar?",
                    "show": true
                },
                "sign": {
                    "fallback": true,
                    "show": true,
                    "signOnWording": "Sign On",
                    "signOnWording_es_US": "Ingresar",
                    "signOffWording": "Sign Off",
                    "signOffWording_es_US": "Salir",
                    "signOnUrl": "/US/login.do",
                    "signOffUrl": "/US/JSO/signoff/SummaryRecord.do?logOff=true",
                    "ngaSignOffUrl": "/sign-off",
                    "showSignModal": true,
                    "wording": "Sign On",
                    "signOnSSRRedirection": true,
                    "modal": {
                        "title": "Sign On",
                        "title_es_US": "Ingresar",
                        "id": "navSignOn",
                        "action": "/signon.do",
                        "buttonText": "Sign On",
                        "buttonText_es_US": "Ingresar",
                        "usernameName": "username",
                        "usernamePlaceholder": "User ID",
                        "usernamePlaceholder_es_US": "ID de Usuario",
                        "passwordName": "password",
                        "passwordPlaceholder": "Password",
                        "passwordPlaceholder_es_US": "ContraseÃ±a",
                        "rememberIdName": "rememberid",
                        "rememberIdText": "Remember my User ID",
                        "rememberIdText_es_US": "Recordar mi ID de Usuario",
                        "userIdMinChars": 3,
                        "userIdBlankError": "Enter a User Id",
                        "userIdBlankError_es_US": "Ingresa ID de Usuario",
                        "userIdShortError": "Your User ID must be greater than 2 characters",
                        "userIdShortError_es_US": "Tu IdentificaciÃ³n de usuario debe tener mÃ¡s de 2 caracteres",
                        "passwordMinChars": 6,
                        "passwordBlankError": "Enter a Password",
                        "passwordBlankError_es_US": "Ingresa una Contraseña",
                        "passwordShortError": "Your password must be at least 6 characters long",
                        "passwordShortError_es_US": "Tu Contraseña debe tener un minimo de 6 caracteres",
                        "rememberText": "Do not select if you are using a public computer.",
                        "rememberText_es_US": "No la selecciones si estÃ¡s usando una computadora pÃºblica.",
                        "forgotUser": {
                            "text": "Forgot User ID?",
                            "action": "/US/JSO/uidn/RequestUserIDReminder.do?fuipFlowInd=userID"
                        },
                        "forgotPassword": {
                            "text": "Forgot Password?",
                            "text_es_US": "OlvidÃ© ID de Usuario",
                            "action": "/US/JSO/uidn/RequestUserIDReminder.do?fuipFlowInd=pwd"
                        },
                        "activateCard": {
                            "text": "Activate a Card",
                            "text_es_US": "OlvidÃ© Contraseña",
                            "action": "/US/ag/activate/index"
                        },
                        "registerOnline": {
                            "text": "Register for Online Access",
                            "text_es_US": "RegÃ­strate para el Acceso en LÃ­nea",
                            "action": "/JSO/reg/Setup.do?"
                        },
                        "existingUsers": {
                            "usernames": [
                                "s***t"
                            ],
                            "addUserText": "A different User",
                            "addUserText_es_US": "Un Usuario diferente",
                            "deleteUserText": "Clear a User ID",
                            "deleteUserText_es_US": "Borrar un ID de Usuario",
                            "deleteUserUrl": "/US/JSO/signon/DeleteUsername.do"
                        }
                    },
                    "url": "/US/login.do"
                }
            }
        },
        "footer": {
            "butler": {
                "show": true,
                "logo": {
                    "show": true,
                    "url": "/CBOL/IA/Angular/assets/citi-logo-footer.png"
                },
                "social": {
                    "show": true,
                    "facebook": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                        "url": "https://www.facebook.com/citibank",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "Información Importante",
                        "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                        "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    },
                    "twitter": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                        "url": "https://twitter.com/Citibank/",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "Información Importante",
                        "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                        "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    },
                    "youtube": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                        "url": "https://www.youtube.com/citi",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "Información Importante",
                        "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                        "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    }
                }
            },
            "navigation": {
                "show": true,
                "sections": [
                    {
                        "title": "Why Citi",
                        "title_es_US": "Por Qué Citi",
                        "id": "navWhyCiti",
                        "links": [
                            {
                                "url": "http://www.citigroup.com/citi/",
                                "title": "Our Story",
                                "title_es_US": "Nuestra Historia",
                                "id": "navOurStory",
                                "domainMap": "default"
                            },
                            {
                                "url": "https://jobs.citi.com/",
                                "title": "Careers",
                                "title_es_US": "Empleos",
                                "id": "navCareers",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=OnlineState",
                                "title": "Benefits and Services",
                                "title_es_US": "Beneficios y Servicios",
                                "id": "navBenefits&Services",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=Rewards",
                                "title": "Rewards",
                                "title_es_US": "Recompensas",
                                "id": "navRewards",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "http://www.citiprivatepass.com/",
                                "title": "Citi Entertainment<sup>&reg;</sup>",
                                "title_es_US": "Citi Entertainment<sup>&reg;</sup>",
                                "id": "navPrivatePass",
                                "target": "_blank",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/portal/template.do?ID=SpecialOffers",
                                "title": "Special Offers",
                                "title_es_US": "Ofertas Especiales",
                                "id": "navSpecialOffers",
                                "domainMap": "legacy"
                            }
                        ]
                    },
                    {
                        "title": "Wealth Management",
                        "title_es_US": "Gestión de Patrimonios",
                        "id": "navRelationshipBanking",
                        "links": [
                            {
                                "title": "Citigold<sup>&reg;</sup> Private Client",
                                "title_es_US": "Citigold<sup>&reg;</sup> Private Client",
                                "url": "/citigold-private-client",
                                "image": false,
                                "id": "navCitiPrivateClient",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=CitigoldOverview",
                                "title": "Citigold",
                                "title_es_US": "Citigold",
                                "id": "navCitigold",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=CitiPriorityOverview",
                                "title": "Citi Priority",
                                "title_es_US": "Citi Priority",
                                "id": "navCitiPriority",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "https://www.privatebank.citibank.com/",
                                "title": "Citi Private Bank",
                                "title_es_US": "Citi Private Bank",
                                "id": "navCitiPrivateBank",
                                "domainMap": "default"
                            }
                        ]
                    },
                    {
                        "title": "Business Banking",
                        "title_es_US": "Servicios Bancarios para Empresas",
                        "id": "navBusinessBanking",
                        "links": [
                            {
                                "url": "/small-business-banking",
                                "title": "Small Business Accounts",
                                "title_es_US": "Cuentas para Pequeñas Empresas",
                                "id": "navSmallBusinessAccounts",
                                "domainMap": "csr"
                            },
                            {
                                "url": "https://www.citibank.com/commercialbank/en/index.html",
                                "title": "Commercial Accounts",
                                "title_es_US": "Cuentas Comerciales",
                                "id": "navCommercialAccounts",
                                "domainMap": "default"
                            }
                        ]
                    },
                    {
                        "title": "Rates",
                        "title_es_US": "Tasas",
                        "id": "navRates",
                        "links": [
                            {
                                "url": "/current-interest-rates/checking-saving-accounts",
                                "title": "Personal Banking",
                                "title_es_US": "Servicios Bancarios Personales",
                                "id": "navPersonal Banking",
                                "domainMap": "csr"
                            },
                            {
                                "url": "https://www.citi.com/credit-cards/compare-credit-cards/citi.action?ID=view-all-credit-cards",
                                "title": "Credit Cards",
                                "title_es_US": "Tarjetas de Crédito",
                                "id": "navCreditCards",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/portal/template.do?ID=todays_mortgage_rates&type=buy",
                                "title": "Mortgage",
                                "title_es_US": "Hipotecas",
                                "id": "navMortgage",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/home-equity/rates",
                                "title": "Home Equity",
                                "title_es_US": "Préstamos con Garantía Hipotecaria",
                                "id": "navHomeEquity",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/current-interest-rates/personal-loans-and-lines-of-credit",
                                "title": "Lending",
                                "title_es_US": "Préstamos",
                                "id": "navLending",
                                "domainMap": "csr"
                            }
                        ]
                    },
                    {
                        "title": "Help &amp; Support",
                        "title_es_US": "Ayuda y Apoyo",
                        "id": "navHelpSupport",
                        "links": [
                            {
                                "url": "/contactus",
                                "title": "Contact Us",
                                "title_es_US": "Contáctanos",
                                "id": "navContactUs",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/helptopic",
                                "title": "Help &amp; FAQs",
                                "title_es_US": "Ayuda y Preguntas Frecuentes",
                                "id": "navHelpFAQs",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/security-center",
                                "title": "Security Center",
                                "title_es_US": "Centro de Seguridad",
                                "id": "navSecurityCenter",
                                "domainMap": "csr"
                            }
                        ]
                    }
                ]
            },
            "disclaimer": {
                "show": true,
                "text": "<p role='heading' aria-level='4'><strong>Important Legal Disclosures & Information</strong></p><p>Citibank.com provides information about and access to accounts and financial services provided by Citibank, N.A. and its affiliates in the United States and its territories. It does not, and should not be construed as, an offer, invitation or solicitation of services to individuals outside of the United States.</p><p>Terms, conditions and fees for accounts, products, programs and services are subject to change. Not all accounts, products, and services as well as pricing described here are available in all jurisdictions or to all customers. Your eligibility for a particular product and service is subject to a final determination by Citibank. Your country of citizenship, domicile, or residence, if other than the United States, may have laws, rules, and regulations that govern or affect your application for and use of our accounts, products and services, including laws and regulations regarding taxes, exchange and/or capital controls that you are responsible for following.</p><p>The products, account packages, promotional offers and services described in this website may not apply to customers of <a target=\"_blank\" class=\"link\" href=\"/JRS/portal/template.do?ID=international-personal-bank&l=en&locale=en_US\">International Personal Bank U.S.</a> in the Citigold<sup>&reg;</sup> Private Client International, Citigold<sup>&reg;</sup> International, Citi International Personal, Citi Global Executive Preferred, and Citi Global Executive Account Packages.</p><p>Deposit products and services are offered by Citibank, N.A., Member FDIC</p>",
                "text_es_US": "<p role='heading' aria-level='4'><strong>Important Legal Disclosures & Information</strong></p><p>Citibank.com provides information about and access to accounts and financial services provided by Citibank, N.A. and its affiliates in the United States and its territories. It does not, and should not be construed as, an offer, invitation or solicitation of services to individuals outside of the United States.</p><p>Terms, conditions and fees for accounts, products, programs and services are subject to change. Not all accounts, products, and services as well as pricing described here are available in all jurisdictions or to all customers. Your eligibility for a particular product and service is subject to a final determination by Citibank. Your country of citizenship, domicile, or residence, if other than the United States, may have laws, rules, and regulations that govern or affect your application for and use of our accounts, products and services, including laws and regulations regarding taxes, exchange and/or capital controls that you are responsible for following.</p><p>The products, account packages, promotional offers and services described in this website may not apply to customers of <a target=\"_blank\" class=\"link\" href=\"/JRS/portal/template.do?ID=international-personal-bank&l=es&locale=es_US\">International Personal Bank U.S.</a> in the Citigold<sup>&reg;</sup> Private Client International, Citigold<sup>&reg;</sup> International, Citi International Personal, Citi Global Executive Preferred, and Citi Global Executive Account Packages.</p><p>Deposit products and services are offered by Citibank, N.A., Member FDIC</p>"
            },
            "badgeNavigation": {
                "show": true,
                "badgeSections": [
                    {
                        "title": "badge",
                        "title_es_US": "badge",
                        "links": [
                            {
                                "title": "Googleplay",
                                "title_es_US": "Googleplay",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                                "label": "Get it on Google Play",
                                "showAppImage": true,
                                "speedbump": {
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                    "url": "https://play.google.com/store/apps/details?id=com.citi.citimobile"
                                },
                                "showSpeedbump": true
                            },
                            {
                                "title": "Appstore",
                                "title_es_US": "Appstore",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                                "label": "Download on the App Store",
                                "showAppImage": true,
                                "speedbump": {
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                    "url": "https://itunes.apple.com/app/citi-mobile-sm/id301724680?mt=8 "
                                },
                                "showSpeedbump": true
                            },
                            {
                                "title": "JDPowerLogo",
                                "title_es_US": "JDPowerLogo",
                                "url": "https://online.citi.com/US/JRS/pands/detail.do?ID=citi-digital-services",
                                "imageUrl": "/CBOL/IA/Angular/assets/JD-power3x.png",
                                "label": "J.D. Power 2019 Mobile App Certification Program",
                                "showAppImage": true,
                                "speedbump": [
                                    {
                                        "header": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span>",
                                        "header_es_US": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span>",
                                        "copy": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span> recognition is based on successful completion of an audit and exceeding a customer experience benchmark through a survey of recent servicing interactions. For more information, visit ",
                                        "copy_es_US": "El reconocimiento que otorga J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span> se basa en la ejecuciÃ³n satisfactoria de una auditorÃ­a y en la capacidad de exceder indicadores relativos a la satisfacciÃ³n del cliente, que se miden a travÃ©s de una encuesta sobre la interacciÃ³n reciente con el servicio. Para obtener mÃ¡s informaciÃ³n, visita ",
                                        "anchorText": "jdpower.com/awards",
                                        "buttonText": "Continue",
                                        "buttonText_es_US": "Continuar",
                                        "url": ""
                                    },
                                    {
                                        "header": "Important Information",
                                        "header_es_US": "Importante Información",
                                        "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                        "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                        "anchorText": "",
                                        "buttonText": "Continue",
                                        "buttonText_es_US": "Continuar",
                                        "url": "http://www.jdpower.com/awards"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "title": "MobileJDPower",
                        "title_es_US": "MobileJDPower",
                        "url": "https://online.citi.com/US/JRS/pands/detail.do?ID=citi-digital-services",
                        "links": [],
                        "domainMap": "legacy"
                    },
                    {
                        "title": "socialmedia",
                        "title_es_US": "socialmedia",
                        "links": [
                            {
                                "name": "facebook",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                                "show": true,
                                "speedbump": {
                                    "url": "https://www.facebook.com/citibank",
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                },
                                "showSpeedbump": true
                            },
                            {
                                "name": "twitter",
                                "show": true,
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                                "speedbump": {
                                    "url": "https://twitter.com/Citibank/",
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                },
                                "showSpeedbump": true
                            },
                            {
                                "name": "youtube",
                                "show": true,
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg",
                                "speedbump": {
                                    "url": "https://www.youtube.com/citi",
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                },
                                "showSpeedbump": true
                            }
                        ]
                    }
                ]
            },
            "subNavigation": {
                "show": true,
                "copyright": {
                    "show": true,
                    "text": "&copy; 2018 Citigroup Inc",
                    "text_es_US": "&copy; 2018 Citigroup Inc"
                },
                "showFeedback": false,
                "feedbackWording": "Feedback",
                "navigation": {
                    "show": true,
                    "links": [
                        {
                            "url": "/termsdisclaimer/termsdisclaimerhome",
                            "title": "Terms &amp; Conditions",
                            "title_es_US": "Términos y Condiciones",
                            "id": "subnavTermsConditions",
                            "domainMap": "csr",
                            "show": true
                        },
                        {
                            "url": "/US/JRS/portal/template.do?ID=Privacy",
                            "title": "Privacy",
                            "title_es_US": "Privacidad",
                            "id": "subnavPrivacy",
                            "domainMap": "legacy",
                            "show": true
                        },
                        {
                            "url": "/JRS/portal/template.do?ID=Privacy#notice-at-collection",
                            "title": "Notice at Collection",
                            "title_es_US": "Aviso de Recopilación",
                            "id": "subnavNoticeAtCollection",
                            "domainMap": "legacy",
                            "show": true
                        },
                        {
                            "url": "/dataprivacyhub",
                            "title": "Do Not Sell or Share My Personal Information",
                            "title_es_US": "No Vender Ni Compartir mi Información Personal",
                            "id": "subnavPrivacyHub",
                            "domainMap": "csr",
                            "show": true
                        },
                        {
                            "url": "/US/JRS/portal/template.do?ID=Accessibility",
                            "title": "Accessibility",
                            "title_es_US": "Accesibilidad",
                            "id": "subnavAccessibility",
                            "domainMap": "legacy",
                            "show": true
                        }
                    ]
                }
            },
            "subFooter": {
                "show": true,
                "images": {
                    "show": true,
                    "fdic": {
                        "url": "/CBOL/IA/Angular/assets/memberfdic.png",
                        "show": false
                    },
                    "equalHousing": {
                        "url": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v2.svg"
                    },
                    "progressiveLogoImageMobile": {
                        "url": "/CBOL/IA/Angular/assets/citiredesign-footer.svg"
                    },
                    "progressiveLogoImageDesktop": {
                        "url": "/CBOL/IA/Angular/assets/citiredesign-footer.svg"
                    }
                }
            }
        }
    }
};

const localBanner = {
    "banner": {
        "preBanner": {
            "show": true,
            "color": "blue",
            "logo": {
                "defaultCust": true,
                "show": true,
                "image": "/CBOL/IA/Angular/assets/citiredesign.svg",
                "skelHeaderCitiLogoImgPath": "/CBOL/IA/Angular/assets/citiredesign.svg",
                "gold": {
                    "desktopImage": "/CBOL/IA/Angular/assets/citigold_D2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/citigold_M2x.svg"
                },
                "cpc": {
                    "desktopImage": "/CBOL/IA/Angular/assets/cpc_M2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/cpc_M2x.svg"
                },
                "priority": {
                    "desktopImage": "/CBOL/IA/Angular/assets/priority_D2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/priority_M2x.svg"
                },
                "cpb": {
                    "desktopImage": "/CBOL/IA/Angular/assets/CPB_D.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/CPB_M.svg"
                },
                "privateCust": false,
                "customer": "default",
                "hovercolor": "default",
                "url": "/"
            },
            "buttonsData": [
                {
                    "title": "ATM / BRANCH",
                    "title_es_US": "ATM / SUCURSAL",
                    "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                    "url": "/citibank-location-finder",
                    "className": "ATMBranch",
                    "id": "butlerATM",
                    "domainMap": "csr"
                },
                {
                    "title": "ENGLISH",
                    "title_es_US": "ENGLISH",
                    "url": "",
                    "urlSuffix": "?locale=en_US",
                    "locale": "es_US",
                    "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                    "className": "espanolLink",
                    "id": "lang"
                },
                {
                    "title": "ESPAÑOL",
                    "title_es_US": "ENGLISH",
                    "url": "",
                    "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                    "className": "espanolLink",
                    "locale": "en_US",
                    "id": "lang",
                    "speedbump": {
                        "urlSuffix": "?locale=es_US",
                        "url": "/US/login.do?locale=es_US",
                        "header": "Important Information",
                        "header_es_US": "Notificación importante",
                        "buttonText": "<span lang='es'>Continuar</span>",
                        "buttonText_es_US": "<span lang='es'>Continuar</span>",
                        "buttonTarget": "_self",
                        "copy": "<p lang='es'><strong>Por favor, tenga en cuenta que es posible que las comunicaciones futuras del banco, ya sean verbales o escritas, sean únicamente en inglés. Estas comunicaciones podrían incluir, entre otras, contratos de cuentas, estados de cuenta y divulgaciones, así como cambios en términos o cargos o cualquier tipo de servicio para su cuenta. Además, es posible que algunas secciones de este website permanezcan en inglés.</strong></p><hr><p>Please be advised that future verbal and written communications from the bank may be in English only. These communications may include, but are not limited to, account agreements, statements and disclosures, changes in terms or fees; or any servicing of your account. Additionally, some sections of this site may remain in English. </p>",
                        "copy_es_US": "<p lang='es'><strong>Por favor, tenga en cuenta que es posible que las comunicaciones futuras del banco, ya sean verbales o escritas, sean únicamente en inglés. Estas comunicaciones podrían incluir, entre otras, contratos de cuentas, estados de cuenta y divulgaciones, así como cambios en términos o cargos o cualquier tipo de servicio para su cuenta. Además, es posible que algunas secciones de este website permanezcan en inglés.</strong></p><hr><p>Please be advised that future verbal and written communications from the bank may be in English only. These communications may include, but are not limited to, account agreements, statements and disclosures, changes in terms or fees; or any servicing of your account. Additionally, some sections of this site may remain in English. </p>"
                    }
                }
            ],
            "contactUs": {
                "show": false,
                "ariaDescribedBy": "contact Us",
                "ariaLabel": "contact Us",
                "contactUsModal": [
                    {
                        "title": "Give us a call",
                        "title_es_US": "Give us a call",
                        "id": "banContactUs",
                        "items": [
                            {
                                "title": "Mortgages and refinancing",
                                "title_es_US": "Mortgages and refinancing",
                                "id": "banMortgages&refinancing",
                                "phone": "1-800-248-4638",
                                "workingHours": "Mon-Fri: 8:00 AM to 10:00 PM ET <br> and Sat: 9:00 AM to 7:00 PM ET"
                            },
                            {
                                "title": "Home equity lines or loans",
                                "title_es_US": "Home equity lines or loans",
                                "id": "banHomeequitylinesorloans",
                                "phone": "1-877-362-9100",
                                "workingHours": "Mon-Sun: 9:00 AM to 11:00 PM ET"
                            },
                            {
                                "title": "For homeowner support",
                                "title_es_US": "For homeowner support",
                                "id": "banHomeownersupport",
                                "phone": "1-866-272-4749"
                            }
                        ]
                    }
                ]
            }
        },
        "postBanner": {
            "butler": {
                "show": true,
                "navigationItems": [
                    {
                        "title": "citi.com",
                        "title_es_US": "citi.com",
                        "url": "/US/login.do",
                        "show": true,
                        "domainMap": "legacy"
                    },
                    {
                        "title": "ATM / Branch",
                        "title_es_US": "ATM / Sucursal",
                        "url": "/citibank-location-finder",
                        "show": true,
                        "domainMap": "csr"
                    },
                    {
                        "title": "Open an Account",
                        "title_es_US": "Abrir una Cuenta",
                        "url": "/open-a-bank-account",
                        "show": { "var": "ff_NavOpenAnAccount" },
                        "domainMap": "csr"
                    }
                ]
            },
            "banner": {
                "show": true,
                "color": "blue",
                "logo": {
                    "defaultCust": true,
                    "show": true,
                    "image": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "url": "/dashboard",
                    "domainMap": "csr"
                },
                "easydeals": {
                    "title": "Explore All Products & Offers",
                    "title_es_US": "Explore All Products & Offers",
                    "url": "/products-offers/products",
                    "domainMap": "csr",
                    "featureflag": "ff_isProductsOffersGeneralThrottled"
                },
                "cart": {
                    "title": "CART",
                    "title_es_US": "CARRO",
                    "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                    "url": "/shoppingCart",
                    "domainMap": "csr",
                    "id": "cart",
                    "featureflag": "ff_ShoppingCart"
                },
                "buttonsData": [
                    {
                        "title": "CART",
                        "title_es_US": "CARRO",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                        "url": "/shoppingCart",
                        "domainMap": "csr",
                        "id": "cart",
                        "featureflag": "ff_ShoppingCart"
                    },
                    {
                        "id": "profiles",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                        "title": "PROFILE",
                        "title_es_US": "PERFIL",
                        "featureflag": "ff_NavProfiles",
                        "navigationItems": [
                            {
                                "subTitle": "PROFILE",
                                "subTitle_es_US": "PERFIL",
                                "items": [
                                    {
                                        "title": "User ID",
                                        "title_es_US": "Identificación de Usuario",
                                        "url": "/profile-update/change-userid",
                                        "featureflag": "ff_UpdateUserId",
                                        "domainMap": "csr"
                                    },
                                    {
                                        "title": "Password",
                                        "title_es_US": "Contraseña",
                                        "url": "/profile-update/change-password",
                                        "featureflag": "ff_UpdatePassword",
                                        "domainMap": "csr"
                                    },
                                    {
                                        "title": "Contact Information",
                                        "title_es_US": "Información de Contacto",
                                        "url": "/ContactInfo/Profiles",
                                        "featureflag": "contactInfo",
                                        "domainMap": "csr"
                                    },
                                    {
                                        "title": "Income Information",
                                        "title_es_US": "Información sobre los Ingresos",
                                        "url": "/updateincomeinfo/landingpage?targetAOApp=cfiOvly",
                                        "featureflag": "incomeInfo",
                                        "domainMap": "csr"
                                    },
                                    {
                                        "title": "Employment Status",
                                        "title_es_US": "Situación Laboral",
                                        "url": "/kyc/data-capture/index/category/employmentInformation",
                                        "domainMap": "csr",
                                        "featureflag": "employmentStatus"
                                    },
                                    {
                                        "title": "Balance & Benefits",
                                        "title_es_US": "Saldo y Beneficios",
                                        "featureflag": "ff_cambBenefitsEveryday",
                                        "url": "/reward/CAMB",
                                        "domainMap": "csr"
                                    },
                                    {
                                        "title": "Relationship Tier",
                                        "title_es_US": "Categoría de Relación",
                                        "featureflag": "ff_cambBenefits",
                                        "url": "/reward/CAMB",
                                        "domainMap": "csr"
                                    }
                                ]
                            },
                            {
                                "subTitle": "SETTINGS",
                                "subTitle_es_US": "CONFIGURACIONES",
                                "items": [
                                    {
                                        "title": "Account Alerts",
                                        "title_es_US": "Alertas de Cuenta",
                                        "url": "/alerts",
                                        "domainMap": "csr",
                                        "featureflag": "accountAlerts"
                                    },
                                    {
                                        "show": true,
                                        "title": "More Settings",
                                        "title_es_US": "Más Configuraciones",
                                        "url": "/servicing/index?pageName=Settings",
                                        "featureflag": "ff_NavMoreSettings",
                                        "domainMap": "csr"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "title": "ATM / BRANCH",
                        "title_es_US": "ATM / SUCURSAL",
                        "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                        "url": "/citibank-location-finder",
                        "domainMap": "csr",
                        "className": "ATMBranch",
                        "id": "butlerATM"
                    }
                ],
                "url": "/dashboard",
                "domainMap": "csr"
            },
            "navigation": {
                "show": true,
                "search": {
                    "show": true,
                    "action": "/US/JRS/globalsearch/Search.do",
                    "placeholder": "What can we help you with?",
                    "placeholder_es_US": "¿Qué podemos ayudarte?",
                    "submitButtonText": "Go",
                    "submitButtonText_es_US": "Go",
                    "ariaDescribedBy": "El enfoque cambiará a la entrada de búsqueda cuando se presione",
                    "ariaDescribedBy_es_US": "Focus will shift to search input when pressed",
                    "ariaLabel": "Search",
                    "ariaLabel_es_US": "Search",
                    "title": "Search",
                    "title_es_US": "Search",
                    "id": "banSearch"
                },
                "navigationItems": [
                    {
                        "title": "Accounts",
                        "title_es_US": "Accounts",
                        "url": "https://www.citi.com/credit-cards/citi.action",
                        "domainMap": "default"
                    },
                    {
                        "title": "Banking",
                        "title_es_US": "Banking",
                        "url": "/US/banking/citi.action?ID=banking-overview",
                        "domainMap": "legacy"
                    },
                    {
                        "title": "Lending",
                        "title_es_US": "Lending",
                        "navigationItems": [
                            {
                                "title": "Personal Loans & Lines of Credit",
                                "title_es_US": "Personal Loans & Lines of Credit",
                                "url": "/personal-loan",
                                "domainMap": "csr"
                            },
                            {
                                "title": "Homeownership",
                                "title_es_US": "Homeownership",
                                "url": "/US/JRS/portal/template.do?ID=mortgage_home_mortgage",
                                "domainMap": "legacy"
                            }
                        ]
                    },
                    {
                        "title": "Investing",
                        "title_es_US": "Investing",
                        "navigationItems": [
                            {
                                "title": "Your Financial Goals",
                                "title_es_US": "Your Financial Goals",
                                "url": "/US/JRS/pands/detail.do?ID=FinancialGoals",
                                "domainMap": "legacy"
                            },
                            {
                                "title": "Investing Overview",
                                "title_es_US": "Panorama de Inversión",
                                "url": "/US/JRS/pands/detail.do?ID=InvestingCiti",
                                "domainMap": "legacy"
                            },
                            {
                                "title": "Insights and Tools",
                                "title_es_US": "Insights and Tools",
                                "url": "/US/JRS/pands/detail.do?ID=InsightsTools",
                                "domainMap": "legacy"
                            }
                        ]
                    },
                    {
                        "title": "Citigold<sup>&reg;</sup>",
                        "title_es_US": "Citigold<sup>&reg;</sup>",
                        "url": "/US/JRS/pands/detail.do?ID=CitigoldOverview",
                        "domainMap": "legacy"
                    }
                ],
                "help": {
                    "title": "How can we help?",
                    "title_es_US": "¿Cómo podemos ayudar?",
                    "featureflag": "ff_NavHowCanWeHelp"
                },
                "sign": {
                    "show": false,
                    "signOnWording": "Sign On",
                    "signOnWording_es_US": "Ingresar",
                    "signOffWording": "Sign Off",
                    "signOffWording_es_US": "Salir",
                    "signOnUrl": "/US/login.do",
                    "signOffUrl": "/US/JSO/signoff/SummaryRecord.do?logOff=true",
                    "ngaSignOffUrl": "/sign-off",
                    "signOnSSRRedirection": true
                }
            },
            "welcome": {
                "show": false,
                "logo": {
                    "show": true,
                    "image": "https://online.citi.com/JRS/images/logo_HH.png"
                }
            }
        }
    },
    "logosData": {
        "spf": {
            "logo": [
                {
                    "color": "black",
                    "image": "/CBOL/IA/Angular/assets/CPB_D.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/images/CPB_M.svg",
                    "privateCust": true,
                    "customer": "cpb",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "CITI Private Banking",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "PrivateBanking"]
                    }
                },
                {
                    "color": "brown",
                    "hoverColor": "gold",
                    "customer": "cpc",
                    "image": "/CBOL/IA/Angular/assets/cpc_M2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/cpc_M2x.svg",
                    "comments": "if CPC",
                    "url": "/US/JPS/portal/Home.do",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "CPC"]
                    }
                },
                {
                    "color": "orange",
                    "image": "/CBOL/IA/Angular/assets/att_D.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/att_M.png",
                    "comments": "if(cardsBranding_id==ATT_NEWUpdated)",
                    "url": "/US/JPS/portal/Home.do",
                    "customer": "att",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "ATTCard"]
                    }
                },
                {
                    "color": "blue",
                    "image": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "Default logo for SPF, always at the end",
                    "default": true
                }
            ]
        },
        "mrc": {
            "logo": [
                {
                    "color": "brown",
                    "hoverColor": "gold",
                    "customer": "cpc",
                    "image": "/CBOL/IA/Angular/assets/cpc_M2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/cpc_M2x.svg",
                    "comments": "if CPC",
                    "url": "/US/JPS/portal/Home.do",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "CPC"]
                    }
                },
                {
                    "color": "black",
                    "image": "/CBOL/IA/Angular/assets/CPB_D.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/CPB_M.svg",
                    "privateCust": true,
                    "customer": "cpb",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "CITI Private Banking",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "PrivateBanking"]
                    }
                },
                {
                    "color": "blue",
                    "customer": "business",
                    "image": "/CBOL/IA/Angular/assets/citibusiness2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/business_M2x.svg",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "if(isBusinessCust==Y)",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "Business"]
                    }
                },
                {
                    "color": "alliance",
                    "hoverColor": "alliance",
                    "customer": "alliance",
                    "image": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "if(isCitiAlliance==Y))",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "Alliance"]
                    }
                },
                {
                    "color": "gold",
                    "hoverColor": "gold",
                    "customer": "gold",
                    "image": "/CBOL/IA/Angular/assets/citigold_D2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/citigold_M2x.svg",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "if(isCitigold==Y) || (isVisitor==Y && isCitiGoldCookie==Y))",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "Gold"]
                    }
                },
                {
                    "color": "priority",
                    "hoverColor": "priority",
                    "customer": "priority",
                    "image": "/CBOL/IA/Angular/assets/priority_D2x.svg",
                    "mobileImage": "/CBOL/IA/Angular/assets/priority_M2x.svg",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "if(isSegmentationFallback==Y) && (isCitipriority==Y || isVisitor==Y || isCitiPriorityCookie==Y ))",
                    "show": {
                        "==": [{
                                "var": "userBranding"
                            }, "Priority"]
                    }
                },
                {
                    "color": "blue",
                    "image": "/CBOL/IA/Angular/assets/citiredesign.svg",
                    "url": "/US/JPS/portal/Home.do",
                    "comments": "Default logo for MRC, always at the end",
                    "default": true
                }
            ]
        }
    }
};
const localFooter = {
    "footer": {
        "preFooter": {
            "butler": {
                "show": true,
                "logo": {
                    "show": true,
                    "url": "/CBOL/IA/Angular/assets/citi-logo-footer.png"
                },
                "social": {
                    "show": true,
                    "facebook": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                        "url": "https://www.facebook.com/citibank",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "Información Importante",
                        "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                        "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    },
                    "twitter": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                        "url": "https://twitter.com/Citibank/",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "Información Importante",
                        "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                        "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    },
                    "youtube": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                        "url": "https://www.youtube.com/citi",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "Información Importante",
                        "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                        "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    }
                }
            },
            "navigation": {
                "show": true,
                "sections": [
                    {
                        "title": "Why Citi",
                        "title_es_US": "Por Qué Citi",
                        "id": "navWhyCiti",
                        "links": [
                            {
                                "url": "http://www.citigroup.com/citi/",
                                "title": "Our Story",
                                "title_es_US": "Nuestra Historia",
                                "id": "navOurStory",
                                "domainMap": "default"
                            },
                            {
                                "url": "https://jobs.citi.com/",
                                "title": "Careers",
                                "title_es_US": "Empleos",
                                "id": "navCareers",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=OnlineState",
                                "title": "Benefits and Services",
                                "title_es_US": "Beneficios y Servicios",
                                "id": "navBenefits&Services",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=Rewards",
                                "title": "Rewards",
                                "title_es_US": "Recompensas",
                                "id": "navRewards",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "https://www.citientertainment.com/?utm_source=CBOL&utm_medium=Footer&utm_campaign=CE_Homepage_Footer",
                                "title": "Citi Entertainment<sup>&reg;</sup>",
                                "title_es_US": "Citi Entertainment<sup>&reg;</sup>",
                                "id": "navPrivatePass",
                                "target": "_blank",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/portal/template.do?ID=SpecialOffers",
                                "title": "Special Offers",
                                "title_es_US": "Ofertas Especiales",
                                "id": "navSpecialOffers",
                                "domainMap": "legacy"
                            }
                        ]
                    },
                    {
                        "title": "Wealth Management",
                        "title_es_US": "Gestión de Patrimonios",
                        "id": "navRelationshipBanking",
                        "links": [
                            {
                                "title": "Citigold<sup>&reg;</sup> Private Client",
                                "title_es_US": "Citigold<sup>&reg;</sup> Private Client",
                                "url": "/banking/citigold-private-client",
                                "image": false,
                                "id": "navCitiPrivateClient",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/banking/citigold",
                                "title": "Citigold",
                                "title_es_US": "Citigold",
                                "id": "navCitigold",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/banking/citi-priority",
                                "title": "Citi Priority",
                                "title_es_US": "Citi Priority",
                                "id": "navCitiPriority",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "https://www.privatebank.citibank.com/",
                                "title": "Citi Private Bank",
                                "title_es_US": "Citi Private Bank",
                                "id": "navCitiPrivateBank",
                                "domainMap": "default"
                            }
                        ]
                    },
                    {
                        "title": "Business Banking",
                        "title_es_US": "Servicios Bancarios para Empresas",
                        "id": "navBusinessBanking",
                        "links": [
                            {
                                "url": "/small-business/banking",
                                "title": "Small Business Accounts",
                                "title_es_US": "Cuentas para Pequeñas Empresas",
                                "id": "navSmallBusinessAccounts",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "https://www.citibank.com/commercialbank/en/index.html",
                                "title": "Commercial Accounts",
                                "title_es_US": "Cuentas Comerciales",
                                "id": "navCommercialAccounts",
                                "domainMap": "default"
                            }
                        ]
                    },
                    {
                        "title": "Rates",
                        "title_es_US": "Tasas",
                        "id": "navRates",
                        "links": [
                            {
                                "url": "/banking/current-interest-rates/savings-accounts",
                                "title": "Personal Banking",
                                "title_es_US": "Servicios Bancarios Personales",
                                "id": "navPersonal Banking",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "https://www.citi.com/credit-cards/compare-credit-cards/citi.action?ID=view-all-credit-cards",
                                "title": "Credit Cards",
                                "title_es_US": "Tarjetas de Crédito",
                                "id": "navCreditCards",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/portal/template.do?ID=todays_mortgage_rates&type=buy",
                                "title": "Mortgage",
                                "title_es_US": "Hipotecas",
                                "id": "navMortgage",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/home-equity/rates",
                                "title": "Home Equity",
                                "title_es_US": "Préstamos con Garantía Hipotecaria",
                                "id": "navHomeEquity",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/current-interest-rates/personal-loans-and-lines-of-credit",
                                "title": "Lending",
                                "title_es_US": "Préstamos",
                                "id": "navLending",
                                "domainMap": "csr"
                            }
                        ]
                    },
                    {
                        "title": "Help &amp; Support",
                        "title_es_US": "Ayuda y Apoyo",
                        "id": "navHelpSupport",
                        "links": [
                            {
                                "url": "/contactus",
                                "title": "Contact Us",
                                "title_es_US": "Contáctanos",
                                "id": "navContactUs",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/helptopic",
                                "title": "Help &amp; FAQs",
                                "title_es_US": "Ayuda y Preguntas Frecuentes",
                                "id": "navHelpFAQs",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/security-center",
                                "title": "Security Center",
                                "title_es_US": "Centro de Seguridad",
                                "id": "navSecurityCenter",
                                "domainMap": "csr"
                            }
                        ]
                    }
                ]
            },
            "disclaimer": {
                "show": true,
                "text": "<p role='heading' aria-level='4'><strong>Important Legal Disclosures & Information</strong></p><p>Citibank.com provides information about and access to accounts and financial services provided by Citibank, N.A. and its affiliates in the United States and its territories. It does not, and should not be construed as, an offer, invitation or solicitation of services to individuals outside of the United States.</p><p>Terms, conditions and fees for accounts, products, programs and services are subject to change. Not all accounts, products, and services as well as pricing described here are available in all jurisdictions or to all customers. Your eligibility for a particular product and service is subject to a final determination by Citibank. Your country of citizenship, domicile, or residence, if other than the United States, may have laws, rules, and regulations that govern or affect your application for and use of our accounts, products and services, including laws and regulations regarding taxes, exchange and/or capital controls that you are responsible for following.</p><p>The products, account packages, promotional offers and services described in this website may not apply to customers of <a target=\"_blank\" class=\"link\" href=\"/JRS/portal/template.do?ID=international-personal-bank&l=en&locale=en_US\">International Personal Bank U.S.</a> in the Citigold<sup>&reg;</sup> Private Client International, Citigold<sup>&reg;</sup> International, Citi International Personal, Citi Global Executive Preferred, and Citi Global Executive Account Packages.</p><p>Deposit products and services are offered by Citibank, N.A., Member FDIC</p>",
                "text_es_US": "<p role='heading' aria-level='4'><strong>Important Legal Disclosures & Information</strong></p><p>Citibank.com provides information about and access to accounts and financial services provided by Citibank, N.A. and its affiliates in the United States and its territories. It does not, and should not be construed as, an offer, invitation or solicitation of services to individuals outside of the United States.</p><p>Terms, conditions and fees for accounts, products, programs and services are subject to change. Not all accounts, products, and services as well as pricing described here are available in all jurisdictions or to all customers. Your eligibility for a particular product and service is subject to a final determination by Citibank. Your country of citizenship, domicile, or residence, if other than the United States, may have laws, rules, and regulations that govern or affect your application for and use of our accounts, products and services, including laws and regulations regarding taxes, exchange and/or capital controls that you are responsible for following.</p><p>The products, account packages, promotional offers and services described in this website may not apply to customers of <a target=\"_blank\" class=\"link\" href=\"/JRS/portal/template.do?ID=international-personal-bank&l=es&locale=es_US\">International Personal Bank U.S.</a> in the Citigold<sup>&reg;</sup> Private Client International, Citigold<sup>&reg;</sup> International, Citi International Personal, Citi Global Executive Preferred, and Citi Global Executive Account Packages.</p><p>Deposit products and services are offered by Citibank, N.A., Member FDIC</p>"
            },
            "badgeNavigation": {
                "show": true,
                "badgeSections": [
                    {
                        "title": "badge",
                        "title_es_US": "badge",
                        "links": [
                            {
                                "title": "Googleplay",
                                "title_es_US": "Googleplay",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "label": "Get it on Google Play",
                                "showAppImage": true,
                                "speedbump": {
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                    "url": "https://play.google.com/store/apps/details?id=com.citi.citimobile"
                                }
                            },
                            {
                                "title": "Appstore",
                                "title_es_US": "Appstore",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "label": "Download on the App Store",
                                "showAppImage": true,
                                "speedbump": {
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                    "url": "https://itunes.apple.com/app/citi-mobile-sm/id301724680?mt=8 "
                                }
                            },
                            {
                                "title": "JDPowerLogo",
                                "title_es_US": "JDPowerLogo",
                                "url": "https://online.citi.com/US/JRS/pands/detail.do?ID=citi-digital-services",
                                "imageUrl": "/CBOL/IA/Angular/assets/JD-power3x.png",
                                "label": "J.D. Power 2019 Mobile App Certification Program",
                                "showAppImage": true,
                                "speedbump": [
                                    {
                                        "header": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span>",
                                        "header_es_US": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span>",
                                        "copy": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span> recognition is based on successful completion of an audit and exceeding a customer experience benchmark through a survey of recent servicing interactions. For more information, visit ",
                                        "copy_es_US": "El reconocimiento que otorga J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span> se basa en la ejecuciÃ³n satisfactoria de una auditorÃ­a y en la capacidad de exceder indicadores relativos a la satisfacciÃ³n del cliente, que se miden a travÃ©s de una encuesta sobre la interacciÃ³n reciente con el servicio. Para obtener mÃ¡s informaciÃ³n, visita ",
                                        "anchorText": "jdpower.com/awards",
                                        "buttonText": "Continue",
                                        "buttonText_es_US": "Continuar",
                                        "url": ""
                                    },
                                    {
                                        "header": "Important Information",
                                        "header_es_US": "Importante Información",
                                        "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                        "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                        "anchorText": "",
                                        "buttonText": "Continue",
                                        "buttonText_es_US": "Continuar",
                                        "url": "http://www.jdpower.com/awards"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "title": "MobileJDPower",
                        "title_es_US": "MobileJDPower",
                        "url": "https://online.citi.com/US/JRS/pands/detail.do?ID=citi-digital-services",
                        "links": [],
                        "domainMap": "legacy"
                    },
                    {
                        "title": "socialmedia",
                        "title_es_US": "socialmedia",
                        "links": [
                            {
                                "name": "facebook",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "show": true,
                                "speedbump": {
                                    "url": "https://www.facebook.com/citibank",
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                }
                            },
                            {
                                "name": "twitter",
                                "show": true,
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "speedbump": {
                                    "url": "https://twitter.com/Citibank/",
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                }
                            },
                            {
                                "name": "youtube",
                                "show": true,
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "speedbump": {
                                    "url": "https://www.youtube.com/citi",
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                }
                            }
                        ]
                    }
                ]
            },
            "subNavigation": {
                "show": true,
                "copyright": {
                    "show": true,
                    "text": "&copy; 2018 Citigroup Inc",
                    "text_es_US": "&copy; 2018 Citigroup Inc"
                },
                "showFeedback": false,
                "feedbackWording": "Feedback",
                "navigation": {
                    "show": true,
                    "links": [
                        {
                            "url": "/termsdisclaimer/termsdisclaimerhome",
                            "title": "Terms &amp; Conditions",
                            "title_es_US": "Términos y Condiciones",
                            "id": "subnavTermsConditions",
                            "domainMap": "csr"
                        },
                        {
                            "url": "/US/JRS/portal/template.do?ID=Privacy",
                            "title": "Privacy",
                            "title_es_US": "Privacidad",
                            "id": "subnavPrivacy",
                            "domainMap": "legacy"
                        },
                        {
                            "url": "/JRS/portal/template.do?ID=Privacy#notice-at-collection",
                            "title": "Notice at Collection",
                            "title_es_US": "Aviso de Recopilación",
                            "id": "subnavNoticeAtCollection",
                            "domainMap": "legacy"
                        },
                        {
                            "url": "/dataprivacyhub",
                            "title": "Do Not Sell or Share My Personal Information",
                            "title_es_US": "No Vender Ni Compartir mi Información Personal",
                            "id": "subnavPrivacyHub",
                            "domainMap": "csr"
                        },
                        {
                            "url": "/US/JRS/portal/template.do?ID=Accessibility",
                            "title": "Accessibility",
                            "title_es_US": "Accesibilidad",
                            "id": "subnavAccessibility",
                            "domainMap": "legacy"
                        }
                    ]
                }
            },
            "subFooter": {
                "show": true,
                "images": {
                    "show": true,
                    "fdic": {
                        "url": "/CBOL/IA/Angular/assets/memberfdic.png",
                        "show": false
                    },
                    "equalHousing": {
                        "url": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg"
                    },
                    "progressiveLogoImageMobile": {
                        "url": "/CBOL/IA/Angular/assets/citiredesign-footer.svg"
                    },
                    "progressiveLogoImageDesktop": {
                        "url": "/CBOL/IA/Angular/assets/citiredesign-footer.svg"
                    }
                }
            }
        },
        "postFooter": {
            "butler": {
                "show": true,
                "logo": {
                    "show": true,
                    "url": "/CBOL/IA/Angular/assets/citi-logo-footer.png"
                },
                "social": {
                    "show": true,
                    "facebook": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                        "url": "https://www.facebook.com/citibank",
                        "domainMap": "default",
                        "header": "Important Information",
                        "headar_es_US": "InformaciÃ³ importante",
                        "copy": "You are leaving a Citigroup website and will be going to a website operated by Facebook. That site has a privacy policy and security that are different from that of the Citigroup website. Other than the materials posted by Citigroup on the facebook.com Citi pages, Citigroup and its affiliates are not responsible for the content on facebook.com.",
                        "copy_es_US": "Usted est? dejando un sitio web de Citigroup y se dirigir? a un sitio web operado por Facebook. Ese sitio tiene una pol?tica de privacidad y seguridad que son diferentes de las del sitio web de Citigroup. Aparte de los materiales publicados por Citigroup en las p?ginas de facebook.com Citi, Citigroup y sus afiliados no son responsables del contenido de facebook.com.",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    },
                    "twitter": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                        "url": "https://twitter.com/Citibank/",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "InformaciÃ³ importante",
                        "copy": "You are leaving a Citigroup website and will be going to a website operated by Twitter Inc. That site has a privacy policy and security that are different from that of the Citigroup website. Other than the Tweets posted by Citigroup, Citigroup and its affiliates are not responsible for the content on Twitter.com.",
                        "copy_es_US": "Usted est? dejando un sitio web de Citigroup y se dirigir? a un sitio web operado por Twitter Inc. Ese sitio tiene una pol?tica de privacidad y seguridad que son diferentes de la del sitio web de Citigroup. Aparte de los Tweets publicados por Citigroup, Citigroup y sus afiliados no son responsables del contenido de Twitter.com.",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    },
                    "youtube": {
                        "show": true,
                        "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                        "url": "https://www.youtube.com/citi",
                        "domainMap": "default",
                        "header": "Important Information",
                        "header_es_US": "InformaciÃ³ importante",
                        "copy": "You are leaving a Citigroup website and will be going to a website operated by You Tube. That site has a privacy policy and security that are different from that of the Citigroup website. Other than the materials posted by Citigroup on the youtube.com/citi pages, Citigroup and its affiliates are not responsible for the content on youtube.com.",
                        "copy_es_US": "Usted est? dejando un sitio web de Citigroup y se dirigir? a un sitio web operado por Twitter Inc. Ese sitio tiene una pol?tica de privacidad y seguridad que son diferentes de la del sitio web de Citigroup. Aparte de los Tweets publicados por Citigroup, Citigroup y sus afiliados no son responsables del contenido de Twitter.com.",
                        "buttonText": "Continue",
                        "buttonText_es_US": "Continuar"
                    }
                }
            },
            "navigation": {
                "show": true,
                "sections": [
                    {
                        "title": "Why Citi",
                        "title_es_US": "Por Qué Citi",
                        "links": [
                            {
                                "url": "http://www.citigroup.com/citi/",
                                "title": "Our Story",
                                "title_es_US": "Nuestra historia",
                                "domainMap": "default"
                            },
                            {
                                "url": "https://jobs.citi.com/",
                                "title": "Careers",
                                "title_es_US": "Careers",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=OnlineState",
                                "title": "Benefits and Services",
                                "title_es_US": "Beneficios y servicios",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/US/JRS/pands/detail.do?ID=Rewards",
                                "title": "Rewards",
                                "title_es_US": "Recompensas",
                                "domainMap": "legacy"
                            },
                            {
                                "url": "/products-offers/mydeals",
                                "title": "Products & Offers",
                                "title_es_US": "Products & Offers",
                                "target": "_blank",
                                "domainMap": "csr"
                            },
                            {
                                "url": "https://www.citientertainment.com/?utm_source=CBOL&utm_medium=Footer&utm_campaign=CE_Homepage_Footer",
                                "title": "Citi Entertainment<sup>&reg;</sup>",
                                "title_es_US": "Citi Entertainment<sup>&reg;</sup>",
                                "target": "_blank",
                                "domainMap": "default"
                            },
                            {
                                "url": "/US/JRS/portal/template.do?ID=SpecialOffers",
                                "title": "Special Offers",
                                "title_es_US": "Ofertas especiales",
                                "domainMap": "legacy"
                            }
                        ]
                    },
                    {
                        "title": "Wealth Management",
                        "title_es_US": "Gestión de Patrimonios",
                        "links": [
                            {
                                "title": "Citigold<sup>&reg;</sup> Private Client",
                                "title_es_US": "Citigold<sup>&reg;</sup> Private Client",
                                "url": "/banking/citigold-private-client",
                                "image": false,
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/banking/citigold",
                                "title": "Citigold",
                                "title_es_US": "Citigold",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/banking/citi-priority",
                                "title": "Citi Priority",
                                "title_es_US": "Citi Priority",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "https://www.privatebank.citibank.com/",
                                "title": "Citi Private Bank",
                                "title_es_US": "Citi Private Bank",
                                "domainMap": "default"
                            }
                        ]
                    },
                    {
                        "title": "Business Banking",
                        "title_es_US": "Servicios Bancarios para Empresas",
                        "links": [
                            {
                                "url": "/small-business/banking",
                                "title": "Small Business Accounts",
                                "title_es_US": "Cuentas para Pequeñas Empresas",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "https://www.citibank.com/commercialbank/en/index.html",
                                "title": "Commercial Accounts",
                                "title_es_US": "Cuentas Comerciales",
                                "domainMap": "default"
                            }
                        ]
                    },
                    {
                        "title": "Rates",
                        "title_es_US": "Tasas",
                        "links": [
                            {
                                "url": "/banking/current-interest-rates/savings-accounts",
                                "title": "Personal Banking",
                                "title_es_US": "Servicios Bancarios Personales",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "https://www.citi.com/credit-cards/compare-credit-cards/citi.action?ID=view-all-credit-cards",
                                "title": "Credit Cards",
                                "title_es_US": "Tarjetas de Crédito",
                                "domainMap": "default"
                            },
                            {
                                "url": "/mortgage/purchase-rates",
                                "title": "Mortgage",
                                "title_es_US": "Hipoteca",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/home-equity/rates",
                                "title": "Home Equity",
                                "title_es_US": "Préstamos con Garantía Hipotecaria",
                                "domainMap": "ssr"
                            },
                            {
                                "url": "/installment-loan",
                                "title": "Lending",
                                "title_es_US": "Préstamos",
                                "domainMap": "csr"
                            }
                        ]
                    },
                    {
                        "title": "Help &amp; Support",
                        "title_es_US": "Ayuda y Apoyo",
                        "chatLink": true,
                        "links": [
                            {
                                "url": "/contactus",
                                "title": "Contact Us",
                                "title_es_US": "Contáctanos",
                                "id": "navContactUs",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/helptopic",
                                "title": "Help &amp; FAQs",
                                "title_es_US": "Ayuda y Preguntas Frecuentes",
                                "domainMap": "csr"
                            },
                            {
                                "url": "/security-center",
                                "title": "Security Center",
                                "title_es_US": "Centro de Seguridad",
                                "domainMap": "csr"
                            },
                            {
                                "url": "https://online.citi.com/US/ag/military-servicemembers-civil-relief-act ",
                                "title": "Servicemembers Civil Relief Act (SCRA)",
                                "title_es_US": "Ley de Ayuda Civil para Miembros de las Fuerzas Armadas - SCRA",
                                "id": "navServicemembers",
                                "domainMap": "csr"
                            }
                        ]
                    }
                ]
            },
            "disclaimer": {
                "show": true,
                "text": "<h4>Important Legal Disclosures & Information</h4><p>Citibank.com provides information about and access to accounts and financial services provided by Citibank, N.A. and its affiliates in the United States and its territories. It does not, and should not be construed as, an offer, invitation or solicitation of services to individuals outside of the United States.</p><p>Terms, conditions and fees for accounts, products, programs and services are subject to change. Not all accounts, products, and services as well as pricing described here are available in all jurisdictions or to all customers. Your eligibility for a particular product and service is subject to a final determination by Citibank. Your country of citizenship, domicile, or residence, if other than the United States, may have laws, rules, and regulations that govern or affect your application for and use of our accounts, products and services, including laws and regulations regarding taxes, exchange and/or capital controls that you are responsible for following.</p><p>The products, account packages, promotional offers and services described in this website may not apply to customers of <a target=\"_blank\" class=\"link\" href=\"https://online.citi.com/JRS/portal/template.do?ID=international-personal-bank&l=en&locale=en_US\">International Personal Bank U.S.</a> in the Citigold<sup>&reg;</sup> Private Client International, Citigold<sup>&reg;</sup> International, Citi International Personal, Citi Global Executive Preferred, and Citi Global Executive Account Packages.</p><p>Deposit products and services are offered by Citibank, N.A., Member FDIC</p>",
                "text_es_US": "<h4>Important Legal Disclosures & Information</h4><p>Citibank.com provides information about and access to accounts and financial services provided by Citibank, N.A. and its affiliates in the United States and its territories. It does not, and should not be construed as, an offer, invitation or solicitation of services to individuals outside of the United States.</p><p>Terms, conditions and fees for accounts, products, programs and services are subject to change. Not all accounts, products, and services as well as pricing described here are available in all jurisdictions or to all customers. Your eligibility for a particular product and service is subject to a final determination by Citibank. Your country of citizenship, domicile, or residence, if other than the United States, may have laws, rules, and regulations that govern or affect your application for and use of our accounts, products and services, including laws and regulations regarding taxes, exchange and/or capital controls that you are responsible for following.</p><p>The products, account packages, promotional offers and services described in this website may not apply to customers of <a target=\"_blank\" class=\"link\" href=\"https://online.citi.com/JRS/portal/template.do?ID=international-personal-bank&l=es&locale=es_US\">International Personal Bank U.S.</a> in the Citigold<sup>&reg;</sup> Private Client International, Citigold<sup>&reg;</sup> International, Citi International Personal, Citi Global Executive Preferred, and Citi Global Executive Account Packages.</p><p>Deposit products and services are offered by Citibank, N.A., Member FDIC</p>"
            },
            "badgeNavigation": {
                "show": true,
                "badgeSections": [
                    {
                        "title": "badge",
                        "title_es_US": "badge",
                        "links": [
                            {
                                "title": "Googleplay",
                                "title_es_US": "Googleplay",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "label": "Get it on Google Play",
                                "label_es_US": "Descárgala en Google Play",
                                "showAppImage": true,
                                "speedbump": {
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas."
                                }
                            },
                            {
                                "title": "Appstore",
                                "title_es_US": "Appstore",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "label": "Download on the App Store",
                                "label_es_US": "Download on the App Store",
                                "showAppImage": true,
                                "speedbump": {
                                    "header": "Important Information",
                                    "header_es_US": "Importante Información",
                                    "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero?<br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas. "
                                }
                            },
                            {
                                "title": "JDPowerLogo",
                                "title_es_US": "JDPowerLogo",
                                "url": "/US/JRS/pands/detail.do?ID=citi-digital-services",
                                "imageUrl": "/CBOL/IA/Angular/assets/JD-power3x.png",
                                "label": "J.D. Power 2019 Mobile App Certification Program",
                                "label_es_US": "J.D. Power 2019 Mobile App Certification Program",
                                "showAppImage": true,
                                "speedbump": [
                                    {
                                        "header": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span>",
                                        "header_es_US": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span>",
                                        "copy": "J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span> recognition is based on successful completion of an audit and exceeding a customer experience benchmark through a survey of recent servicing interactions. For more information, visit ",
                                        "copy_es_US": "El reconocimiento que otorga J.D. Power 2019 Mobile App Certification Program&#8480;<span class='sr-only'>Service Mark</span> se basa en la ejecución satisfactoria de una auditoría y en la capacidad de exceder indicadores relativos a la satisfacción del cliente, que se miden a través de una encuesta sobre la interacción reciente con el servicio. Para obtener más información, visita ",
                                        "anchorText": "jdpower.com/awards",
                                        "anchorText_es_US": "jdpower.com/awards",
                                        "buttonText": "Continue",
                                        "buttonText_es_US": "Continuar",
                                        "url": ""
                                    },
                                    {
                                        "header": "Important Information",
                                        "header_es_US": "Importante Información",
                                        "copy": "You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site? <br><br>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.",
                                        "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros. ¿Deseas ir al sitio del tercero? <br><br>Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.",
                                        "anchorText": "",
                                        "anchorText_es_US": "",
                                        "buttonText": "Continue",
                                        "buttonText_es_US": "Continuar",
                                        "url": "http://www.jdpower.com/awards"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "title": "MobileJDPower",
                        "title_es_US": "MobileJDPower",
                        "url": "/US/JRS/pands/detail.do?ID=citi-digital-services",
                        "links": [],
                        "domainMap": "legacy"
                    },
                    {
                        "title": "socialmedia",
                        "title_es_US": "socialmedia",
                        "links": [
                            {
                                "name": "facebook",
                                "name_es_US": "facebook",
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "show": true,
                                "speedbump": {
                                    "url": "https://www.facebook.com/citibank",
                                    "header": "Important Information",
                                    "header_es_US": "Información Importante",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros.</p><p> ¿Deseas ir al sitio del tercero? Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                }
                            },
                            {
                                "name": "twitter",
                                "name_es_US": "twitter",
                                "show": true,
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "speedbump": {
                                    "url": "https://twitter.com/Citibank/",
                                    "header": "Important Information",
                                    "header_es_US": "Información Importante",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "<p>Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros.</p><p> ¿Deseas ir al sitio del tercero? Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                }
                            },
                            {
                                "name": "youtube",
                                "show": true,
                                "imageUrl": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg",
                                "speedbump": {
                                    "url": "https://www.youtube.com/citi",
                                    "header": "Important Information",
                                    "header_es_US": "Información Importante",
                                    "copy": "<p>You are leaving a Citi Website and going to a third party site. That site may have a privacy policy different from Citi and may provide less security than this Citi site. Citi and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?</p><p>Citi is not responsible for the products, services or facilities provided and/or owned by other companies.</p>",
                                    "copy_es_US": "Dejarás el Website de Citi y te diriges al sitio de un tercero. Este sitio podría tener políticas de privacidad diferentes de las de Citi y podría proporcionarte menos seguridad que el sitio de Citi. Citi y sus afiliadas no son responsables de los productos, servicios ni del contenido de los websites de terceros.</p><p> ¿Deseas ir al sitio del tercero? Citi no es responsable de los productos, servicios o atributos proporcionados y/o de propiedad de otras empresas.</p>",
                                    "buttonText": "Continue",
                                    "buttonText_es_US": "Continuar"
                                }
                            }
                        ]
                    }
                ]
            },
            "subNavigation": {
                "show": true,
                "copyright": {
                    "show": true,
                    "text": "&copy; 2018 Citigroup Inc",
                    "text_es_US": "&copy; 2018 Citigroup Inc"
                },
                "showFeedback": false,
                "feedbackWording": "Feedback",
                "navigation": {
                    "show": true,
                    "links": [
                        {
                            "url": "/termsdisclaimer/termsdisclaimerhome",
                            "title_es_US": "Términos y Condiciones",
                            "title": "Terms &amp; Conditions",
                            "id": "subnavTermsConditions",
                            "id_es_US": "subnavTermsConditions",
                            "domainMap": "csr"
                        },
                        {
                            "url": "/US/JRS/portal/template.do?ID=Privacy",
                            "title": "Privacy",
                            "title_es_US": "Intimidad",
                            "id": "subnavPrivacy",
                            "id_es_US": "subnavPrivacy",
                            "domainMap": "legacy"
                        },
                        {
                            "url": "/JRS/portal/template.do?ID=Privacy#notice-at-collection",
                            "title": "Notice at Collection",
                            "title_es_US": "Aviso de Recopilación",
                            "id": "subnavNoticeAtCollection",
                            "id_es_US": "subnavNoticeAtCollection",
                            "domainMap": "legacy"
                        },
                        {
                            "url": "/dataprivacyhub",
                            "title": "Do Not Sell or Share My Personal Information",
                            "title_es_US": "No Vender Ni Compartir mi Información Personal",
                            "id": "subnavPrivacyHub",
                            "id_ES_US": "subnavPrivacyHub",
                            "domainMap": "csr"
                        },
                        {
                            "url": "https://www.citi.com/credit-cards/compare-credit-cards/citi.action?ID=CMA-PIT",
                            "domainMap": "default",
                            "title": "Card Member Agreement",
                            "title_es_US": "Contrato del Tarjetahabiente",
                            "id": "subnavCardMemberAgreement"
                        },
                        {
                            "url": "/US/JRS/portal/template.do?ID=Accessibility",
                            "domainMap": "legacy",
                            "title": "Accessibility",
                            "title_es_US": "Accesibilidad",
                            "id": "subnavAccessibility"
                        }
                    ]
                }
            },
            "subFooter": {
                "images": {
                    "show": true,
                    "fdic": {
                        "url": "/CBOL/IA/Angular/assets/memberfdic.png",
                        "show": false
                    },
                    "equalHousing": {
                        "url": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_v1.svg"
                    },
                    "progressiveLogoImageMobile": {
                        "url": "/CBOL/IA/Angular/assets/citiredesign-footer.svg"
                    },
                    "progressiveLogoImageDesktop": {
                        "url": "/CBOL/IA/Angular/assets/citiredesign-footer.svg"
                    }
                }
            }
        }
    }
};
const localPreNavigation = {
    "preNavigation": {
        "show": true,
        "search": {
            "show": true,
            "action": "/US/JRS/globalsearch/Search.do",
            "placeholder": "What can we help you with?",
            "placeholder_es_US": "¿Qué podemos ayudarte?",
            "submitButtonText": "Go",
            "ariaDescribedBy": "Focus will shift to search input when pressed",
            "ariaDescribedBy_es_US": "El enfoque cambiará a la entrada de búsqueda cuando se presione",
            "ariaLabel": "Search",
            "title": "Search",
            "title_es_US": "Search",
            "id": "banSearch"
        },
        "navigationItems": [
            {
                "title": "Credit Cards",
                "title_es_US": "Tarjetas de Crédito",
                "id": "navcreditCard",
                "show": true,
                "navigationItems": [
                    {
                        "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                        "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                        "items": [
                            {
                                "title": "View All Credit Cards",
                                "title_es_US": "Ver Todas las Tarjetas de Crédito",
                                "url": "/credit-cards/compare/view-all-credit-cards?intc=citihpmenu~creditcards~vac",
                                "id": "navViewCrds",
                                "show": true,
                                "domainMap": "mkr"
                            },
                            {
                                "title": "Balance Transfer Credit Cards",
                                "title_es_US": "Tarjetas de Crédito para Transferencias de Saldo",
                                "url": "/credit-cards/compare/balance-transfer-credit-cards?intc=citihpmenu~creditcards~bt",
                                "id": "navBalTrans",
                                "domainMap": "mkr"
                            },
                            {
                                "title": "0% Intro APR Credit Cards",
                                "title_es_US": "Tarjetas de Crédito con 0% APR Inicial",
                                "url": "/credit-cards/compare/0-percent-intro-apr-credit-cards?intc=citihpmenu~creditcards~intro",
                                "id": "navLowinterest",
                                "domainMap": "mkr"
                            },
                            {
                                "title": "Rewards Credit Cards",
                                "title_es_US": "Tarjetas de Crédito con Recompensas",
                                "url": "/credit-cards/compare/rewards-credit-cards?intc=citihpmenu~creditcards~rewards",
                                "id": "navRewCred",
                                "domainMap": "mkr"
                            },
                            {
                                "title": "Cash Back Credit Cards",
                                "title_es_US": "Tarjetas de Crédito con Reembolsos en Efectivo",
                                "url": "/credit-cards/compare/savings-and-cash-back-credit-cards?intc=citihpmenu~creditcards~cash",
                                "id": "navCashBackCre",
                                "domainMap": "mkr"
                            },
                            {
                                "title": "Travel Credit Cards",
                                "title_es_US": "Tarjetas de Crédito para Viajes",
                                "url": "/credit-cards/compare/travel-reward-credit-cards?intc=citihpmenu~creditcards~travel",
                                "id": "navTravelCreds",
                                "domainMap": "mkr"
                            },
                            {
                                "title": "Retail Store Cards",
                                "title_es_US": "Tarjetas de Tiendas Minoristas",
                                "url": "/credit-cards/compare/retail-store-credit-cards?intc=citihpmenu~creditcards~crs",
                                "id": "navRetailStoreCards",
                                "domainMap": "mkr"
                            },
                            {
                                "title": "Small Business Credit Cards",
                                "title_es_US": "Tarjetas de Crédito para Pequeñas Empresas",
                                "url": "/credit-cards/compare/business-credit-cards?intc=citihpmenu~creditcards~smallbus",
                                "id": "navSmallBusinessCreditCards",
                                "domainMap": "mkr"
                            }
                        ],
                        "quickLinks": [
                            {
                                "linkId": "ktCenter",
                                "linkText": "Citi<sup id='reg' aria-hidden='true'>&reg;</sup> Credit Knowledge Center",
                                "linkText_es_US": "Centro de Información sobre Crédito de Citi<sup id='reg' aria-hidden='true'>&reg;</sup>",
                                "url": "/credit-cards/knowledge-center",
                                "domainMap": "mkr",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "prequalified",
                                "linkText": "See If You’re Pre-Qualified",
                                "linkText_es_US": "Consulta Si Ya Precalificas",
                                "url": "/cards/pre-screen?OC=CC-CITI-3D5&intc=citihpmenu_creditcards_pq",
                                "domainMap": "csr",
                                "linkimage": "/CBOL/IA/Angular/assets/029-document-check-grey.svg"
                            },
                            {
                                "linkId": "mailOffer",
                                "linkText": "Respond to Mail Offer",
                                "linkText_es_US": "Responder a una Oferta Recibida por Correo",
                                "url": "https://www.citicards.com/cards/credit/application/flow.action?isInvitation=Y",
                                "domainMap": "default",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Banking",
                "title_es_US": "Servicios Bancarios",
                "id": "navbanking",
                "show": true,
                "navigationItems": [
                    {
                        "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                        "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                        "items": [
                            {
                                "title": "Checking",
                                "title_es_US": "Cuenta de Cheques",
                                "url": "/banking/checking-account?intc=citihpmenu_overview_checking",
                                "id": "navchkin",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Savings",
                                "title_es_US": "Cuenta de Ahorros",
                                "url": "/banking/savings-account?intc=citihpmenu_overview_savings",
                                "id": "navsavin",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Banking Overview ",
                                "title_es_US": "Descripción General de Servicios Bancarios",
                                "url": "/banking/bank-accounts?intc=citihpmenu_overview_banking",
                                "id": "navbnkOvr",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Certificates of Deposit",
                                "title_es_US": "Certificados de Depósito",
                                "url": "/banking/cd-account?intc=citihpmenu_overview_CD",
                                "id": "navCertificatesDeposit",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Banking IRAs",
                                "title_es_US": "Cuentas IRA Bancarias",
                                "url": "/banking/ira?intc=citihpmenu_overview_IRA",
                                "id": "navBankingIRAs",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Rates",
                                "title_es_US": "Tasas",
                                "url": "/banking/current-interest-rates/savings-accounts?intc=citihpmenu_overview_rates",
                                "id": "navRates",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Small Business Banking",
                                "title_es_US": "Servicios Bancarios para Pequeñas Empresas",
                                "url": "/small-business/banking?intc=citihpmenu_overview_smallbusiness",
                                "id": "navSmlBusBank",
                                "domainMap": "ssr"
                            }
                        ],
                        "quickLinks": [
                            {
                                "linkId": "personalBankingGuide",
                                "linkText": "Personal Banking Guide",
                                "linkText_es_US": "Personal Banking Guide",
                                "url": "https://www.citi.com/banking/personal-banking-guide",
                                "domainMap": "default",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "citiBonusOffers",
                                "linkText": "Citi<sup id='reg'>&reg;</sup> Bonus Offers",
                                "linkText_es_US": "Ofertas Adicionales de Citi<sup id='reg'>&reg;</sup>",
                                "url": "/banking/special-offers?intc=citihpmenu_overview_special-offers",
                                "domainMap": "csr",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Lending",
                "title_es_US": "Préstamos",
                "id": "navlending",
                "show": true,
                "navigationItems": [
                    {
                        "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                        "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                        "items": [
                            {
                                "title": "Personal Loans",
                                "title_es_US": "Préstamos Personales",
                                "url": "https://banking.citi.com/lending/loans/personal-loans/onsite/default.htm?affcode=CLN&intc=globalnav_pil_lob_prelogin",
                                "id": "navPerLoanCred",
                                "domainMap": "default"
                            },
                            {
                                "title": "Overdraft Line of Credit",
                                "title_es_US": "Línea de Crédito para Sobregiros",
                                "url": "/US/JRS/pands/detail.do?ID=CheckingPlus",
                                "id": "navOverdraftLineCredit",
                                "domainMap": "legacy"
                            },
                            {
                                "title": "Home Lending",
                                "title_es_US": "Préstamos para Viviendas",
                                "url": "/mortgage/home-mortgage",
                                "id": "navHomeLending",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Buy a Home",
                                "title_es_US": "Comprar una Vivienda",
                                "url": "/mortgage/buying-a-home",
                                "id": "navBuyaHome",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Refinance Your Home",
                                "title_es_US": "Refinanciar Tu Vivienda",
                                "url": "/mortgage/refinancing-your-home",
                                "id": "navRefYourHome",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Use Your Home Equity",
                                "title_es_US": "Usa Tu Préstamo con Garantía Hipotecaria",
                                "url": "/home-equity/line-of-credit",
                                "id": "navHmEqt",
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Small Business Lending",
                                "title_es_US": "Préstamos para Pequeñas Empresas",
                                "url": "/small-business/loans?intc=citihpmenu_lending_smallbusiness",
                                "id": "navSmlBusLend",
                                "domainMap": "ssr"
                            }
                        ],
                        "quickLinks": [
                            {
                                "linkId": "mortCalc",
                                "linkText": "Mortgage Calculators",
                                "linkText_es_US": "Calculadoras para Hipotecas",
                                "url": "/mortgage/refinance-and-mortgage-calculators",
                                "domainMap": "ssr",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "hec",
                                "linkText": "Home Equity Calculators",
                                "linkText_es_US": "Calculadoras para Préstamos con Garantía Hipotecaria",
                                "url": "/home-equity/calculators",
                                "domainMap": "ssr",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "mlc",
                                "linkText": "Mortgage Learning Center",
                                "linkText_es_US": "Centro de Aprendizaje sobre Hipotecas",
                                "url": "/mortgage/learning-center",
                                "domainMap": "ssr",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "plc",
                                "linkText": "Personal Loans Center",
                                "linkText_es_US": "Centro para Préstamos Personales",
                                "url": "https://www.citi.com/personal-loans/learning-center",
                                "domainMap": "default",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Investing",
                "title_es_US": "Inversiones",
                "id": "investing",
                "show": true,
                "navigationItems": [
                    {
                        "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                        "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                        "items": [
                            {
                                "title": "Investing Overview",
                                "title_es_US": "Panorama de Inversión",
                                "url": "/investing/investingwithciti",
                                "id": "navInvst",
                                "domainMap": "csr"
                            },
                            {
                                "title": "Self-Directed Investing",
                                "title_es_US": "Inversión Autodirigida",
                                "url": "/citi-self-invest",
                                "id": "navSelfDirectedTrad",
                                "domainMap": "csr"
                            },
                            {
                                "title": "Guided Investing",
                                "title_es_US": "Inversión Guiada",
                                "url": "/cwb?entry=topnav",
                                "id": "navCitiWealthBuild",
                                "domainMap": "csr"
                            },
                            {
                                "title": "Working with an Advisor",
                                "title_es_US": "Trabajando con un Asesor",
                                "url": "/mgp/cwamarketing",
                                "id": "navWrkWithAdvs",
                                "domainMap": "csr"
                            }
                        ],
                        "quickLinks": [
                            {
                                "linkId": "finPlan",
                                "linkText": "Planning Tools",
                                "linkText_es_US": "Herramientas de Planificación",
                                "url": "/US/JRS/pands/detail.do?ID=FinancialPlanningTools&JFP_TOKEN=PD3BPM40",
                                "domainMap": "legacy",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "marketIns",
                                "linkText": "Market Insights",
                                "linkText_es_US": "Perspectivas del Mercado",
                                "url": "https://marketinsights.citi.com/",
                                "domainMap": "default",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "invIns",
                                "linkText": "Investments & Insurance",
                                "linkText_es_US": "Inversiones y Seguros",
                                "url": "/US/JRS/pands/detail.do?ID=InvestingProducts&JFP_TOKEN=PZKYHT3Q",
                                "domainMap": "legacy",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            }
                        ]
                    }
                ]
            },
            {
                "title": "Wealth Management",
                "title_es_US": "Gestión de Patrimonios",
                "id": "wealthMgmnt",
                "show": true,
                "navigationItems": [
                    {
                        "subTitle": "<div role='heading' aria-level='2'>Quick Links</div>",
                        "subTitle_es_US": "<div role='heading' aria-level='2'>Enlaces Rápidos</div>",
                        "items": [
                            {
                                "title": "Citigold",
                                "title_es_US": "Citigold",
                                "url": "/banking/citigold?intc=citihpmenu_overview_citigold",
                                "id": "navCitGold",
                                "image": false,
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Citigold<sup>&reg;</sup> Private Client",
                                "title_es_US": "Citigold<sup>&reg;</sup> Private Client",
                                "url": "/banking/citigold-private-client?intc=citihpmenu_overview_citigold-private-client",
                                "id": "navCitiGoldPrivCli",
                                "image": false,
                                "domainMap": "ssr"
                            },
                            {
                                "title": "Citi Priority",
                                "title_es_US": "Citi Priority",
                                "url": "/banking/citi-priority?intc=citihpmenu_overview_citi-priority",
                                "id": "navCitiPriority",
                                "image": false,
                                "domainMap": "ssr"
                            }
                        ],
                        "quickLinks": [
                            {
                                "linkId": "findRelMan",
                                "linkText": "Find a Wealth Team",
                                "linkText_es_US": "Buscar un Equipo de Gestión de Patrimonios",
                                "url": "https://contactcitigold.citi.com/",
                                "domainMap": "default",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            },
                            {
                                "linkId": "citiWelAdv",
                                "linkText": "Planning Tools",
                                "linkText_es_US": "Herramientas de Planificación",
                                "url": "/US/JRS/pands/detail.do?ID=FinancialPlanningTools&JFP_TOKEN=PD3BPM40",
                                "domainMap": "legacy",
                                "linkimage": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v1.svg"
                            }
                        ],
                        "subDiv": {
                            "image": "",
                            "subNavItemsDivTitle": "Invest In Your Future With Citi",
                            "subNavItemsDivDescription": "Open an Investment Account with Citi and take advantage of personalized guidance.",
                            "subNavItemsDivLearnMore": "Learn more"
                        }
                    }
                ]
            },
            {
                "title": "ATM / BRANCH",
                "title_es_US": "ATM / SUCURSAL",
                "url": "/citibank-location-finder",
                "className": "ATMBranch",
                "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                "id": "butlerATM",
                "show": true,
                "domainMap": "csr"
            },
            {
                "title": "ENGLISH",
                "title_es_US": "ENGLISH",
                "url": "",
                "urlSuffix": "?locale=en_US",
                "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                "className": "espanolLink",
                "id": "butlerEspanol",
                "show": true,
                "locale": "es_US"
            },
            {
                "title": "ESPAÑOL",
                "title_es_US": "ENGLISH",
                "url": "",
                "className": "espanolLink",
                "id": "butlerEspanol",
                "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                "show": true,
                "speedbump": {
                    "urlSuffix": "?locale=es_US",
                    "url": "/US/login.do?locale=es_US",
                    "header": "Notificación importante",
                    "buttonText": "<span lang='es'>Continuar</span>",
                    "buttonTarget": "_self",
                    "copy": "<p lang='es'><strong>Por favor, tenga en cuenta que es posible que las comunicaciones futuras del banco, ya sean verbales o escritas, sean únicamente en inglés. Estas comunicaciones podrían incluir, entre otras, contratos de cuentas, estados de cuenta y divulgaciones, así como cambios en términos o cargos o cualquier tipo de servicio para su cuenta. Además, es posible que algunas secciones de este website permanezcan en inglés.</strong></p><hr><p>Please be advised that future verbal and written communications from the bank may be in English only. These communications may include, but are not limited to, account agreements, statements and disclosures, changes in terms or fees; or any servicing of your account. Additionally, some sections of this site may remain in English. </p>"
                },
                "locale": "en_US"
            },
            {
                "title": "Open an Account",
                "title_es_US": "Abrir una Cuenta",
                "url": "/banking/bank-accounts?intc=citihpmenu_overview_bank-accounts",
                "id": "navOpenAcc",
                "show": true,
                "domainMap": "ssr"
            }
        ],
        "help": {
            "title": "How can we help?",
            "title_es_US": "¿Cómo podemos ayudar?",
            "show": true
        },
        "sign": {
            "fallback": true,
            "show": true,
            "signOnWording": "Sign On",
            "signOnWording_es_US": "Ingresar",
            "signOffWording": "Sign Off",
            "signOffWording_es_US": "Salir",
            "signOnUrl": "/US/login.do",
            "signOffUrl": "/US/JSO/signoff/SummaryRecord.do?logOff=true",
            "ngaSignOffUrl": "/sign-off",
            "showSignModal": true,
            "wording": "Sign On",
            "signOnSSRRedirection": true,
            "modal": {
                "title": "Sign On",
                "title_es_US": "Ingresar",
                "id": "navSignOn",
                "action": "/signon.do",
                "buttonText": "Sign On",
                "buttonText_es_US": "Ingresar",
                "usernameName": "username",
                "usernamePlaceholder": "User ID",
                "usernamePlaceholder_es_US": "ID de Usuario",
                "passwordName": "password",
                "passwordPlaceholder": "Password",
                "passwordPlaceholder_es_US": "ContraseÃ±a",
                "rememberIdName": "rememberid",
                "rememberIdText": "Remember my User ID",
                "rememberIdText_es_US": "Recordar mi ID de Usuario",
                "userIdMinChars": 3,
                "userIdBlankError": "Enter a User Id",
                "userIdBlankError_es_US": "Ingresa ID de Usuario",
                "userIdShortError": "Your User ID must be greater than 2 characters",
                "userIdShortError_es_US": "Tu IdentificaciÃ³n de usuario debe tener mÃ¡s de 2 caracteres",
                "passwordMinChars": 6,
                "passwordBlankError": "Enter a Password",
                "passwordBlankError_es_US": "Ingresa una Contraseña",
                "passwordShortError": "Your password must be at least 6 characters long",
                "passwordShortError_es_US": "Tu Contraseña debe tener un minimo de 6 caracteres",
                "rememberText": "Do not select if you are using a public computer.",
                "rememberText_es_US": "No la selecciones si estÃ¡s usando una computadora pÃºblica.",
                "forgotUser": {
                    "text": "Forgot User ID?",
                    "action": "/US/JSO/uidn/RequestUserIDReminder.do?fuipFlowInd=userID"
                },
                "forgotPassword": {
                    "text": "Forgot Password?",
                    "text_es_US": "OlvidÃ© ID de Usuario",
                    "action": "/US/JSO/uidn/RequestUserIDReminder.do?fuipFlowInd=pwd"
                },
                "activateCard": {
                    "text": "Activate a Card",
                    "text_es_US": "OlvidÃ© Contraseña",
                    "action": "/US/ag/activate/index"
                },
                "registerOnline": {
                    "text": "Register for Online Access",
                    "text_es_US": "RegÃ­strate para el Acceso en LÃ­nea",
                    "action": "/JSO/reg/Setup.do?"
                },
                "existingUsers": {
                    "usernames": [
                        "short"
                    ],
                    "addUserText": "A different User",
                    "addUserText_es_US": "Un Usuario diferente",
                    "deleteUserText": "Clear a User ID",
                    "deleteUserText_es_US": "Borrar un ID de Usuario",
                    "deleteUserUrl": "/US/JSO/signon/DeleteUsername.do"
                }
            }
        }
    }
};
const localPostNavigation = {
    "postNavigation": {
        "overview": {
            "description": "Overview",
            "description_es_US": "Generalidades",
            "accountInstanceId": "none",
            "navigationURL": "/US/ag/mrc/dashboard",
            "domainMap": "csr",
            "completeDescription": "Overview",
            "featureflag": "ff_singlecardevolutionoct",
            "completeDescription_es_US": "Generalidades",
            "navigationId": "accountsoverview"
        },
        "seeMoreOptions": {
            "description": "See All Accounts",
            "description_es_US": "Ver Todas las cuentas",
            "accountInstanceId": "none",
            "navigationURL": "/US/ag/mrc/dashboard",
            "domainMap": "csr",
            "completeDescription": "See More Accounts",
            "completeDescription_es_US": "Ver Todas las cuentas"
        },
        "navigationItems": [
            {
                "order": 1,
                "title": "Accounts",
                "title_es_US": "Cuentas",
                "id": "accounts",
                "navigationItems": []
            },
            {
                "order": 2,
                "title": "Payments & Transfers",
                "title_es_US": "Pagos y Transferencias",
                "title_onlyCZ4": "Transfers",
                "title_es_US_onlyCZ4": "Transferencias",
                "featureflag": "paymentsAndTransfers",
                "customContent": true,
                "id": "pnt",
                "navigationItems": [
                    {
                        "title": "Payments",
                        "title_es_US": "Pagos",
                        "isSubtitle": true,
                        "featureflag": "ff_NavPayments",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Your External Accounts",
                        "title_es_US": "Tus Cuentas Externas",
                        "featureflag": "ff_transferBrokerageOnly",
                        "url": "/iitTfr/domestic/input",
                        "domainMap": "csr"
                    },
                    {
                        "title": "Activity",
                        "title_es_US": "Actividad",
                        "featureflag": "ff_activityBrokerageOnly",
                        "url": "/transhistory/transCommon/list?transactionType=IIT",
                        "domainMap": "csr"
                    },
                    {
                        "title": "Payments Dashboard",
                        "title_es_US": "Pantalla de Pagos",
                        "featureflag": "paymentsDashboard",
                        "url": "/paymentHub/landing",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Payments & Transfer Activity",
                        "title_es_US": "Actividad de Pagos y Transferencias",
                        "featureflag": "paymentActivity",
                        "url": "/transhistory/transCommon/pntactivity",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Pay Bills",
                        "title_es_US": "Pagar Facturas",
                        "featureflag": "ff_PayBillsCDOnly",
                        "url": "/US/jba/mp4/InitializeSubApp.do?TTC=23",
                        "domainMap": "legacy",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Pay Bills",
                        "title_es_US": "Pagar Facturas",
                        "featureflag": "payBills",
                        "url": "/paymentHub/upcomingAndAllBillPayees",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Pay Citi Credit Cards",
                        "title_es_US": "Pagar Tarjetas de Crédito Citi",
                        "url": "/payments/crecarpay/input",
                        "featureflag": "payCitiCreditCards",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Manage Payees",
                        "title_es_US": "Administrar Beneficiarios",
                        "featureflag": "ff_ManagePayeesCDOnly",
                        "url": "/US/CBOL/pnt/mngpayee/flow.action?jfp.layout=AppBodyAndFAQ",
                        "domainMap": "legacy",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Manage Payees",
                        "title_es_US": "Administrar Beneficiarios",
                        "featureflag": "managePayees",
                        "url": "/paymentHub/managePayee?action=billstab",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Manage Auto Deduct",
                        "title_es_US": "Administrar Auto Deduct",
                        "featureflag": "manageAutoDeduct",
                        "url": "/autoDeduct",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Personal Loan Autopay",
                        "title_es_US": "Préstamo Personal AutoPay",
                        "featureflag": "ff_managePilAutoPay",
                        "url": "/autopay",
                        "domainMap": "csr",
                        "subtitleId": "payments",
                        "subtitleId_es_US": "pagos"
                    },
                    {
                        "title": "Transfers",
                        "title_es_US": "Transferencias",
                        "isSubtitle": true,
                        "subtitleId": "transfers",
                        "featureflag": "ff_NavTransfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Your Citi Accounts",
                        "title_es_US": "Tus Cuentas Citi",
                        "featureflag": "ff_YourCitiAccountsCDOnly",
                        "url": "/US/jba/mt/InitializeSubApp.do?TTC=7",
                        "domainMap": "legacy",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Your Citi Accounts",
                        "title_es_US": "Tus Cuentas Citi",
                        "featureflag": "citiAccounts",
                        "url": "/paymentHub/landing?ID=accounts",
                        "domainMap": "csr",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Your External Accounts",
                        "title_es_US": "Tus Cuentas Externas",
                        "url": "/iitTfr/domestic/input",
                        "domainMap": "csr",
                        "featureflag": "yourExternalAccounts",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Wires & Transfers",
                        "title_es_US": "Transferencias Cablegráficas y de Otro Tipo",
                        "featureflag": "ff_AnyCitiAccountsCDOnly",
                        "url": "/US/jba/ic/ICTFR.do",
                        "domainMap": "legacy",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Wires & Transfers",
                        "title_es_US": "Transferencias Cablegráficas y de Otro Tipo",
                        "url": "/paymentHub/landing?ID=payee",
                        "featureflag": "ff_AnyCitiAccounts",
                        "domainMap": "csr",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Any External Account",
                        "title_es_US": "Cualquier Cuenta Externa",
                        "url": "/citi-partner-sso/iframe/bluewires",
                        "domainMap": "csr",
                        "featureflag": "ff_AnyExternalAccountsOther",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Any External Account",
                        "title_es_US": "Cualquier Cuenta Externa",
                        "url": "/paymentHub/landing?ID=payee",
                        "featureflag": "anyExternalAccounts",
                        "domainMap": "csr",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Balance Transfers",
                        "title_es_US": "Transferencias de Saldo",
                        "featureflag": "balanceTransfers",
                        "url": "/btlanding",
                        "domainMap": "csr",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Send Money with Zelle<sup>&#174;</sup>",
                        "title_es_US": "Enviar Dinero con Zelle<sup>&#174;</sup>",
                        "featureflag": "sendWithZelle",
                        "url": "/zelle/transfer",
                        "domainMap": "csr",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    },
                    {
                        "title": "Transfer My Investments to Citi",
                        "title_es_US": "Transferir Mis Inversiones a Citi",
                        "url": "/acat",
                        "domainMap": "csr",
                        "featureflag": "ff_acat",
                        "subtitleId": "transfers",
                        "subtitleId_es_US": "transferencias"
                    }
                ]
            },
            {
                "order": 3,
                "title": "Services",
                "title_es_US": "Servicios",
                "featureflag": "ff_NavServices",
                "id": "services",
                "navigationItems": [
                    {
                        "title": "Banking Services",
                        "title_es_US": "Servicios Bancarios",
                        "url": "/servicing/index?pageName=BankingServices",
                        "domainMap": "csr",
                        "featureflag": "bankingServices",
                        "customContent": true
                    },
                    {
                        "title": "Credit Card Services",
                        "title_es_US": "Servicios de Tarjeta de Crédito",
                        "url": "/servicing/index?pageName=CreditCardServices",
                        "domainMap": "csr",
                        "featureflag": "creditCardServices"
                    },
                    {
                        "title": "Investment Services",
                        "title_es_US": "Servicios de Inversión",
                        "url": "/servicing/index?pageName=InvestmentServices",
                        "domainMap": "csr",
                        "featureflag": "ff_investmentServices"
                    },
                    {
                        "title": "Travel Services",
                        "title_es_US": "Servicios de Viaje",
                        "url": "/tranotview?pageName=travelServices",
                        "domainMap": "csr",
                        "featureflag": "travelServices"
                    },
                    {
                        "title": "Statements & Documents",
                        "title_es_US": "Estados de Cuenta y Documentos",
                        "url": "/servicing/index?pageName=StatementsAndDocumentServices",
                        "domainMap": "csr",
                        "featureflag": "ff_NavStatementsAndDocuments"
                    },
                    {
                        "title": "Security Center",
                        "title_es_US": "Centro de Seguridad",
                        "url": "/security-center",
                        "domainMap": "csr",
                        "featureflag": "ff_security_center"
                    },
                    {
                        "title": "Fraud & Scam Updates",
                        "title_es_US": "Novedades sobre Fraudes y Estafas",
                        "url": "/fraudprevention",
                        "domainMap": "ssr",
                        "featureflag": "ff_endpoint"
                    },
                    {
                        "title": "Financial Resource Center",
                        "title_es_US": "Financial Resource Center",
                        "url": "/financial-resource-center",
                        "featureflag": "ff_financialResourceCenter",
                        "domainMap": "csr"
                    }
                ]
            },
            {
                "order": 4,
                "title": "Explore Products",
                "title_es_US": "Explorar Productos",
                "id": "expProducts",
                "parentTitle": "exploreProducts",
                "featureflag": "ff_NavExploreProduct",
                "navigationItems": [
                    [
                        {
                            "title": "Checking & Savings",
                            "title_es_US": "Cuentas de Cheques y Ahorros",
                            "isSubtitle": true,
                            "subtitleId": "Checking & Savings",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros",
                            "url": "",
                            "target": "_self",
                            "featureflag": "ff_NavProductCheckingSavings",
                            "id": "checkNsavg"
                        },
                        {
                            "title": "Banking Overview",
                            "title_es_US": "Descripción General de Servicios Bancarios",
                            "url": "/banking/bank-accounts?intc=citihpmenu_overview_banking",
                            "domainMap": "ssr",
                            "subtitleId": "Checking & Savings",
                            "featureflag": "ff_NavBankingOverview",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros"
                        },
                        {
                            "title": "Checking",
                            "title_es_US": "Cuentas de Cheques",
                            "url": "/banking/checking-account?intc=citihpmenu_overview_checking",
                            "domainMap": "ssr",
                            "subtitleId": "Checking & Savings",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros",
                            "featureflag": "ff_NavCheckingAccount"
                        },
                        {
                            "title": "Savings",
                            "title_es_US": "Cuentas de Ahorros",
                            "url": "/banking/savings-account?intc=citihpmenu_overview_savings",
                            "domainMap": "ssr",
                            "subtitleId": "Checking & Savings",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros",
                            "featureflag": "ff_NavSavingAccount"
                        },
                        {
                            "title": "CDs",
                            "title_es_US": "Certificados de Depósito (CD)",
                            "url": "/banking/cd-account?intc=citihpmenu_overview_CD",
                            "domainMap": "ssr",
                            "subtitleId": "Checking & Savings",
                            "featureflag": "ff_NavCDs",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros"
                        },
                        {
                            "title": "IRAs",
                            "title_es_US": "Cuentas de Retiro Individual (IRA)",
                            "url": "/US/banking/cd-ira/citi.action?ID=citi-ira",
                            "domainMap": "legacy",
                            "subtitleId": "Checking & Savings",
                            "featureflag": "ff_NavIRAs",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros"
                        },
                        {
                            "title": "Rates",
                            "title_es_US": "Tasas",
                            "url": "/banking/current-interest-rates/savings-accounts?intc=citihpmenu_overview_rates",
                            "domainMap": "ssr",
                            "featureflag": "ff_NavRates",
                            "subtitleId": "Checking & Savings",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros"
                        },
                        {
                            "title": "Small Business",
                            "title_es_US": "Pequeñas Empresas",
                            "url": "/small-business/banking?intc=1_5_51_2_BANR_2_SMB_HP_SMB_Banking",
                            "domainMap": "ssr",
                            "subtitleId": "Checking & Savings",
                            "subtitleId_es_US": "Cuentas de Cheques y Ahorros",
                            "featureflag": "ff_NavSmallBusiness"
                        }
                    ],
                    [
                        {
                            "title": "Credit Cards",
                            "title_es_US": "Tarjetas de Crédito",
                            "isSubtitle": true,
                            "subtitleId": "Credit Cards",
                            "subtitleId_es_US": "Tarjetas de Crédito",
                            "featureflag": "ff_NavCreditCards",
                            "url": "",
                            "target": "_self",
                            "id": "ccds"
                        },
                        {
                            "title": "View All Credit Cards",
                            "title_es_US": "Ver Todas las Tarjetas de Crédito",
                            "url": "https://www.citi.com/credit-cards/compare/view-all-credit-cards?intc=citihpmenu~creditcards~vac",
                            "domainMap": "default",
                            "subtitleId": "Credit Cards",
                            "subtitleId_es_US": "Tarjetas de Crédito",
                            "featureflag": "ff_NavViewAllCreditCards"
                        },
                        {
                            "title": "Rewards",
                            "title_es_US": "Recompensas",
                            "url": "https://www.citi.com/credit-cards/compare/rewards-credit-cards?intc=citihpmenu~creditcards~rewards",
                            "domainMap": "default",
                            "subtitleId": "Credit Cards",
                            "subtitleId_es_US": "Tarjetas de Crédito",
                            "featureflag": "ff_NavRewards"
                        },
                        {
                            "title": "0% Intro APR",
                            "title_es_US": "0% APR Inicial",
                            "url": "https://www.citi.com/credit-cards/compare/0-percent-intro-apr-credit-cards?intc=citihpmenu~creditcards~intro",
                            "domainMap": "default",
                            "subtitleId": "Credit Cards",
                            "subtitleId_es_US": "Tarjetas de Crédito",
                            "featureflag": "ff_Nav0%IntroAPR"
                        },
                        {
                            "title": "Balance Transfer",
                            "title_es_US": "Transferencias de Saldo",
                            "url": "https://www.citi.com/credit-cards/compare/balance-transfer-credit-cards?intc=citihpmenu~creditcards~smallbus",
                            "domainMap": "default",
                            "subtitleId": "Credit Cards",
                            "subtitleId_es_US": "Tarjetas de Crédito",
                            "featureflag": "ff_NavBalanceTransfer"
                        },
                        {
                            "title": "Small Business",
                            "title_es_US": "Pequeñas Empresas",
                            "url": "https://www.citi.com/credit-cards/compare/business-credit-cards?intc=citihpmenu~creditcards~smallbus",
                            "domainMap": "default",
                            "subtitleId": "Credit Cards",
                            "subtitleId_es_US": "Tarjetas de Crédito",
                            "featureflag": "ff_NavSmallBusiness"
                        }
                    ],
                    [
                        {
                            "title": "Investing",
                            "title_es_US": "Inversiones",
                            "isSubtitle": true,
                            "subtitleId": "Investing",
                            "subtitleId_es_US": "Inversiones",
                            "featureflag": "ff_NavInvesting",
                            "url": "",
                            "target": "_self",
                            "id": "invstng"
                        },
                        {
                            "title": "Self-Directed Investing",
                            "title_es_US": "Inversión Autodirigida",
                            "url": "/citi-self-invest",
                            "domainMap": "csr",
                            "subtitleId": "Investing",
                            "featureflag": "ff_NavSelfDirectedTrading",
                            "subtitleId_es_US": "Inversiones"
                        },
                        {
                            "title": "Guided Investing",
                            "title_es_US": "Inversión Guiada",
                            "url": "/cwb?entry=topnav",
                            "domainMap": "csr",
                            "featureflag": "ff_NavRoboAdvisor",
                            "subtitleId": "Investing",
                            "subtitleId_es_US": "Inversiones"
                        },
                        {
                            "title": "Working with an Advisor",
                            "title_es_US": "Trabajando con un Asesor",
                            "url": "/mgp/cwamarketing",
                            "domainMap": "csr",
                            "featureflag": "ff_NavWorkingwithanAdvisor",
                            "subtitleId": "Investing",
                            "subtitleId_es_US": "Inversiones"
                        }
                    ],
                    [
                        {
                            "title": "Lending",
                            "title_es_US": "Préstamos",
                            "isSubtitle": true,
                            "subtitleId": "Lending",
                            "subtitleId_es_US": "Préstamos",
                            "featureflag": "ff_NavLending",
                            "url": "",
                            "target": "_self",
                            "id": "lndg"
                        },
                        {
                            "title": "Personal Installment Loan",
                            "title_es_US": "Préstamo Personal a Plazos",
                            "url": "/lending/landingroute?intc=pil_topnav",
                            "domainMap": "csr",
                            "featureflag": "ff_NavPersonalInstallmentLoan",
                            "subtitleId": "Lending",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Flex Loan",
                            "title_es_US": "Flex Loan",
                            "url": "/citi-flex-loan/customizeloan",
                            "domainMap": "csr",
                            "featureflag": "flexLoanOffer",
                            "subtitleId": "Lending",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Flex Pay",
                            "title_es_US": "Flex Pay",
                            "url": "/citi-flex-pay/select-transaction",
                            "domainMap": "csr",
                            "subtitleId": "Lending",
                            "featureflag": "flexPayOffer",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Balance Transfer",
                            "title_es_US": "Transferencias de Saldo",
                            "url": "/btlanding",
                            "domainMap": "csr",
                            "featureflag": "balanceTransfers",
                            "subtitleId": "Lending",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Credit Line Increase",
                            "title_es_US": "Aumento de Línea de Crédito",
                            "url": "/US/ag/creditlineincrease?aoOfferParams=screenId:jJRSMENU_BenefitsAndServices|offerName:EC_P_ICLI_11142_1N|locID:SERVICING|offerID:ICLIGENR00|offerCat:CLI|origin:COR|flowOrigin:AccountServicing",
                            "domainMap": "legacy",
                            "subtitleId": "Lending",
                            "featureflag": "requestCLI",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Mortgages",
                            "title_es_US": "Hipoteca",
                            "url": "/mortgage/purchase-rates",
                            "domainMap": "ssr",
                            "subtitleId": "Lending",
                            "featureflag": "ff_NavMortgages",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Home Equity",
                            "title_es_US": "Garantía hipotecaria",
                            "url": "/home-equity/line-of-credit",
                            "domainMap": "ssr",
                            "featureflag": "ff_NavHomeEquity",
                            "subtitleId": "Lending",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Promotional Purchase Rate Offer",
                            "title_es_US": "Tasa Promocional para Compras",
                            "url": "/rate-sale",
                            "domainMap": "csr",
                            "featureflag": "promotionalPurchaseOffer",
                            "subtitleId": "Lending",
                            "subtitleId_es_US": "Préstamos"
                        },
                        {
                            "title": "Small Business",
                            "title_es_US": "Pequeñas Empresas",
                            "url": "/small-business/loans?intc=citihpmenu_lending_smallbusiness",
                            "domainMap": "ssr",
                            "subtitleId": "Lending",
                            "featureflag": "ff_NavSmallBusiness",
                            "subtitleId_es_US": "Préstamos"
                        }
                    ],
                    [
                        {
                            "title": "Wealth Management",
                            "title_es_US": "Gestión de Patrimonios",
                            "isSubtitle": true,
                            "subtitleId": "Wealth Management",
                            "subtitleId_es_US": "Gestión de Patrimonios",
                            "featureflag": "ff_NavWealthManagement",
                            "url": "",
                            "target": "_self",
                            "id": "welMngmnt"
                        },
                        {
                            "title": "Citigold<sup>&reg;</sup> Private Client",
                            "title_es_US": "Citigold<sup>&reg;</sup> Private Client",
                            "url": "/banking/citigold-private-client",
                            "domainMap": "ssr",
                            "featureflag": "ff_CitigoldPrivateClient",
                            "subtitleId": "Wealth Management",
                            "subtitleId_es_US": "Gestión de Patrimonios"
                        },
                        {
                            "title": "Citigold",
                            "title_es_US": "Citigold",
                            "url": "/banking/citigold",
                            "domainMap": "ssr",
                            "featureflag": "ff_CitiGold",
                            "subtitleId": "Wealth Management",
                            "subtitleId_es_US": "Gestión de Patrimonios"
                        },
                        {
                            "title": "Find a Wealth Team",
                            "title_es_US": "Buscar un Equipo de Gestión de Patrimonios",
                            "url": "https://contactcitigold.citi.com/",
                            "domainMap": "default",
                            "featureflag": "ff_FindWealthTeam",
                            "subtitleId": "Wealth Management",
                            "subtitleId_es_US": "Gestión de Patrimonios"
                        }
                    ]
                ]
            },
            {
                "order": 5,
                "title": "Rewards & Offers",
                "title_es_US": "Recompensas & Ofertas",
                "id": "rewards",
                "featureflag": "ff_NavRewardsAndOffers",
                "navigationItems": [
                    {
                        "title": "Costco Cash Rewards",
                        "title_es_US": "Recompensas de Costco Cash Rewards",
                        "url": "/rewards/dashboard/costco?accountInstanceId=",
                        "featureflag": "costcoCashRewards",
                        "domainMap": "csr"
                    },
                    {
                        "title": "Expedia&#174; Rewards",
                        "title_es_US": "Expedia® Rewards",
                        "url": "/rewards/dashboard/expedia?accountInstanceId=",
                        "domainMap": "csr",
                        "featureflag": "expediaRewards"
                    },
                    {
                        "title": "Double Cash Rewards",
                        "title_es_US": "Double Cash Rewards",
                        "url": "/rewards/dashboard/cashback?accountInstanceId=",
                        "domainMap": "csr",
                        "featureflag": "doubleCashRewards"
                    },
                    {
                        "title": "Custom Cash Rewards",
                        "title_es_US": "Recompensas Cash Rewards Personalizadas",
                        "url": "/rewards/dashboard/thankyou?accountInstanceId=",
                        "domainMap": "csr",
                        "featureflag": "customCashRewards"
                    },
                    {
                        "title": "ThankYou Rewards",
                        "title_es_US": "ThankYou Rewards",
                        "url": "/citi-partner-sso/ThankYou",
                        "domainMap": "csr",
                        "featureflag": "thankYouRewards",
                        "target": "_blank"
                    },
                    {
                        "title": "Offers for You",
                        "title_es_US": "Ofertas Para Ti",
                        "url": "/citioffersforyou",
                        "domainMap": "csr",
                        "featureflag": "offersForYou"
                    },
                    {
                        "title": "Citi Entertainment<sup>&reg;</sup>",
                        "title_es_US": "Citi Entertainment<sup>&reg;</sup>",
                        "featureflag": "citiEntertainment",
                        "url": "https://www.citientertainment.com/?utm_source=CBOL&utm_medium=RewardsOffers",
                        "domainMap": "default",
                        "target": "_blank"
                    },
                    {
                        "title": "Citi Travel<sup>SM</sup> Portal",
                        "title_es_US": "Citi Travel<sup>SM</sup> Portal",
                        "url": "/citi-partner/travel/login",
                        "domainMap": "ssr",
                        "featureflag": "ff_travelNav"
                    },
                    {
                        "title": "Special Offers",
                        "title_es_US": "Ofertas Especiales",
                        "featureflag": "specialOffers",
                        "url": "/US/JRS/portal/template.do?ID=SpecialOffers",
                        "domainMap": "legacy"
                    },
                    {
                        "title": "Card Benefits",
                        "title_es_US": "Beneficios de la Tarjeta",
                        "url": "/sso/index?tenantId=BenefitBuilder&cid=AFC~01~140601~CBOL~AcctMgmt~Header",
                        "featureflag": "cardBenefits",
                        "domainMap": "csr"
                    },
                    {
                        "title": "Explore All Products & Offers",
                        "title_es_US": "Explore All Products & Offers",
                        "url": "/products-offers/products",
                        "domainMap": "csr",
                        "featureflag": "ff_isProductsOffersGeneralThrottled"
                    }
                ]
            },
            {
                "order": 6,
                "title": "Profile",
                "title_es_US": "Perfil",
                "id": "profilesNav",
                "featureflag": "ff_NavProfiles",
                "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                "navigationItems": [
                    {
                        "title": "PROFILE",
                        "title_es_US": "PERFIL",
                        "isSubtitle": true,
                        "subtitleId": "PROFILE",
                        "featureflag": "ff_NavProfiles",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "User ID",
                        "title_es_US": "Identificación de Usuario",
                        "url": "/profile-update/change-userid",
                        "domainMap": "csr",
                        "featureflag": "ff_UpdateUserId",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "Password",
                        "title_es_US": "Contraseña",
                        "url": "/profile-update/change-password",
                        "domainMap": "csr",
                        "featureflag": "ff_UpdatePassword",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "Contact Information",
                        "title_es_US": "Información de Contacto",
                        "url": "/ContactInfo/Profiles",
                        "domainMap": "csr",
                        "featureflag": "contactInfo",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "Income Information",
                        "title_es_US": "Información sobre los Ingresos",
                        "url": "/updateincomeinfo/landingpage?targetAOApp=cfiOvly",
                        "domainMap": "csr",
                        "featureflag": "incomeInfo",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "Employment Status",
                        "title_es_US": "Situación Laboral",
                        "featureflag": "employmentStatus",
                        "url": "/kyc/data-capture/index/category/employmentInformation",
                        "domainMap": "csr",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "Balance & Benefits",
                        "title_es_US": "Saldo y Beneficios",
                        "featureflag": "ff_cambBenefitsEveryday",
                        "url": "/reward/CAMB",
                        "domainMap": "csr",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "Relationship Tier",
                        "title_es_US": "Categoría de Relación",
                        "featureflag": "ff_cambBenefits",
                        "url": "/reward/CAMB",
                        "domainMap": "csr",
                        "subtitleId": "PROFILE",
                        "subtitleId_es_US": "PERFIL"
                    },
                    {
                        "title": "SETTINGS",
                        "title_es_US": "CONFIGURACIONES",
                        "isSubtitle": true,
                        "subtitleId": "SETTINGS",
                        "featureflag": "accountAlerts",
                        "subtitleId_es_US": "CONFIGURACIONES"
                    },
                    {
                        "title": "Account Alerts",
                        "title_es_US": "Alertas de Cuenta",
                        "url": "/alerts",
                        "domainMap": "csr",
                        "featureflag": "accountAlerts",
                        "subtitleId": "SETTINGS",
                        "subtitleId_es_US": "CONFIGURACIONES"
                    },
                    {
                        "title": "More Settings",
                        "title_es_US": "Más Configuraciones",
                        "url": "/servicing/index?pageName=Settings",
                        "featureflag": "ff_NavMoreSettings",
                        "domainMap": "csr",
                        "subtitleId": "SETTINGS",
                        "subtitleId_es_US": "CONFIGURACIONES"
                    }
                ]
            },
            {
                "order": 7,
                "title": "ATM / Branch",
                "title_es_US": "ATM / Sucursal",
                "url": "/citibank-location-finder",
                "domainMap": "csr",
                "featureflag": "ff_NavATMBranch",
                "className": "ATMBranch",
                "id": "ATMNav",
                "image": "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg",
                "navigationItems": []
            },
            {
                "order": 8,
                "title": "Open an Account",
                "title_es_US": "Abrir una Cuenta",
                "id": "openAccPost",
                "url": "/banking/bank-accounts",
                "featureflag": "ff_NavOpenAnAccount",
                "domainMap": "ssr",
                "navigationItems": [
                    {}
                ]
            },
            {
                "order": 9,
                "title": "Check Personal Loan Rate",
                "title_es_US": "Check Personal Loan Rate",
                "id": "checkPersonalLoan",
                "url": "/lending/landingroute?intc=megamenu~view-personal-loan-rate",
                "featureflag": "ff_checkPersonalLoanRate",
                "domainMap": "csr",
                "navigationItems": [
                    {}
                ]
            },
            {
                "order": 10,
                "title": "Sign Off",
                "title_es_US": "Salir",
                "url": "/sign-off",
                "domainMap": "csr",
                "id": "signOff"
            }
        ]
    }
};
const localBrandingMap = {
    "domainMap": {
        "csr": "uatX.online.citi.com/US/ag",
        "mfe": "testXX.online.citi.com/US/nga",
        "ssr": "uatXX.citi.com",
        "legacy": "uatX.online.citi.com",
        "mkr": "testXX.creditcards.citi.com",
        "default": ""
    },
    "qaEditIconShow": true
};
const localFDIC = {
    "urlPatterns": [
        {
            "isSSR": true,
            "subRoutes": [
                {
                    "path": "/",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/bank-accounts",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/checking-account",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/savings-account",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/cd-account",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/citi-priority",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/citigold",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/citigold-private-client",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/compare-bank-accounts",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/current-interest-rates/savings-accounts",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/current-interest-rates/cd",
                    "noQueryParams": true
                },
                {
                    "path": "/banking/current-interest-rates/cd",
                    "queryParams": {
                        "type": "fixed-rate-cd"
                    }
                },
                {
                    "path": "/banking/current-interest-rates/cd",
                    "queryParams": {
                        "type": "no-penalty-cd"
                    }
                },
                {
                    "path": "/banking/current-interest-rates/cd",
                    "queryParams": {
                        "type": "step-up-cd"
                    }
                }
            ]
        },
        {
            "isCSR": true,
            "subRoutes": [
                {
                    "path": "/dashboard/savings",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/cd",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/checking",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/retirement",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/ira/index",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/ira/contribute",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/ira/contribute/select-plan",
                    "noQueryParams": true
                },
                {
                    "path": "/dashboard/ira/contribute/submit-plan",
                    "noQueryParams": true
                },
                {
                    "path": "/lat-transfer/landing",
                    "noQueryParams": true
                },
                {
                    "path": "/iitTfr/domestic",
                    "noQueryParams": true
                },
                {
                    "path": "/clickswitch/account-selection",
                    "noQueryParams": true
                },
                {
                    "path": "/clickswitch/review-summary",
                    "noQueryParams": true
                },
                {
                    "path": "/fundtransfer/fundinitiate",
                    "noQueryParams": true
                },
                {
                    "path": "/cards/applications/fund-your-card-account",
                    "queryParams": {
                        "appstatus": "y"
                    }
                },
                {
                    "path": "/cards/applications/fund-your-card-account",
                    "noQueryParams": true
                },
                {
                    "path": "/clickswitch/review-summary",
                    "noQueryParams": true
                },
                {
                    "path": "/fundtransfer/fundinitiate",
                    "noQueryParams": true
                },
                {
                    "path": "/account-opening/index",
                    "queryParams": {
                        "formCode": "*",
                        "Promo_ID": "*",
                        "product_list": "*",
                        "cst": "*",
                        "GS": "*"
                    },
                    "allowWildcardParams": true
                },
                {
                    "path": "/easyaddbank/easyadd",
                    "queryParams": {
                        "Promo_ID": "*",
                        "cst": "*",
                        "product_list": "*"
                    },
                    "allowWildcardParams": true
                }
            ]
        }
    ]
};

class BrandingTypeService {
    constructor() {
        this.types = {
            ssrnewbase: ssrnewbase,
            localBanner: localBanner,
            localFooter: localFooter,
            localPreNavigation: localPreNavigation,
            localPostNavigation: localPostNavigation,
            localBrandingMap: localBrandingMap,
            localFDIC: localFDIC
        };
        this.init = () => {
        };
        this.getBranding = type => {
            return this.types[type] || false;
        };
        this.init();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingTypeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingTypeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingTypeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class BrandingMapService {
    constructor(_httpClient, appConfigService, _router, _window, _appConfigService, _sessionStorage, _platformId, cookieService, brandingTypeService) {
        this._httpClient = _httpClient;
        this.appConfigService = appConfigService;
        this._router = _router;
        this._window = _window;
        this._appConfigService = _appConfigService;
        this._sessionStorage = _sessionStorage;
        this._platformId = _platformId;
        this.cookieService = cookieService;
        this.brandingTypeService = brandingTypeService;
        this.host_url = '';
        this.url = this.appConfigService.getConfig('customConfig')
            .brandingEndpoint;
        this.isBrowser = isPlatformBrowser(this._platformId);
        this.init();
    }
    //method for checking if route exists on current container
    routerCheck(val, arr) {
        return arr.some(e => e.path === val);
    }
    //init method where it get's mapper object from ICMS for parforming calculations
    init() {
        console.log("Reached Mapper Init---->");
        //checking for host name
        if (!this.isBrowser) {
            console.log("Branding Map Server Side check is not happening!");
            return;
        }
        if (this._window) {
            this.host_url = this.isBrowser
                ? this._window.location.origin
                : '';
        }
        //Retrieving mapper object from brandingMap
        let url = this.host_url + this.url;
        if (window.location.hostname === 'localhost' || window.location.host.includes('.creditcards.citi.com') || /^https?:\/\//i.test(this.url || '')) {
            url = this.url;
        }
        let channelID = this.cookieService.getCookie('channelId');
        if (!(channelID == 'SFRTL' || channelID == 'ECLIPSE')) {
            this._httpClient.get(url + `/brandingMap.json`).subscribe(res => {
                this.mapperObject = res;
                console.log("getting mapper object", this.mapperObject);
            }, error => {
                console.log("mapper object error", error);
                this.mapperObject = this.brandingTypeService.getBranding('localBrandingMap');
            });
        }
        this.routerObject = this._router.config;
    }
    //Toggle for Edit Icon in Quick Action Tile
    getQaEditShowValue() {
        if (this.mapperObject.qaEditIconShow === true) {
            return this.mapperObject.qaEditIconShow;
        }
        return false;
    }
    //Host URL Removal based on appEnv Configs.
    hostURLChecker(obj) {
        if (obj.domainMap === 'csr') {
            this.newUrl = obj.url ? obj.url : obj.routerLink;
            this.newUrl = this.newUrl.replace('https://online.citi.com/US/ag', '');
            if (obj.url) {
                obj.url = this.newUrl;
            }
            else {
                obj.routerLink = this.newUrl;
            }
        }
        else if (obj.domainMap === 'legacy') {
            this.newUrl = obj.url ? obj.url : obj.routerLink;
            this.newUrl = this.newUrl.replace('https://online.citi.com', '');
            if (obj.url) {
                obj.url = this.newUrl;
            }
            else {
                obj.routerLink = this.newUrl;
            }
        }
        else if (obj.domainMap === 'mfe') {
            this.newUrl = obj.url ? obj.url : obj.routerLink;
            this.newUrl = this.newUrl.replace('https://online.citi.com/US/nga', '');
            if (obj.url) {
                obj.url = this.newUrl;
            }
            else {
                obj.routerLink = this.newUrl;
            }
        }
        else if (obj.domainMap === 'mkr') {
            this.newUrl = obj.url ? obj.url : obj.routerLink;
            this.newUrl = this.newUrl.replace('https://www.citi.com', '');
            if (obj.url) {
                obj.url = this.newUrl;
            }
            else {
                obj.routerLink = this.newUrl;
            }
        }
        else if (obj.domainMap === 'ssr') {
            this.newUrl = obj.url ? obj.url : obj.routerLink;
            this.newUrl = this.newUrl.replace('https://www.citi.com', '');
            if (obj.url) {
                obj.url = this.newUrl;
            }
            else {
                obj.routerLink = this.newUrl;
            }
        }
        else {
            console.log("This is a default route!");
        }
        return obj;
    }
    checkCurrentContainer() {
        let domainMap = this.mapperObject.domainMap;
        // Check the current URL with the values in the domainMap to see which container we're in
        return Object.keys(domainMap).find(k => this._window.location.href.includes(domainMap[k].substring(domainMap[k].indexOf('.') + 1)));
    }
    checkContainerForRoute(obj) {
        // Check if route exists in the container, perform routerLink if it does
        if (this.routerCheck(this.linkChecker(obj).substring(1).split('/')[0], this.routerObject)) {
            if (obj.url.split('?')[1]) {
                this._router.navigateByUrl(obj.url.split('?')[0] + '?' + obj.url.split('?')[1]);
            }
            else {
                this._router.navigateByUrl(this.linkChecker(obj));
            }
        }
        else {
            // Route doesn't exist in container, perform href
            this.redirectRoute(obj.domainMap, obj);
        }
    }
    brandingMap(obj) {
        console.log("getting data from map (updated brandingMap method)", obj);
        this.hostURLChecker(obj);
        // Checking if the object contains url or routerLink. If URL then there's no need to check routerLink condition.
        if (obj.domainMap === 'csr' || obj.domainMap === 'mfe' || obj.domainMap === 'mkr') {
            // Check which container we're on and if it matches the domainMap of the URL
            if (this.checkCurrentContainer() === obj.domainMap) {
                this.checkContainerForRoute(obj);
            }
            else {
                // Current container doesn't match domainMap of URL, perform href
                this.redirectRoute(obj.domainMap, obj);
            }
        }
        else {
            // Current container isn't csr, ssr or mfe, perform href
            this.redirectRoute(obj.domainMap, obj);
        }
    }
    //This method is for checking url or routerLink
    linkChecker(val) {
        if (val.url) {
            return val.url;
        }
        else {
            return val.routerLink;
        }
    }
    //Method for constructing which URL that it needs to redirect to if route is not found.
    redirectRoute(key, link) {
        if (key === 'default') {
            if (link.target) {
                this._window.open(this.linkChecker(link), link.target);
            }
            else {
                this._window.location.href = this.linkChecker(link);
            }
        }
        else if (key === 'legacy') {
            this._window.location.href = this._appConfigService.getcsrHostName() + this.linkChecker(link);
        }
        else if (key === 'ssr') {
            this._window.location.href = this._appConfigService.getnewCitiHostName() + this.linkChecker(link);
        }
        else if (key === 'mkr') {
            this._window.location.href = this._appConfigService.getcardsmkrHostName() + this.linkChecker(link);
        }
        else if (key === 'csr') {
            if (link.queryParams) {
                var params = link.queryParams;
                var esc = encodeURIComponent;
                var query = Object.keys(params)
                    .map(k => esc(k) + '=' + esc(params[k]))
                    .join('&');
                const queryParamsLink = this.linkChecker(link) + '?' + query;
                this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + queryParamsLink;
            }
            else if (link.pageName) {
                this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(link) + '?pageName=' + link.pageName;
            }
            else {
                this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(link);
            }
        }
        else if (key === 'mfe') {
            this._window.location.href = this._appConfigService.getcsrHostName() + '/US/nga' + this.linkChecker(link);
        }
        else {
            this._window.location.href = this._window.location.origin + this.linkChecker(link);
        }
    }
    modifyURLPrefixRightClick(event, key, link) {
        this.hostURLChecker(link);
        if (key === 'default') {
            this.modifyTarget(event, this.linkChecker(link));
        }
        else if (key === 'legacy') {
            this.modifyTarget(event, this._appConfigService.getcsrHostName() + this.linkChecker(link));
        }
        else if (key === 'ssr') {
            this.modifyTarget(event, this._appConfigService.getnewCitiHostName() + this.linkChecker(link));
        }
        else if (key === 'mkr') {
            this.modifyTarget(event, this._appConfigService.getcardsmkrHostName() + this.linkChecker(link));
        }
        else if (key === 'csr') {
            if (link.queryParams) {
                var params = link.queryParams;
                var esc = encodeURIComponent;
                var query = Object.keys(params)
                    .map(k => esc(k) + '=' + esc(params[k]))
                    .join('&');
                const queryParamsLink = this.linkChecker(link) + '?' + query;
                this.modifyTarget(event, this._appConfigService.getcsrHostName() + '/US/ag' + queryParamsLink);
            }
            else if (link.pageName) {
                this.modifyTarget(event, this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(link) + '?pageName=' + link.pageName);
            }
            else {
                this.modifyTarget(event, this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(link));
            }
        }
        else if (key === 'mfe') {
            this.modifyTarget(event, this._appConfigService.getcsrHostName() + '/US/nga' + this.linkChecker(link));
        }
        else {
            this.modifyTarget(event, this._window.location.origin + this.linkChecker(link));
        }
    }
    //cta and other tag issues on modifying right prefix
    modifyTarget(event, url) {
        if (event.currentTarget.nodeName.toLowerCase() === 'a') {
            event.currentTarget.href = url;
        }
        else if (event.currentTarget.nodeName.toLowerCase() === 'citi-cta') {
            if (event.target instanceof HTMLAnchorElement) {
                event.target.href = url;
            }
        }
        else {
            event.currentTarget.href = url;
        }
    }
    //navigation3 Signoff Implementation for any container
    deleteSignOff(obj, isRouterLink) {
        this.hostURLChecker(obj);
        if (this._window &&
            (this._window.location.hostname === 'uat02.citi.com' ||
                this._window.location.hostname === 'www.citi.com')) {
            let spbs = this._sessionStorage
                ? this._sessionStorage.getItem('sessionPostBrandingStorage')
                : null;
            if (spbs) {
                this._sessionStorage.removeItem('sessionPostBrandingStorage');
            }
        }
        if (isRouterLink === undefined) {
            if (obj.domainMap === 'csr' || obj.domainMap === 'ssr' || obj.domainMap === 'mfe') {
                if (this.checkCurrentContainer() === obj.domainMap) {
                    this._router.navigateByUrl(this.linkChecker(obj));
                }
                else {
                    // Current container doesn't match domainMap of URL, perform href
                    this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(obj);
                }
            }
            else {
                // Current container doesn't match domainMap of URL, perform href
                this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(obj);
            }
        }
        // other teams are using this parameter so making it optional
        if (isRouterLink !== undefined) {
            if (this._window && !isRouterLink) {
                if (obj.url.includes('/US/ag')) {
                    this._window.location.href = this._appConfigService.getcsrHostName() + this.linkChecker(obj);
                }
                else
                    this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(obj);
            }
            if (this._router && isRouterLink) {
                if ((this.routerCheck(obj.routerLink.substring(1).split('/')[0], this.routerObject)) && (obj.domainMap === 'csr')) {
                    this._router.navigateByUrl(this.linkChecker(obj));
                }
                else {
                    this._window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.linkChecker(obj);
                }
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingMapService, deps: [{ token: i1.HttpClient }, { token: i1$1.AppConfigService }, { token: i3.Router }, { token: WINDOW }, { token: i1$1.AppConfigService }, { token: SESSION_STORAGE }, { token: PLATFORM_ID }, { token: i1$1.CookieService }, { token: BrandingTypeService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingMapService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i1$1.AppConfigService }, { type: i3.Router }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1$1.AppConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i1$1.CookieService }, { type: BrandingTypeService }] });

class ProfileNavComponent {
    constructor(host, renderer, mapperService) {
        this.host = host;
        this.renderer = renderer;
        this.mapperService = mapperService;
        this.childLinkClicked = new EventEmitter();
    }
    ngOnInit() { }
    onChildLinkClick(e) {
        e.stopPropagation();
        this.childLinkClicked.emit(true);
    }
    navigateToURL(obj, event) {
        obj.targetLink = event;
        obj.subTitle = this.childNavGroup.subTitle;
        this.childLinkClicked.emit(obj);
    }
    onRightClick(obj, event) {
        if (event.type == 'contextmenu' || event.type == 'mouseover') {
            if (event.type === 'contextmenu') {
                obj.targetLink = event;
                obj.subTitle = this.childNavGroup.subTitle;
                this.childLinkClicked.emit(obj);
            }
            this.mapperService.modifyURLPrefixRightClick(event, obj.domainMap, obj);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ProfileNavComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BrandingMapService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ProfileNavComponent, isStandalone: false, selector: "profile-nav", inputs: { childNavGroup: "childNavGroup", isMobile: "isMobile" }, outputs: { childLinkClicked: "childLinkClicked" }, ngImport: i0, template: "<div\n  *ngIf=\"childNavGroup.subTitle\"\n  class=\"subMenuGroupTitle\"\n  [ngStyle]=\"{\n    display: 'block'\n  }\"\n>\n  <h6\n    [class]=\"childNavGroup.subTitle\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></h6>\n</div>\n\n<!-- creating UL for every subMenu Group -->\n<ul\n  role=\"list\"\n  [attr.aria-label]=\"childNavGroup.subTitle\"\n  class=\"subMenuGroupUL\"\n  #menuContainer\n  *ngIf=\"childNavGroup\"\n  [ngStyle]=\"{ background: '#fff' }\"\n>\n  <ng-container *ngFor=\"let link of childNavGroup.items; let i = index\">\n    <!-- looping thorugh links under submenu Groups -->\n    <li *ngIf=\"link.show\" class=\"subMenuGroupLI\" role=\"listitem\">\n      <a\n        *ngIf=\"link.url || link.routerLink\"\n        [id]=\"link.title + 'childLink' + i\"\n        class=\"child-links\"\n        tabindex=\"0\"\n        role=\"link\"\n        [attr.href]=\"link.url ? link.url : link.routerLink\"\n        (click)=\"navigateToURL(link,$event)\"\n        (contextmenu)=\"onRightClick(link, $event)\"\n        (mouseover)=\"onRightClick(link,$event)\"\n        [attr.target]=\"link.target\"\n        [innerHtml]=\"link.title\"\n      ></a>\n    </li>\n  </ng-container>\n</ul>\n<hr *ngIf=\"childNavGroup.subTitle == 'profile'\" class=\"profileSeperation\" />\n", styles: [".subMenuGroupUL{width:100%;padding:0;background:#fff;margin-bottom:0}.subMenuGroupUL:first-child{padding-top:10px}.subMenuGroupUL:last-child{padding-bottom:16px}.subMenuGroupLI,.subMenuGroupTitle{list-style-type:none}.subMenuGroupTitle{margin:0}.subMenuGroupTitle h6{font-size:12px;color:var(--profilenav-header-color, #666);letter-spacing:0;text-transform:uppercase;line-height:20px;margin-bottom:0;cursor:text;padding-top:16px}.subMenuGroupLI{margin:0;width:100%;line-height:1.5}.subMenuGroupLI .child-links{display:inline-block;text-align:left;text-decoration:none;color:var(--profilenav-text-color, #333);padding-top:20px;cursor:pointer;line-height:1;white-space:pre-wrap}.subMenuGroupLI .child-links:hover{color:var(--profilenav-text-hover-color, #333);text-decoration:underline}.subMenuGroupLI .child-links:focus{outline:-webkit-focus-ring-color auto 5px!important;outline-offset:1px!important}.profileSeperation{width:calc(100% - 40px);margin:0 auto;color:#bfbfbf}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ProfileNavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'profile-nav', standalone: false, template: "<div\n  *ngIf=\"childNavGroup.subTitle\"\n  class=\"subMenuGroupTitle\"\n  [ngStyle]=\"{\n    display: 'block'\n  }\"\n>\n  <h6\n    [class]=\"childNavGroup.subTitle\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></h6>\n</div>\n\n<!-- creating UL for every subMenu Group -->\n<ul\n  role=\"list\"\n  [attr.aria-label]=\"childNavGroup.subTitle\"\n  class=\"subMenuGroupUL\"\n  #menuContainer\n  *ngIf=\"childNavGroup\"\n  [ngStyle]=\"{ background: '#fff' }\"\n>\n  <ng-container *ngFor=\"let link of childNavGroup.items; let i = index\">\n    <!-- looping thorugh links under submenu Groups -->\n    <li *ngIf=\"link.show\" class=\"subMenuGroupLI\" role=\"listitem\">\n      <a\n        *ngIf=\"link.url || link.routerLink\"\n        [id]=\"link.title + 'childLink' + i\"\n        class=\"child-links\"\n        tabindex=\"0\"\n        role=\"link\"\n        [attr.href]=\"link.url ? link.url : link.routerLink\"\n        (click)=\"navigateToURL(link,$event)\"\n        (contextmenu)=\"onRightClick(link, $event)\"\n        (mouseover)=\"onRightClick(link,$event)\"\n        [attr.target]=\"link.target\"\n        [innerHtml]=\"link.title\"\n      ></a>\n    </li>\n  </ng-container>\n</ul>\n<hr *ngIf=\"childNavGroup.subTitle == 'profile'\" class=\"profileSeperation\" />\n", styles: [".subMenuGroupUL{width:100%;padding:0;background:#fff;margin-bottom:0}.subMenuGroupUL:first-child{padding-top:10px}.subMenuGroupUL:last-child{padding-bottom:16px}.subMenuGroupLI,.subMenuGroupTitle{list-style-type:none}.subMenuGroupTitle{margin:0}.subMenuGroupTitle h6{font-size:12px;color:var(--profilenav-header-color, #666);letter-spacing:0;text-transform:uppercase;line-height:20px;margin-bottom:0;cursor:text;padding-top:16px}.subMenuGroupLI{margin:0;width:100%;line-height:1.5}.subMenuGroupLI .child-links{display:inline-block;text-align:left;text-decoration:none;color:var(--profilenav-text-color, #333);padding-top:20px;cursor:pointer;line-height:1;white-space:pre-wrap}.subMenuGroupLI .child-links:hover{color:var(--profilenav-text-hover-color, #333);text-decoration:underline}.subMenuGroupLI .child-links:focus{outline:-webkit-focus-ring-color auto 5px!important;outline-offset:1px!important}.profileSeperation{width:calc(100% - 40px);margin:0 auto;color:#bfbfbf}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BrandingMapService }], propDecorators: { childNavGroup: [{
                type: Input
            }], isMobile: [{
                type: Input
            }], childLinkClicked: [{
                type: Output
            }] } });

class LayoutsService {
    constructor(_document, router) {
        this._document = _document;
        this.router = router;
        this.fullpageLoading = true;
        this.appbodyLoading = false;
        this.suppressJamp = false;
        this.fullbleed = false;
        this.manualOverride = false;
        this.themeChanged = new EventEmitter();
        this.widthChanged = new EventEmitter();
        this.endpointChanged = new EventEmitter();
        this.fullpageLoadingChanged = new EventEmitter();
        this.appbodyLoadingChanged = new EventEmitter();
        this.suppressJampChanged = new EventEmitter();
        this.fullbleedChanged = new EventEmitter();
        this.responsiveChanged = new EventEmitter();
        this.brandingTypeChanged = new EventEmitter();
        this.singleBreakpointChanged = new EventEmitter();
        this.preloginChanged = new EventEmitter();
        this.pageIdChanged = new EventEmitter();
        this.servicingTypeChanged = new EventEmitter();
        this.waitMessageChanged = new EventEmitter();
        this.readyMessageChanged = new EventEmitter();
        this.postBrandingStorage = new BehaviorSubject(false);
        this.releaseManualControl = new EventEmitter();
        this.toggleSearchPanel = new BehaviorSubject(false);
        this.clearClasses = new EventEmitter();
        this.changeTheme = function (theme) {
            this.theme = theme;
            this.themeChanged.emit(theme);
        };
        this.changeEndpoint = function (endpoint) {
            this.endpoint = endpoint;
            this.endpointChanged.emit(endpoint);
        };
        this.changeResponsive = function (responsive) {
            if (responsive == null) {
                responsive = 'true';
            }
            this.responsive = responsive;
            let viewMeta = this._document.querySelector("meta[name='viewport']");
            this.responsive == true || this.responsive == 'true'
                ? viewMeta.setAttribute('content', 'width=device-width, initial-scale=1')
                : viewMeta.setAttribute('content', 'width=device-width, initial-scale=0');
            this.responsiveChanged.emit(responsive);
        };
        this.changeWidth = function (width) {
            this.width = width;
            this.widthChanged.emit(width);
        };
        this.changeSingleBreakpoint = function (singleBreakpoint) {
            this.singleBreakpoint = singleBreakpoint;
            this.singleBreakpointChanged.emit(singleBreakpoint);
        };
        this.changeFullPageLoading = function (fullpageLoading) {
            if (fullpageLoading === true || fullpageLoading === 'true') {
                this.fullpageLoading = true;
                this.fullpageLoadingChanged.emit(true);
            }
            else {
                this.fullpageLoading = false;
                this.fullpageLoadingChanged.emit(false);
            }
        };
        this.changeAppbodyLoading = function (appbodyLoading) {
            if (appbodyLoading === true || appbodyLoading === 'true') {
                this.appbodyLoading = true;
                this.appbodyLoadingChanged.emit(true);
            }
            else {
                this.appbodyLoading = false;
                this.appbodyLoadingChanged.emit(false);
            }
        };
        this.changeSuppressJamp = function (suppressJamp) {
            this.suppressJamp = suppressJamp;
            this.suppressJampChanged.emit(suppressJamp);
        };
        this.changeBrandingType = (type) => {
            if (typeof type === 'string' && type.length) {
                this.brandingType = type;
                this.brandingTypeChanged.emit(type);
            }
        };
        this.changePrelogin = function (prelogin) {
            this.prelogin = prelogin;
            this.preloginChanged.emit(prelogin);
        };
        this.changePageId = id => {
            this.pageId = id;
            this.pageIdChanged.emit(id);
        };
        this.changeServicingType = type => {
            this.servicingType = type;
            this.servicingTypeChanged.emit(type);
        };
        this.changeFullbleed = function (fullbleed) {
            this.fullbleed = fullbleed;
            this.fullbleedChanged.emit(fullbleed);
        };
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                // Check if navigation start is going to parent interstial or dashboard
                if (event.url.includes('parent-interstitial') || event.url === '/mrc/dashboard' || event.url.split('?')[0] === '/dashboard') {
                    this.changeSuppressJamp(true);
                }
            }
            else if (event instanceof NavigationEnd) {
                // Set suppress jamp to false for all routes except parent-interstitial and dashboard
                if (!event.url.includes('parent-interstitial') && event.url.split('?')[0] !== '/dashboard') {
                    this.changeSuppressJamp(false);
                }
            }
        });
    }
    resetClasses() {
        this.manualOverride = true;
        // this.clearClasses.emit(this.manualOverride);
        this.clearClasses.emit(true);
    }
    releaseControl() {
        this.manualOverride = false;
        // this.releaseManualControl.emit(this.manualOverride);
        this.releaseManualControl.emit(true);
    }
    changeWaitMessage(message) {
        this.waitMessage = message;
        this.waitMessageChanged.emit(message);
    }
    changeReadyMessage(message) {
        this.readyMessage = message;
        this.readyMessageChanged.emit(message);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: LayoutsService, deps: [{ token: DOCUMENT }, { token: i3.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: LayoutsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: LayoutsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i3.Router }] });

class BrandingEntitlementService {
    constructor(_sessionStorage, _window, _httpClient, _httpService, appConfigService, _platformId) {
        this._sessionStorage = _sessionStorage;
        this._window = _window;
        this._httpClient = _httpClient;
        this._httpService = _httpService;
        this.appConfigService = appConfigService;
        this._platformId = _platformId;
        this.isBrowser = isPlatformBrowser(this._platformId);
        this.init();
    }
    init() {
        this.entitlementFlagValue = this.appConfigService.getEntitlementFlagConfig();
        console.log("Branding Entitlement Service Flag---->", this.appConfigService.getEntitlementFlagConfig());
    }
    getSPBS() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                if (sessionParams) {
                    return sessionParams;
                }
            }
            catch (err) {
                return false;
            }
        }
    }
    //BAU Calculation that returns true or false for serviceLinksBean
    getShowValue(value) {
        if (typeof value == 'undefined')
            return true;
        else if (JSON.stringify(value) === '{}')
            return true;
        else if (value == 'Y' || value == true)
            return true;
        else
            return false;
    }
    setSessionParams() {
        this.sessionParams = this.getSPBS();
        this.entitlementObject = this.sessionParams?.featureFlags ? this.sessionParams?.featureFlags : {};
    }
    getNewEntitlementLogic(value, show, flag) {
        if (this.sessionParams == null || this.sessionParams == undefined) {
            this.setSessionParams();
        }
        else if (JSON.stringify(this.sessionParams) !== JSON.stringify(this.getSPBS)) {
            this.setSessionParams();
        }
        // GBC-8203 - Updating current feature flag logic to accomodate multiple featureflags as a array
        if (this.entitlementFlagValue && value.featureflag && Array.isArray(value.featureflag)) {
            let multipleFlags = [];
            multipleFlags = value.featureflag.map(v => this.entitlementObject[v] ? this.getShowValue(this.entitlementObject[v]) : ''); //[true, false]
            return multipleFlags.some(Boolean);
        }
        else if (this.entitlementFlagValue && value.featureflag && this.entitlementObject[value.featureflag] != null && this.entitlementObject[value.featureflag] != undefined) {
            return this.getShowValue(this.entitlementObject[value.featureflag]);
        }
        else {
            console.warn('Branding entitlement service: object does not have a feature flag. Please make sure a feature flag exists for this object:', value);
            return false;
            // if(show){
            //  return  this.getServiceLinksBeanLogic(value.show, flag)
            // }else{
            //  return this.getServiceLinksBeanLogic(value, flag)
            // }
        }
    }
    getNewEntitlementLogicForServicing(value) {
        if (!this.sessionParams || JSON.stringify(this.sessionParams) !== JSON.stringify(this.getSPBS())) {
            this.setSessionParams();
        }
        // GBC-8203 - Updating current feature flag logic to accommodate multiple feature flags as an array
        const { featureflag } = value;
        if (this.entitlementFlagValue && featureflag) {
            if (Array.isArray(featureflag.array)) {
                const hasTrueValue = featureflag.array.some(v => this.entitlementObject[v] && this.getShowValue(this.entitlementObject[v]));
                return hasTrueValue;
            }
            else if (this.entitlementObject[featureflag] != null) {
                return this.getShowValue(this.entitlementObject[featureflag]);
            }
        }
        return false;
    }
    getServiceLinksBean(value) {
        if (this.sessionParams.serviceLinksBean) {
            return this.sessionParams.serviceLinksBean[value];
        }
    }
    // TODO: Remove method after instances of this method from other features are removed
    getServiceLinksBeanLogic(linkValue, flag) {
        // if(flag){
        //   return jsonLogic.apply(linkValue, this.sessionParams.serviceLinksBean);
        // }
        // else{
        //   return this.getShowValue(jsonLogic.apply(linkValue, this.sessionParams.serviceLinksBean));
        // }
    }
    renamingLogic(titleObj, descriptionValue) {
        let defaultTitle = {};
        if ((sessionStorage.getItem("sessionPostBrandingStorage")) && (sessionStorage.getItem("sessionPostBrandingStorage") !== "null") && (sessionStorage.getItem("sessionPostBrandingStorage") !== null)) {
            // Session post branding storage
            let spbs = JSON.parse(window.sessionStorage.getItem("sessionPostBrandingStorage"));
            defaultTitle = {
                title_en: titleObj.title,
                title_es_US: titleObj.title_es_US
            };
            if (descriptionValue !== undefined && descriptionValue) {
                let descriptionTitle = {
                    description_en: titleObj.description,
                    description_es_US: titleObj.description_es_US
                };
                if (spbs?.custSegmentType !== undefined) {
                    Object.keys(titleObj).forEach(keys => {
                        if (keys.includes(spbs?.custSegmentType) && keys.includes("description")) {
                            if (!keys.includes('description_es_US')) {
                                descriptionTitle.description_en = titleObj[keys];
                            }
                            if (keys.includes('description_es_US')) {
                                descriptionTitle.description_es_US = titleObj[keys];
                            }
                        }
                    });
                }
                return descriptionTitle;
            }
            // Checking if the custSegmentType key is present in SPBS. If not default Titles with default title is returned.
            if (spbs?.custSegmentType !== undefined) {
                Object.keys(titleObj).forEach(keys => {
                    if (keys.includes(spbs?.custSegmentType) && keys.includes("title")) {
                        if (!keys.includes('es_US')) {
                            defaultTitle.title_en = titleObj[keys];
                        }
                        if (keys.includes('es_US')) {
                            defaultTitle.title_es_US = titleObj[keys];
                        }
                    }
                });
            }
        }
        return defaultTitle;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingEntitlementService, deps: [{ token: SESSION_STORAGE }, { token: WINDOW }, { token: i1.HttpClient }, { token: i6.HttpService }, { token: i1$1.AppConfigService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingEntitlementService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingEntitlementService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.HttpClient }, { type: i6.HttpService }, { type: i1$1.AppConfigService }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

// App Imports
class BrandingService {
    constructor(
    // App config service.  Allows us to retrieve values from the application configuration
    appConfigService, 
    // Layouts service
    layoutsService, 
    //Branding Entitlement Service
    _brandingEntitlementService, router, 
    // Branding type service
    brandingTypeService, 
    // Cookie service.  Allows retrieving of a cookie by name
    cookieService, 
    // ECM cookie service.  Allows retrieving values from the ECM cookie
    ecmCookieService, 
    // Post session service to retrieve values from sessionPostBrandingStorage object
    postSessionService, contentService, angularHttp, authService, http, _platformId, _sessionStorage, _windows, _isSSRApp) {
        this.appConfigService = appConfigService;
        this.layoutsService = layoutsService;
        this._brandingEntitlementService = _brandingEntitlementService;
        this.router = router;
        this.brandingTypeService = brandingTypeService;
        this.cookieService = cookieService;
        this.ecmCookieService = ecmCookieService;
        this.postSessionService = postSessionService;
        this.contentService = contentService;
        this.angularHttp = angularHttp;
        this.authService = authService;
        this.http = http;
        this._platformId = _platformId;
        this._sessionStorage = _sessionStorage;
        this._windows = _windows;
        this._isSSRApp = _isSSRApp;
        this.ToggleFdic = new EventEmitter();
        this.destroyed = new Subject();
        // This key is for pointing to old or new logic for postlogin Branding content
        this.newLogicBranding = this.appConfigService.getBrandingFlagConfig();
        // This key is for pointing to old or new logic for merging csr and ssr
        this.mergeSSRCSR = this.appConfigService.getMergeSSRCSR();
        this.serviceBrandingCall = false;
        this.interstitialBrandingCall = false;
        this.defaultBrandingSet = false;
        // Variables {
        // Holds data retrieved from the branding microservice.
        this.data = null;
        this.dataBackUp = null;
        // The endpoint URL for the branding microservice.
        this.url = this.appConfigService.getConfig('customConfig')
            .brandingEndpoint;
        // The observable other components will subscribe to
        this.dataUpdate = new EventEmitter();
        // The observable that journey teams can consume for social media buttons
        this.mediaClick = new EventEmitter();
        // The observable that journey teams can consume for social media buttons
        this.mediaContinueClick = new EventEmitter();
        // Event emitter that will let other apps know when the data is ready the first time
        this.onDataReady = new ReplaySubject(1);
        /*commented below code based on DRR-15792*/
        // stores reference to acocuntInstanceId, for some links that require inorder to navigate ...e,g /US/ag/cards/accountId?={AccountInstanceId}
        /*accountInstanceIdStore: any = {};*/
        // Which layout values have been loaded
        this.loadedLayoutValues = [];
        // show loan Fx
        this.showLoanFx = new EventEmitter();
        this.isMobile = false;
        //nga intr to servicing fix
        this.isSetServiceDone = false;
        // journey teams sets this variable for turning the signOn link to on/off
        // navigation2 component listens to this and does accordingly
        this.signOn = new BehaviorSubject(true);
        this.movesignOn = new BehaviorSubject(true);
        this.homepagesignOn = new BehaviorSubject(false);
        this.interstitialsType = new BehaviorSubject(false);
        //journey teams sets these variable for turning the below footer content with links to on/off
        this.footerLinks = new BehaviorSubject(true);
        this.footerLogos = new BehaviorSubject(true);
        this.changeUrl = new BehaviorSubject(true);
        this.headerSize = new BehaviorSubject(false);
        this.buttonsOn = new BehaviorSubject(true);
        this.overrideBrandingData = new BehaviorSubject(false);
        this.modifyBranding = new BehaviorSubject(null);
        this.footerLoaded = new BehaviorSubject(false);
        //GBC-3615 Fallback Branding
        this.errorBranding = '';
        this.htmlKeys = ['copy', 'copy_es_US', 'text', 'text_es_US'];
        this.keysToRemoveIfNull = [
            'target', 'name', 'url', 'anchorText', 'buttonText', 'buttonText_es_Us', 'label'
        ];
        this.keysToRemoveIfFalse = ['image', 'showAppImage'];
        this.unwrapArrayKeys = ['speedbump'];
        this.decodeHtmlEntities = (str) => {
            const parser = new DOMParser();
            const decoded = parser.parseFromString(str, 'text/html');
            return decoded.body.textContent || "";
        };
        this.transformObject = (obj, parentKey = '') => {
            if (obj === null || typeof obj !== 'object')
                return obj;
            if (Array.isArray(obj)) {
                const cleanedArray = obj
                    .map((item) => this.transformObject(item, parentKey))
                    .filter((item) => item !== null &&
                    (typeof item !== 'object' || Object.keys(item).length > 0));
                if (this.unwrapArrayKeys.includes(parentKey)) {
                    if (cleanedArray.length === 1)
                        return cleanedArray[0];
                    if (cleanedArray.length === 0)
                        return null;
                }
                return cleanedArray;
            }
            const result = {};
            for (const key in obj) {
                const value = obj[key];
                if (value === null && this.keysToRemoveIfNull.includes(key))
                    continue;
                if (value === false && this.keysToRemoveIfFalse.includes(key))
                    continue;
                if (this.htmlKeys.includes(key) &&
                    value?.html &&
                    typeof value.html === 'string') {
                    result[key] = this.cleanHtmlValue(value.html, key, parentKey);
                    continue;
                }
                const cleaned = this.transformObject(value, key);
                const isValid = cleaned !== null &&
                    (typeof cleaned !== 'object' ||
                        (Array.isArray(cleaned) && cleaned.length > 0) ||
                        (!Array.isArray(cleaned) && Object.keys(cleaned).length > 0));
                if (isValid)
                    result[key] = cleaned;
            }
            return result;
        };
        //////////////////////
        // BRANDING LOADING //
        ////////////////////// {
        // Sets the service
        this.setServiceData = (isSmartSearchEnabled, pageId, servicingType, brandingType) => {
            // Set whether or not the branding type should be updated
            //this.shouldUpdateBrandingType = !this.type || brandingType !== this.type ? true : false;
            // Set each of the four values we need on the service
            this.isSmartSearchEnabled = isSmartSearchEnabled;
            this.pageId = pageId;
            this.servicingType = servicingType;
            this.type =
                !this.type || this.type !== brandingType ? brandingType : this.type;
            // Update the branding type
            if (this.checkValidations() && !this.callCheck) {
                this.callCheck = true;
                this.updateJamp();
                this.getNavigationData().subscribe((result) => {
                    this.callCheck = true;
                    this.brandingData = result;
                    console.log("branding", this.brandingData);
                    this.bannerData = this.brandingData.find(item => item.hasOwnProperty("banner"));
                    this.preNavigationData = result.find(item => item.hasOwnProperty("preNavigation"));
                    this.postNavigationData = result.find(item => item.hasOwnProperty("postNavigation"));
                    this.updateBrandingType();
                }, err => {
                    // Handle the error case for navigation content file
                    this.bannerData = this.brandingTypeService.getBranding('localBanner');
                    this.preNavigationData = this.brandingTypeService.getBranding('localPreNavigation');
                    this.postNavigationData = this.brandingTypeService.getBranding('localPostNavigation');
                    this.updateBrandingType();
                });
                this.footerLoaded.subscribe(val => {
                    if (val) {
                        this.contentService
                            .getAemContent(`global-nav/get-gn-footer%3Bpath=/content/dam/cfs/uspb/global-nav/en/web/footer/footer-links/footer-cont`)
                            .subscribe(res => {
                            if (res.data !== null) {
                                console.log('AEM footer data', res);
                                this.callCheck = true;
                                this.brandingData = res;
                                const dataChanged = this.transformObject(this.brandingData);
                                this.footerData = {
                                    footer: dataChanged.data.footer.item
                                };
                                this.shouldUpdateBrandingType = true;
                                this.updateBrandingType();
                            }
                            else {
                                this.shouldUpdateBrandingType = true;
                                this.footerICMS();
                            }
                        }, error => {
                            // Route to ICMS if content fails
                            this.shouldUpdateBrandingType = true;
                            this.footerICMS();
                        });
                    }
                });
            }
            else if (this.brandingData) {
                this.updateBrandingType();
            }
        };
        this.isBrowser = isPlatformBrowser(this._platformId);
        this.host_url = this.isBrowser
            ? ''
            : this.appConfigService.getConfig('customConfig').brandingApiUrl;
        this.getMobile();
        this.init();
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), pairwise(), filter((events) => {
            console.log('Reset Branding call', events[0].url.split('/'));
            console.log("service events", events[1].url.split('/')[1], events[0].url.split('/')[1]);
            return (events[0].url.split('/')[1] !==
                events[1].url.split('/')[1]);
        }), startWith('Initial call'), takeUntil(this.destroyed))
            .subscribe((events) => {
            this.resetBrandingData();
        });
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
    // TODO: Remove method after instances of this method from other features are removed
    FdicToggle(showHide) {
        // this.showHide = !this.showHide;
        // this.ToggleFdic.emit(showHide);
    }
    getMobile() {
        return (this.isBrowser && window.innerWidth <= 990) || false;
    }
    showSignOn(val) {
        this.signOn.next(val);
    }
    moveSignOn(val) {
        this.movesignOn.next(val);
    }
    homepageSignOn(val) {
        this.homepagesignOn.next(val);
    }
    // WPB Microsite toggle features
    showFooterLinks(val) {
        this.footerLinks.next(val);
    }
    showFooterLogos(val) {
        this.footerLogos.next(val);
    }
    changeLogoUrl(val) {
        this.changeUrl.next(val);
    }
    reduceHeaderSize(val) {
        this.headerSize.next(val);
    }
    //HLO Buttons toggle feature
    showBannerButtons(val) {
        this.buttonsOn.next(val);
    }
    //Deferred Footer Loading
    notifyFooterLoad() {
        this.footerLoaded.next(true);
    }
    // On Init
    // Subscribes to the layoutsService brandingTypeChange event emitter
    // Handles changing the branding type if needed based on the new branding type caught from the layouts service and the state of the branding service
    init() {
        console.log("Inside Branding Service Init");
        this.getLoggedInStatus();
        // Get the locale for the visitor
        this.locale = this.getLocale();
        // Get the user role
        this.userRole = this.getUserRole();
        // Get the language of the document
        this.language = this.getLanguage();
        // Branding SSR show or not
        this.showBrandingSSR = this._isSSRApp || this.isModFed();
        console.log("Checking isBrowser Value", this.isBrowser);
        if (!this.isBrowser) {
            console.log("Server Side Check of Branding Service Init Method");
            this.layoutsService.changeFullPageLoading(false);
            let brandingData = this.checkBrandingUrl('newbaseCSRSSR');
            this.emitData(brandingData, true);
            return;
        }
        // Subscribe to all four values we need to wait on before proceding
        combineLatest(this.getSmartSearchEnabled(), this.layoutsService.pageIdChanged, this.layoutsService.servicingTypeChanged, this.layoutsService.brandingTypeChanged).subscribe(data => {
            this.setServiceData(...Array.from(data));
        }, error => {
            // Get default branding as a backup
            this.type = 'default';
            this.getDefaultBranding();
        });
        // Listen for the page id to change on the layout
        this.layoutsService.pageIdChanged.subscribe(id => {
            // Set the page id
            this.pageId = id;
            // Push this value to the loaded layout values array
            this.loadedLayoutValues.push('pageId');
        });
        // Listen for a new servicing type to be set on the layout
        this.layoutsService.servicingTypeChanged.subscribe(type => {
            // Set the servicing type
            this.servicingType = type;
            // Push this value to the loaded layout values array
            this.loadedLayoutValues.push('servicingType');
        });
        // Listen for the branding type to change on the layout
        this.layoutsService.brandingTypeChanged.subscribe(brandingType => {
            // Get whether or not the branding should be updated based on the new type
            this.shouldUpdateBrandingType =
                !this.type || brandingType !== this.type || !this.isSetServiceDone
                    ? true
                    : false;
            // Set the new type
            this.type = this.shouldUpdateBrandingType ? brandingType : this.type;
            // Push this value to the loaded layout values array
            this.loadedLayoutValues.push('servicingType');
        });
    }
    checkValidations() {
        if (!this.isLoggedIn) {
            if (!this.preNavigationData) {
                this.callCheck = false;
                return true;
            }
            else
                return false;
        }
        else if (this.isLoggedIn) {
            if (!this.postNavigationData) {
                return true;
            }
            else
                return false;
        }
    }
    //////////////////////
    // BRANDING FETCH //
    ////////////////////// 
    getNavigationData() {
        if (!this.isLoggedIn) {
            let bannerUrl = this.host_url + this.url + '/banner.json';
            let navUrl = this.host_url + this.url + '/preNavigation.json';
            return forkJoin([
                this.angularHttp.get(bannerUrl),
                this.angularHttp.get(navUrl)
            ]);
        }
        else {
            let bannerUrl = this.host_url + this.url + '/banner.json';
            let navUrl = this.host_url + this.url + '/postNavigation.json';
            return forkJoin([
                this.angularHttp.get(bannerUrl),
                this.angularHttp.get(navUrl)
            ]);
        }
    }
    getFooterData() {
        if (!this.isLoggedIn) {
            let footerUrl = this.host_url + this.url + '/footer.json';
            return forkJoin([
                this.angularHttp.get(footerUrl)
            ]);
        }
        else {
            let footerUrl = this.host_url + this.url + '/footer.json';
            return forkJoin([
                this.angularHttp.get(footerUrl)
            ]);
        }
    }
    cleanHtmlValue(htmlString, key, parentKey) {
        const decoded = this.decodeHtmlEntities(htmlString.trim());
        return decoded;
    }
    footerICMS() {
        this.getFooterData().subscribe((result) => {
            this.brandingData = result;
            this.footerData = this.brandingData.find(item => item.hasOwnProperty("footer"));
            this.updateBrandingType();
        }, err => {
            // Handle the error case for navigation content file
            this.footerData = this.brandingTypeService.getBranding('localFooter');
            this.updateBrandingType();
        });
    }
    getSPBS() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                if (sessionParams) {
                    return sessionParams;
                }
            }
            catch (err) {
                return false;
            }
        }
    }
    // For SSR do not change loading to avoid blank page on homepage
    updateJamp() {
        if (this._isSSRApp) {
            console.log('full page loading not triggered for ssr app and default branding type, do not show JAMP');
            // put this after oct release
            this.layoutsService.changeFullPageLoading(false);
        }
        else {
            // Set the full page JAMP to show
            this.layoutsService.changeFullPageLoading(true);
        }
    }
    // Updates the branding type
    updateBrandingType() {
        // null branding on first load fix
        if (this.overrideBrandingData.getValue() == false) {
            this.shouldUpdateBrandingType = true;
        }
        // If we are trying to load default branding
        if (this.shouldUpdateBrandingType) {
            this.updateJamp();
            if (this.type === 'default') {
                if (this.isBrowser && this._sessionStorage)
                    this._sessionStorage.setItem('isMarketingBrandingOrDefault', 'true');
                // Get the default branding
                this.getDefaultBranding();
            }
            else if (this.type === 'servicing') {
                if (this.isBrowser && this._sessionStorage)
                    // Get the data from the micro-service
                    this._sessionStorage.setItem('isMarketingBrandingOrDefault', 'false');
                if (this.serviceBrandingCall) {
                    this.getBrandingFromService();
                }
                else {
                    if (this.defaultBrandingSet) {
                        if (this.isBrowser &&
                            (window.location.hostname.includes('citi.com') &&
                                this.isLoggedIn)) {
                            this.layoutsService.postBrandingStorage.subscribe(res => {
                                if (!!res) {
                                    this.sessionParams = this.getSPBS();
                                    this.getBrandingFromService();
                                }
                            }, err => {
                                this.getBrandingFromService();
                            });
                        }
                        else {
                            this.sessionParams = this.getSPBS();
                            this.getBrandingFromService();
                        }
                    }
                    else {
                        this.layoutsService.postBrandingStorage.subscribe(res => {
                            if (!!res) {
                                this.sessionParams = this.getSPBS();
                                this.getBrandingFromService();
                            }
                        }, err => {
                            this.getBrandingFromService();
                        });
                    }
                }
            }
            else if (this.type === 'interstitials') {
                this.interstitialsType.next(this.type);
                if (this.isBrowser && this._sessionStorage)
                    this._sessionStorage.setItem('isMarketingBrandingOrDefault', 'false');
                if (this.interstitialBrandingCall) {
                    this.getInterstitialsBranding();
                }
                else {
                    this.layoutsService.postBrandingStorage.subscribe(res => {
                        if (!!res && this.type === 'interstitials') {
                            this.sessionParams = this.getSPBS();
                            let routerURL = this.router.url;
                            if (routerURL.includes('BankingServices')) {
                                this.getBrandingFromService();
                            }
                            else {
                                this.getInterstitialsBranding();
                            }
                        }
                    }, err => {
                        this.getInterstitialsBranding();
                    });
                }
            }
            else if (this.type === 'marketing') {
                if (this.isBrowser && this._sessionStorage)
                    this._sessionStorage.setItem('isMarketingBrandingOrDefault', 'true');
                // Get the marketing branding from the branding type service
                this.getMarketingBranding();
            }
            else if (this.type === 'preLoginVanilla') {
                this.interstitialsType.next(this.type);
                this.getCustomInterstitials();
            }
            else if (this.type === 'none') {
                // Emit an empty object to remove branding from the page
                // this.emitData({}, true);
                this.removeBranding();
            }
        }
    }
    removeBranding() {
        let data;
        data = {};
        data.header = {};
        data.header.butler = {};
        data.header.banner = {};
        data.footer = {};
        this.emitData(data, true);
    }
    // Gets the marketing branding based on the ECM and locale cookies.  Uses the branding type service.
    getMarketingBranding() {
        // Get the base branding data using the locale
        let brandingType = 'newbaseCSRSSR';
        // Load local branding based on the branding type above
        this.loadLocalBranding(brandingType);
    }
    // Gets the default branding based on logged in/out state, locale, and customer relationship.
    // This might be able to be extended to support the new work on branding to separate PII and static data.
    getDefaultBranding() {
        // Get the branding type we should be using
        //let brandingType = this.getBrandingType();
        let brandingType = 'newbaseCSRSSR';
        // Load branding based on the above type
        this.loadLocalBranding(brandingType);
    }
    //Used in multiple places inside branding service for emitting branding data
    getDataFromMultipleSources(brandingUrl, logosUrl, topNavUrl, modifier) {
        if (!logosUrl && !topNavUrl && !modifier) {
            const brandingResult = this.checkBrandingUrl(brandingUrl);
            const data = this.validateContent(brandingResult);
            return data ? of(data) : throwError("Error in fetching branding data");
        }
        else if (!logosUrl) {
            const brandingResult = this.checkBrandingUrl(brandingUrl);
            const topNavResult = this.checkTopNavUrl(topNavUrl);
            const data = this.validateContent(brandingResult, topNavResult);
            return data ? of(data) : throwError("Error in fetching branding data");
        }
        else if (topNavUrl) {
            const brandingResult = this.checkBrandingUrl(brandingUrl);
            const logosResult = this.checkLogosUrl(logosUrl);
            const topNavResult = this.checkTopNavUrl(topNavUrl);
            const data = this.validateContent(brandingResult, logosResult, topNavResult);
            return (data && topNavResult) ? of(data) : throwError("Error in fetching branding data");
        }
        else {
            const brandingResult = this.checkBrandingUrl(brandingUrl);
            const logosResult = this.checkLogosUrl(logosUrl);
            const data = this.validateContent(brandingResult, logosResult);
            return data ? of(data) : throwError("Error in fetching branding data");
        }
    }
    //method for constructing data structure similar to newbaseCSRSSR/newBranding
    checkBrandingUrl(key) {
        if (key === 'newbaseCSRSSR') {
            const newBase = {};
            newBase.data = { header: {}, footer: {} };
            if ((this.bannerData && this.preNavigationData) || this.footerData) {
                newBase.data.header.banner = JSON.parse(JSON.stringify(this.bannerData.banner.preBanner));
                newBase.data.header.navigation = JSON.parse(JSON.stringify(this.preNavigationData.preNavigation));
                this.footerData ? newBase.data.footer = JSON.parse(JSON.stringify(this.footerData.footer.preFooter)) : '';
                return newBase;
            }
        }
        else if (key === 'newBranding') {
            const newBranding = {};
            newBranding.data = { header: {}, footer: {} };
            if (this.bannerData) {
                newBranding.data.header = JSON.parse(JSON.stringify(this.bannerData.banner.postBanner));
                this.footerData ? newBranding.data.footer = JSON.parse(JSON.stringify(this.footerData.footer.postFooter)) : '';
                return newBranding;
            }
        }
    }
    //method for constructing data structure similar to newLogos
    checkLogosUrl(key) {
        if (key === 'newLogos') {
            let logos = {};
            if (this.bannerData) {
                logos.data = JSON.parse(JSON.stringify(this.bannerData.logosData));
                return logos;
            }
        }
    }
    //method for constructing data structure similar to newTopNavigation
    checkTopNavUrl(key) {
        if (key === 'newTopNavigationCSRSSR') {
            let topNav = {};
            if (this.postNavigationData) {
                topNav.data = JSON.parse(JSON.stringify(this.postNavigationData.postNavigation));
                return topNav;
            }
        }
    }
    //returns proper array of data objects from getDataFromMultipleSources method.
    validateContent(...objects) {
        const validObjects = objects.filter(obj => obj !== undefined && obj !== null && Object.keys(obj).length > 0);
        if (validObjects.length > 0) {
            return validObjects;
        }
    }
    // Loads local branding based on a given type
    loadLocalBranding(brandingType) {
        this.sessionParams = this.getSPBS();
        // Get the branding modifier if there is one
        let modifier = this.getBrandingModifier();
        // Branding data urls
        let brandingUrl = 'newbaseCSRSSR';
        //Fix for GBC-6685
        let logosUrl = 'newLogos';
        // If we got a modifier
        const hasModifier = modifier !== false;
        if (this.isBrowser) {
            // ForkJoin - First param is getting branding json, 2nd param-modifier, 3rd param - getting logos json.
            this.getDataFromMultipleSources(brandingUrl, logosUrl).subscribe((brandingResults) => {
                this.displayDefaultBranding(brandingResults, hasModifier, hasModifier ? modifier : undefined);
            }, (err) => {
                console.log(`Error: prelogin calls failed in branding - ${err}`);
                this.loadBrandingOnError(brandingType, hasModifier, hasModifier ? modifier : undefined);
            });
        }
    }
    displayDefaultBranding(brandingResults, brandingModified, newModiferData) {
        console.log('Displaying prelogin/Marketing branding');
        let i;
        let j;
        let k;
        let brandingData;
        let logo;
        let displayPreloginNavs = null;
        brandingData = brandingResults[0].data;
        // Set the sign button
        brandingData = this.setSignButton(brandingData);
        // Set the page information on the branding data object
        brandingData = this.setPageInformation(brandingData);
        if (brandingModified) {
            brandingData.header.banner.logo.defaultCust = false;
            if (newModiferData === 'cpb') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.cpb.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.cpb.mobileImage;
                //brandingData.header.banner.logo.privateCust = true;
                brandingData.header.banner.logo.hoverColor = 'private';
                brandingData.header.banner.logo.customer = 'cpb';
            }
            else if (newModiferData === 'cpc') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.cpc.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.cpc.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'cpc';
                brandingData.header.banner.logo.customer = 'cpc';
            }
            else if (newModiferData === 'alliance') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.alliance.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.alliance.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'alliance';
                brandingData.header.banner.logo.customer = 'alliance';
            }
            else if (newModiferData === 'gold') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.gold.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.gold.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'gold';
                brandingData.header.banner.logo.customer = 'gold';
            }
            else if (newModiferData === 'priority') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.priority.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.priority.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'priority';
                brandingData.header.banner.logo.customer = 'priority';
            }
            if (this.sessionParams) {
                logo = this.getLogo(brandingResults[1], this.sessionParams);
                brandingData.header.banner.logo.defaultCust = logo.default
                    ? logo.default
                    : false;
                brandingData.header.banner.logo.image = logo.image;
                brandingData.header.banner.logo.mobileImage = logo.mobileImage
                    ? logo.mobileImage
                    : null;
                brandingData.header.banner.logo.hoverColor = logo.hoverColor;
                brandingData.header.banner.logo.customer = logo.customer
                    ? logo.customer
                    : 'default';
            }
        }
        else {
            if (this.sessionParams) {
                logo = this.getLogo(brandingResults[1], this.sessionParams);
                brandingData.header.banner.logo.defaultCust = logo.default
                    ? logo.default
                    : false;
                brandingData.header.banner.logo.image = logo.image;
                brandingData.header.banner.logo.mobileImage = logo.mobileImage
                    ? logo.mobileImage
                    : null;
                brandingData.header.banner.logo.hoverColor = logo.hoverColor;
                brandingData.header.banner.logo.customer = logo.customer
                    ? logo.customer
                    : 'default';
            }
        }
        if (brandingData && brandingData.header) {
            this.updateHeaderData(brandingData.header);
        }
        if (brandingData && brandingData.header && brandingData.header.navigation) {
            displayPreloginNavs = brandingData.header.navigation.navigationItems;
            for (i = 0; i < displayPreloginNavs.length; i++) {
                if (displayPreloginNavs[i].navigationItems) {
                    for (j = 0; j < Object.keys(displayPreloginNavs[i].navigationItems).length; j++) {
                        if (displayPreloginNavs[i].navigationItems[j].items) {
                            for (k = 0; k < displayPreloginNavs[i].navigationItems[j].items.length; k++)
                                displayPreloginNavs[i].navigationItems[j].items[k].show = this.getShowValue(displayPreloginNavs[i].navigationItems[j].items[k].show);
                        }
                    }
                }
            }
        }
        let footer = this.getFooter(brandingResults[0], this.sessionParams);
        brandingData.footer = footer;
        this.emitData(brandingData, true);
    }
    //GBC-3615 Fallback Branding
    loadPostBrandingOnError() {
        console.log('Enters into PostBranding error scenario');
        if (this.showBrandingSSR) {
            return;
        }
        if (this.errorBranding != '') {
            return;
        }
        let overallData = [
            this.checkBrandingUrl(`newBranding`),
            this.checkTopNavUrl(`newTopNavigationCSRSSR`),
            this.checkLogosUrl('newLogos')
        ];
        let branding = overallData[0];
        let topNav = this.getTopNav(overallData[1], this.sessionParams);
        let footerData = this.getFooter(branding, false);
        let logo = this.getLogo(overallData[2], this.sessionParams);
        branding.data.header.navigation.navigationItems = topNav;
        branding.data.footer = footerData;
        branding.data = this.showLoanFxBrandingButler(branding.data);
        if (branding.data && branding.data.header) {
            this.updateHeaderData(branding.data.header);
        }
        if (this.sessionParams.isSPFMigrated == 'Y' &&
            this.sessionParams.isATTCard != 'Y') {
            branding.data.header.welcome.logo = logo;
        }
        else {
            let logo = this.getLogo(overallData[2], this.sessionParams);
            branding.data.header.banner.logo.defaultCust = logo.default
                ? logo.default
                : false;
            branding.data.header.banner.logo.customer = logo.customer
                ? logo.customer
                : 'default';
            branding.data.header.banner.logo.image = logo.image;
            branding.data.header.banner.logo.mobileImage = logo.mobileImage
                ? logo.mobileImage
                : null;
            branding.data.header.banner.logo.hoverColor = logo.hoverColor;
        }
        this.emitData(branding.data, true);
        this.errorBranding = 'avoid multiple times call';
    }
    loadBrandingOnError(brandingType, brandingModified, newModiferData) {
        if (this.showBrandingSSR) {
            brandingType = 'newbaseCSRSSR';
        }
        //GBC-3615 Fallback Branding
        if (this.isLoggedIn && !this.showBrandingSSR) {
            this.loadPostBrandingOnError();
            return;
        }
        let brandingData = this.checkBrandingUrl(brandingType);
        if (brandingData && brandingData.header) {
            this.updateHeaderData(brandingData.header);
        }
        if (brandingModified) {
            brandingData.header.banner.logo.defaultCust = false;
            if (newModiferData === 'cpb') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.cpb.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.cpb.mobileImage;
                //brandingData.header.banner.logo.privateCust= true;
                brandingData.header.banner.logo.hoverColor = 'private';
                brandingData.header.banner.logo.customer = 'cpb';
            }
            else if (newModiferData === 'cpc') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.cpc.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.cpc.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'cpc';
                brandingData.header.banner.logo.customer = 'cpc';
            }
            else if (newModiferData === 'gold') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.gold.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.gold.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'gold';
                brandingData.header.banner.logo.customer = 'gold';
            }
            else if (newModiferData === 'priority') {
                brandingData.header.banner.logo.image =
                    brandingData.header.banner.logo.priority.desktopImage;
                brandingData.header.banner.logo.mobileImage =
                    brandingData.header.banner.logo.priority.mobileImage;
                brandingData.header.banner.logo.hoverColor = 'priority';
                brandingData.header.banner.logo.customer = 'priority';
            }
        }
        if (brandingData && brandingData.header && brandingData.header.navigation) {
            let displayPreloginNavs = brandingData.header.navigation.navigationItems;
            for (let i = 0; i < displayPreloginNavs.length; i++) {
                if (displayPreloginNavs[i].navigationItems) {
                    for (let j = 0; j < Object.keys(displayPreloginNavs[i].navigationItems).length; j++) {
                        if (displayPreloginNavs[i].navigationItems[j].items) {
                            for (let k = 0; k < displayPreloginNavs[i].navigationItems[j].items.length; k++)
                                displayPreloginNavs[i].navigationItems[j].items[k].show = this.getShowValue(displayPreloginNavs[i].navigationItems[j].items[k].show);
                        }
                    }
                }
            }
        }
        console.log(brandingData);
        this.emitData(brandingData, true);
    }
    // Gets data from the branding micro-service using the container HTTP service
    getBrandingFromService() {
        this.interstitialsType.next(false);
        this.serviceBrandingCall = true;
        let logosUrl = 'newLogos';
        // Cancel any existing call
        this.call ? this.call.unsubscribe() : false;
        // Set the servicing type on the session params if it is available
        if (this.servicingType) {
            this.sessionParams.type = this.servicingType;
        }
        if (this.sessionParams) {
            let brandingUrl;
            if (this.isLoggedIn) {
                brandingUrl = 'newBranding';
                console.log('new branding url is modified to ' + brandingUrl);
            }
            let topNavUrl = '';
            topNavUrl = 'newTopNavigationCSRSSR';
            console.log('teast' + topNavUrl);
            this.getDataFromMultipleSources(brandingUrl, logosUrl, topNavUrl).subscribe(results => {
                let branding = results[0];
                let logo = this.getLogo(results[1], this.sessionParams);
                let topNavs = this.getTopNav(results[2], this.sessionParams);
                let footer = this.getFooter(branding, this.sessionParams);
                branding.data.footer = footer;
                branding.data.header.navigation.navigationItems = topNavs;
                if (branding.data && branding.data.header) {
                    this.updateHeaderData(branding.data.header);
                }
                branding = this.showLoanFxBrandingButler(branding);
                if (this.sessionParams.isSPFMigrated == 'Y' &&
                    this.sessionParams.isATTCard != 'Y') {
                    branding.data.header.welcome.logo = logo;
                }
                else {
                    let logo = this.getLogo(results[1], this.sessionParams);
                    branding.data.header.banner.logo.defaultCust = logo.default
                        ? logo.default
                        : false;
                    branding.data.header.banner.logo.customer = logo.customer
                        ? logo.customer
                        : 'default';
                    branding.data.header.banner.logo.image = logo.image;
                    branding.data.header.banner.logo.mobileImage = logo.mobileImage
                        ? logo.mobileImage
                        : null;
                    branding.data.header.banner.logo.comments = logo.comments
                        ? logo.comments
                        : null;
                    branding.data.header.banner.logo.hoverColor = logo.hoverColor;
                }
                // Emit the new data
                branding.data = this.setPageInformation(branding.data);
                let brandingData = this.setSignButtonPostLogin(branding.data);
                // loanFx logic
                this.emitData(branding.data, true);
                this.isSetServiceDone = true;
            }, err => {
                // Handle the error
                this.handleError();
            });
        }
        else {
            // Handle the error
            this.handleIAError();
        }
        // this.layoutsService.postBrandingStorage.unsubscribe();
    }
    stripAssetHostName(str) {
        if (str.includes(this.appConfigService.getcsrHostName())) {
            str = str.replace(this.appConfigService.getcsrHostName(), '');
            return str;
        }
        else if (str.includes(this.appConfigService.getnewCitiHostName())) {
            str = str.replace(this.appConfigService.getnewCitiHostName(), '');
            return str;
        }
        else {
            return str;
        }
    }
    // show loanfx branding function
    showLoanFxBrandingButler(branding) {
        // loanFx logic
        if (this.sessionParams.customerType == 'LOANFX' &&
            this.type !== 'marketing') {
            this.showLoanFx.emit(true);
            branding.data.header.navigation.navigationItems = branding.data.header.navigation.navigationItems.filter(item => item.title == 'Sign Off');
            branding.data.header.butler.navigationItems = branding.data.header.butler.navigationItems.filter(nav => nav.title == 'My Accounts');
        }
        return branding;
    }
    getInterstitialsBranding() {
        this.interstitialBrandingCall = true;
        this.isSetServiceDone = false;
        // Cancel any existing call
        this.call ? this.call.unsubscribe() : false;
        if (this.isBrowser && this._sessionStorage)
            this._sessionStorage.removeItem('selectedMenuIndex');
        // Set the servicing type on the session params if it is available
        if (this.servicingType) {
            this.sessionParams.type = this.servicingType;
        }
        if (this.sessionParams) {
            //this.sessionParams = JSON.parse(this.sessionParams);
            let brandingUrl;
            if (this.isLoggedIn) {
                brandingUrl = 'newBranding';
                console.log('new branding url is modified to ' + brandingUrl);
            }
            let topNavUrl = '';
            topNavUrl = 'newTopNavigationCSRSSR';
            // let topNavUrl = this.host_url + this.url + '/newTopNavigation.json';
            console.log('test' + topNavUrl);
            this.getDataFromMultipleSources(brandingUrl, undefined, topNavUrl).subscribe(results => {
                let branding = results[0];
                let navs = results[1];
                //branding.data.header.butler.show = false;
                //branding.data.header.banner.search.show = false;
                if (branding.data && branding.data.header) {
                    this.updateHeaderData(branding.data.header);
                }
                branding.data.header.banner.buttonsData = [];
                let topNavs = [];
                let i;
                if (navs.data) {
                    for (i = 0; i < Object.keys(navs.data.navigationItems).length; i++) {
                        if (navs.data.navigationItems[i].id == 'signOff') {
                            navs.data.navigationItems[i].interstitials = true;
                            navs.data.navigationItems[i].show = true;
                            topNavs.push(navs.data.navigationItems[i]);
                        }
                    }
                }
                let footer = this.getFooter(branding, this.sessionParams);
                branding.data.footer = footer;
                branding.data.header.navigation.navigationItems = topNavs;
                this.emitData(branding.data, true);
            }, err => {
                // Handle the error
                this.handleError();
            });
        }
        else {
            // Handle the error
            this.handleIAError();
        }
        // this.layoutsService.postBrandingStorage.unsubscribe();
    }
    getCustomInterstitials() {
        this.call ? this.call.unsubscribe() : false;
        if (this.isBrowser && this._sessionStorage)
            this._sessionStorage.removeItem('selectedMenuIndex');
        let brandingUrl;
        brandingUrl = 'newbaseCSRSSR';
        this.getDataFromMultipleSources(brandingUrl).subscribe(results => {
            let branding = results[0];
            branding.data.header.banner.buttonsData = [];
            branding.data.header.navigation.help.show = false;
            branding.data.header.navigation.navigationItems = [];
            let footer = this.getFooter(branding, this.sessionParams);
            branding.data.footer = footer;
            this.emitData(branding.data, true);
        }, err => {
            let brandingType = 'newbaseCSRSSR';
            let branding = this.checkBrandingUrl(brandingType);
            branding.header.banner.buttonsData = [];
            branding.header.navigation.help.show = false;
            branding.header.navigation.navigationItems = [];
            this.emitData(branding, true);
        });
    }
    emitSocialMediaLinks(data) {
        this.mediaLink = data;
        console.log("Emitted Value", this.mediaLink);
        this.mediaClick.emit(this.mediaLink);
    }
    emitSocialMediaContinueLinks(data) {
        this.mediaContinueLink = data;
        console.log("Emitted Value from continue button", this.mediaContinueLink);
        this.mediaContinueClick.emit(this.mediaContinueLink);
    }
    ///////////////////
    // DATA HANDLING //
    /////////////////// {
    // Sets the data to the service and emits dataUpdate and onDataReady as needed
    emitData(data, newDataIsInternal) {
        // Set the data on the service
        //toggle branding for Reimagine
        if (data) {
            let channelID = this.cookieService.getCookie('channelId');
            if (channelID) {
                if (channelID == 'SFRTL' || channelID == 'ECLIPSE') {
                    if (Object.keys(data.header).length > 0 && Object.keys(data.footer).length > 0) {
                        data.header.show = false;
                        data.footer.show = false;
                    }
                }
            }
            this.dataBackUp = JSON.parse(JSON.stringify(this.data));
            this.data = data;
            // Emit the data update
            this.dataUpdate.emit(this.data);
            // If this is the first run
            if (newDataIsInternal) {
                // Emit that the data is ready
                this.onDataReady.next(true);
            }
            console.log("Backed Up Data", this.dataBackUp);
            // Remove the loader
            this.layoutsService.changeFullPageLoading(false);
        }
    }
    // Gets the data from the branding service
    getData() {
        // Return the data attached to the service
        return this.data;
    }
    resetBrandingData() {
        this.overrideBrandingData.next(false);
        //this.data = this.dataBackUp;
    }
    // Accepts new data for the branding service
    setData(data) {
        // Check if we got data
        if (typeof data !== 'undefined') {
            // Emit the changes
            this.overrideBrandingData.next(true);
            this.emitData(data, false);
        }
    }
    ////////////////////
    // ERROR HANDLING //
    //////////////////// {
    // Handles any errors
    handleError() {
        //GBC-3615 Fallback Branding
        if (this.isLoggedIn && !this.showBrandingSSR) {
            this.loadPostBrandingOnError();
            return;
        }
        // Get default branding in the case that branding fails
        this.getDefaultBranding();
    }
    handleIAError() {
        // Get MRC branding in the case that branding fails for IA
        let brandingUrl;
        if (this.isLoggedIn) {
            brandingUrl = 'newBranding';
        }
        let logosUrl = 'newLogos';
        let topNavUrl = '';
        topNavUrl = 'newTopNavigationCSRSSR';
        this.getDataFromMultipleSources(brandingUrl, logosUrl, topNavUrl).subscribe(results => {
            let branding = results[0];
            let logo = this.getLogo(results[1], this.sessionParams);
            let topNavs = this.getTopNav(results[2], this.sessionParams);
            let footer = this.getFooter(branding, this.sessionParams);
            branding.data.footer = footer;
            branding.data.header.navigation.navigationItems = topNavs;
            // Emit the new data
            this.emitData(branding.data, true);
        }, err => {
            // Handle the error
            this.handleError();
        });
    }
    ///////////////////////
    // UTILITY FUNCTIONS //
    /////////////////////// {
    // Gets the logged in status of the user visiting the page and returns true or false
    getLoggedInStatus() {
        /* value returns a string of type of session user is in(nga/legacy). But if it is falsy, user is not loggedIn */
        this.authService.getSessionObservable().subscribe(val => {
            this.isLoggedIn = !!val;
            if (!!val) {
                this.sessionParams = this.getSPBS();
            }
        });
    }
    // Gets the locale from the locale cookie.  Falls back on en_US if no locale is set.
    getLocale() {
        // Get the locale from the cookie
        let locale = this.isBrowser
            ? this.cookieService.getCookie('locale')
            : 'en_US';
        // Fall back on en_US if no locale is specified
        locale = locale ? locale : 'en_US';
        //added indexOf below for GBC-4817, JFP token is appending to locale cookie happens in production
        if (locale.indexOf('es_US') >= 0) {
            locale = 'es_US';
        }
        else {
            locale = 'en_US';
        }
        // Return the locale
        return locale;
    }
    // Gets the customer relationship type.  Current supported values are mrc, spf, and base
    getBrandingType() {
        // The string we will use to get the type of branding we need
        let brandingType;
        // Check if the user is SPF migrated
        let isSpf = this.postSessionService.getItem('isSpfMigrated') === 'Y';
        // Determine whether or not the user is an MRC customer
        let isMrc = this.isLoggedIn && !isSpf ? true : false;
        // Determine whether or not this is a blue customer
        let isBlue = !isSpf && !isMrc ? true : false;
        // Add the SPF or MRC prefix based on the value we found for isSpf
        brandingType = isBlue ? 'base' : isMrc ? 'mrc' : isSpf ? 'spf' : false;
        // If we got a branding type and a locale
        if (brandingType && this.locale) {
            // Return the branding type
            return brandingType + '_' + this.locale;
        }
        else {
            // Otherwise return false
            return false;
        }
    }
    // Gets the branding modifier if there is one to be applied
    getBrandingModifier() {
        // Check whether or not the logged in customer is a CitiGold customer
        let isGold = this.ecmCookieService.getValueByName('isCitigoldCookie');
        // Check whether or not the logged in customer is a CitiPriority customer
        // changed isPriority to isCitiPriority due to ecm cookie fetch issue GBC-2896
        let isPriority = this.ecmCookieService.getValueByName('isCitiPriority');
        // Check whether or not the logged in customer is a CitiPrivateBank customer
        let isCPB = this.ecmCookieService.getValueByName('isPBG');
        //Check whether the branding is CITIAlliance
        let isAlliance = this.ecmCookieService.getValueByName('isCitiAlliance');
        // Check whether or not the logged in customer is a CitiGoldPrivateClient customer
        let isCitiGoldPrivateClientCookie = this.ecmCookieService.getValueByName('isCitiGoldPrivateClientCookie');
        // The modifier object
        let newModifier;
        if (isCPB === 'Y') {
            newModifier = 'cpb';
        }
        else if (isCitiGoldPrivateClientCookie === 'Y') {
            newModifier = 'cpc';
        }
        else if (isAlliance === 'Y') {
            newModifier = 'alliance';
        }
        else if (isGold === 'Y') {
            newModifier = 'gold';
        }
        else if (isPriority === 'Y') {
            newModifier = 'priority';
        }
        // If we got a modifier, return it otherwise return false
        return newModifier ? newModifier : false;
    }
    // Sets the sign button on a branding JavaScript object
    setSignButton(brandingData) {
        // If the visitor is signed in
        if (this.isLoggedIn) {
            // If we have the values we need
            if (brandingData.header.navigation &&
                brandingData.header.navigation.sign &&
                brandingData.header.navigation.sign.signOffWording &&
                brandingData.header.navigation.sign.signOffUrl) {
                // Set the button wording
                brandingData.header.navigation.sign.wording =
                    brandingData.header.navigation.sign.signOffWording;
                // Set the button url
                brandingData.header.navigation.sign.url =
                    brandingData.header.navigation.sign.signOffUrl;
            }
        }
        else {
            // If we have the values we need
            if (brandingData.header.navigation &&
                brandingData.header.navigation.sign &&
                brandingData.header.navigation.sign.signOnWording &&
                brandingData.header.navigation.sign.signOnUrl) {
                // Set the button wording
                brandingData.header.navigation.sign.wording =
                    brandingData.header.navigation.sign.signOnWording;
                // Set the button url
                brandingData.header.navigation.sign.url =
                    brandingData.header.navigation.sign.signOnUrl;
            }
        }
        return brandingData;
    }
    // Sets the sign button on a branding for post login customer
    setSignButtonPostLogin(brandingData) {
        let i;
        for (i = 0; i < brandingData.header.butler.navigationItems.length; i++) {
            var linkName = brandingData.header.butler.navigationItems[i].linkName;
            if (linkName && linkName == 'signWording') {
                // If the visitor is signed in and NGA cookie is available
                if (this.isLoggedIn && Cookie.get('NGACoExistenceCookie')) {
                    // If we have the values we need
                    if (brandingData.header.navigation &&
                        brandingData.header.navigation.sign &&
                        brandingData.header.navigation.sign.signOffWording &&
                        brandingData.header.navigation.sign.signOffUrl) {
                        // Set the button wording
                        brandingData.header.butler.navigationItems[i].title =
                            brandingData.header.navigation.sign.signOffWording;
                        // Set the button url
                        brandingData.header.butler.navigationItems[i].url =
                            brandingData.header.navigation.sign.signOffUrl;
                    }
                }
                else {
                    // If we have the values we need
                    if (brandingData.header.navigation &&
                        brandingData.header.navigation.sign &&
                        brandingData.header.navigation.sign.signOnWording &&
                        brandingData.header.navigation.sign.signOnUrl) {
                        // Set the button wording
                        brandingData.header.butler.navigationItems[i].title =
                            brandingData.header.navigation.sign.signOnWording;
                        // Set the button url
                        brandingData.header.butler.navigationItems[i].url =
                            brandingData.header.navigation.sign.signOnUrl;
                    }
                }
                return brandingData;
            }
        }
    }
    // Sets the page information on the search section of the branding data
    setPageInformation(brandingData) {
        // Get just the search section from the branding data
        let search = brandingData.header.banner.search;
        // If we got a search section
        if (search) {
            // Set smart search enabled flag
            search.isSmartSearchEnabled = this.isSmartSearchEnabled;
            // Set is logged in flag
            search.isLoggedIn = this.isLoggedIn;
            // Set page id
            search.pageId = this.pageId;
            // Set user role
            search.userRole = this.userRole;
            // Set page language
            search.language = this.language;
        }
        return brandingData;
    }
    // Get and return the user role
    getUserRole() {
        // Return the user role
        let userRole = this.postSessionService.getItem('userRole') || false;
        // If we are not logged in and we didn't get a user role
        if (!this.isLoggedIn && !userRole) {
            return 'VISITOR';
            // Otherwise return the user role we got
        }
        else {
            return userRole;
        }
    }
    // Get and return the current language
    getLanguage() {
        // Return the set language or false
        let language = this.postSessionService.getItem('language') || false;
        // If we are not logged in and we didn't find a language
        if (language) {
            return language;
        }
        else {
            // Try to get the locale cookie
            let locale = this.cookieService.getCookie('locale');
            // If we got the locale cookie
            if (locale) {
                // Return the first two characters of the locale string
                return locale.slice(0, 2);
            }
            else {
                // Otherwise return "en" as a default
                return 'en';
            }
        }
    }
    // Get and return if the document is smart search enabled
    getSmartSearchEnabled() {
        return of(true);
    }
    getLogo(logo, inputBrandingParams) {
        let displayLogo = null;
        if (logo && logo.data && inputBrandingParams) {
            if (inputBrandingParams.isSPFMigrated == 'Y' && logo.data.spf) {
                displayLogo = this.getDisplayLogo(logo.data.spf, inputBrandingParams);
            }
            else {
                displayLogo = this.getDisplayLogo(logo.data.mrc, inputBrandingParams);
            }
        }
        return displayLogo;
    }
    getDisplayLogo(logos, inputBrandingParams) {
        let i = 0;
        if (logos.logo) {
            for (i = 0; i < logos.logo.length; i++) {
                var logoVar = logos.logo[i];
                if (logoVar) {
                    let show = jsonLogic.apply(logoVar.show, inputBrandingParams);
                    if (show) {
                        logoVar.show = true;
                        return logoVar;
                    }
                    else if (logoVar.default) {
                        return logoVar;
                    }
                }
            }
        }
    }
    getShowValue(value) {
        if (typeof value == 'undefined')
            return true;
        else if (JSON.stringify(value) === '{}')
            return true;
        else if (value == 'Y' || value == true)
            return true;
        else
            return false;
    }
    createNavItems(topNav, inputBrandingParams) {
        let displayNavs;
        displayNavs = this.getDisplayNavs(topNav.data, inputBrandingParams);
        //sorting the top Nav elements for signOff to float right in DOM
        if (!this.isMobile) {
            let products = displayNavs.find(elem => elem.id == 'productExplorer');
            //let profile = displayNavs.find(elem => elem.id == "profiles");
            let signOff = displayNavs.find(elem => elem.id == 'signOff');
            if (products && signOff) {
                let temp = products.order;
                products.order = signOff.order;
                signOff.order = temp;
            }
        }
        displayNavs = displayNavs.sort(function (a, b) {
            return a.order - b.order;
        });
        return displayNavs;
    }
    getTopNav(topNav, inputBrandingParams) {
        let displayNavs = null;
        this.topNavOverview = topNav.data.overview;
        this.topNavSeeMoreOptions = topNav.data.seeMoreOptions;
        if (topNav && topNav.data && inputBrandingParams) {
            displayNavs = this.createNavItems(topNav, inputBrandingParams);
        }
        else {
            this.getDefaultBranding();
        }
        return displayNavs;
    }
    getDisplayNavs(topNav, inputBrandingParams) {
        let i = 0;
        let custType = inputBrandingParams.customerType.toLowerCase() + 'Show';
        if (this.locale === "es_US") {
            topNav.overview['description'] = topNav.overview['description_es_US'];
            topNav.overview['completeDescription'] = topNav.overview['completeDescription_es_US'];
            topNav.seeMoreOptions['description'] = topNav.seeMoreOptions['description_es_US'];
            topNav.seeMoreOptions['completeDescription'] = topNav.seeMoreOptions['completeDescription_es_US'];
        }
        this.topNavOverview = topNav.overview;
        this.topNavSeeMoreOptions = topNav.seeMoreOptions;
        var updatedTopNav = [];
        if (topNav.navigationItems) {
            for (i = 0; i < topNav.navigationItems.length; i++) {
                var topNavVar = topNav.navigationItems[i];
                topNavVar['show'] = topNavVar[custType];
                //  This renamingLogic from BrandingEntitlementService returns an object with updated title to show in the Navigation based on the subcategory "customContent" key
                //  for both English and Spanish to relevant navigation objects. Branding service will check for subcategory "customContent" key and if that matches to be true, then
                //  title gets updated through renamingLogic() from EntitlementService.
                if (topNavVar?.customContent) {
                    let newTitle = this._brandingEntitlementService.renamingLogic(topNavVar);
                    topNavVar.title = newTitle.title_en;
                    topNavVar.title_es_US = newTitle.title_es_US;
                }
                if (this.locale === "es_US") {
                    topNavVar['title'] = topNavVar['title_es_US'];
                    if (topNavVar['navigationItems']) {
                        for (const tempNavItem of topNavVar['navigationItems']) {
                            if (tempNavItem && tempNavItem instanceof Array) {
                                for (let subtempNavItem of tempNavItem) {
                                    subtempNavItem['title'] = subtempNavItem['title_es_US'];
                                }
                            }
                            tempNavItem['title'] = tempNavItem['title_es_US'];
                            tempNavItem['subtitleId'] = tempNavItem['subtitleId_es_US'];
                        }
                    }
                }
                //        if(!this.newLogicBranding){   /* fix for DRR-24483 */
                topNavVar['show'] = topNavVar[custType];
                if (topNavVar['navigationItems']) {
                    for (const tempNavItem of topNavVar['navigationItems']) {
                        if (tempNavItem && tempNavItem instanceof Array) {
                            for (let subtempNavItem of tempNavItem) {
                                if (subtempNavItem['show']) {
                                    subtempNavItem['show'] = subtempNavItem[custType];
                                }
                            }
                        }
                        if (tempNavItem['show']) {
                            tempNavItem['show'] = tempNavItem[custType];
                        }
                    }
                }
                //        }
                if (topNavVar) {
                    topNavVar.show = this.getShowValue(jsonLogic.apply(topNavVar.show, inputBrandingParams));
                    if (topNavVar.show) {
                        if (topNavVar.id == 'productExplorer') {
                            topNavVar.offerTemplate = this._brandingEntitlementService.getNewEntitlementLogic(topNavVar.offerTemplate, false, true);
                            topNavVar.showSubHeadertext = this._brandingEntitlementService.getNewEntitlementLogic(topNavVar.showSubHeadertext, false, false);
                        }
                        if (topNavVar.id == 'accounts') {
                            topNavVar = this.getAccountsNav(topNavVar);
                        }
                        else if (topNavVar.navigationItems) {
                            let subNavItems = this.getSubmenus(topNavVar.navigationItems);
                            topNavVar['navigationItems'] = subNavItems;
                        }
                        updatedTopNav.push(topNavVar);
                    }
                }
            }
        }
        var productOffersFields = [
            'linkURL1',
            'linkURL2',
            'offer1Title',
            'offer1Text',
            'offer1Image1',
            'OfferButton1',
            'OfferButton2',
            'offer2Image',
            'offer2Title',
            'offer2Text'
        ];
        for (let j = 0; j < updatedTopNav.length; j++) {
            if (updatedTopNav[j].id !== 'signOff') {
                for (var k = 0; k < updatedTopNav[j].navigationItems.length; k++) {
                    if (updatedTopNav[j].navigationItems[k].items) {
                        for (var m = 0; m < updatedTopNav[j].navigationItems[k].items.length; m++) {
                            if (updatedTopNav[j].id === 'accounts') {
                                updatedTopNav[j].navigationItems[k].items[m].show = true;
                            }
                            else {
                                updatedTopNav[j].navigationItems[k].items[m].show = this._brandingEntitlementService.getNewEntitlementLogic(updatedTopNav[j].navigationItems[k].items[m], true, false);
                                updatedTopNav[j].show = this._brandingEntitlementService.getNewEntitlementLogic(updatedTopNav[j], true, false);
                            }
                            for (var elem in updatedTopNav[j].navigationItems[k].items[m]) {
                                if (productOffersFields.includes(elem) &&
                                    updatedTopNav[j].navigationItems[k].items[m][elem]) {
                                    console.log('This is from productOffersFields', updatedTopNav[j].navigationItems[k].items[m][elem]);
                                    updatedTopNav[j].navigationItems[k].items[m][elem] = this._brandingEntitlementService.getNewEntitlementLogic(updatedTopNav[j].navigationItems[k].items[m][elem], false, true);
                                }
                            }
                        }
                    }
                }
            }
        }
        console.log('Updated nav items: ', updatedTopNav);
        sessionStorage.setItem('updatedTopNav', JSON.stringify(updatedTopNav));
        return updatedTopNav;
    }
    getSubmenus(subMenus) {
        let updatedNavItem = [];
        for (var i in subMenus) {
            let item = {};
            let menu = subMenus[i];
            //  This renamingLogic from BrandingEntitlementService returns an object with updated title to show in the Navigation based on the subcategory "customContent" key
            //  for both English and Spanish to relevant navigation objects. Branding service will check for subcategory "customContent" key and if that matches to be true, then
            //  title gets updated through renamingLogic() from EntitlementService.
            if (menu?.customContent) {
                let newTitle = this._brandingEntitlementService.renamingLogic(menu);
                menu.title = newTitle.title_en;
                menu.title_es_US = newTitle.title_es_US;
            }
            /* Added below if condition for GBC-2903 to loop the Array for Investing menu under credit cards menu on the below of Explore Products Main menu */
            if (menu.length > 1) {
                for (var j in menu) {
                    if (menu[j]) {
                        if (menu[j].isSubtitle &&
                            !updatedNavItem.some(item => item.subTitle == menu[j].subtitleId)) {
                            item.subTitle = menu[j].subtitleId;
                            item.subTitle_es_US = menu[j].subtitleId_es_US;
                            item.items = [];
                            updatedNavItem.push(item);
                        }
                        else {
                            let data = updatedNavItem.find(elem => elem.subTitle == menu[j].subtitleId);
                            if (data == null) {
                                item.items = [];
                                item.items.push(menu[j]);
                                updatedNavItem.push(item);
                            }
                            else {
                                data.items.push(menu[j]);
                            }
                        }
                    }
                }
            }
            else {
                if (menu.isSubtitle &&
                    !updatedNavItem.some(item => item.subTitle == menu.subtitleId)) {
                    item.subTitle = menu.subtitleId;
                    item.subTitle_es_US = menu.subtitleId_es_US;
                    item.items = [];
                    updatedNavItem.push(item);
                }
                else {
                    let data = updatedNavItem.find(elem => elem.subTitle == menu.subtitleId);
                    if (data == null) {
                        item.items = [];
                        item.items.push(menu);
                        updatedNavItem.push(item);
                    }
                    else {
                        data.items.push(menu);
                    }
                }
            }
        }
        return updatedNavItem;
    }
    getAccountsNav(topNav) {
        let accountsNav = {};
        if (this.isBrowser &&
            this._sessionStorage &&
            this._sessionStorage.getItem('sessionPostBrandingStorage') &&
            this._sessionStorage.getItem('sessionPostBrandingStorage') !== 'null' &&
            this._sessionStorage.getItem('sessionPostBrandingStorage') !== null) {
            let sessionPostBranding = this._sessionStorage.getItem('sessionPostBrandingStorage');
            sessionPostBranding = JSON.parse(sessionPostBranding);
            let accounts = sessionPostBranding.accounts;
            let i = 0;
            let counter = 0;
            let noOfAccts = accounts.length;
            let maxLengthOfAccounts = 6;
            let updatedAccounts = [];
            for (let i = 0; i < accounts.length; i++) {
                if (i <= maxLengthOfAccounts) {
                    updatedAccounts.push(accounts[i]);
                }
            }
            if (accounts.length >= 0) {
                updatedAccounts.unshift(this.topNavOverview);
            }
            if (accounts.length >= 8) {
                updatedAccounts.push(this.topNavSeeMoreOptions);
            }
            if (updatedAccounts) {
                noOfAccts = updatedAccounts.length;
                let navigationItems = [];
                let item = {};
                for (i = 0; i < updatedAccounts.length; i++) {
                    if (i <= 8) {
                        counter = counter + 1;
                        if (updatedAccounts[i] !== null) {
                            let navigationItem = {};
                            navigationItem.title = updatedAccounts[i].description;
                            navigationItem.featureflag = updatedAccounts[i].featureflag;
                            navigationItem.domainMap = 'csr';
                            if (this.showBrandingSSR) {
                                navigationItem.url =
                                    updatedAccounts[i].navigationURL &&
                                        updatedAccounts[i].featureflag !== 'ff_navMenuLinkUpdate' &&
                                        updatedAccounts[i].featureflag !== 'ff_navMenuLinkUpdate'
                                        ? 'https://online.citi.com' +
                                            updatedAccounts[i].navigationURL
                                        : updatedAccounts[i].navigationURL;
                            }
                            else {
                                const overviewCheck = updatedAccounts[i]?.featureflag ? this._brandingEntitlementService.getNewEntitlementLogic(updatedAccounts[i]) : updatedAccounts[i]?.show;
                                navigationItem.url = overviewCheck ? updatedAccounts[i].updatedNavigationURL.replace('US/ag/', '').split("?")[0] : updatedAccounts[i].navigationURL.replace('US/ag/', '').split("?")[0];
                                if (updatedAccounts[i].navigationURL.split("?").length > 1) {
                                    let queryString = updatedAccounts[i].navigationURL.slice(0, updatedAccounts[i].navigationURL.lastIndexOf('=') + 0);
                                    this.urlkey = queryString.split('?').pop();
                                    var obj = {};
                                    var key = this.urlkey;
                                    obj[key] = updatedAccounts[i].accountInstanceId;
                                    var params = obj;
                                    var esc = encodeURIComponent;
                                    var query = Object.keys(params)
                                        .map(k => esc(k) + '=' + esc(params[k]))
                                        .join('&');
                                    navigationItem.url = navigationItem.url + '?' + query;
                                }
                            }
                            navigationItem.id =
                                updatedAccounts[i].navigationId;
                            navigationItem.completeTitle =
                                updatedAccounts[i].description;
                            navigationItem.show = this.getShowValue(jsonLogic.apply(updatedAccounts[i].show, topNav));
                            if (counter == 1) {
                                item = {};
                                item.items = [];
                            }
                            if (counter <= 3) {
                                item.items.push(navigationItem);
                                if (noOfAccts < 3 && counter == noOfAccts) {
                                    navigationItems.push(item);
                                }
                                else if (item.items.length == 3) {
                                    navigationItems.push(item);
                                    noOfAccts = noOfAccts - 3;
                                }
                                if (counter == 3) {
                                    counter = 0;
                                }
                            }
                        }
                    }
                }
                if (navigationItems.length >= 1 && topNav.navigationItems[0]) {
                    navigationItems[0].items.unshift(topNav.navigationItems[0]);
                }
                accountsNav.order = topNav.order;
                accountsNav.title = topNav.title;
                accountsNav.id = topNav.id;
                accountsNav.completeTitle = topNav.completeTitle;
                accountsNav.show = true;
                accountsNav.navigationItems = navigationItems;
            }
            else {
                accountsNav = this.getDefaultAcctNav(topNav);
            }
        }
        else {
            accountsNav = this.getDefaultAcctNav(topNav);
        }
        if (!accountsNav.completeTitle) {
            accountsNav.completeTitle = accountsNav.title;
        }
        return accountsNav;
    }
    getDefaultAcctNav(topNav) {
        let accountsNav = {};
        let navigationItems = [];
        let item = {};
        accountsNav.order = topNav.order;
        accountsNav.title = topNav.title;
        accountsNav.id = topNav.id;
        accountsNav.completeTitle = topNav.completeTitle;
        accountsNav.show = true;
        item.items = [];
        item.items.push(topNav.navigationItems[0]);
        navigationItems.push(item);
        accountsNav.navigationItems = navigationItems;
        return accountsNav;
    }
    // Function to Apply json logic for footer - subfooter & navigation component
    getFooter(branding, inputBrandingParams) {
        if (branding && branding.data && Object.keys(branding.data.footer).length !== 0) {
            let links = null;
            let updatedLinks = [];
            let i = 0;
            // Apply Json logic for subfooter component - FDIC and EquiHousing images
            if (inputBrandingParams) {
                branding.data.footer.subFooter.show = jsonLogic.apply(branding.data.footer.subFooter.show, inputBrandingParams);
            }
            else {
                branding.data.footer.subFooter.show = true;
            }
            if (branding.data.footer.subNavigation &&
                branding.data.footer.subNavigation.navigation) {
                links = branding.data.footer.subNavigation.navigation.links;
                if (links) {
                    for (i = 0; i < links.length; i++) {
                        let linksVar = links[i];
                        if (linksVar) {
                            // Default all links to true
                            if (linksVar.show) {
                                // Apply jsonlogic
                                if (inputBrandingParams) {
                                    linksVar.show = jsonLogic.apply(linksVar.show, inputBrandingParams);
                                }
                                else {
                                    linksVar.show = false;
                                }
                            }
                            else {
                                linksVar.show = true;
                            }
                            if (linksVar.show) {
                                updatedLinks.push(links[i]);
                            }
                        }
                    }
                    // Update the links to the main branding object
                    branding.data.footer.subNavigation.navigation.links = updatedLinks;
                }
            }
            //locale changes
            if (this.locale === 'es_US') {
                if (branding.data.footer.badgeNavigation && branding.data.footer.badgeNavigation.badgeSections) {
                    for (let badgeSec of branding.data.footer.badgeNavigation.badgeSections) {
                        badgeSec.title = badgeSec.title_es_US;
                    }
                }
                if (branding.data.footer.navigation && branding.data.footer.navigation.sections) {
                    for (let section of branding.data.footer.navigation.sections) {
                        section.title = section.title_es_US;
                        if (section.links) {
                            for (let link of section.links) {
                                link.title = link.title_es_US;
                            }
                        }
                    }
                }
                if (branding.data.footer.subNavigation) {
                    if (branding.data.footer.subNavigation.copyright) {
                        branding.data.footer.subNavigation.copyright.text = branding.data.footer.subNavigation.copyright.text_es_US;
                    }
                    if (branding.data.footer.subNavigation.navigation) {
                        for (let link of branding.data.footer.subNavigation.navigation.links) {
                            link.title = link.title_es_US;
                            /* Added below if condition for GBC-7918 */
                            if (link.id == 'countryAndJurisdictions') {
                                link.speedbump.title = link.speedbump.title_es_US;
                            }
                        }
                    }
                    for (let section of branding.data.footer.navigation.sections) {
                        section.title = section.title_es_US;
                        if (section.links) {
                            for (let link of section.links) {
                                link.title = link.title_es_US;
                            }
                        }
                    }
                }
                if (branding.data.footer.disclaimer) {
                    branding.data.footer.disclaimer['text'] = branding.data.footer.disclaimer['text_es_US'];
                }
            }
        }
        return branding.data.footer;
    }
    isModFed() {
        if (this.isBrowser && window) {
            return window.location.pathname.startsWith('/US/nga');
        }
        return false;
    }
    updateHeaderData(header) {
        if (this.locale === 'es_US') {
            if (header.banner) {
                if (header.banner.buttonsData) {
                    for (let data of header.banner.buttonsData) {
                        if (data.title_es_US) {
                            data.title = data.title_es_US;
                        }
                        if (data.navigationItems) {
                            for (let navItem of data.navigationItems) {
                                if (navItem.items) {
                                    for (let item of navItem.items) {
                                        item.title = item.title_es_US;
                                    }
                                }
                                navItem['subTitle'] = navItem['subTitle_es_US'];
                            }
                        }
                    }
                }
            }
            if (header.butler) {
                if (header.butler.navigationItems) {
                    for (let navItem of header.butler.navigationItems) {
                        navItem.title = navItem.title_es_US;
                    }
                }
            }
            if (header.navigation) {
                if (header.navigation.help) {
                    header.navigation.help.title = header.navigation.help.title_es_US;
                }
                if (header.navigation.search) {
                    header.navigation.search.title = header.navigation.search.title_es_US;
                    header.navigation.search.ariaDescribedBy = header.navigation.search.ariaDescribedBy_es_US;
                    header.navigation.search.ariaLabel = header.navigation.search.ariaLabel_es_US;
                    header.navigation.search.placeholder = header.navigation.search.placeholder_es_US;
                    header.navigation.search.submitButtonText = header.navigation.search.submitButtonText_es_US;
                    header.navigation.search.id = header.navigation.search.id_es_US;
                }
                if (header.navigation.navigationItems) {
                    for (let navItem of header.navigation.navigationItems) {
                        navItem.title = navItem.title_es_US;
                        if (navItem.navigationItems) {
                            for (let nItem of navItem.navigationItems) {
                                nItem.subTitle = nItem.subTitle_es_US;
                                if (nItem.items) {
                                    for (let item of nItem.items) {
                                        item.title = item.title_es_US;
                                    }
                                }
                                if (nItem.quickLinks) {
                                    for (let link of nItem.quickLinks) {
                                        link.linkText = link.linkText_es_US;
                                    }
                                }
                            }
                        }
                    }
                }
                if (header.navigation.sign) {
                    header.navigation.sign.signOnWording = header.navigation.sign.signOnWording_es_US;
                    header.navigation.sign.signOffWording = header.navigation.sign.signOffWording_es_US;
                    if (header.navigation.sign.modal) {
                        header.navigation.sign.modal.buttonText = header.navigation.sign.modal.buttonText_es_US;
                        header.navigation.sign.modal.title = header.navigation.sign.modal.title_es_US;
                        header.navigation.sign.modal.passwordPlaceholder = header.navigation.sign.modal.passwordPlaceholder_es_US;
                        header.navigation.sign.modal.rememberIdText = header.navigation.sign.modal.rememberIdText_es_US;
                        header.navigation.sign.modal.passwordShortError = header.navigation.sign.modal.passwordShortError_es_US;
                    }
                }
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingService, deps: [{ token: i1$1.AppConfigService }, { token: LayoutsService }, { token: BrandingEntitlementService }, { token: i3.Router }, { token: BrandingTypeService }, { token: i1$1.CookieService }, { token: i1$1.EcmCookieService }, { token: i1$1.PostSessionService }, { token: i6.ContentService }, { token: i1.HttpClient }, { token: i3$1.AuthorizationService }, { token: i6.HttpService }, { token: PLATFORM_ID }, { token: SESSION_STORAGE }, { token: WINDOW }, { token: IS_SSRENDERED_APP, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.AppConfigService }, { type: LayoutsService }, { type: BrandingEntitlementService }, { type: i3.Router }, { type: BrandingTypeService }, { type: i1$1.CookieService }, { type: i1$1.EcmCookieService }, { type: i1$1.PostSessionService }, { type: i6.ContentService }, { type: i1.HttpClient }, { type: i3$1.AuthorizationService }, { type: i6.HttpService }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }], propDecorators: { ToggleFdic: [{
                type: Output
            }] } });

class SmartBannerSharedService {
    constructor(_contentService) {
        this._contentService = _contentService;
        this.smartBannerStateSource = new Subject();
        this.smartBannerState$ = this.smartBannerStateSource.asObservable();
        this.qAcontentObs$ = new BehaviorSubject(false);
        this.bannerStateSource = new Subject();
        this.bannerState$ = this.bannerStateSource.asObservable();
    }
    closeSmartBanner() {
        this.smartBannerStateSource.next(false);
    }
    setBanner(isHidden) {
        this.bannerStateSource.next(isHidden);
    }
    getQAData() {
        const appId = 'quickaction';
        this._contentService.getStaticBundle(appId).subscribe(data => {
            this.qAcontentObs$.next(true);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartBannerSharedService, deps: [{ token: i6.ContentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartBannerSharedService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartBannerSharedService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i6.ContentService }] });

class CobrandingService {
    constructor(_window, location, appConfigService) {
        this._window = _window;
        this.location = location;
        this.appConfigService = appConfigService;
        this.hasCobranding = new BehaviorSubject(false);
        this.toggleFDICEligibility = new BehaviorSubject(null);
    }
    /**
     * @param hasCB - Should contain co branding.
     * @param cbObj - Contains two properties image URL and external URL. Use image URL for logo and external URL for link.
     */
    addCoBranding(hasCB, cbObj) {
        console.log('reaching me-->', hasCB);
        this.brandingImage = cbObj.imgURL;
        this.brandingLink = cbObj.externalURL;
        this.altText = cbObj.altText;
        this.hasCobranding.next(hasCB);
    }
    getSSRContext() {
        if (this._window) {
            let href = this._window.location.href;
            if (!href.includes('/US/ag')) {
                console.log('This is for SSR Pages');
                let capturedStr = this.location.path();
                let capturedPathName = this._window.location.pathname;
                let queryIndex = capturedStr.indexOf('?');
                let hashIndex = capturedStr.indexOf('#');
                let queryParams = '';
                let hashParams = '';
                if (queryIndex !== -1) {
                    queryParams = capturedStr.substring(queryIndex);
                    capturedStr = capturedStr.substring(0, queryIndex);
                }
                if (hashIndex !== -1) {
                    hashParams = capturedStr.substring(hashIndex);
                    capturedStr = capturedStr.substring(0, hashIndex);
                }
                if (capturedStr === '') {
                    if (capturedPathName === '/') {
                        return capturedStr + queryParams + hashParams;
                    }
                    else {
                        let strippedPath = capturedPathName.replace(/\/$/, '');
                        return strippedPath + queryParams + hashParams;
                    }
                }
                if (capturedStr !== '' && capturedPathName !== '/') {
                    let windowSegments = capturedPathName.split('/');
                    let locationSegments = capturedStr.split('/');
                    let missingPart = [];
                    let matched = false;
                    for (let i = 0; i < windowSegments.length; i++) {
                        if (locationSegments[0] === windowSegments[i]) {
                            matched = true;
                        }
                        if (matched) {
                            missingPart.push(windowSegments[i]);
                        }
                    }
                    let finalPath = [...missingPart, ...locationSegments].join('/');
                    return finalPath.replace(/\/+/g, '/') + queryParams + hashParams;
                }
                return capturedStr + queryParams + hashParams;
            }
            else {
                console.log('context name cannot be passed');
            }
        }
    }
    //FDIC Eligibility logic handler with ICMS url's
    validateFDICEligibility(url, jsonStructure) {
        if (jsonStructure) {
            const queryParams = {};
            const urlObj = new URL(url);
            const baseUrl = urlObj.origin;
            const pathname = urlObj.pathname;
            const searchParams = new URLSearchParams(urlObj.search);
            searchParams.forEach((value, key) => {
                queryParams[key] = value;
            });
            const hasQueryParams = Object.keys(queryParams).length > 0;
            return jsonStructure.urlPatterns.some(pattern => {
                // Dynamically get the base URL using this.config.geturl()
                const actualBaseUrl = pattern.isSSR
                    ? this.appConfigService.getnewCitiHostName()
                    : this.appConfigService.getcsrHostName();
                if (baseUrl !== actualBaseUrl)
                    return false;
                return pattern.subRoutes.some(subRoute => {
                    const routePattern = new RegExp(subRoute.path.replace(/\*/g, '.*') + '$');
                    if (!routePattern.test(pathname))
                        return false;
                    // If noQueryParams is true, return true only if the URL has no query parameters
                    if (subRoute.noQueryParams)
                        return !hasQueryParams;
                    // If queryParams is not defined, consider them optional and return true
                    if (!subRoute.queryParams)
                        return true;
                    // Check if all required query params match
                    const queryMatch = subRoute.allowWildcardParams ||
                        Object.keys(subRoute.queryParams).length ===
                            Object.keys(queryParams).length;
                    if (queryMatch) {
                        const paramsMatch = Object.entries(subRoute.queryParams).every(([key, value]) => {
                            return (queryParams[key] !== undefined &&
                                (value === '*' || queryParams[key] === value));
                        });
                        return paramsMatch;
                    }
                    else {
                        return false;
                    }
                });
            });
        }
        else {
            return false;
        }
    }
    //FDIC Eligibility logic handler from partner side to enable FDIC
    partnerFDICEligibility(eligible) {
        this.toggleFDICEligibility.next(eligible);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CobrandingService, deps: [{ token: WINDOW }, { token: i2.Location }, { token: i1$1.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CobrandingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CobrandingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i2.Location }, { type: i1$1.AppConfigService }] });

class BrandingTaggingService {
    constructor(_taggingService, _window) {
        this._taggingService = _taggingService;
        this._window = _window;
    }
    /**
     * @Service: Branding Tagging Service
     * @Section: Footer Tagging Template
     * @Description: This method is used for calling tagging service on all footer tech specifications
     */
    footerNavigationTagging(sectionPos, linkPos, sectionTitle, linkTitle) {
        const footerSection = this.domParser(sectionTitle);
        const footerLink = this.domParser(linkTitle);
        const title = sectionPos + 1 + '.' + (linkPos + 1) + '|' + footerSection + '|' + footerLink;
        const footerAppHierarchy = this.isUserLoggedIn()
            ? 'secure|enable|footer|link clicked'
            : 'public|enable|footer|link clicked';
        this._taggingService.triggerEventTagging('nonicms_content', '543aFooterLinkClicked', {
            dynamicContent: {
                footer_link: title,
                app_hierarchy: footerAppHierarchy
            }
        });
    }
    /**
     * @Service: Branding Tagging Service
     * @Section: Top header Tagging Template Browser
     * @Description: This method is used for calling tagging service on all top header tech specifications
     */
    topNavigationTagging(obj, submenuIndex, topIndex, topNavItem) {
        const subTitle = this.isUserLoggedIn()
            ? (obj['subtitleId'] ? obj['subtitleId'] : "") // subtitleID to set value in postlogin scenario ex: 2.3.8 Payments & Transfers:transfers:Balance Transfers
            : (topNavItem.navigationItems[0].quickLinks.some(r => r.linkText === obj.title || r.linkText === obj.linkText))
                ? "QUICK LINKS"
                : "";
        var clickedItemTitle = this.domParser(obj['title'] ? obj['title'] : obj['linkText']);
        if (topNavItem.id === "accounts") {
            clickedItemTitle = (clickedItemTitle.split("-")[0]).replace(/\./g, "");
        }
        if (subTitle === 'QUICK LINKS') {
            submenuIndex = submenuIndex + 1;
        }
        const navigation_items = subTitle !== ''
            ? `${topIndex + 1}.${submenuIndex + 1}.${obj?.index + 1} ${topNavItem['title']}:${subTitle.toUpperCase()}:${clickedItemTitle}`
            : `${topIndex + 1}.${submenuIndex + 1}.${obj?.index + 1} ${topNavItem['title']}::${clickedItemTitle}`;
        this.triggerPageTagging(navigation_items);
    }
    /**
    * @Service: Branding Tagging Service
    * @Section: Top header Tagging Template Mobile responsive view for first level
    * @Description: This method is used for calling tagging service on all top header tech specifications
    */
    topNavTagWithNavItems(title) {
        this.triggerPageTagging(title);
    }
    /**
     * @Service: Branding Tagging Service
     * @Section: Top header Tagging Template Mobile responsive view
     * @Description: This method is used for calling tagging service on all top header tech specifications
     */
    triggerPageTagging(navigation_items) {
        this._taggingService.triggerPageTagging("nonicms_content", this.isUserLoggedIn(), "544cTopNavNavigationItemClicked", {
            dynamicContent: {
                navigation_items,
                navigation_item_click_attribution: true
            }
        });
    }
    /**
       * @Service: Branding Tagging Service
       * @Section: Pre/Post Login
       * @Description: This method is used in deciding app hierarchy for tagging
       */
    isUserLoggedIn() {
        let sessionPostBrandingStorage = this._window
            ? this._window.sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        return !sessionPostBrandingStorage ? false : true;
    }
    /**
       * @Service: Branding Tagging Service
       * @Section: Dom Parser
       * @Description: This method is used for removing html tags, special characters in one go
       */
    domParser(text) {
        return new DOMParser()
            .parseFromString(`<body>${text}</body>`, 'text/html')
            .body.textContent.replace(/[\u00A9\u00AE\u2122\u2026]+/g, '');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingTaggingService, deps: [{ token: i1$1.TaggingService }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingTaggingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BrandingTaggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.TaggingService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

class Banner2Component {
    constructor(_document, _window, _navigator, _sessionStorage, http, angularHttp, _platformId, appConfigService, cobrandingService, brandingService, brandingTypeService, _brandingEntitlementService, mapperService, 
    // Cookie service.  Allows retrieving of a cookie by name
    cookieService, brandingTag, shoppingCartService, layoutsService, 
    // private _cbolCoreConfigService: CbolCoreConfigService,
    _isSSRApp, _router) {
        this._document = _document;
        this._window = _window;
        this._navigator = _navigator;
        this._sessionStorage = _sessionStorage;
        this.http = http;
        this.angularHttp = angularHttp;
        this._platformId = _platformId;
        this.appConfigService = appConfigService;
        this.cobrandingService = cobrandingService;
        this.brandingService = brandingService;
        this.brandingTypeService = brandingTypeService;
        this._brandingEntitlementService = _brandingEntitlementService;
        this.mapperService = mapperService;
        this.cookieService = cookieService;
        this.brandingTag = brandingTag;
        this.shoppingCartService = shoppingCartService;
        this.layoutsService = layoutsService;
        this._isSSRApp = _isSSRApp;
        this._router = _router;
        this.showModal = [];
        this.activeOnLinkClick = false;
        this.hoverColor = 'default';
        this.activeSubMenuId = 'none';
        this.activeMainLink = 99999;
        this.hasCoB = false;
        // For shopping cart
        this.cartItemQuantity = 0;
        this.url = this.appConfigService.getConfig('customConfig')
            .brandingEndpoint;
        this.langBtnClicked = new EventEmitter();
        this.changeLocale = function (_locale, item) {
            const maxAge = 60 * 60 * 24 * 365;
            const path = '/';
            const domain = '.citi.com';
            this._document.cookie = `locale=${_locale};Domain=${domain};Max-Age=${maxAge}; Path=${path}`;
            if (_locale == 'en_US') {
                if (this._window)
                    this._window.location.href = this.currentPath;
            }
        };
        this.twoSecondsTimeout = undefined;
        this.init = () => {
            this.currentPath = this.getPath();
            this._isMobile =
                this._navigator &&
                    this._navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
            // This is implemented for journey teams to toggle on/off footer logos.
            this.brandingService.changeUrl.subscribe(val => {
                this.chgUrl = val;
            });
            this.brandingService.buttonsOn.subscribe(val => {
                this.showButtons = val;
            });
            this.hookIntoCobranding();
            this.hookIntoPartnerFDIC();
        };
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setBannerConfig = function (_config) {
            this.fdicEligibility();
            var bannerConfig = {};
            var contactUsConfig = {};
            // If the banner should be shown...
            if (_config.header.banner &&
                _config.header.banner.show &&
                typeof _config.header.banner.color === 'string' &&
                _config.header.banner.color.length > 0) {
                // ...set it to display
                bannerConfig.showBanner = true;
                // Provide the color of the banner
                bannerConfig.bannerColor = _config.header.banner.color;
                // If the logo should be displayed and there is an image defined
                if (_config.header.banner.logo &&
                    _config.header.banner.logo.show &&
                    _config.header.banner.logo.image &&
                    typeof _config.header.banner.logo.image === 'string' &&
                    _config.header.banner.logo.image.length > 0) {
                    // ...set it to display...
                    bannerConfig.showLogo = true;
                    // ...and provide the image url given
                    bannerConfig.customer = _config.header.banner.logo.customer;
                    bannerConfig.comments = _config.header.banner.logo?.comments ? _config.header.banner.logo?.comments : _config.header.banner.logo[bannerConfig.customer]?.comments;
                    //spcial case for cpb
                    // bannerConfig.cpb = _config.header.banner.logo.cpb ? _config.header.banner.logo.cpb : false;
                    bannerConfig.logoImage = (this._isSSRApp ? this.citiUrl : this.csrUrl) + _config.header.banner.logo.image;
                    bannerConfig.fdicImage = (this._isSSRApp ? this.citiUrl : this.csrUrl) + _config.header.banner.logo.fdicImage;
                    if (_config.header.banner.logo.mobileImage) {
                        bannerConfig.logoMobileImage = _config.header.banner.logo.mobileImage;
                    }
                    bannerConfig.defaultCust = _config.header.banner.logo.defaultCust
                        ? _config.header.banner.logo.defaultCust
                        : false;
                    // bannerConfig.privateCust = _config.header.banner.logo.privateCust
                    // ? _config.header.banner.logo.privateCust
                    // : false;
                    bannerConfig.url = _config.header.banner.logo.url;
                    bannerConfig.routerLink = _config.header.banner.logo.routerLink;
                    bannerConfig.redirectSsr = _config.header.banner.logo;
                    bannerConfig.bannerUrl = _config.header.banner.url;
                    bannerConfig.domainMap = _config.header.banner.domainMap;
                    this.hoverColor = _config.header.banner.logo.hoverColor;
                }
                var buttonsData = _config.header.banner.buttonsData;
                for (var i = 0; i < buttonsData.length; i++) {
                    if (_config.header.banner.buttonsData) {
                        _config.header.banner.buttonsData[i].image = (this._isSSRApp ? this.citiUrl : this.csrUrl) + this.brandingService.stripAssetHostName(_config.header.banner.buttonsData[i].image);
                    }
                }
                if (_config.header.navigation) {
                    if (_config.header.navigation.navigationItems) {
                        for (let navItem of _config.header.navigation.navigationItems) {
                            if (navItem.navigationItems) {
                                for (let nItem of navItem.navigationItems) {
                                    if (nItem.quickLinks) {
                                        for (let link of nItem.quickLinks) {
                                            link.linkimage = (this._isSSRApp ? this.citiUrl : this.csrUrl) + link.linkimage;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (_config.header.banner.cart) {
                    let showCart = this._brandingEntitlementService.getNewEntitlementLogic(_config.header.banner.cart, true, false);
                    if (showCart) {
                        bannerConfig.cart = _config.header.banner.cart;
                    }
                }
                if (_config.header.banner.buttonsData &&
                    _config.header.banner.buttonsData.length >= 1) {
                    bannerConfig.showButtonsData = true;
                    bannerConfig.buttonsData = this.solveProfilesMenu(_config.header.banner.buttonsData);
                }
            }
            // Set the config for use by the dom (DOM will not show until this is set);
            this.config = bannerConfig;
            // Kick off the banner init
            this.init();
        };
        _router.events
            .pipe(filter$1(event => {
            return event instanceof GuardsCheckEnd;
        }))
            .subscribe((event) => {
            this.csrRoute = event.urlAfterRedirects;
            this.fdicEligibility();
        });
        this.isBrowser = isPlatformBrowser(this._platformId);
        this.host_url = this.isBrowser
            ? ''
            : this.appConfigService.getConfig('customConfig').brandingApiUrl;
        (isPlatformBrowser(this._platformId)) ? this.fdicInit() : '';
        this.currentPath = this.getPath();
        this.showBrandingSSR = this._isSSRApp;
        this.locale = this.getLocale();
        this.csrUrl = this.appConfigService.getcsrHostName();
        this.citiUrl = this.appConfigService.getnewCitiHostName();
    }
    ngOnInit() {
        this.colorByUserType();
        this.layoutsService.postBrandingStorage.asObservable().subscribe(res => {
            if (res) {
                let sessionParams = this.getSPBS();
                this.colorByUserType();
                if (sessionParams && sessionParams?.featureFlags?.ff_ShoppingCart == 'Y') {
                    this.shoppingCartService.getShoppingCartData();
                }
            }
        });
        this.shoppingCartService.retrivedCartBs$.asObservable().subscribe(shoppingCartData => {
            if (shoppingCartData &&
                Object.keys(shoppingCartData).length === 0 &&
                shoppingCartData.constructor === Object) {
                this.cartItemQuantity = 0;
            }
            if (shoppingCartData.orderSummary && shoppingCartData.orderSummary.totalItemQuantity) {
                this.cartItemQuantity = shoppingCartData.orderSummary.totalItemQuantity;
            }
        });
    }
    // Header component handles opening the language change modal and switching languages
    onLangBtnClick(item) {
        this.langBtnClicked.emit(item);
    }
    getSPBS() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                if (sessionParams) {
                    return sessionParams;
                }
            }
            catch (err) {
                return false;
            }
        }
    }
    colorByUserType() {
        let sessionParams = this.getSPBS();
        if (sessionParams != undefined) {
            this.customerType = sessionParams['userBranding'].toLowerCase();
            let otherUserTypes = ['PrivateBanking', 'Alliance', 'Gold', 'CPC', 'Priority'];
            if (!otherUserTypes.includes(sessionParams['userBranding'])) {
                this.customerType = 'blue';
            }
        }
        else {
            let modifier = this.brandingService.getBrandingModifier();
            this.customerType = modifier;
            let otherModifierTypes = ['cpb', 'alliance', 'gold', 'cpc', 'priority'];
            if (!otherModifierTypes.includes(modifier)) {
                this.customerType = 'blue';
            }
        }
    }
    navigateToURL(obj, event) {
        if (event.type === 'contextmenu') {
            return true;
        }
        event.preventDefault();
        this.mapperService.brandingMap(obj);
    }
    profileTagging(obj, profileContainer) {
        const index = Array.from(profileContainer.getElementsByTagName('a'))
            .findIndex((el) => el === obj.targetLink.currentTarget);
        let navigation_items = `6.1.${index + 1} PROFILE:${obj.subTitle}:${obj.title}`;
        this.brandingTag.topNavTagWithNavItems(navigation_items);
    }
    onRightClick(obj, event) {
        if (event.type == 'contextmenu' || event.type == 'mouseover') {
            this.mapperService.modifyURLPrefixRightClick(event, obj.domainMap, obj);
        }
    }
    bannerTagging(item) {
        const navigation_items = !this.brandingTag.isUserLoggedIn() && (item.id == 'butlerATM') ? `6.1.0 ${item.title}::`
            : this.brandingTag.isUserLoggedIn() && (item.id == 'butlerATM') ? `7.1.0 ${item.title}::`
                : item.id == 'lang' && item.locale == "es_US" ? `7.1.0 ${item.title}::`
                    : item.id == 'lang' && item.locale == "en_US" ? `7.1.0 ${item.title}::` : "";
        this.brandingTag.topNavTagWithNavItems(navigation_items);
    }
    onMouseClick(e, item, i) {
        e.stopPropagation();
        if (item.id == 'butlerATM' || (item.id == 'lang' && item.locale == "es_US") || (item.id == 'lang' && item.locale == "en_US")) {
            this.bannerTagging(item);
        }
        if (item.id == 'profiles') {
            var prflsAria = this._document
                .getElementById('profileMenu')
                .getAttribute('aria-expanded');
            if (prflsAria == 'false')
                this._document
                    .getElementById('profileMenu')
                    .setAttribute('aria-expanded', true);
            else {
                this._document
                    .getElementById('profileMenu')
                    .setAttribute('aria-expanded', false);
            }
        }
        if (!this.activeOnLinkClick) {
            let someId = item.id + 'subGroup' + i;
            let domElementFound = document.getElementById(item.id + 'subGroup' + i);
            if (domElementFound) {
                let subNavId = document.getElementById(this.subNavItemId);
                if (subNavId) {
                    if (someId == subNavId.id) {
                        document.getElementById(this.subNavItemId).style.display = 'none';
                        this.subNavItemId = undefined;
                        return;
                    }
                }
                else if (subNavId) {
                    document.getElementById(item.id + 'subGroup' + i).style.display =
                        'none';
                }
                else {
                    document.getElementById(item.id + 'subGroup' + i).style.display =
                        'block';
                }
            }
            else {
                let domElementFound = document.getElementById(item.id + 'subGroup' + i);
                if (domElementFound)
                    this._document
                        .getElementById('profileMenu')
                        .setAttribute('aria-expanded', false);
                let subNavId = document.getElementById(this.subNavItemId);
                if (subNavId)
                    document.getElementById(this.subNavItemId).style.display = 'none';
            }
        }
        this.subNavItemId = item.id + 'subGroup' + i;
        this.activeSubMenuId = item.id;
        this.activeMainLink = i;
    }
    onMouseOver(item, i, e) {
        e.stopPropagation();
        if (item.id != 'profiles' && item.id != 'lang') {
            this.changeColorOnhover(item.id);
        }
        else if (item.id == 'profiles') {
            this._document
                .getElementById('profileMenu')
                .setAttribute('aria-expanded', true);
            this.changeColorOnhover('profileMenu');
        }
        else if (item.id == 'lang') {
            this.changeColorOnhover('langBtn');
        }
        let domElem = document.getElementById(item.id + 'subGroup' + i);
        if (domElem)
            domElem.style.display = 'block';
    }
    changeColorOnhover(elem) {
        if (this.customerType == 'blue') {
            document.getElementById(elem).style.filter =
                'brightness(0) saturate(100%) invert(14%) sepia(100%) saturate(7415%) hue-rotate(248deg) brightness(89%) contrast(101%)';
        }
        else if (this.hoverColor == 'cpc' || this.hoverColor == 'gold') {
            document.getElementById(elem).style.filter =
                'drop-shadow(0px 0px 0px gold)';
        }
        else if (this.hoverColor == 'priority') {
            document.getElementById(elem).style.filter =
                'invert(13%) sepia(44%) saturate(1469%) hue-rotate(177deg) brightness(92%) contrast(95%)';
        }
        else {
            document.getElementById(elem).style.filter =
                'invert(26%) sepia(84%) saturate(1912%) hue-rotate(190deg) brightness(75%) contrast(93%)';
        }
    }
    removeHoverColor(item) {
        if (item.id == 'profiles') {
            document.getElementById('profileMenu').style.filter = 'unset';
        }
        else if (item.id == 'lang') {
            document.getElementById('langBtn').style.filter = 'unset';
        }
        else {
            document.getElementById(item.id).style.filter = 'unset';
        }
    }
    onMouseLeave(item, i) {
        if (this.twoSecondsTimeout) {
            clearTimeout(this.twoSecondsTimeout);
            this.twoSecondsTimeout = undefined;
        }
        this.removeHoverColor(item);
        if (!this.activeOnLinkClick) {
            var domElemFound = document.getElementById(item.id + 'subGroup' + i);
            if (domElemFound) {
                if (this._document.getElementById('profileMenu')) {
                    this._document
                        .getElementById('profileMenu')
                        .setAttribute('aria-expanded', false);
                }
                domElemFound.style.display = 'none';
            }
        }
    }
    onClick(event) {
        let activeProfileDiv = document.getElementById(this.activeSubMenuId + 'subGroup' + this.activeMainLink);
        if (this._document.getElementById('profileMenu')) {
            this._document
                .getElementById('profileMenu')
                .setAttribute('aria-expanded', false);
        }
        let targetElem = event.target;
        if (targetElem != activeProfileDiv) {
            if (activeProfileDiv) {
                activeProfileDiv.style.display = 'none';
                this.activeMainLink = 99999;
                this.activeSubMenuId = 'none';
                this.activeOnLinkClick = false;
            }
        }
    }
    hookIntoCobranding() {
        this.cobrandingService.hasCobranding.subscribe(hcb => {
            this.hasCoB = hcb;
            if (hcb) {
                this.cbObj = {
                    img: this.cobrandingService.brandingImage,
                    eURL: this.cobrandingService.brandingLink,
                    altTxt: this.cobrandingService.altText
                };
            }
        });
    }
    hookIntoPartnerFDIC() {
        this.cobrandingService.toggleFDICEligibility.subscribe(fdic => {
            if (fdic != null) {
                this.fdicEligible = fdic;
            }
        });
    }
    isMobile() {
        return this._window && this._window.innerWidth <= 990;
    }
    isExtendBanner(customer) {
        if (customer === 'cpc') {
            return this._window && this._window.innerWidth <= 634;
        }
        else {
            return this._window && this._window.innerWidth <= 499;
        }
    }
    isFDICSmallMobile(customer) {
        if (customer === 'cpc') {
            return this._window && this._window.innerWidth >= 635 && this._window.innerWidth <= 810;
        }
        else {
            return this._window && this._window.innerWidth >= 500 && this._window.innerWidth <= 650;
        }
    }
    getFDICData() {
        let fdicUrl = this.host_url + this.url + '/fdicEligibility.json';
        return this.angularHttp.get(fdicUrl);
    }
    fdicInit() {
        this.ssrSkeletonLoader = document.getElementsByClassName("skelheaderssr").length > 0 ? true : false;
        if (!this.ssrSkeletonLoader) {
            this.getFDICData().subscribe((result) => {
                this.fdicData = result;
                this.fdicEligibility();
                console.log("FDIC", this.fdicData);
            }, err => {
                // Handle the error case for navigation content file
                this.fdicData = this.brandingTypeService.getBranding('localFDIC');
            });
        }
    }
    fdicEligibility() {
        this.fdicRoute = this.csrRoute ? this.csrRoute : this.cobrandingService.getSSRContext();
        if (this._window)
            this.fdicRoute = this.fdicRoute ? this._window.location.origin + this.fdicRoute : this._window.location.href;
        this.fdicEligible = (isPlatformBrowser(this._platformId)) ? (this.cobrandingService.validateFDICEligibility(this.fdicRoute, this.fdicData)) : false;
    }
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.brandingObject = _config;
            this.setBannerConfig(_config);
        }
    }
    solveProfilesMenu(buttonsData) {
        for (var i = 0; i < buttonsData.length; i++) {
            if (buttonsData[i].id === 'profiles') {
                buttonsData[i].show = this._brandingEntitlementService.getNewEntitlementLogic(buttonsData[i]);
                for (var j = 0; j < buttonsData[i].navigationItems.length; j++) {
                    buttonsData[i].navigationItems[j] = this.solveShow(buttonsData[i].navigationItems[j]);
                }
            }
        }
        return buttonsData;
    }
    solveShow(profilesNavItems) {
        let sessionParams = this.getSPBS();
        for (var i = 0; i < profilesNavItems.items.length; i++) {
            profilesNavItems.items[i].show = this._brandingEntitlementService.getNewEntitlementLogic(profilesNavItems.items[i], true, false);
        }
        return profilesNavItems;
    }
    getPath() {
        if (this._window) {
            let path = this._window.location.pathname;
            let query = this._window.location.search;
            if (query) {
                path += query;
            }
            return path;
        }
        return null;
    }
    // Gets the locale from the locale cookie.  Falls back on en_US if no locale is set.
    getLocale() {
        // Get the locale from the cookie
        let locale = this.cookieService.getCookie('locale');
        // Fall back on en_US if no locale is specified
        locale = locale ? locale : 'en_US';
        //added indexOf below for GBC-4817, JFP token is appending to locale cookie happens in production
        if (locale.indexOf('es_US') >= 0) {
            locale = 'es_US';
        }
        else {
            locale = 'en_US';
        }
        // Return the locale
        return locale;
    }
    // GBC-11137/11224 - make desktop dropdowns and mobile submenus dismissible via Esc key - WCAG 2.1 1.4.13 (AA)
    onEscapePress(event, item, i) {
        let domElementFound = document.getElementById(item.id + 'subGroup' + i);
        if (domElementFound && domElementFound.style.display != 'none') {
            document.getElementById(item.id + 'subGroup' + i).style.display =
                'none';
            document
                .getElementById('profileMenu')
                .setAttribute('aria-expanded', 'false');
            document.getElementById('profileMenu').focus();
            this.activeMainLink = 99999;
            this.subNavItemId = undefined;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Banner2Component, deps: [{ token: DOCUMENT }, { token: WINDOW }, { token: NAVIGATOR }, { token: SESSION_STORAGE }, { token: i6.HttpService }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i1$1.AppConfigService }, { token: CobrandingService }, { token: BrandingService }, { token: BrandingTypeService }, { token: BrandingEntitlementService }, { token: BrandingMapService }, { token: i1$1.CookieService }, { token: BrandingTaggingService }, { token: i10.ShoppingCartService }, { token: LayoutsService }, { token: IS_SSRENDERED_APP, optional: true }, { token: i3.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: Banner2Component, isStandalone: false, selector: "citi-banner2", inputs: { brandingConfig: "brandingConfig" }, outputs: { langBtnClicked: "langBtnClicked" }, host: { listeners: { "window:click": "onClick($event)" } }, ngImport: i0, template: "<div *ngIf=\"config?.showBanner\" role=\"banner\" class=\"banner\" [ngClass]=\"fdicEligible && isExtendBanner(config?.customer) && config.customer != 'default'  ? 'fdicBanner' : ''\">\n  <div class=\"content-wrap\">\n    <div [ngClass]=\"fdicEligible && isExtendBanner(config?.customer) && config.customer != 'default'  ? 'journeyFdicLogo' : 'journeyLogo'\">\n      <div\n        *ngIf=\"config && config.showLogo\"\n        [ngClass]=\"config.customer\"\n        class=\"logoDiv\"\n        id=\"logoDiv\"\n      >\n        <a\n          *ngIf=\"config.url || config.routerLink\"\n          id=\"sessionFocusUrl\"\n          aria-label=\"citi-redesign-sessionfocus\"\n          [href]=\"chgUrl ? config.url || config.routerLink : cbObj.eURL\"\n          (click)=\"navigateToURL(config, $event)\"\n          (mouseover)=\"onRightClick(config, $event)\"\n          (contextmenu)=\"onRightClick(config, $event)\"\n          tabindex=\"0\"\n        >\n          <img\n            *ngIf=\"isMobile() && config.logoMobileImage\"\n            [src]=\"config.logoMobileImage\"\n            aria-label=\"citi-mobile-logo\"\n            id=\"mobileLogo\"\n            role = \"none\"\n            [attr.alt]=\"\n              config.customer == 'default' ? 'Citi' : config.comments\n            \"\n          />\n          <img\n            *ngIf=\"isMobile() && !config.logoMobileImage\"\n            [src]=\"config.logoImage\"\n            role = \"none\"\n            [attr.alt]=\"\n              config.customer == 'default' ? 'Citi' : config.comments\n            \"\n          />\n          <img\n            *ngIf=\"!isMobile()\"\n            [src]=\"config.logoImage\"\n            role = \"none\"\n            [attr.alt]=\"\n              config.customer == 'default' ? 'Citi' : config.comments\n            \"\n          />\n        </a>\n      </div>\n\n      <!-- Adding this repeated div for co branding-->\n      <div class=\"divider\" *ngIf=\"config && config.showLogo && hasCoB\" id=\"divider\"></div>\n      <div *ngIf=\"config && config.showLogo && hasCoB\" class=\"webDiv\" id=\"coBranding\">\n        <a [href]=\"cbObj.eURL\" class=\"box small\" tabindex=\"0\">\n          <img\n        *ngIf=\"isMobile() && config.logoMobileImage\"\n        [src]=\"cbObj.img\"\n        id=\"mobileCoLogo\"\n        [alt]=\"cbObj.altTxt\"\n          />\n          <img\n        *ngIf=\"isMobile() && !config.logoMobileImage\"\n        [src]=\"cbObj.img\"\n        [alt]=\"cbObj.altTxt\"\n          />\n          <img\n        *ngIf=\"!isMobile()\"\n        [src]=\"cbObj.img\"\n        [alt]=\"cbObj.altTxt\"\n        class=\"webLogo\"\n          />\n        </a>\n      </div>\n\n      <div *ngIf=\"fdicEligible\" id=\"fdicDiv\">\n          <a\n          role=\"presentation\"\n          id=\"fdicFocusUrl\"\n          tabindex=\"0\">\n          <img\n            *ngIf=\"isExtendBanner(config?.customer) || isFDICSmallMobile(config?.customer)\"\n            [src]=\"config.fdicImage\"\n            id=\"fdicMobileImage\"\n            alt=\"Citi FDIC Insured\"\n          />\n          <img\n            *ngIf=\"!isExtendBanner(config?.customer) && !isFDICSmallMobile(config?.customer)\"\n            [src]=\"config.fdicImage\"\n            [id]=\"!isFDICSmallMobile() && !isMobile() ? 'fdicLogoA' : 'fdicLogoB'\"\n            alt=\"Citi FDIC Insured\"\n          />\n        </a>\n      </div>\n    </div>\n\n    <div\n      class=\"cartIconResponsive\"\n      *ngIf=\"config && config.cart && cartItemQuantity > 0\"\n    >\n      <a\n        id=\"cartLinkResponsive\"\n        (click)=\"onMouseClick($event, config.cart, 0)\"\n        (focus)=\"onMouseClick($event, config.cart, 0)\"\n        (focusout)=\"onMouseLeave(config.cart, 0)\"\n        [href]=\"config.cart.url || config.cart.routerLink\"\n        (click)=\"navigateToURL(config.cart, $event)\"\n        (contextmenu)=\"onRightClick(config.cart, $event)\"\n        (mouseover)=\"onRightClick(config.cart, $event)\"\n        attr.aria-label=\"{{\n          cartItemQuantity > 1\n            ? cartItemQuantity + ' items in shopping cart'\n            : cartItemQuantity + ' item in shopping cart'\n        }}\"\n      >\n        <div class=\"cartIconContainer\">\n          <img [src]=\"config.cart.image\" alt=\"\" />\n          <span class=\"cartValue\">{{ this.cartItemQuantity }}</span>\n        </div>\n        <span>{{ config.cart.title }}</span>\n      </a>\n    </div>\n\n    <div\n      *ngIf=\"showButtons && config && config.showButtonsData\"\n      class=\"buttons\"\n    >\n      <ng-container *ngFor=\"let item of config.buttonsData; let i = index\">\n        <div\n          *ngIf=\"item.id && item.id == 'lang' ? item.locale == locale : true\"\n          class=\"navButton\"\n          [id]=\"item.id\"\n          (mouseover)=\"onMouseOver(item, i, $event)\"\n          (mouseleave)=\"onMouseLeave(item, i)\"\n          (focus)=\"onMouseOver(item, i, $event)\"\n          (mouseout)=\"onMouseLeave(item, i)\"\n        >\n          <a\n            *ngIf=\"(item.url || item.routerLink) && item.id == 'butlerATM'\"\n            id=\"atmLink\"\n            (click)=\"onMouseClick($event, item, i)\"\n            (focus)=\"onMouseClick($event, item, i)\"\n            (focusout)=\"onMouseLeave(item, i)\"\n            [attr.href]=\"item.url\"\n            (click)=\"navigateToURL(item, $event)\"\n            (contextmenu)=\"onRightClick(item, $event)\"\n            (mouseover)=\"onRightClick(item, $event)\"\n          >\n            <img [src]=\"item.image\" aria-hidden=\"true\" alt=\"\" />\n            <span>{{ item.title }}</span>\n          </a>\n          <a\n            *ngIf=\"\n              (item.routerLink || item.url) &&\n              item.id == 'cart' &&\n              config.cart &&\n              cartItemQuantity > 0\n            \"\n            id=\"cartLink\"\n            (click)=\"onMouseClick($event, item, i)\"\n            (focus)=\"onMouseClick($event, item, i)\"\n            (focusout)=\"onMouseLeave(item, i)\"\n            [routerLink]=\"item.routerLink || item.url\"\n            (click)=\"navigateToURL(item, $event)\"\n            (contextmenu)=\"onRightClick(item, $event)\"\n            attr.aria-label=\"{{\n              cartItemQuantity > 1\n                ? cartItemQuantity + ' items in shopping cart'\n                : cartItemQuantity + ' item in shopping cart'\n            }}\"\n          >\n            <div class=\"cartIconContainer\">\n              <img [src]=\"item.image\" alt=\"\" />\n              <span class=\"cartValue\">{{ this.cartItemQuantity }}</span>\n            </div>\n            <span>{{ item.title }}</span>\n          </a>\n          <button\n            [attr.aria-expanded]=\"false\"\n            [attr.aria-controls]=\"item.id + 'subGroup' + i\"\n            id=\"profileMenu\"\n            *ngIf=\"item.id == 'profiles' && item.show\"\n            (click)=\"onMouseClick($event, item, i)\"\n            (mouseout)=\"onMouseLeave(item, i)\"\n          >\n            <img\n              role=\"img\"\n              [src]=\"item.image\"\n              [alt]=\"item.className\"\n            />\n            <span role=\"presentation\">{{ item.title }}</span>\n          </button>\n          <div\n            class=\"subMenuGroupParent profileNavDropdown\"\n            [id]=\"item.id + 'subGroup' + i\"\n            *ngIf=\"\n              item.id == 'profiles' &&\n              item.navigationItems &&\n              item.navigationItems.length\n            \"\n            [ngStyle]=\"{\n              right: !isMobile ? '0' : '50px'\n            }\"\n            (keyup.escape)=\"onEscapePress($event, item, i)\"\n          >\n            <div\n              #profileContainer\n              class=\"flexColumnContainer profileNavDropdown\"\n              [ngStyle]=\"{ background: '#fff' }\"\n            >\n              <ng-container>\n                <profile-nav\n                  *ngFor=\"\n                    let childNavGroup of item.navigationItems;\n                    let secondLevelIndex = index\n                  \"\n                  [childNavGroup]=\"childNavGroup\"\n                  class=\"{{ customerType }}ProfileNavTheme\"\n                  (childLinkClicked)=\"profileTagging($event, profileContainer); navigateToURL($event, $event.targetLink)\"\n                ></profile-nav>\n              </ng-container>\n            </div>\n          </div>\n\n          <button\n            [attr.lang]=\"item.locale == 'es_US' ? 'en' : 'es'\"\n            *ngIf=\"item.id == 'lang' && item.locale == locale\"\n            id=\"langBtn\"\n            attr.data-target=\"#citi-modalb{{ i }}\"\n            [attr.aria-label]=\"\n              item.locale == 'es_US'\n                ? 'Click to change page language to English'\n                : 'Haz clic para cambiar la p\u00E1gina al espa\u00F1ol'\n            \"\n            (click)=\"onLangBtnClick(item)\"\n          >\n            <img aria-hidden=\"true\" [src]=\"item.image\" alt=\"\" />\n            <span [attr.lang]=\"item.locale == 'es_US' ? 'en' : 'es'\">{{\n              item.title\n            }}</span>\n          </button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n", styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.blueProfileNavTheme{--profilenav-text-color: #04208F;--profilenav-text-hover-color: #4400CC;--profilenav-header-color: #5E676B}.journeyLogo{display:flex;cursor:pointer}.journeyFdicLogo{display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:auto;gap:0;cursor:pointer}#logoDiv,#divider,#coBranding{grid-column:span 1}#fdicDiv{grid-column:span 2}.divider{border-left:3.5px solid lightgray;height:28px;margin-top:23px;margin-right:10px}.webLogo{max-width:100%;max-height:100%;display:block}.box{width:180px;display:flex;justify-content:left;align-items:center}.webDiv{margin-left:5px}.box.small{height:72px}.box.small img{height:40px}@media screen and (max-width: 425px){.journeyLogo{align-items:center}}@media screen and (min-width: 1000px){.divider{margin-left:35px;height:37px;margin-top:27px}.box.small{height:88px}.box.small img{height:48px}.webDiv{margin-left:15px}}.fdicBanner{height:150px!important}.banner{height:88px;background-color:#fff!important}@media (max-width: 990px){.banner{height:72px}}.banner .content-wrap{height:100%;padding:0 35px 0 20px;position:relative;display:flex;justify-content:space-between}@media (max-width: 990px){.banner .content-wrap{padding:0}}.banner .content-wrap .cpc{height:88px;width:auto;padding-bottom:20px;padding-left:17px}.banner .content-wrap .cpc img{height:auto;width:auto}@media (max-width: 990px){.banner .content-wrap .cpc{height:72px;width:auto;padding:0}.banner .content-wrap .cpc img{height:72px;width:auto;padding-left:16px}}.banner .content-wrap .cpb{height:88px;width:auto}.banner .content-wrap .cpb img{width:auto}@media (max-width: 990px){.banner .content-wrap .cpb,.banner .content-wrap .cpb img{height:72px;width:auto}}.banner .content-wrap .gold,.banner .content-wrap .priority,.banner .content-wrap .business{height:88px;width:auto;padding-top:28px;padding-bottom:20px;padding-left:14px}.banner .content-wrap .gold img,.banner .content-wrap .priority img,.banner .content-wrap .business img{height:40px;width:auto}@media (max-width: 990px){.banner .content-wrap .gold,.banner .content-wrap .priority,.banner .content-wrap .business{height:72px;width:auto;padding:0}.banner .content-wrap .gold img,.banner .content-wrap .priority img,.banner .content-wrap .business img{height:72px;width:auto;padding-left:16px}}.banner .content-wrap .att{height:auto;width:auto;padding-top:16px;padding-bottom:16px;padding-left:37px}.banner .content-wrap .att img{height:56px;width:188.6px}@media (max-width: 990px){.banner .content-wrap .att{height:auto;width:auto;padding-top:10px;padding-bottom:10px;padding-left:13px}.banner .content-wrap .att img{height:52px;width:170px}}.banner .content-wrap .default{height:88px;width:88px;padding-left:20px}.banner .content-wrap .default img{height:88px;width:88px}@media (max-width: 990px){.banner .content-wrap .default{height:72px;width:72px;padding:0}.banner .content-wrap .default img{height:72px;width:72px}}.banner .content-wrap .buttons{display:flex}.banner .content-wrap .buttons :host ::ng-deep child-nav-group :host ::ng-deep child-nav-group ul{background-color:#fff}.banner .content-wrap .buttons :host ::ng-deep child-nav-group .subMenuGroupTitle{font-family:Interstate-Regular,sans-serif;font-size:12px;color:#666;letter-spacing:0;line-height:20px}.banner .content-wrap .buttons :host ::ng-deep child-nav-group .child-links{font-family:Interstate-Light;font-size:16px;color:#333;letter-spacing:0;line-height:22px}@media screen and (max-width: 1120px){.banner .content-wrap .buttons{display:none}}.banner .content-wrap .buttons .navButton{padding:7px 4px;margin:15px 8px 7px}.banner .content-wrap .buttons .navButton:last-child{padding-right:0}.banner .content-wrap .buttons .navButton a,.banner .content-wrap .buttons .navButton button{cursor:pointer;background:none;border:none}.banner .content-wrap .buttons .navButton button{padding-top:0}.banner .content-wrap .buttons .navButton img{height:26px;width:26px;margin:auto;display:block}.banner .content-wrap .buttons .navButton #atmLink img{object-fit:none;object-position:-167px -21px;width:30px;height:26px}.banner .content-wrap .buttons .navButton #langBtn img{object-fit:none;object-position:-247px -21px;width:30px;height:26px}.banner .content-wrap .buttons .navButton .cartIconContainer img{object-fit:none;object-position:-17px -20px;width:30px;height:26px}.banner .content-wrap .buttons .navButton #profileMenu img{object-fit:none;object-position:-97px -21px;width:30px;height:26px}.banner .content-wrap .buttons .navButton span{display:block;padding-top:8px;font-family:Interstate-Regular,sans-serif;font-size:11px;color:#666;letter-spacing:0;text-align:center}.banner .content-wrap .buttons .subMenuGroupParent{width:max-content;border:1px solid #eee;background:#fff;z-index:1;display:none;position:absolute;box-shadow:0 2px 4px #00000020}.banner .content-wrap .buttons .subMenuGroupParent .flexColumnContainer{padding-left:20px;padding-right:20px}a#atmLink{text-decoration:none}.cartIconResponsive{display:none}@media screen and (max-width: 1120px){.cartIconResponsive{display:flex;padding-top:22px;padding-bottom:20px}.cartIconResponsive img{margin:auto;display:block;object-fit:none;object-position:-17px -20px;width:30px;height:26px}.cartIconResponsive span{display:block;padding-top:8px;font-family:Interstate-Regular,sans-serif;font-size:11px;color:#666;letter-spacing:0;text-align:center}}@media screen and (max-width: 990px){.cartIconResponsive{padding:16px}}.cartIconContainer{position:relative}.cartValue{position:absolute;top:-5px;right:-7px;line-height:3px;color:#fff!important;background-color:#056dae;width:16px;height:16px;border-radius:9px}.profileNavDropdown{border-radius:0 0 8px 8px}@media print{#sessionFocusUrl:after{visibility:hidden}}#fdicLogoA{margin-top:30px;margin-left:40px;object-fit:none;object-position:-20px -173px;width:427px;height:32px}#fdicLogoB{margin-top:24px;margin-left:30px;object-fit:none;object-position:-20px -173px;width:427px;height:32px}#fdicMobileImage{margin-top:11px;margin-left:12px;object-fit:none;object-position:-20px -256px;width:246px;height:44px}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i3.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: ProfileNavComponent, selector: "profile-nav", inputs: ["childNavGroup", "isMobile"], outputs: ["childLinkClicked"] }] }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Banner2Component, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Banner2Component, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }, {
            type: Component,
            args: [{ selector: 'citi-banner2', standalone: false, template: "<div *ngIf=\"config?.showBanner\" role=\"banner\" class=\"banner\" [ngClass]=\"fdicEligible && isExtendBanner(config?.customer) && config.customer != 'default'  ? 'fdicBanner' : ''\">\n  <div class=\"content-wrap\">\n    <div [ngClass]=\"fdicEligible && isExtendBanner(config?.customer) && config.customer != 'default'  ? 'journeyFdicLogo' : 'journeyLogo'\">\n      <div\n        *ngIf=\"config && config.showLogo\"\n        [ngClass]=\"config.customer\"\n        class=\"logoDiv\"\n        id=\"logoDiv\"\n      >\n        <a\n          *ngIf=\"config.url || config.routerLink\"\n          id=\"sessionFocusUrl\"\n          aria-label=\"citi-redesign-sessionfocus\"\n          [href]=\"chgUrl ? config.url || config.routerLink : cbObj.eURL\"\n          (click)=\"navigateToURL(config, $event)\"\n          (mouseover)=\"onRightClick(config, $event)\"\n          (contextmenu)=\"onRightClick(config, $event)\"\n          tabindex=\"0\"\n        >\n          <img\n            *ngIf=\"isMobile() && config.logoMobileImage\"\n            [src]=\"config.logoMobileImage\"\n            aria-label=\"citi-mobile-logo\"\n            id=\"mobileLogo\"\n            role = \"none\"\n            [attr.alt]=\"\n              config.customer == 'default' ? 'Citi' : config.comments\n            \"\n          />\n          <img\n            *ngIf=\"isMobile() && !config.logoMobileImage\"\n            [src]=\"config.logoImage\"\n            role = \"none\"\n            [attr.alt]=\"\n              config.customer == 'default' ? 'Citi' : config.comments\n            \"\n          />\n          <img\n            *ngIf=\"!isMobile()\"\n            [src]=\"config.logoImage\"\n            role = \"none\"\n            [attr.alt]=\"\n              config.customer == 'default' ? 'Citi' : config.comments\n            \"\n          />\n        </a>\n      </div>\n\n      <!-- Adding this repeated div for co branding-->\n      <div class=\"divider\" *ngIf=\"config && config.showLogo && hasCoB\" id=\"divider\"></div>\n      <div *ngIf=\"config && config.showLogo && hasCoB\" class=\"webDiv\" id=\"coBranding\">\n        <a [href]=\"cbObj.eURL\" class=\"box small\" tabindex=\"0\">\n          <img\n        *ngIf=\"isMobile() && config.logoMobileImage\"\n        [src]=\"cbObj.img\"\n        id=\"mobileCoLogo\"\n        [alt]=\"cbObj.altTxt\"\n          />\n          <img\n        *ngIf=\"isMobile() && !config.logoMobileImage\"\n        [src]=\"cbObj.img\"\n        [alt]=\"cbObj.altTxt\"\n          />\n          <img\n        *ngIf=\"!isMobile()\"\n        [src]=\"cbObj.img\"\n        [alt]=\"cbObj.altTxt\"\n        class=\"webLogo\"\n          />\n        </a>\n      </div>\n\n      <div *ngIf=\"fdicEligible\" id=\"fdicDiv\">\n          <a\n          role=\"presentation\"\n          id=\"fdicFocusUrl\"\n          tabindex=\"0\">\n          <img\n            *ngIf=\"isExtendBanner(config?.customer) || isFDICSmallMobile(config?.customer)\"\n            [src]=\"config.fdicImage\"\n            id=\"fdicMobileImage\"\n            alt=\"Citi FDIC Insured\"\n          />\n          <img\n            *ngIf=\"!isExtendBanner(config?.customer) && !isFDICSmallMobile(config?.customer)\"\n            [src]=\"config.fdicImage\"\n            [id]=\"!isFDICSmallMobile() && !isMobile() ? 'fdicLogoA' : 'fdicLogoB'\"\n            alt=\"Citi FDIC Insured\"\n          />\n        </a>\n      </div>\n    </div>\n\n    <div\n      class=\"cartIconResponsive\"\n      *ngIf=\"config && config.cart && cartItemQuantity > 0\"\n    >\n      <a\n        id=\"cartLinkResponsive\"\n        (click)=\"onMouseClick($event, config.cart, 0)\"\n        (focus)=\"onMouseClick($event, config.cart, 0)\"\n        (focusout)=\"onMouseLeave(config.cart, 0)\"\n        [href]=\"config.cart.url || config.cart.routerLink\"\n        (click)=\"navigateToURL(config.cart, $event)\"\n        (contextmenu)=\"onRightClick(config.cart, $event)\"\n        (mouseover)=\"onRightClick(config.cart, $event)\"\n        attr.aria-label=\"{{\n          cartItemQuantity > 1\n            ? cartItemQuantity + ' items in shopping cart'\n            : cartItemQuantity + ' item in shopping cart'\n        }}\"\n      >\n        <div class=\"cartIconContainer\">\n          <img [src]=\"config.cart.image\" alt=\"\" />\n          <span class=\"cartValue\">{{ this.cartItemQuantity }}</span>\n        </div>\n        <span>{{ config.cart.title }}</span>\n      </a>\n    </div>\n\n    <div\n      *ngIf=\"showButtons && config && config.showButtonsData\"\n      class=\"buttons\"\n    >\n      <ng-container *ngFor=\"let item of config.buttonsData; let i = index\">\n        <div\n          *ngIf=\"item.id && item.id == 'lang' ? item.locale == locale : true\"\n          class=\"navButton\"\n          [id]=\"item.id\"\n          (mouseover)=\"onMouseOver(item, i, $event)\"\n          (mouseleave)=\"onMouseLeave(item, i)\"\n          (focus)=\"onMouseOver(item, i, $event)\"\n          (mouseout)=\"onMouseLeave(item, i)\"\n        >\n          <a\n            *ngIf=\"(item.url || item.routerLink) && item.id == 'butlerATM'\"\n            id=\"atmLink\"\n            (click)=\"onMouseClick($event, item, i)\"\n            (focus)=\"onMouseClick($event, item, i)\"\n            (focusout)=\"onMouseLeave(item, i)\"\n            [attr.href]=\"item.url\"\n            (click)=\"navigateToURL(item, $event)\"\n            (contextmenu)=\"onRightClick(item, $event)\"\n            (mouseover)=\"onRightClick(item, $event)\"\n          >\n            <img [src]=\"item.image\" aria-hidden=\"true\" alt=\"\" />\n            <span>{{ item.title }}</span>\n          </a>\n          <a\n            *ngIf=\"\n              (item.routerLink || item.url) &&\n              item.id == 'cart' &&\n              config.cart &&\n              cartItemQuantity > 0\n            \"\n            id=\"cartLink\"\n            (click)=\"onMouseClick($event, item, i)\"\n            (focus)=\"onMouseClick($event, item, i)\"\n            (focusout)=\"onMouseLeave(item, i)\"\n            [routerLink]=\"item.routerLink || item.url\"\n            (click)=\"navigateToURL(item, $event)\"\n            (contextmenu)=\"onRightClick(item, $event)\"\n            attr.aria-label=\"{{\n              cartItemQuantity > 1\n                ? cartItemQuantity + ' items in shopping cart'\n                : cartItemQuantity + ' item in shopping cart'\n            }}\"\n          >\n            <div class=\"cartIconContainer\">\n              <img [src]=\"item.image\" alt=\"\" />\n              <span class=\"cartValue\">{{ this.cartItemQuantity }}</span>\n            </div>\n            <span>{{ item.title }}</span>\n          </a>\n          <button\n            [attr.aria-expanded]=\"false\"\n            [attr.aria-controls]=\"item.id + 'subGroup' + i\"\n            id=\"profileMenu\"\n            *ngIf=\"item.id == 'profiles' && item.show\"\n            (click)=\"onMouseClick($event, item, i)\"\n            (mouseout)=\"onMouseLeave(item, i)\"\n          >\n            <img\n              role=\"img\"\n              [src]=\"item.image\"\n              [alt]=\"item.className\"\n            />\n            <span role=\"presentation\">{{ item.title }}</span>\n          </button>\n          <div\n            class=\"subMenuGroupParent profileNavDropdown\"\n            [id]=\"item.id + 'subGroup' + i\"\n            *ngIf=\"\n              item.id == 'profiles' &&\n              item.navigationItems &&\n              item.navigationItems.length\n            \"\n            [ngStyle]=\"{\n              right: !isMobile ? '0' : '50px'\n            }\"\n            (keyup.escape)=\"onEscapePress($event, item, i)\"\n          >\n            <div\n              #profileContainer\n              class=\"flexColumnContainer profileNavDropdown\"\n              [ngStyle]=\"{ background: '#fff' }\"\n            >\n              <ng-container>\n                <profile-nav\n                  *ngFor=\"\n                    let childNavGroup of item.navigationItems;\n                    let secondLevelIndex = index\n                  \"\n                  [childNavGroup]=\"childNavGroup\"\n                  class=\"{{ customerType }}ProfileNavTheme\"\n                  (childLinkClicked)=\"profileTagging($event, profileContainer); navigateToURL($event, $event.targetLink)\"\n                ></profile-nav>\n              </ng-container>\n            </div>\n          </div>\n\n          <button\n            [attr.lang]=\"item.locale == 'es_US' ? 'en' : 'es'\"\n            *ngIf=\"item.id == 'lang' && item.locale == locale\"\n            id=\"langBtn\"\n            attr.data-target=\"#citi-modalb{{ i }}\"\n            [attr.aria-label]=\"\n              item.locale == 'es_US'\n                ? 'Click to change page language to English'\n                : 'Haz clic para cambiar la p\u00E1gina al espa\u00F1ol'\n            \"\n            (click)=\"onLangBtnClick(item)\"\n          >\n            <img aria-hidden=\"true\" [src]=\"item.image\" alt=\"\" />\n            <span [attr.lang]=\"item.locale == 'es_US' ? 'en' : 'es'\">{{\n              item.title\n            }}</span>\n          </button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n", styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.blueProfileNavTheme{--profilenav-text-color: #04208F;--profilenav-text-hover-color: #4400CC;--profilenav-header-color: #5E676B}.journeyLogo{display:flex;cursor:pointer}.journeyFdicLogo{display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:auto;gap:0;cursor:pointer}#logoDiv,#divider,#coBranding{grid-column:span 1}#fdicDiv{grid-column:span 2}.divider{border-left:3.5px solid lightgray;height:28px;margin-top:23px;margin-right:10px}.webLogo{max-width:100%;max-height:100%;display:block}.box{width:180px;display:flex;justify-content:left;align-items:center}.webDiv{margin-left:5px}.box.small{height:72px}.box.small img{height:40px}@media screen and (max-width: 425px){.journeyLogo{align-items:center}}@media screen and (min-width: 1000px){.divider{margin-left:35px;height:37px;margin-top:27px}.box.small{height:88px}.box.small img{height:48px}.webDiv{margin-left:15px}}.fdicBanner{height:150px!important}.banner{height:88px;background-color:#fff!important}@media (max-width: 990px){.banner{height:72px}}.banner .content-wrap{height:100%;padding:0 35px 0 20px;position:relative;display:flex;justify-content:space-between}@media (max-width: 990px){.banner .content-wrap{padding:0}}.banner .content-wrap .cpc{height:88px;width:auto;padding-bottom:20px;padding-left:17px}.banner .content-wrap .cpc img{height:auto;width:auto}@media (max-width: 990px){.banner .content-wrap .cpc{height:72px;width:auto;padding:0}.banner .content-wrap .cpc img{height:72px;width:auto;padding-left:16px}}.banner .content-wrap .cpb{height:88px;width:auto}.banner .content-wrap .cpb img{width:auto}@media (max-width: 990px){.banner .content-wrap .cpb,.banner .content-wrap .cpb img{height:72px;width:auto}}.banner .content-wrap .gold,.banner .content-wrap .priority,.banner .content-wrap .business{height:88px;width:auto;padding-top:28px;padding-bottom:20px;padding-left:14px}.banner .content-wrap .gold img,.banner .content-wrap .priority img,.banner .content-wrap .business img{height:40px;width:auto}@media (max-width: 990px){.banner .content-wrap .gold,.banner .content-wrap .priority,.banner .content-wrap .business{height:72px;width:auto;padding:0}.banner .content-wrap .gold img,.banner .content-wrap .priority img,.banner .content-wrap .business img{height:72px;width:auto;padding-left:16px}}.banner .content-wrap .att{height:auto;width:auto;padding-top:16px;padding-bottom:16px;padding-left:37px}.banner .content-wrap .att img{height:56px;width:188.6px}@media (max-width: 990px){.banner .content-wrap .att{height:auto;width:auto;padding-top:10px;padding-bottom:10px;padding-left:13px}.banner .content-wrap .att img{height:52px;width:170px}}.banner .content-wrap .default{height:88px;width:88px;padding-left:20px}.banner .content-wrap .default img{height:88px;width:88px}@media (max-width: 990px){.banner .content-wrap .default{height:72px;width:72px;padding:0}.banner .content-wrap .default img{height:72px;width:72px}}.banner .content-wrap .buttons{display:flex}.banner .content-wrap .buttons :host ::ng-deep child-nav-group :host ::ng-deep child-nav-group ul{background-color:#fff}.banner .content-wrap .buttons :host ::ng-deep child-nav-group .subMenuGroupTitle{font-family:Interstate-Regular,sans-serif;font-size:12px;color:#666;letter-spacing:0;line-height:20px}.banner .content-wrap .buttons :host ::ng-deep child-nav-group .child-links{font-family:Interstate-Light;font-size:16px;color:#333;letter-spacing:0;line-height:22px}@media screen and (max-width: 1120px){.banner .content-wrap .buttons{display:none}}.banner .content-wrap .buttons .navButton{padding:7px 4px;margin:15px 8px 7px}.banner .content-wrap .buttons .navButton:last-child{padding-right:0}.banner .content-wrap .buttons .navButton a,.banner .content-wrap .buttons .navButton button{cursor:pointer;background:none;border:none}.banner .content-wrap .buttons .navButton button{padding-top:0}.banner .content-wrap .buttons .navButton img{height:26px;width:26px;margin:auto;display:block}.banner .content-wrap .buttons .navButton #atmLink img{object-fit:none;object-position:-167px -21px;width:30px;height:26px}.banner .content-wrap .buttons .navButton #langBtn img{object-fit:none;object-position:-247px -21px;width:30px;height:26px}.banner .content-wrap .buttons .navButton .cartIconContainer img{object-fit:none;object-position:-17px -20px;width:30px;height:26px}.banner .content-wrap .buttons .navButton #profileMenu img{object-fit:none;object-position:-97px -21px;width:30px;height:26px}.banner .content-wrap .buttons .navButton span{display:block;padding-top:8px;font-family:Interstate-Regular,sans-serif;font-size:11px;color:#666;letter-spacing:0;text-align:center}.banner .content-wrap .buttons .subMenuGroupParent{width:max-content;border:1px solid #eee;background:#fff;z-index:1;display:none;position:absolute;box-shadow:0 2px 4px #00000020}.banner .content-wrap .buttons .subMenuGroupParent .flexColumnContainer{padding-left:20px;padding-right:20px}a#atmLink{text-decoration:none}.cartIconResponsive{display:none}@media screen and (max-width: 1120px){.cartIconResponsive{display:flex;padding-top:22px;padding-bottom:20px}.cartIconResponsive img{margin:auto;display:block;object-fit:none;object-position:-17px -20px;width:30px;height:26px}.cartIconResponsive span{display:block;padding-top:8px;font-family:Interstate-Regular,sans-serif;font-size:11px;color:#666;letter-spacing:0;text-align:center}}@media screen and (max-width: 990px){.cartIconResponsive{padding:16px}}.cartIconContainer{position:relative}.cartValue{position:absolute;top:-5px;right:-7px;line-height:3px;color:#fff!important;background-color:#056dae;width:16px;height:16px;border-radius:9px}.profileNavDropdown{border-radius:0 0 8px 8px}@media print{#sessionFocusUrl:after{visibility:hidden}}#fdicLogoA{margin-top:30px;margin-left:40px;object-fit:none;object-position:-20px -173px;width:427px;height:32px}#fdicLogoB{margin-top:24px;margin-left:30px;object-fit:none;object-position:-20px -173px;width:427px;height:32px}#fdicMobileImage{margin-top:11px;margin-left:12px;object-fit:none;object-position:-20px -256px;width:246px;height:44px}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: i6.HttpService }, { type: i1.HttpClient }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i1$1.AppConfigService }, { type: CobrandingService }, { type: BrandingService }, { type: BrandingTypeService }, { type: BrandingEntitlementService }, { type: BrandingMapService }, { type: i1$1.CookieService }, { type: BrandingTaggingService }, { type: i10.ShoppingCartService }, { type: LayoutsService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }, { type: i3.Router }], propDecorators: { langBtnClicked: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['window:click', ['$event']]
            }], brandingConfig: [{
                type: Input
            }] } });

class ChildNavGroup3Component {
    constructor(_brandingEntitlementService, host, renderer, mapperService, _isSSRApp, titleService, _sessionStorage, brandingTag, sanitizer) {
        this._brandingEntitlementService = _brandingEntitlementService;
        this.host = host;
        this.renderer = renderer;
        this.mapperService = mapperService;
        this._isSSRApp = _isSSRApp;
        this.titleService = titleService;
        this._sessionStorage = _sessionStorage;
        this.brandingTag = brandingTag;
        this.sanitizer = sanitizer;
        this.sideNavModel = false;
        this.toggleOpenCloseDiv = false;
        this.childLinkClicked = new EventEmitter();
        this.routerLinkClicked = new EventEmitter();
    }
    set getUserTypeFromNav(value) {
        this.userTypeFromNav = value;
    }
    set userLoggedIn(value) {
        this.isUserLoggedinForChild = value;
        // console.log('this.isUserLoggedIn', this.isUserLoggedinForChild);
    }
    set navData(value) {
        // console.log(value);
        this.navDataForSOM = value;
    }
    getSPBS() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                if (sessionParams) {
                    return sessionParams;
                }
            }
            catch (err) {
                return false;
            }
        }
    }
    ngOnInit() {
        this.showBrandingSSR = this._isSSRApp;
        this.sessionParams = this.getSPBS();
        for (var i = 0; i < this.childNavGroup.items.length; i++) {
            if (this.childNavGroup.items[i].id == 'accountsoverview') {
                if (this.sessionParams && this.sessionParams?.featureFlags?.ff_singlecardevolutionoct === 'N') {
                    this.childNavGroup.items[i].show = true;
                    console.log('child overview ==> ', this.childNavGroup.items[i].show, "testing");
                }
                else if (this.sessionParams && this.sessionParams?.featureFlags?.ff_singlecardevolutionoct === 'Y') {
                    this.childNavGroup.items[i].show = false;
                }
            }
        }
        console.log('childNavGroup ==> ', this.childNavGroup, this.isUserLoggedinForChild, "testing");
        if (this.isMobile) {
            this.sessionParams = this.getSPBS();
            if (this.sessionParams && this.sessionParams?.featureFlags?.ff_isProductsOffersGeneralThrottled === 'Y') {
                if (this.childNavGroup.items.some(e => e.featureflag === 'ff_isProductsOffersGeneralThrottled')) {
                    this.childNavGroup.items.unshift(this.childNavGroup.items.splice(this.childNavGroup.items.findIndex(e => e.featureflag == "ff_isProductsOffersGeneralThrottled"), 1)[0]);
                }
            }
        }
    }
    // Function to determine whether to show the NEW tag for entry points
    shouldShowTag(link) {
        // ff_citiStrataEliteCardBenefitsTopNav is a feature flag tied to the entry point and is targeted to show the NEW tag, newTagCitiStrata enables the 30-day cookie logic for display
        // ff_citiStrataCardBenefitsTopNav is a feature flag tied to the entry point and is targeted to show the NEW tag, newTagCitiStrataCardsBenefits enables the 30-day cookie logic for display
        return (link?.featureflag === 'ff_citiStrataEliteCardBenefitsTopNav' && this.newTagCitiStrata) || (link?.featureflag === 'ff_citiStrataCardBenefitsTopNav' && this.newTagCitiStrataCardsBenefits) || (link?.featureflag === 'ff_citiAAdvantageGlobeCardBenetisTopNav' && this.newTagCitiAaAdVantageGlobeMasterCard);
    }
    navigateToURL(obj, event, submenuContainer) {
        //Top Nav tagging setting submenu index for mobile and browser
        obj.index = Array.from(submenuContainer.getElementsByTagName('a')).findIndex((el) => el === event.currentTarget);
        if (this.isMobile) {
            obj.submenuIndex = Array.from(submenuContainer.parentElement.parentElement.getElementsByTagName('child-nav-group3'))
                .filter((el) => el.style.display === 'block')
                .findIndex((el) => el === event.currentTarget.parentElement.parentElement.parentElement);
            if (this.thirdLevelChild) { // third level for explore products mobile
                obj.submenuIndex = Array.from(submenuContainer.parentElement.parentElement.parentElement.getElementsByTagName('child-nav-group3'))
                    .filter((el) => el.style.display === 'block')
                    .findIndex((el) => el === event.currentTarget.parentElement.parentElement.parentElement.parentElement);
            }
        }
        else {
            obj.submenuIndex = Array.from(submenuContainer.parentElement.parentElement.getElementsByTagName('child-nav-group3'))
                .filter((el) => el.style.display === 'flex')
                .findIndex((el) => el === event.currentTarget.parentElement.parentElement.parentElement);
        }
        if (Array.from(event.currentTarget.parentElement.parentElement.getElementsByClassName('quickLinksListItem')).length) {
            obj.submenuIndex = 0; // submenuindex for quicklinks
        }
        //console.log('--- navigate url in child component----');
        this.routerLinkClicked.emit(obj);
        this.titleService.setTitle(obj.title);
        event.preventDefault();
        this.mapperService.brandingMap(obj);
    }
    onRightClick(obj, event, submenuContainer) {
        if (event.type == 'contextmenu' || event.type == 'mouseover') {
            if (event.type == 'contextmenu') {
                obj.eventType = 'contextmenu';
                obj.index = Array.from(submenuContainer.getElementsByTagName('a')).findIndex((el) => el === event.currentTarget);
                obj.submenuIndex = Array.from(submenuContainer.parentElement.parentElement.getElementsByTagName('child-nav-group3'))
                    .filter((el) => el.style.display === 'flex')
                    .findIndex((el) => el === event.currentTarget.parentElement.parentElement.parentElement);
                if (Array.from(event.currentTarget.parentElement.parentElement.getElementsByClassName('quickLinksListItem')).length) {
                    obj.submenuIndex = 0; // submenuindex for quicklinks
                }
                this.routerLinkClicked.emit(obj);
            }
            this.mapperService.modifyURLPrefixRightClick(event, obj.domainMap, obj);
        }
    }
    onChildLinkClick(e, item) {
        this.titleService.setTitle(item.title);
        this.childLinkClicked.emit(true);
        e.preventDefault();
    }
    onRouterLinkClick(obj, event, index) {
        this.routerLinkClicked.emit(true);
        event.preventDefault();
        this.mapperService.brandingMap(obj);
    }
    onSubChildLinkClick(e, item, i) {
        e.preventDefault();
        let dynamicId = item.title + 'subChild' + i;
        if (this.isMobile) {
            this.subChildGroup.forEach(elem => {
                if (elem.nativeElement.id === dynamicId) {
                    this.renderer.addClass(elem.nativeElement, 'openSideNav');
                    this.renderer.removeClass(elem.nativeElement, 'closeSideNav');
                    this.sideNavModel = true;
                }
                else {
                }
            });
        }
    }
    onClickTitleTemp(e, item) {
        this.thirdLevelChild = item;
        this.thirdLevelChildList = item.items;
        this.thirdLevelChildTitle = item.subTitle;
        this.sideNavModel = true;
        this.toggleOpenCloseDiv = true;
    }
    // GBC-11224 - third-level submenus on mobile should be dismissible via Esc key - WCAG 2.1 1.4.13 (AA)
    onEscapePress(event) {
        event.stopPropagation();
        this.onCloseSubSideNav();
        this.exploreProductsCategory.nativeElement.focus();
    }
    onCloseSubSideNav() {
        this.toggleOpenCloseDiv = false;
    }
    // If user tabs out of the first or last element of the submenu, dismiss the submenu
    onSubmenuBlur(event) {
        if (!this.subChildGroup.first.nativeElement.contains(event.relatedTarget)) {
            this.onCloseSubSideNav();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ChildNavGroup3Component, deps: [{ token: BrandingEntitlementService }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BrandingMapService }, { token: IS_SSRENDERED_APP, optional: true }, { token: i3$2.Title }, { token: SESSION_STORAGE }, { token: BrandingTaggingService }, { token: i3$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ChildNavGroup3Component, isStandalone: false, selector: "child-nav-group3, [child-nav-group3]", inputs: { childNavGroup: "childNavGroup", isMobile: "isMobile", newTagCitiStrata: "newTagCitiStrata", newTagCitiStrataCardsBenefits: "newTagCitiStrataCardsBenefits", newTagCitiAaAdVantageGlobeMasterCard: "newTagCitiAaAdVantageGlobeMasterCard", isExploreProducts: "isExploreProducts", getUserTypeFromNav: "getUserTypeFromNav", userLoggedIn: "userLoggedIn", navData: "navData" }, outputs: { childLinkClicked: "childLinkClicked", routerLinkClicked: "routerLinkClicked" }, host: { classAttribute: "child-nav-group3" }, viewQueries: [{ propertyName: "exploreProductsCategory", first: true, predicate: ["exploreProductsCategory"], descendants: true }, { propertyName: "subChildGroup", predicate: ["subChildGroup"], descendants: true }], ngImport: i0, template: "<div\n  class=\"subMenuGroupTitle\"\n  *ngIf=\"isUserLoggedinForChild && childNavGroup.subTitle\"\n  (keydown.enter)=\"onClickTitleTemp($event, childNavGroup)\"\n>\n  <!-- This is the mobile link for each sub-category inside of Explore Products -->\n  <a\n    #exploreProductsCategory\n    class=\"mobileHeadingAnchorTag\"\n    *ngIf=\"isMobile && isExploreProducts\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n    [tabIndex]=\"childNavGroup.subTitle ? 0 : -1\"\n    (click)=\"onClickTitleTemp($event, childNavGroup)\"\n  ></a>\n\n  <!-- Mobile header used for categorized links in Payments & Transfers and Profile -->\n  <h5\n    aria-level=\"2\"\n    class=\"subHeadersOnMobile\"\n    *ngIf=\"isMobile && !isExploreProducts\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></h5>\n\n  <!-- Desktop header used for all categorized links (Payments & Transfers, Explore Products) -->\n  <h6\n    aria-level=\"2\"\n    class=\"subHeadersOnDesktop\"\n    *ngIf=\"!isMobile && childNavGroup.show\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></h6>\n</div>\n\n<!-- List of links in the navigation category / submenu group -->\n<ul\n  role=\"list\"\n  #submenuContainer\n  class=\"subMenuGroupUL\"\n  *ngIf=\"childNavGroup && (!isMobile || !isExploreProducts)\"\n>\n  <ng-container *ngFor=\"let link of childNavGroup.items; let i = index\">\n    <li\n      *ngIf=\"link.show\"\n      class=\"subMenuGroupLI\"\n      role=\"listitem\"\n      [ngClass]=\"shouldShowTag(link) ? 'cbolui-cds' : ''\"\n    >\n      <a\n        *ngIf=\"link.url || link.routerLink\"\n        [id]=\"link?.id + link.title + link?.subtitleId + i\"\n        class=\"child-links\"\n        (mouseover)=\"onRightClick(link, $event, submenuContainer)\"\n        tabindex=\"0\"\n        role=\"link\"\n        [attr.href]=\"link.url || link.routerLink\"\n        (click)=\"navigateToURL(link, $event, submenuContainer)\"\n        [attr.target]=\"link.target\"\n        [innerHtml]=\"link.title\"\n        (contextmenu)=\"onRightClick(link, $event, submenuContainer)\"\n      ></a>\n      <div\n        *ngIf=\"shouldShowTag(link)\"\n        class=\"cds-tags-standard newTagCitiStrata\"\n      > NEW </div>\n    </li>\n  </ng-container>\n</ul>\n\n<!-- Third-level submenu for Explore Products categories on mobile responsive -->\n<div\n  #subChildGroup\n  *ngIf=\"isUserLoggedinForChild && isMobile && isExploreProducts\"\n  class=\"exploreSubNav\"\n  [ngClass]=\"{\n    openSideNav: toggleOpenCloseDiv && isMobile,\n    closeSideNav: !toggleOpenCloseDiv && isMobile\n  }\"\n  (keyup.escape)=\"onEscapePress($event)\"\n  (focusout)=\"onSubmenuBlur($event)\"\n>\n  <!-- Title of the Explore Products category + button to navigate back -->\n  <div class=\"exploreSubmenuTitle\">\n    <a\n      [tabIndex]=\"toggleOpenCloseDiv ? 0 : -1\"\n      (click)=\"onCloseSubSideNav()\"\n      (keydown.enter)=\"onCloseSubSideNav()\"\n    >{{ thirdLevelChildTitle }}\n    </a>\n  </div>\n  <ul\n    class=\"exploreUl\"\n    #thirdLevelSubmenuContainer\n  >\n    <ng-container *ngFor=\"let tlc of thirdLevelChildList\">\n      <li *ngIf=\"tlc.show\">\n        <a\n          *ngIf=\"tlc.url\"\n          class=\"child-links\"\n          (click)=\"navigateToURL(tlc, $event, thirdLevelSubmenuContainer)\"\n          [attr.href]=\"tlc.url\"\n          [innerHtml]=\"tlc.title\"\n          [tabIndex]=\"toggleOpenCloseDiv ? 0 : -1\"\n        ></a>\n      </li>\n    </ng-container>\n  </ul>\n</div>\n\n<!-- Pre-Login Quick Links - these exist under every nav category in pre-login -->\n<div\n  class=\"quickLinks\"\n  *ngIf=\"!isUserLoggedinForChild\"\n>\n  <div\n    class=\"quickLinksSubTitle\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></div>\n  <ul #quickLinksContainer>\n    <!-- Logo and link text for each quick link -->\n    <li\n      *ngFor=\"let quickLink of childNavGroup.quickLinks\"\n      class=\"quickLinksListItem\"\n    >\n      <img\n        [ngClass]=\"quickLink.linkId\"\n        [src]=\"quickLink.linkimage\"\n        aria-hidden=\"true\"\n      />\n      <a\n        *ngIf=\"quickLink.url || quickLink.routerLink\"\n        class=\"quickLinkText\"\n        [attr.id]=\"quickLink.linkId\"\n        [attr.href]=\"quickLink.url || quickLink.routerLink\"\n        (click)=\"navigateToURL(quickLink, $event, quickLinksContainer)\"\n        (contextmenu)=\"onRightClick(quickLink, $event, quickLinksContainer)\"\n        [attr.target]=\"\"\n        [innerHtml]=\"quickLink.linkText\"\n        (mouseover)=\"onRightClick(quickLink, $event, quickLinksContainer)\"\n      ></a>\n    </li>\n  </ul>\n</div>", styles: [":host{max-width:1440px;display:flex}a{cursor:pointer}.subHeadersOnMobile{font-size:12px;font-family:Interstate_Regular,sans-serif;color:#666;font-weight:600;text-transform:uppercase;letter-spacing:0;line-height:20px;margin-left:44px;margin-top:15px}.mobileHeadingAnchorTag{color:var(--text-color, #333);font-family:Interstate_Regular,sans-serif;text-decoration:none}.mobileHeadingAnchorTag:focus,.mobileHeadingAnchorTag:hover{color:var(--text-hover-color, #333)}.mobileHeadingAnchorTag:after{content:\"\";background-image:url(/citi-branding-assets/images/right-chevi.svg);background-repeat:no-repeat;position:absolute;top:24px;right:-8px;width:20px;height:20px}.subMenuGroupUL{padding:0;background:#fff;display:flex;flex-direction:column;width:100%;font-family:Interstate-Regular,sans-serif}@media screen and (max-width: 1120px){.subMenuGroupUL{padding-left:26px}}.quickLinks{padding-left:20px}.quickLinks ul{padding-inline-start:0}.quickLinks .quickLinksSubTitle{color:var(--header-color, #666666);font-size:12px;letter-spacing:1px;font-family:Interstate-Regular,sans-serif;text-transform:uppercase;margin-bottom:8px;line-height:20px}@media screen and (max-width: 1120px){.quickLinks .quickLinksSubTitle{margin-top:12px}}.quickLinks .quickLinksListItem{list-style:none;position:relative;padding-bottom:16px;margin-bottom:0}.quickLinks .quickLinksListItem .quickLinkText{color:var(--text-color, #333);text-decoration:none;font-family:Interstate_Light,sans-serif}.quickLinks .quickLinksListItem .quickLinkText:focus,.quickLinks .quickLinksListItem .quickLinkText:hover{color:var(--text-hover-color, #333);text-decoration:underline}.quickLinks .quickLinksListItem img{object-fit:none;vertical-align:middle;background-repeat:no-repeat;width:30px;height:26px;margin-right:10px}.quickLinks .quickLinksListItem img.findRelMan{object-position:-931px -20px}.quickLinks .quickLinksListItem img.ktCenter{object-position:-19px -23px}.quickLinks .quickLinksListItem img.citiBonusOffers{object-position:-248px -21px}.quickLinks .quickLinksListItem img.personalBankingGuide{object-position:-171px -21px}.quickLinks .quickLinksListItem img.mortCalc{object-position:-322px -20px}.quickLinks .quickLinksListItem img.hec{object-position:-398px -20px}.quickLinks .quickLinksListItem img.mlc{object-position:-473px -20px}.quickLinks .quickLinksListItem img.plc{object-position:-549px -21px}.quickLinks .quickLinksListItem img.finPlan{object-position:-629px -20px}.quickLinks .quickLinksListItem img.marketIns{object-position:-477px -20px}.quickLinks .quickLinksListItem img.invIns{object-position:-701px -20px}.quickLinks .quickLinksListItem img.citiWelAdv{object-position:-779px -20px}.quickLinks .quickLinksListItem img.prequalified,.quickLinks .quickLinksListItem img.checkYourApp{object-position:-323px -82px}.quickLinks .quickLinksListItem img.citishop{object-position:-248px -85px}.quickLinks .quickLinksListItem img.dcc{object-position:-170px -85px}.quickLinks .quickLinksListItem img.mailOffer{object-position:-856px -20px}.subMenuGroupTitle{margin:0;position:relative}.subMenuGroupTitle .subHeadersOnDesktop{padding-bottom:10px;text-transform:uppercase;font-size:12px;color:var(--header-color, #666666);letter-spacing:0;margin:5px 0;cursor:text;font-family:Interstate_Regular,sans-serif}.child-links{display:inline-block;text-decoration:none;color:var(--text-color, #333);padding-bottom:16px;line-height:1.5;font-family:Interstate_Light,sans-serif}.child-links:focus,.child-links:hover{color:var(--text-hover-color, #333)}.child-links:hover{text-decoration:underline}.child-links:focus{outline:none}.child-links:focus-visible{border:2px solid black;border-radius:3px}@media screen and (max-width: 1120px){.child-links{font-weight:600;color:var(--text-color, #002d72);padding:12px 20px}.child-links:focus,.child-links:hover{color:var(--text-hover-color, #002d72)}}.subMenuGroupLI{margin:0;list-style-type:none}.subMenuGroupLI .newTagCitiStrata{background-color:#6a3077;margin-left:8px}.exploreSubNav{position:absolute;top:0;background:#fff;left:0;height:100%}.exploreSubNav .exploreUl{list-style:none;padding-left:36px}.exploreSubNav .exploreSubmenuTitle{position:relative;border-bottom:1px solid #eee;margin-bottom:12px;margin-left:56px;line-height:4em}.exploreSubNav .exploreSubmenuTitle a{color:var(--header-color, #000);font-family:Interstate_Regular,sans-serif}.exploreSubNav .exploreSubmenuTitle a:before{content:\"\";background-image:url(/citi-branding-assets/images/chevronLeft.svg);background-repeat:no-repeat;position:absolute;top:25px;left:-25px;width:20px;height:20px}.closeSideNav{display:block!important;width:100%;height:100%;z-index:9;position:absolute;transform:translate(100%);transition:.5s ease-in}.openSideNav{display:block!important;width:100%;height:100%;z-index:9;position:absolute;transform:translate(0);transition:.5s ease-in}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ChildNavGroup3Component, decorators: [{
            type: Component,
            args: [{ selector: 'child-nav-group3, [child-nav-group3]', standalone: false, host: { class: 'child-nav-group3' }, template: "<div\n  class=\"subMenuGroupTitle\"\n  *ngIf=\"isUserLoggedinForChild && childNavGroup.subTitle\"\n  (keydown.enter)=\"onClickTitleTemp($event, childNavGroup)\"\n>\n  <!-- This is the mobile link for each sub-category inside of Explore Products -->\n  <a\n    #exploreProductsCategory\n    class=\"mobileHeadingAnchorTag\"\n    *ngIf=\"isMobile && isExploreProducts\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n    [tabIndex]=\"childNavGroup.subTitle ? 0 : -1\"\n    (click)=\"onClickTitleTemp($event, childNavGroup)\"\n  ></a>\n\n  <!-- Mobile header used for categorized links in Payments & Transfers and Profile -->\n  <h5\n    aria-level=\"2\"\n    class=\"subHeadersOnMobile\"\n    *ngIf=\"isMobile && !isExploreProducts\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></h5>\n\n  <!-- Desktop header used for all categorized links (Payments & Transfers, Explore Products) -->\n  <h6\n    aria-level=\"2\"\n    class=\"subHeadersOnDesktop\"\n    *ngIf=\"!isMobile && childNavGroup.show\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></h6>\n</div>\n\n<!-- List of links in the navigation category / submenu group -->\n<ul\n  role=\"list\"\n  #submenuContainer\n  class=\"subMenuGroupUL\"\n  *ngIf=\"childNavGroup && (!isMobile || !isExploreProducts)\"\n>\n  <ng-container *ngFor=\"let link of childNavGroup.items; let i = index\">\n    <li\n      *ngIf=\"link.show\"\n      class=\"subMenuGroupLI\"\n      role=\"listitem\"\n      [ngClass]=\"shouldShowTag(link) ? 'cbolui-cds' : ''\"\n    >\n      <a\n        *ngIf=\"link.url || link.routerLink\"\n        [id]=\"link?.id + link.title + link?.subtitleId + i\"\n        class=\"child-links\"\n        (mouseover)=\"onRightClick(link, $event, submenuContainer)\"\n        tabindex=\"0\"\n        role=\"link\"\n        [attr.href]=\"link.url || link.routerLink\"\n        (click)=\"navigateToURL(link, $event, submenuContainer)\"\n        [attr.target]=\"link.target\"\n        [innerHtml]=\"link.title\"\n        (contextmenu)=\"onRightClick(link, $event, submenuContainer)\"\n      ></a>\n      <div\n        *ngIf=\"shouldShowTag(link)\"\n        class=\"cds-tags-standard newTagCitiStrata\"\n      > NEW </div>\n    </li>\n  </ng-container>\n</ul>\n\n<!-- Third-level submenu for Explore Products categories on mobile responsive -->\n<div\n  #subChildGroup\n  *ngIf=\"isUserLoggedinForChild && isMobile && isExploreProducts\"\n  class=\"exploreSubNav\"\n  [ngClass]=\"{\n    openSideNav: toggleOpenCloseDiv && isMobile,\n    closeSideNav: !toggleOpenCloseDiv && isMobile\n  }\"\n  (keyup.escape)=\"onEscapePress($event)\"\n  (focusout)=\"onSubmenuBlur($event)\"\n>\n  <!-- Title of the Explore Products category + button to navigate back -->\n  <div class=\"exploreSubmenuTitle\">\n    <a\n      [tabIndex]=\"toggleOpenCloseDiv ? 0 : -1\"\n      (click)=\"onCloseSubSideNav()\"\n      (keydown.enter)=\"onCloseSubSideNav()\"\n    >{{ thirdLevelChildTitle }}\n    </a>\n  </div>\n  <ul\n    class=\"exploreUl\"\n    #thirdLevelSubmenuContainer\n  >\n    <ng-container *ngFor=\"let tlc of thirdLevelChildList\">\n      <li *ngIf=\"tlc.show\">\n        <a\n          *ngIf=\"tlc.url\"\n          class=\"child-links\"\n          (click)=\"navigateToURL(tlc, $event, thirdLevelSubmenuContainer)\"\n          [attr.href]=\"tlc.url\"\n          [innerHtml]=\"tlc.title\"\n          [tabIndex]=\"toggleOpenCloseDiv ? 0 : -1\"\n        ></a>\n      </li>\n    </ng-container>\n  </ul>\n</div>\n\n<!-- Pre-Login Quick Links - these exist under every nav category in pre-login -->\n<div\n  class=\"quickLinks\"\n  *ngIf=\"!isUserLoggedinForChild\"\n>\n  <div\n    class=\"quickLinksSubTitle\"\n    [innerHtml]=\"childNavGroup.subTitle\"\n  ></div>\n  <ul #quickLinksContainer>\n    <!-- Logo and link text for each quick link -->\n    <li\n      *ngFor=\"let quickLink of childNavGroup.quickLinks\"\n      class=\"quickLinksListItem\"\n    >\n      <img\n        [ngClass]=\"quickLink.linkId\"\n        [src]=\"quickLink.linkimage\"\n        aria-hidden=\"true\"\n      />\n      <a\n        *ngIf=\"quickLink.url || quickLink.routerLink\"\n        class=\"quickLinkText\"\n        [attr.id]=\"quickLink.linkId\"\n        [attr.href]=\"quickLink.url || quickLink.routerLink\"\n        (click)=\"navigateToURL(quickLink, $event, quickLinksContainer)\"\n        (contextmenu)=\"onRightClick(quickLink, $event, quickLinksContainer)\"\n        [attr.target]=\"\"\n        [innerHtml]=\"quickLink.linkText\"\n        (mouseover)=\"onRightClick(quickLink, $event, quickLinksContainer)\"\n      ></a>\n    </li>\n  </ul>\n</div>", styles: [":host{max-width:1440px;display:flex}a{cursor:pointer}.subHeadersOnMobile{font-size:12px;font-family:Interstate_Regular,sans-serif;color:#666;font-weight:600;text-transform:uppercase;letter-spacing:0;line-height:20px;margin-left:44px;margin-top:15px}.mobileHeadingAnchorTag{color:var(--text-color, #333);font-family:Interstate_Regular,sans-serif;text-decoration:none}.mobileHeadingAnchorTag:focus,.mobileHeadingAnchorTag:hover{color:var(--text-hover-color, #333)}.mobileHeadingAnchorTag:after{content:\"\";background-image:url(/citi-branding-assets/images/right-chevi.svg);background-repeat:no-repeat;position:absolute;top:24px;right:-8px;width:20px;height:20px}.subMenuGroupUL{padding:0;background:#fff;display:flex;flex-direction:column;width:100%;font-family:Interstate-Regular,sans-serif}@media screen and (max-width: 1120px){.subMenuGroupUL{padding-left:26px}}.quickLinks{padding-left:20px}.quickLinks ul{padding-inline-start:0}.quickLinks .quickLinksSubTitle{color:var(--header-color, #666666);font-size:12px;letter-spacing:1px;font-family:Interstate-Regular,sans-serif;text-transform:uppercase;margin-bottom:8px;line-height:20px}@media screen and (max-width: 1120px){.quickLinks .quickLinksSubTitle{margin-top:12px}}.quickLinks .quickLinksListItem{list-style:none;position:relative;padding-bottom:16px;margin-bottom:0}.quickLinks .quickLinksListItem .quickLinkText{color:var(--text-color, #333);text-decoration:none;font-family:Interstate_Light,sans-serif}.quickLinks .quickLinksListItem .quickLinkText:focus,.quickLinks .quickLinksListItem .quickLinkText:hover{color:var(--text-hover-color, #333);text-decoration:underline}.quickLinks .quickLinksListItem img{object-fit:none;vertical-align:middle;background-repeat:no-repeat;width:30px;height:26px;margin-right:10px}.quickLinks .quickLinksListItem img.findRelMan{object-position:-931px -20px}.quickLinks .quickLinksListItem img.ktCenter{object-position:-19px -23px}.quickLinks .quickLinksListItem img.citiBonusOffers{object-position:-248px -21px}.quickLinks .quickLinksListItem img.personalBankingGuide{object-position:-171px -21px}.quickLinks .quickLinksListItem img.mortCalc{object-position:-322px -20px}.quickLinks .quickLinksListItem img.hec{object-position:-398px -20px}.quickLinks .quickLinksListItem img.mlc{object-position:-473px -20px}.quickLinks .quickLinksListItem img.plc{object-position:-549px -21px}.quickLinks .quickLinksListItem img.finPlan{object-position:-629px -20px}.quickLinks .quickLinksListItem img.marketIns{object-position:-477px -20px}.quickLinks .quickLinksListItem img.invIns{object-position:-701px -20px}.quickLinks .quickLinksListItem img.citiWelAdv{object-position:-779px -20px}.quickLinks .quickLinksListItem img.prequalified,.quickLinks .quickLinksListItem img.checkYourApp{object-position:-323px -82px}.quickLinks .quickLinksListItem img.citishop{object-position:-248px -85px}.quickLinks .quickLinksListItem img.dcc{object-position:-170px -85px}.quickLinks .quickLinksListItem img.mailOffer{object-position:-856px -20px}.subMenuGroupTitle{margin:0;position:relative}.subMenuGroupTitle .subHeadersOnDesktop{padding-bottom:10px;text-transform:uppercase;font-size:12px;color:var(--header-color, #666666);letter-spacing:0;margin:5px 0;cursor:text;font-family:Interstate_Regular,sans-serif}.child-links{display:inline-block;text-decoration:none;color:var(--text-color, #333);padding-bottom:16px;line-height:1.5;font-family:Interstate_Light,sans-serif}.child-links:focus,.child-links:hover{color:var(--text-hover-color, #333)}.child-links:hover{text-decoration:underline}.child-links:focus{outline:none}.child-links:focus-visible{border:2px solid black;border-radius:3px}@media screen and (max-width: 1120px){.child-links{font-weight:600;color:var(--text-color, #002d72);padding:12px 20px}.child-links:focus,.child-links:hover{color:var(--text-hover-color, #002d72)}}.subMenuGroupLI{margin:0;list-style-type:none}.subMenuGroupLI .newTagCitiStrata{background-color:#6a3077;margin-left:8px}.exploreSubNav{position:absolute;top:0;background:#fff;left:0;height:100%}.exploreSubNav .exploreUl{list-style:none;padding-left:36px}.exploreSubNav .exploreSubmenuTitle{position:relative;border-bottom:1px solid #eee;margin-bottom:12px;margin-left:56px;line-height:4em}.exploreSubNav .exploreSubmenuTitle a{color:var(--header-color, #000);font-family:Interstate_Regular,sans-serif}.exploreSubNav .exploreSubmenuTitle a:before{content:\"\";background-image:url(/citi-branding-assets/images/chevronLeft.svg);background-repeat:no-repeat;position:absolute;top:25px;left:-25px;width:20px;height:20px}.closeSideNav{display:block!important;width:100%;height:100%;z-index:9;position:absolute;transform:translate(100%);transition:.5s ease-in}.openSideNav{display:block!important;width:100%;height:100%;z-index:9;position:absolute;transform:translate(0);transition:.5s ease-in}\n"] }]
        }], ctorParameters: () => [{ type: BrandingEntitlementService }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BrandingMapService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }, { type: i3$2.Title }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: BrandingTaggingService }, { type: i3$2.DomSanitizer }], propDecorators: { childNavGroup: [{
                type: Input
            }], isMobile: [{
                type: Input
            }], newTagCitiStrata: [{
                type: Input
            }], newTagCitiStrataCardsBenefits: [{
                type: Input
            }], newTagCitiAaAdVantageGlobeMasterCard: [{
                type: Input
            }], isExploreProducts: [{
                type: Input
            }], childLinkClicked: [{
                type: Output
            }], routerLinkClicked: [{
                type: Output
            }], subChildGroup: [{
                type: ViewChildren,
                args: ['subChildGroup']
            }], exploreProductsCategory: [{
                type: ViewChild,
                args: ['exploreProductsCategory']
            }], getUserTypeFromNav: [{
                type: Input
            }], userLoggedIn: [{
                type: Input
            }], navData: [{
                type: Input
            }] } });

class SmartSearchComponent {
    constructor(_document, _window) {
        this._document = _document;
        this._window = _window;
        this.closeSearchDroor = new EventEmitter();
    }
    ngOnInit() {
    }
    closeDroor() {
        this.closeSearchDroor.emit();
    }
    ngAfterViewInit() {
        // this.citiSearch.isFullSearch = false;
        // this.citiSearch.isSearchDroor = true;
        // let type = this.injectSearchFallback?'horizontal':'vertical';
        // this.citiSearch.searchMagnifierClick(type);
        // this.citiSearch.isSearchPanel = !this.injectSearchFallback;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartSearchComponent, deps: [{ token: DOCUMENT }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SmartSearchComponent, isStandalone: false, selector: "citi-smart-search", inputs: { isVisitor: "isVisitor", settings: "settings", injectSearchFallback: "injectSearchFallback" }, outputs: { closeSearchDroor: "closeSearchDroor" }, ngImport: i0, template: "<div  [ngClass]=\"{'citi-search-drawer': injectSearchFallback, 'citi-search-panel': !injectSearchFallback}\">\n    <!-- <live-search (closeSearchDroor)=\"closeDroor()\" [isSearchDroor]=\"true\"></live-search> -->\n    <!-- This is what will be replaced with the Angular Element -->\n    <!-- This is the only location I need to replace it. -->\n</div>\n", styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.live-search .accordionSubMenu{background-color:#eff3f8!important}.citi-search-panel{padding:20px;background-color:#eff3f8!important;min-height:100%}@media screen and (max-width: 768px){.citi-search-panel{margin-left:-1px!important}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-smart-search', standalone: false, template: "<div  [ngClass]=\"{'citi-search-drawer': injectSearchFallback, 'citi-search-panel': !injectSearchFallback}\">\n    <!-- <live-search (closeSearchDroor)=\"closeDroor()\" [isSearchDroor]=\"true\"></live-search> -->\n    <!-- This is what will be replaced with the Angular Element -->\n    <!-- This is the only location I need to replace it. -->\n</div>\n", styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.live-search .accordionSubMenu{background-color:#eff3f8!important}.citi-search-panel{padding:20px;background-color:#eff3f8!important;min-height:100%}@media screen and (max-width: 768px){.citi-search-panel{margin-left:-1px!important}}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }], propDecorators: { isVisitor: [{
                type: Input
            }], closeSearchDroor: [{
                type: Output
            }], settings: [{
                type: Input
            }], injectSearchFallback: [{
                type: Input
            }] } });

/**
 * @Component: Header Banner Bar
 * @Section: Navigation
 * @Description: This component generates the banner (logo and search) section of the header.
 */
class NavSearchComponent {
    constructor(_taggingService, BannerElement, scriptLoadingService, postSessionService, ngZone, datePipe, layoutService, appConfigService, 
    // private _searchPanelService: SearchPanelService,
    // private _taggingService: CitiSearchTaggingService,
    _navigator, _window) {
        this._taggingService = _taggingService;
        this.BannerElement = BannerElement;
        this.scriptLoadingService = scriptLoadingService;
        this.postSessionService = postSessionService;
        this.ngZone = ngZone;
        this.datePipe = datePipe;
        this.layoutService = layoutService;
        this.appConfigService = appConfigService;
        this._navigator = _navigator;
        this._window = _window;
        this.loggedInstatus = false;
        this.currentDate = new Date();
        this.eDate = '2019-12-31';
        this.mobileView = false;
        this.isMobileSized = false;
        this.openSearchDroor = new EventEmitter();
        // Whether or not the search clear button should show
        this.showSearchResetButton = false;
        this.injectSearchFallback = false;
        this.enableLegacySearch = false;
        this.showContactModal = false;
        // Handles focusing the search field when it is cleared on mobile
        this.focusSearch = function () {
            // Focus the CSE input
            this.cseInput.focus();
        };
        // Resets the search input
        this.resetSearch = function (event) {
            // Reset the CSE input value
            this.cseInput.value = '';
            // Hide the search reset button
            this.showSearchResetButton = false;
            // Focus the CSE input
            this.focusSearch();
            event.stopPropagation();
        };
        // Handles opening and closing the search
        this.toggleSearch = function (event) {
            this.modelOpenClose = false;
            // this.passModelBoolean.emit(this.modelOpenClose);
            this.injectSmartSearch = !this.injectSmartSearch;
            if (event)
                event.stopPropagation();
        };
        // Submits the GCSE search
        this.submitSearch = function (event) {
            // Get the value of the search input
            var value = this.cseInput.value;
            // If there is a value
            if (value && value.length) {
                // Execute the search with the value
                this.cse.execute(value);
            }
            event.stopPropagation();
        };
        // loadGcseSearch: Function = () => {
        //   this.injectGcseSearch = true;
        //   this.injectSmartSearch = false;
        //   // Callback object for GCSE load
        //   if (!this._window) return;
        //   (<any>this._window).__gcse = {
        //     // Callback function for GCSE load
        //     callback: () => {
        //       // Render the search
        //       var renderSearchInterval = setInterval(() => {
        //         this.ngZone.run(() => {
        //           // Wait for all elements needed to be ready
        //           if (
        //             typeof this.config !== 'undefined' &&
        //             this.config.bannerSearchAction &&
        //             google &&
        //             this.cseElement
        //           ) {
        //             // Clear the interval
        //             clearInterval(renderSearchInterval);
        //             // Render the search element
        //             google.search.cse.element.render({
        //               div: 'cse-input',
        //               tag: 'searchbox-only',
        //               gname: 'hkgcbSearch',
        //               attributes: {
        //                 resultsUrl: this.config.bannerSearchAction
        //               }
        //             });
        //             // Create a reference to the cse object
        //             this.cse = google.search.cse.element.getElement('hkgcbSearch');
        //             // Create a reference to the input in the cse search
        //             this.cseInput = this.cseElement.nativeElement.querySelectorAll(
        //               "input[type='text']"
        //             )[0];
        //             // Set the placeholder
        //             this.cseInput.placeholder = this.config.bannerSearchPlaceholder;
        //             // Set the tabindex to -1 by default to prevent tab focus of the input while it is in its default hiddent state
        //             this.cseInput.tabIndex = '-1';
        //             // Add an input event bind to the input
        //             this.cseInput.oninput = event => {
        //               // Check the value
        //               let value = this.cseInput.value;
        //               // If we got a valid value
        //               if (typeof value === 'string' && value.length) {
        //                 // Set the search reset button to show
        //                 this.showSearchResetButton = true;
        //               } else {
        //                 // Otherwise set it to be hidden
        //                 this.showSearchResetButton = false;
        //               }
        //             };
        //           }
        //         });
        //       }, 0);
        //     }
        //   };
        //   // Create the script tag for GCSE
        //   let cx = '009695499870347544712:e3dyicpbrwu';
        //   let gcseUrl = 'https://cse.google.com/cse.js?cx=' + cx;
        //   this.scriptLoadingService.loadScript(gcseUrl);
        // };
        this.loadSmartAssistSearch = () => {
            // Get the values we need from session storage
            let isLoggedIn = this.config.isLoggedIn;
            let userRole = this.config.userRole;
            let language = this.config.language;
            let pageId = this.config.pageId;
            if (!pageId) {
                pageId = 'otherPage';
            }
            // If we have all of the information we need to inject smart search
            if (typeof isLoggedIn !== 'undefined' &&
                typeof userRole === 'string' &&
                userRole.length &&
                typeof language === 'string' &&
                language.length &&
                typeof pageId === 'string' &&
                pageId.length) {
                // Set the smart search settings object
                this.smartSearchSettings = {
                    isLoggedIn: isLoggedIn,
                    userRole: userRole,
                    language: language,
                    pageId: pageId
                };
                // Inject smart search
                // This works because the smart search tag in the template has an *ngIf based on this value
                // All logic for loading smart search is done in the smart search component
                // All this component does is pass it the above smartSearchSettings object
                //this.injectSmartSearch = true;
                // this.injectGcseSearch = false;
            }
            else {
                // Otherwise fall back on GCSE
                // this.loadGcseSearch();
            }
        };
        // On Init
        this.init = () => {
            this._isMobile =
                this._navigator &&
                    this._navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
            this.mobileView = this.isMobile();
            if (this.cDate <= this.eDate) {
                if (this._window && this._window['citiNGA']) {
                    this.loggedInstatus = true;
                }
                else {
                    this.loggedInstatus = false;
                }
            }
            // If we should load smart assist search
            if (this.config.loadSmartAssist) {
                // Load smart assist search
                this.loadSmartAssistSearch();
            }
            else {
                //TODO:remove below code - not used
                // Otherwise load GCSE search
                //this.loadGcseSearch();
            }
        };
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setSearchConfig = function (_config) {
            var searchConfig = {};
            var contactUsConfig = {};
            // If the banner should be shown...
            if (_config.header.navigation &&
                _config.header.navigation.show) {
                // Get the page ID for the search
                if (_config.header.navigation.search && _config.header.navigation.search.pageId) {
                    searchConfig.pageId = _config.header.navigation.search.pageId;
                }
                else {
                    searchConfig.pageId = 'otherPage';
                }
                // If the search menu should be displayed and we have all necessary values...
                if (_config.header.navigation.search &&
                    _config.header.navigation.search.show &&
                    _config.header.navigation.search.action &&
                    typeof _config.header.navigation.search.action === 'string' &&
                    _config.header.navigation.search.action.length > 0 &&
                    typeof _config.header.navigation.search.placeholder === 'string' &&
                    _config.header.navigation.search.placeholder.length > 0 &&
                    _config.header.navigation.search.ariaDescribedBy &&
                    _config.header.navigation.search.ariaLabel &&
                    _config.header.navigation.search.submitButtonText) {
                    // ...set it to display...
                    // gcse/google IOS error breaks the search input so we need to hide it for now if on IOS
                    // the search object never gets created and the gcse callback never executes on IOS (8/29/17)
                    //                if(/iPad|iPhone|iPod/.test(navigator.userAgent) && !(<any>window).MSStream) {
                    //                    searchConfig.showBannerSearch = false;
                    //                } else {
                    //                    searchConfig.showBannerSearch = true;
                    //                }
                    searchConfig.searchHidden = true;
                    // ...and provide all necessary values
                    searchConfig.bannerSearchAction = _config.header.navigation.search.action;
                    searchConfig.bannerSearchPlaceholder =
                        _config.header.navigation.search.placeholder;
                    searchConfig.submitButtonText =
                        _config.header.navigation.search.submitButtonText;
                    searchConfig.ariaDescription =
                        _config.header.navigation.search.ariaDescribedBy;
                    searchConfig.ariaLabel = _config.header.navigation.search.ariaLabel;
                    searchConfig.searchTitle = _config.header.navigation.search.title;
                    // ... bump the search over a little if the sign is showing
                    if (_config.header.navigation &&
                        _config.header.navigation.sign &&
                        _config.header.navigation.sign.show &&
                        _config.header.navigation.sign.wording &&
                        _config.header.navigation.sign.url) {
                        searchConfig.bumpSearch = true;
                    }
                    // If we have all of the values for smart assist search
                    if (typeof _config.header.navigation.search.isSmartSearchEnabled !==
                        'undefined' &&
                        typeof _config.header.navigation.search.isLoggedIn !== 'undefined' &&
                        typeof _config.header.navigation.search.userRole !== 'undefined' &&
                        typeof _config.header.navigation.search.language !== 'undefined') {
                        // Provide the smart assist values
                        searchConfig.isSmartSearchEnabled =
                            _config.header.navigation.search.isSmartSearchEnabled;
                        searchConfig.isLoggedIn = _config.header.navigation.search.isLoggedIn;
                        searchConfig.userRole = _config.header.navigation.search.userRole;
                        searchConfig.language = _config.header.navigation.search.language;
                        // Set the banner to show smart assist
                        searchConfig.loadSmartAssist = searchConfig.isSmartSearchEnabled;
                    }
                }
                if (_config.header && _config.header.navigation && _config.header.navigation.search && _config.header.navigation.search.enableLegacySearch != 'undefined') {
                    //TODO:remove first if condition once the search panel issue is fixed for citi hero component
                    this.injectSearchFallback = this.enableLegacySearch = _config.header.navigation.search.enableLegacySearch ? true : false;
                    //this.updateInjectSearchFallback();
                }
            }
            // Set the config for use by the dom (DOM will not show until this is set);
            this.config = searchConfig;
            //Set the contactUsConfig to contactConfig param to use by the DOM
            this.contactConfig = contactUsConfig;
            // Kick off the banner init
            this.init();
        };
        this.redirectTo = function () {
            if (this._window)
                this._window.location.href = this.config.bannerUrl;
        };
        this.cDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    }
    ngOnInit() {
        // this._taggingService.setPageID();
        this.toggleHeroCss();
        //check if the routing change is from search panel or not
        //if it's from search panel then load search panel
        // if(!this.injectSearchFallback && this._searchPanelService.getLoadSearchPanelFlag() == true){
        //   this.initIntelligentSearch(true);
        //   this.passModelBoolean.emit(this.modelOpenClose);
        // }
        // Initialize search panel elements when panel is toggled from navigation or footer
        this.layoutService.toggleSearchPanel.subscribe(searchVisible => {
            this.isMobileSized = window.innerWidth <= 992;
            if (this.isLoggedIn() === true && !this.isMobileSized) {
                this.sessionBasedSearchPanelToggle(searchVisible);
            }
            else {
                this.initIntelligentSearch(searchVisible);
            }
        });
    }
    // sessionBasedSearchPanelToggle() keeps panel open/sticky based on existence of sessionStorage searchPanelOpen
    sessionBasedSearchPanelToggle(value) {
        // console.log("this is the stickySearchToggle value", value)
        //changes value to true, opening panel once 'How can we help' button is pressed
        if (value !== true && !sessionStorage.getItem('searchPanelOpen')) {
            this.initIntelligentSearch(value);
        }
        // opens panel and sets sessionStorage searchPanelOpen: Y
        else if (value === true && !sessionStorage.getItem('searchPanelOpen')) {
            sessionStorage.setItem('searchPanelOpen', 'Y');
            this.initIntelligentSearch(value);
        }
        // this closes the panel and removes sessionstorage
        else if (value !== true && sessionStorage.getItem('searchPanelOpen') === 'Y') {
            //  value = true
            // console.log("this is the first else")
            this.toggleSearch();
            sessionStorage.removeItem('searchPanelOpen');
            this.initIntelligentSearch(value);
        }
        // when navigating website, if searchPanelOpen = Y and value = false, sets value = true in ngOnInit in navigation3.component.ts,
        //
        else if (value === true && sessionStorage.getItem('searchPanelOpen') === 'Y') {
            // value = false
            // console.log("this is the second else")
            // this.toggleSearch()
            // sessionStorage.setItem('searchPanelOpen', 'Y')
            this.initIntelligentSearch(value);
        }
    }
    // initIntelligentSearch() handles opening and closing of panel
    initIntelligentSearch(value) {
        console.log("this is the initIntelligentSearch value", value);
        this.toggleHeroCss();
        this.modelOpenClose = value; // initiates as false
        if (!this.injectSearchFallback) {
            // this.layoutService.toggleSearchPanel.next(value);
            // this.layoutService.toggleSearchPanel.subscribe(searchVisible => {
            //   if (searchVisible != this.modelOpenClose) {
            //     this.toggleSearch();
            //   }
            // });
            // if true loads/opens search panel
            if (this.modelOpenClose)
                // this._searchPanelService.initializeSearchPanelSettings();
                this.loadSearchElement();
            this.openSearchDroor.emit();
        }
        else {
            // this._searchPanelService.removePanelSettings();
        }
    }
    loadSearchElement() {
        if (!document.getElementById('citiIntelligentSearchAngularEl')) {
            // const searchEl: HTMLElement = document.querySelector(".search-panel")
            let angularElScript = document.createElement('script');
            angularElScript.id = 'citiIntelligentSearchAngularEl';
            angularElScript.type = 'text/javascript';
            // GBC-9047 For loading intelligent search js on marketing pages
            if (this.appConfigService.getBusinessId() == 'USMKT') {
                this._window.webpackJsonp = []; //fix for card marketing page to get SSR domain
                angularElScript.src = `${this.appConfigService.getnewCitiHostName()}/angular-elements/citi-intelligent-search.js`;
            }
            else if (this._window.location.host && this._window.location.host.indexOf("online.") == -1) {
                this._window.webpackJsonp = []; //Fix for SSR page
                angularElScript.src = this._window.location.origin + '/angular-elements/citi-intelligent-search.js';
            }
            else {
                // comment for local
                angularElScript.src = '/angular-elements/citi-intelligent-search.js';
            }
            // uncomment for local
            // angularElScript.src = './assets/citi-intelligent-search.js';
            document.getElementsByTagName('head')[0].appendChild(angularElScript);
        }
        setTimeout(() => {
            let cbolSource = '<citi-intelligent-search></citi-intelligent-search>';
            const searchEl = document.querySelector('.citi-search-panel');
            searchEl.innerHTML = cbolSource;
            const searchAngularEl = document.querySelector('citi-intelligent-search');
            searchAngularEl.addEventListener('closeSearchDroor', () => { this.layoutService.toggleSearchPanel.next(false); });
        }, 0);
    }
    showContactUsModal() {
        this.showContactModal = !this.showContactModal;
    }
    showChangeContactModal(isContactUsDisplayed) {
        this.showContactModal = isContactUsDisplayed;
    }
    sendModelData() {
        this.modelOpenClose = false;
        // this.passModelBoolean.emit(this.modelOpenClose);
    }
    /*
    *Fix - hero componet adjust width on screen size change event preventing search panel
    *This will override hero componet inline css
    *CSS code is in parent layout scss file
    */
    toggleHeroCss() {
        if (this._window && this._window.document) {
            let citiHero = this._window.document.querySelectorAll("citi-hero");
            if ((citiHero && citiHero.length > 0)) {
                if (this.modelOpenClose) {
                    this._window.document.body.style.overflowY = "";
                }
                else {
                    this._window.document.body.style.overflowY = "auto";
                }
            }
            else {
                //update value from original flag
                this.injectSearchFallback = this.enableLegacySearch;
            }
        }
    }
    isLoggedIn() {
        if (this._window && this._window.sessionStorage) {
            const sessionPostBrandingStorage = this._window.sessionStorage.getItem('sessionPostBrandingStorage');
            return sessionPostBrandingStorage ? true : false;
        }
        return false;
    }
    isMobile() {
        if (this._isMobile == null)
            return false;
        else
            return true;
    }
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.brandingObject = _config;
            this.setSearchConfig(_config);
        }
    }
    tagSearchPanelClose() {
        this._taggingService.triggerEventTagging('nonicms_content', "324ad1SearchPanelHowCanWeHelpHide");
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NavSearchComponent, deps: [{ token: i1$1.TaggingService }, { token: i0.ElementRef }, { token: i1$1.ScriptLoadService }, { token: i1$1.PostSessionService }, { token: i0.NgZone }, { token: i2.DatePipe }, { token: LayoutsService }, { token: i1$1.AppConfigService }, { token: NAVIGATOR }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: NavSearchComponent, isStandalone: false, selector: "citi-nav-search", inputs: { brandingConfig: "brandingConfig" }, outputs: { openSearchDroor: "openSearchDroor" }, viewQueries: [{ propertyName: "cseElement", first: true, predicate: ["cse"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"injectSearchFallback\"\n  role=\"banner\"\n  class=\"banner\"\n>\n  <div class=\"content-wrap\">\n    <div\n      class=\"search\"\n      role=\"search\"\n    >\n      <div\n        *ngIf=\"modelOpenClose\"\n        id=\"search-wrapper\"\n      >\n        <div\n          (click)=\"sendModelData()\"\n          class=\"blur-background\"\n          style=\"display: block; opacity: 0.6; z-index: 0; position: fixed; bottom: 0; top: 0px; right: 0; left: 0; background-color: #000;\"\n        ></div>\n        <citi-smart-search\n          (closeSearchDroor)=\"[toggleSearch($event), tagSearchPanelClose()]\"\n          [injectSearchFallback]=\"injectSearchFallback\"\n          [settings]=\"smartSearchSettings\"\n        ></citi-smart-search>\n      </div>\n    </div>\n  </div>\n</div>\n<!-- <banner-search-override *ngIf=\"injectSearchFallback\"></banner-search-override> -->\n", styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.banner .content-wrap{max-width:1440px;height:100%;margin:0 auto;position:relative}.banner .content-wrap .logo{display:-ms-inline-flexbox;display:-webkit-inline-flex;display:inline-flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:100%;line-height:100%}.banner .content-wrap .logo a{display:inline-block;height:40px;position:relative;top:-2px}@media (max-width: 768px){.banner .content-wrap .logo a{height:30px}}.banner .content-wrap .logo a img{height:100%;vertical-align:middle}.banner .content-wrap .buttons{display:-ms-flexbox;display:-webkit-flex;display:flex;float:right;height:100%}.banner .content-wrap .buttons .contactUs{height:100%;margin-right:40px}.banner .content-wrap .buttons .contactUs .contact-us-section:nth-of-type(4){border-top:2px solid #999999;padding:10px 0 0;margin-top:20px;margin-bottom:40px}.banner .content-wrap .buttons .contactUs .contact-us-content h3{font-size:1.625rem;line-height:2rem;font-family:Interstate_Light,sans-serif;font-weight:400;color:#333;text-transform:none;letter-spacing:normal;margin-bottom:12px}.banner .content-wrap .buttons .contactUs strong{font-weight:700}.banner .content-wrap .buttons .contactUs p{margin:12px 0 15px}.banner .content-wrap .buttons .contactUs .separator-line{border-top:2px solid #999999;margin-bottom:20px}.banner .content-wrap .buttons .contactUs .underline{text-decoration:underline}@media (min-width: 1200px){.banner .content-wrap .buttons .contactUs>citi-modal ::ng-deep .citi-modal-box{width:30%}}@media (min-width: 1440px){.banner .content-wrap .buttons .contactUs>citi-modal ::ng-deep .citi-modal-box{width:30%}}.banner .content-wrap .buttons .contactUs>citi-cta.en_spaceBtwPhone ::ng-deep button{margin-right:80px}.banner .content-wrap .buttons .contactUs>citi-cta.es_spaceBtwPhone ::ng-deep button{margin-right:-20px}.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button{display:inline-block;line-height:1;border:none;background:transparent url(/citi-branding-assets/images/Citi-Mortgage_Phone.png) no-repeat center center;background-size:18px 18px;height:100%;width:65px}@media (max-width: 768px){.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button{background-size:16px 16px}}.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button:hover,.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button.open{background-color:#00000040}.banner .content-wrap .buttons .search{height:100%}.banner .content-wrap .buttons .search form{height:100%;width:70px}.banner .content-wrap .buttons .search form .searchText ::ng-deep{margin-right:43px;position:absolute;top:24px;right:10px;font-family:Interstate_Bold,sans-serif;color:#fff;font-size:16px;pointer-events:none;font-weight:700}@media (max-width: 768px){.banner .content-wrap .buttons .search form .searchText ::ng-deep{display:none;margin-right:10px;position:absolute;top:20px;right:39px;font-family:Interstate_Bold,sans-serif;color:#fff;font-size:12px;pointer-events:none;font-weight:700}}.banner .content-wrap .buttons .search form>*{float:right}.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button{background:transparent url(/citi-branding-assets/images/search.svg) no-repeat center right;background-color:transparent!important;background-position:left;font-family:Interstate-Regular,sans-serif;text-decoration:none;color:#fff}.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button:hover,.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button:focus,.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button.open{background:transparent url(/citi-branding-assets/images/search.svg) no-repeat center right;background-color:transparent!important;background-position:left;font-family:Interstate-Regular,sans-serif;text-decoration:none;color:#fff}.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button.activeSearch{background:transparent url(/citi-branding-assets/images/search.svg) no-repeat center right;background-color:transparent!important;background-position:left;font-family:Interstate-Regular,sans-serif;text-decoration:none;color:#fff}.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button{background:transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAtdJREFUWAm1lr9rVEEQx/NMikMRBE2hRBQCQRQttNEiFipnQPBS6T+Qxk5RwcZCK61s0watDGhME7AUvNIq+KOIYMAEISomaAQTz8/3uD3nZvfucu8uA192Z3bmu/N29+1s1rcFqVQqw7iNgwvgINgPdoJlsATegBnwKsuyDdreCBOfBWWwVVnB8TYodJUBBHvBDMgrnwgs5kqCwGNgoc3Mq4x/AZst/DYYu95REgRo8h8J0p/YJsEY2B1I6Q+Ao+AOeAdSci/4t2yJ1LKnvnwK+4GWwQzi0w8mwHfg5Uq7eBH4Pf+D7VrbQOdAzAj4AKxoBQ851/8qgzrtXjqePDBCNASWHeHjMB61OPpfbSpy6tAA56hL4C/68YgG47Bz1HK13fOIKGGAZ9pxP4jccLjpnCYjp5wGeE857vcRFQ5zzmkscurCAPei4x+ydDtQdLdbeW2VHvTLjqNhPiWgwhJkjWKyFpQetZ8dj52vTwmoqgVZD50etp5zl+VWAiqpQfaxXwNB6VHb8MVwrlheJaB6HkT6SFB61B5xPHa+6hboMWHlslW66bOag8SfNhyr9OeNXi0i591v8ha9v8EppwKPHidWZiMqRlVS9ZKxMhE5dmiAbA/4Zknpl5I0DPhMVVJznwViM/AcWFGp1xmLhYEC8DeWSmrDrRVHxhZiNPkj4KX12cL7ItAzyopK6mg8TdqCr5b9mSWo9efSEc6K841EsExPwUnnXlcZGwS3wFeQknWMxXqA6WSmX+3ieJ/OXW+v6Yu0ZaDrVTecLhn952dAen8ZqMlv2hJX/ctgaNqSxFXwC3QjqrL6citNVyJKhqjD4AnQS6YT+Yhz9cDRFkH+JJQVBCfAQ+Afmpjqoqf8LBgHDVuB3jKJ6AxES2EMkKmWC9p7VTUVFp2HefZ2kzYpSoKBF6BgHHQmLhl9e7tNVmJhe2d17IkklpzL9qskcQ7oWtYlV/oHSXrsoaCkJdEAAAAASUVORK5CYII=) no-repeat center right;background-size:20px 20px;background-position-x:69px;height:100%;width:95px}.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button:hover,.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button:focus,.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button.open{background-color:#00000040}@media (max-width: 768px){.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button{width:26px;margin-right:-19px;right:35px;background-size:16px 16px;height:100%;background-position-x:6px;position:relative}}.banner .content-wrap .buttons .search form>citi-cta ::ng-deep{height:100%}.banner .content-wrap .buttons .search form>citi-cta ::ng-deep button{display:inline-block;line-height:1;margin-right:11px;border:none;height:100%;width:200px;right:-16px;position:relative}@media (max-width: 768px){.banner .content-wrap .buttons .search form>citi-cta ::ng-deep button{background-size:16px 16px;height:100%;background-position-x:6px;position:relative;margin-right:0;right:-6px}}.banner .content-wrap .buttons .search form .input{display:inline-flex;line-height:1;white-space:nowrap;position:relative;z-index:5;height:50px}.banner .content-wrap .buttons .search form .input ::-webkit-input-placeholder,.banner .content-wrap .buttons .search form .input ::-moz-placeholder,.banner .content-wrap .buttons .search form .input :-ms-input-placeholder,.banner .content-wrap .buttons .search form .input :-moz-placeholder{color:#666;opacity:1}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep{width:250px}@media (max-width: 768px){.banner .content-wrap .buttons .search form .input .search-input ::ng-deep{width:100%;display:none}}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep tr{border:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box{border:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box.gsc-input-box-hover,.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box.gsc-input-box-focus{box-shadow:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input{border:none;outline:none;color:#666;background:#eee!important;text-indent:0!important;text-rendering:optimizeLegibility!important;-webkit-font-smoothing:antialiased!important;padding:0 20px!important}@media (min-width: 769px){.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus{border:2px solid #056dae!important}}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input::-ms-clear{display:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus:placholder-shown{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus::-webkit-input-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus::-moz-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus:-ms-input-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus:-moz-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-search-button,.banner .content-wrap .buttons .search form .input .search-input ::ng-deep .gsib_b{display:none}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button{border:none;border-radius:0;background-color:#056dae;color:#fff;font-family:Interstate_Bold,san-serif;height:50px;width:50px;min-width:auto;margin:0;padding:0;float:none}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button:hover,.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button:focus{background-color:#002a54}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{width:40px;padding:0;background:transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABGdBTUEAALGPC/xhBQAAAU9JREFUOBGtlTFygzAQABH8Apr8AfhBJr2rZMYPifOD5CEu8o+kYuiSIqlcwRtSGHyLdR6IJaHCNyOETneruxMSSWKlLMvnuq4fdRzb44Ov2me8iGIn3au0TVEUP13XfaNfk6qqnsRmL+0hz/O/vu8/jKUDm8QYc5S2bZrmXXWunsjGcdxLm4KyNrtU5ABEnTDAMJS+CwYDVkZ6Eu6vKDYCTS2Y3pm+D6ZZTeEK9IvaAQlB12AEY3iohByw+V8z0tTIlLEAovRBmZtvgAuGzXyHGCfU1JO+1jfxwfC/AgagTAVhzF9WZXALcUboquNsMe8nhc0V0AWzNRvFXjPyQhe7HIBtWT3ms7lEGIJxrgO7vzhRE3ANRnRIDNTEws7I8zPkkw7DcBdzAuZASsCRY7NUDwNWJpfiJ5ejTNyHToA6au9I/6Vt2zed59a+yS/gBOhbMKO903d/AAAAAElFTkSuQmCC) no-repeat center center;background-size:10px 10px;border:none;position:absolute;right:0;bottom:0;margin-right:0}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{right:10px}}@media (min-width: 769px){.banner .content-wrap .buttons .search form .input{-webkit-transition:width .35s ease-in-out;-moz-transition:width .35s ease-in-out;-ms-transition:width .35s ease-in-out;-o-transition:width .35s ease-in-out;transition:width .35s ease-in-out;position:relative;top:6px;right:75px;overflow:hidden;width:0;max-width:300px;visibility:hidden}.banner .content-wrap .buttons .search form .input .container{display:inline-flex;line-height:1;white-space:nowrap;padding-right:0;padding-left:0;position:absolute;z-index:5;width:auto!important;height:100%}.banner .content-wrap .buttons .search form .input.open{width:320px;max-width:320px;-webkit-transition:width .35s ease-in-out;-moz-transition:width .35s ease-in-out;-ms-transition:width .35s ease-in-out;-o-transition:width .35s ease-in-out;transition:width .35s ease-in-out;visibility:visible}.banner .content-wrap .buttons .search form .input.bump{margin-right:32px}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input{width:250px!important;height:50px!important;margin-top:0!important;padding-right:35px!important;-webkit-appearance:none!important;border-radius:0!important}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{margin-right:50px;right:0}}@media (max-width: 768px){.banner .content-wrap .buttons .search form .input{-webkit-transition:height .35s ease-in-out;-moz-transition:height .35s ease-in-out;-ms-transition:height .35s ease-in-out;-o-transition:height .35s ease-in-out;transition:height .35s ease-in-out;position:absolute;left:0;top:55px;width:100%;height:0;overflow:hidden;border-bottom:1px solid #eee}.banner .content-wrap .buttons .search form .input .container{width:auto!important;padding:0}.banner .content-wrap .buttons .search form .input.open{height:50px;-webkit-transition:height .35s ease-in-out;-moz-transition:height .35s ease-in-out;-ms-transition:height .35s ease-in-out;-o-transition:height .35s ease-in-out;transition:height .35s ease-in-out}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input{width:100%!important;height:50px!important;padding-right:40px!important;background-color:#fff!important;position:absolute!important;bottom:0!important}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button{display:none}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{height:50px;display:block}}.banner.blue{background:-webkit-linear-gradient(top,#00bdf2,#00b3f0 18%,#0066b3 77%,#004985);background:linear-gradient(180deg,#00bdf2,#00b3f0 18%,#0066b3 77%,#004985)}.banner.gold{background:-webkit-linear-gradient(top,#b4975a,#a0864a 49%,#78622a 99%);background:linear-gradient(180deg,#b4975a,#a0864a 49%,#78622a 99%)}.banner.orange{background:-webkit-linear-gradient(top,#fcb314,#ff7200 99%);background:linear-gradient(180deg,#fcb314,#ff7200 99%)}.banner.white{background-color:#fff}.banner.black{background-color:#333}.banner.brown{background-color:#281814}.banner.priority{background-color:#0e2a48}.banner.priority .content-wrap .logo a,.banner.white .content-wrap .logo a{position:initial}:host ::ng-deep .wrapper.position-left{width:380px!important;height:70px;margin-top:10px}:host ::ng-deep .trigger{background-image:none!important}#mobileLogo{width:115px;height:40px;margin-left:-12px}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SmartSearchComponent, selector: "citi-smart-search", inputs: ["isVisitor", "settings", "injectSearchFallback"], outputs: ["closeSearchDroor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NavSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nav-search', standalone: false, template: "<div *ngIf=\"injectSearchFallback\"\n  role=\"banner\"\n  class=\"banner\"\n>\n  <div class=\"content-wrap\">\n    <div\n      class=\"search\"\n      role=\"search\"\n    >\n      <div\n        *ngIf=\"modelOpenClose\"\n        id=\"search-wrapper\"\n      >\n        <div\n          (click)=\"sendModelData()\"\n          class=\"blur-background\"\n          style=\"display: block; opacity: 0.6; z-index: 0; position: fixed; bottom: 0; top: 0px; right: 0; left: 0; background-color: #000;\"\n        ></div>\n        <citi-smart-search\n          (closeSearchDroor)=\"[toggleSearch($event), tagSearchPanelClose()]\"\n          [injectSearchFallback]=\"injectSearchFallback\"\n          [settings]=\"smartSearchSettings\"\n        ></citi-smart-search>\n      </div>\n    </div>\n  </div>\n</div>\n<!-- <banner-search-override *ngIf=\"injectSearchFallback\"></banner-search-override> -->\n", styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.banner .content-wrap{max-width:1440px;height:100%;margin:0 auto;position:relative}.banner .content-wrap .logo{display:-ms-inline-flexbox;display:-webkit-inline-flex;display:inline-flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:100%;line-height:100%}.banner .content-wrap .logo a{display:inline-block;height:40px;position:relative;top:-2px}@media (max-width: 768px){.banner .content-wrap .logo a{height:30px}}.banner .content-wrap .logo a img{height:100%;vertical-align:middle}.banner .content-wrap .buttons{display:-ms-flexbox;display:-webkit-flex;display:flex;float:right;height:100%}.banner .content-wrap .buttons .contactUs{height:100%;margin-right:40px}.banner .content-wrap .buttons .contactUs .contact-us-section:nth-of-type(4){border-top:2px solid #999999;padding:10px 0 0;margin-top:20px;margin-bottom:40px}.banner .content-wrap .buttons .contactUs .contact-us-content h3{font-size:1.625rem;line-height:2rem;font-family:Interstate_Light,sans-serif;font-weight:400;color:#333;text-transform:none;letter-spacing:normal;margin-bottom:12px}.banner .content-wrap .buttons .contactUs strong{font-weight:700}.banner .content-wrap .buttons .contactUs p{margin:12px 0 15px}.banner .content-wrap .buttons .contactUs .separator-line{border-top:2px solid #999999;margin-bottom:20px}.banner .content-wrap .buttons .contactUs .underline{text-decoration:underline}@media (min-width: 1200px){.banner .content-wrap .buttons .contactUs>citi-modal ::ng-deep .citi-modal-box{width:30%}}@media (min-width: 1440px){.banner .content-wrap .buttons .contactUs>citi-modal ::ng-deep .citi-modal-box{width:30%}}.banner .content-wrap .buttons .contactUs>citi-cta.en_spaceBtwPhone ::ng-deep button{margin-right:80px}.banner .content-wrap .buttons .contactUs>citi-cta.es_spaceBtwPhone ::ng-deep button{margin-right:-20px}.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button{display:inline-block;line-height:1;border:none;background:transparent url(/citi-branding-assets/images/Citi-Mortgage_Phone.png) no-repeat center center;background-size:18px 18px;height:100%;width:65px}@media (max-width: 768px){.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button{background-size:16px 16px}}.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button:hover,.banner .content-wrap .buttons .contactUs>citi-cta ::ng-deep button.open{background-color:#00000040}.banner .content-wrap .buttons .search{height:100%}.banner .content-wrap .buttons .search form{height:100%;width:70px}.banner .content-wrap .buttons .search form .searchText ::ng-deep{margin-right:43px;position:absolute;top:24px;right:10px;font-family:Interstate_Bold,sans-serif;color:#fff;font-size:16px;pointer-events:none;font-weight:700}@media (max-width: 768px){.banner .content-wrap .buttons .search form .searchText ::ng-deep{display:none;margin-right:10px;position:absolute;top:20px;right:39px;font-family:Interstate_Bold,sans-serif;color:#fff;font-size:12px;pointer-events:none;font-weight:700}}.banner .content-wrap .buttons .search form>*{float:right}.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button{background:transparent url(/citi-branding-assets/images/search.svg) no-repeat center right;background-color:transparent!important;background-position:left;font-family:Interstate-Regular,sans-serif;text-decoration:none;color:#fff}.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button:hover,.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button:focus,.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button.open{background:transparent url(/citi-branding-assets/images/search.svg) no-repeat center right;background-color:transparent!important;background-position:left;font-family:Interstate-Regular,sans-serif;text-decoration:none;color:#fff}.banner .content-wrap .buttons .search form>citi-cta.showEnglishBg ::ng-deep button.activeSearch{background:transparent url(/citi-branding-assets/images/search.svg) no-repeat center right;background-color:transparent!important;background-position:left;font-family:Interstate-Regular,sans-serif;text-decoration:none;color:#fff}.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button{background:transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAtdJREFUWAm1lr9rVEEQx/NMikMRBE2hRBQCQRQttNEiFipnQPBS6T+Qxk5RwcZCK61s0watDGhME7AUvNIq+KOIYMAEISomaAQTz8/3uD3nZvfucu8uA192Z3bmu/N29+1s1rcFqVQqw7iNgwvgINgPdoJlsATegBnwKsuyDdreCBOfBWWwVVnB8TYodJUBBHvBDMgrnwgs5kqCwGNgoc3Mq4x/AZst/DYYu95REgRo8h8J0p/YJsEY2B1I6Q+Ao+AOeAdSci/4t2yJ1LKnvnwK+4GWwQzi0w8mwHfg5Uq7eBH4Pf+D7VrbQOdAzAj4AKxoBQ851/8qgzrtXjqePDBCNASWHeHjMB61OPpfbSpy6tAA56hL4C/68YgG47Bz1HK13fOIKGGAZ9pxP4jccLjpnCYjp5wGeE857vcRFQ5zzmkscurCAPei4x+ydDtQdLdbeW2VHvTLjqNhPiWgwhJkjWKyFpQetZ8dj52vTwmoqgVZD50etp5zl+VWAiqpQfaxXwNB6VHb8MVwrlheJaB6HkT6SFB61B5xPHa+6hboMWHlslW66bOag8SfNhyr9OeNXi0i591v8ha9v8EppwKPHidWZiMqRlVS9ZKxMhE5dmiAbA/4Zknpl5I0DPhMVVJznwViM/AcWFGp1xmLhYEC8DeWSmrDrRVHxhZiNPkj4KX12cL7ItAzyopK6mg8TdqCr5b9mSWo9efSEc6K841EsExPwUnnXlcZGwS3wFeQknWMxXqA6WSmX+3ieJ/OXW+v6Yu0ZaDrVTecLhn952dAen8ZqMlv2hJX/ctgaNqSxFXwC3QjqrL6citNVyJKhqjD4AnQS6YT+Yhz9cDRFkH+JJQVBCfAQ+Afmpjqoqf8LBgHDVuB3jKJ6AxES2EMkKmWC9p7VTUVFp2HefZ2kzYpSoKBF6BgHHQmLhl9e7tNVmJhe2d17IkklpzL9qskcQ7oWtYlV/oHSXrsoaCkJdEAAAAASUVORK5CYII=) no-repeat center right;background-size:20px 20px;background-position-x:69px;height:100%;width:95px}.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button:hover,.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button:focus,.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button.open{background-color:#00000040}@media (max-width: 768px){.banner .content-wrap .buttons .search form>citi-cta.showSpanishBg ::ng-deep button{width:26px;margin-right:-19px;right:35px;background-size:16px 16px;height:100%;background-position-x:6px;position:relative}}.banner .content-wrap .buttons .search form>citi-cta ::ng-deep{height:100%}.banner .content-wrap .buttons .search form>citi-cta ::ng-deep button{display:inline-block;line-height:1;margin-right:11px;border:none;height:100%;width:200px;right:-16px;position:relative}@media (max-width: 768px){.banner .content-wrap .buttons .search form>citi-cta ::ng-deep button{background-size:16px 16px;height:100%;background-position-x:6px;position:relative;margin-right:0;right:-6px}}.banner .content-wrap .buttons .search form .input{display:inline-flex;line-height:1;white-space:nowrap;position:relative;z-index:5;height:50px}.banner .content-wrap .buttons .search form .input ::-webkit-input-placeholder,.banner .content-wrap .buttons .search form .input ::-moz-placeholder,.banner .content-wrap .buttons .search form .input :-ms-input-placeholder,.banner .content-wrap .buttons .search form .input :-moz-placeholder{color:#666;opacity:1}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep{width:250px}@media (max-width: 768px){.banner .content-wrap .buttons .search form .input .search-input ::ng-deep{width:100%;display:none}}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep tr{border:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box{border:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box.gsc-input-box-hover,.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box.gsc-input-box-focus{box-shadow:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input{border:none;outline:none;color:#666;background:#eee!important;text-indent:0!important;text-rendering:optimizeLegibility!important;-webkit-font-smoothing:antialiased!important;padding:0 20px!important}@media (min-width: 769px){.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus{border:2px solid #056dae!important}}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input::-ms-clear{display:none}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus:placholder-shown{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus::-webkit-input-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus::-moz-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus:-ms-input-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input:focus:-moz-placeholder{color:#333!important}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-search-button,.banner .content-wrap .buttons .search form .input .search-input ::ng-deep .gsib_b{display:none}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button{border:none;border-radius:0;background-color:#056dae;color:#fff;font-family:Interstate_Bold,san-serif;height:50px;width:50px;min-width:auto;margin:0;padding:0;float:none}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button:hover,.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button:focus{background-color:#002a54}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{width:40px;padding:0;background:transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABGdBTUEAALGPC/xhBQAAAU9JREFUOBGtlTFygzAQABH8Apr8AfhBJr2rZMYPifOD5CEu8o+kYuiSIqlcwRtSGHyLdR6IJaHCNyOETneruxMSSWKlLMvnuq4fdRzb44Ov2me8iGIn3au0TVEUP13XfaNfk6qqnsRmL+0hz/O/vu8/jKUDm8QYc5S2bZrmXXWunsjGcdxLm4KyNrtU5ABEnTDAMJS+CwYDVkZ6Eu6vKDYCTS2Y3pm+D6ZZTeEK9IvaAQlB12AEY3iohByw+V8z0tTIlLEAovRBmZtvgAuGzXyHGCfU1JO+1jfxwfC/AgagTAVhzF9WZXALcUboquNsMe8nhc0V0AWzNRvFXjPyQhe7HIBtWT3ms7lEGIJxrgO7vzhRE3ANRnRIDNTEws7I8zPkkw7DcBdzAuZASsCRY7NUDwNWJpfiJ5ejTNyHToA6au9I/6Vt2zed59a+yS/gBOhbMKO903d/AAAAAElFTkSuQmCC) no-repeat center center;background-size:10px 10px;border:none;position:absolute;right:0;bottom:0;margin-right:0}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{right:10px}}@media (min-width: 769px){.banner .content-wrap .buttons .search form .input{-webkit-transition:width .35s ease-in-out;-moz-transition:width .35s ease-in-out;-ms-transition:width .35s ease-in-out;-o-transition:width .35s ease-in-out;transition:width .35s ease-in-out;position:relative;top:6px;right:75px;overflow:hidden;width:0;max-width:300px;visibility:hidden}.banner .content-wrap .buttons .search form .input .container{display:inline-flex;line-height:1;white-space:nowrap;padding-right:0;padding-left:0;position:absolute;z-index:5;width:auto!important;height:100%}.banner .content-wrap .buttons .search form .input.open{width:320px;max-width:320px;-webkit-transition:width .35s ease-in-out;-moz-transition:width .35s ease-in-out;-ms-transition:width .35s ease-in-out;-o-transition:width .35s ease-in-out;transition:width .35s ease-in-out;visibility:visible}.banner .content-wrap .buttons .search form .input.bump{margin-right:32px}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input{width:250px!important;height:50px!important;margin-top:0!important;padding-right:35px!important;-webkit-appearance:none!important;border-radius:0!important}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{margin-right:50px;right:0}}@media (max-width: 768px){.banner .content-wrap .buttons .search form .input{-webkit-transition:height .35s ease-in-out;-moz-transition:height .35s ease-in-out;-ms-transition:height .35s ease-in-out;-o-transition:height .35s ease-in-out;transition:height .35s ease-in-out;position:absolute;left:0;top:55px;width:100%;height:0;overflow:hidden;border-bottom:1px solid #eee}.banner .content-wrap .buttons .search form .input .container{width:auto!important;padding:0}.banner .content-wrap .buttons .search form .input.open{height:50px;-webkit-transition:height .35s ease-in-out;-moz-transition:height .35s ease-in-out;-ms-transition:height .35s ease-in-out;-o-transition:height .35s ease-in-out;transition:height .35s ease-in-out}.banner .content-wrap .buttons .search form .input .search-input ::ng-deep td.gsc-input .gsc-input-box input.gsc-input{width:100%!important;height:50px!important;padding-right:40px!important;background-color:#fff!important;position:absolute!important;bottom:0!important}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button{display:none}.banner .content-wrap .buttons .search form .input citi-cta ::ng-deep button[type=reset]{height:50px;display:block}}.banner.blue{background:-webkit-linear-gradient(top,#00bdf2,#00b3f0 18%,#0066b3 77%,#004985);background:linear-gradient(180deg,#00bdf2,#00b3f0 18%,#0066b3 77%,#004985)}.banner.gold{background:-webkit-linear-gradient(top,#b4975a,#a0864a 49%,#78622a 99%);background:linear-gradient(180deg,#b4975a,#a0864a 49%,#78622a 99%)}.banner.orange{background:-webkit-linear-gradient(top,#fcb314,#ff7200 99%);background:linear-gradient(180deg,#fcb314,#ff7200 99%)}.banner.white{background-color:#fff}.banner.black{background-color:#333}.banner.brown{background-color:#281814}.banner.priority{background-color:#0e2a48}.banner.priority .content-wrap .logo a,.banner.white .content-wrap .logo a{position:initial}:host ::ng-deep .wrapper.position-left{width:380px!important;height:70px;margin-top:10px}:host ::ng-deep .trigger{background-image:none!important}#mobileLogo{width:115px;height:40px;margin-left:-12px}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.TaggingService }, { type: i0.ElementRef }, { type: i1$1.ScriptLoadService }, { type: i1$1.PostSessionService }, { type: i0.NgZone }, { type: i2.DatePipe }, { type: LayoutsService }, { type: i1$1.AppConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }], propDecorators: { cseElement: [{
                type: ViewChild,
                args: ['cse']
            }], openSearchDroor: [{
                type: Output
            }], brandingConfig: [{
                type: Input
            }] } });

class Navigation3Component {
    get navData() {
        if (this.config) {
            return this.config.menuNavigationItems;
        }
    }
    get isMobile() {
        this._isMobile = this._document && this._document.body.offsetWidth < 1121; // 992
        return this._isMobile;
    }
    set brandingConfig(_config) {
        this.setLoginStatus();
        if (_config) {
            this.bannerConfig = _config;
            this.setNavigationConfig(_config);
        }
    }
    constructor(_layOutService, _document, _storageService, _window, _tmxService, _siteCatService, brandingService, mapperService, _brandingEntitlementService, authService, _router, renderer, http, _taggingService, brandingTag, appConfigService, _isSSRApp, _sessionStorage) {
        this._layOutService = _layOutService;
        this._document = _document;
        this._storageService = _storageService;
        this._window = _window;
        this._tmxService = _tmxService;
        this._siteCatService = _siteCatService;
        this.brandingService = brandingService;
        this.mapperService = mapperService;
        this._brandingEntitlementService = _brandingEntitlementService;
        this.authService = authService;
        this._router = _router;
        this.renderer = renderer;
        this.http = http;
        this._taggingService = _taggingService;
        this.brandingTag = brandingTag;
        this.appConfigService = appConfigService;
        this._isSSRApp = _isSSRApp;
        this._sessionStorage = _sessionStorage;
        this.newTagCitiStrata = false;
        this.newTagCitiStrataAaAdVantage = false;
        this.newTagCitiStrataCardsBenefits = false;
        this.newTagCitiAaAdVantageGlobeMasterCard = false;
        this.showSubMenu = false;
        this.showSignModal = false;
        this.signOnSSRRedirection = false;
        this.signOffUrl = '';
        this.signOffRouterLink = '';
        this.signOffQueryParams = {};
        this.homepageFallback = false;
        this.sideNavModel = false;
        this.isExploreProducts = false;
        this.showModal = [];
        this.modalData = {
            dropDownArray: [],
            addUserText: '',
            deleteUserText: '',
            deleteUserUrl: ''
        };
        this.mobileNavbarExpanded = false;
        this.isUserLoggedIn = true;
        this.isClose = false;
        this.activeMainLink = 99999;
        this.activeSubmenuId = 'none';
        this.linkClicked = false;
        this.focusCheck = false;
        this.homepageSignOn = false;
        this.showHowCanWeHelp = false;
        this.keysToCheck = ["newTagCitiStrata", "newTagCitiStrataCardsBenefits", "newTagCitiAaAdVantageGlobeMasterCard"];
        this.langBtnClicked = new EventEmitter();
        this.changeLocale = function (_locale, item) {
            const maxAge = 60 * 60 * 24 * 365;
            const path = '/';
            const domain = '.citi.com';
            this._document.cookie = `locale=${_locale};Domain=${domain};Max-Age=${maxAge}; Path=${path}`;
            if (_locale == 'en_US') {
                if (this._window)
                    this._window.location.href = this.currentPath;
            }
        };
        this.currentPath = this.getPath();
        this.csrUrl = this.appConfigService.getcsrHostName();
        this.citiUrl = this.appConfigService.getnewCitiHostName();
    }
    // localeSuffix = "";
    ngOnInit() {
        if (this._isSSRApp == null) {
            this._isSSRApp = false;
        }
        this.currentPath = this.getPath();
        this._isMobile = this._document && this._document.body.offsetWidth < 1121; // 992
        // let brandingTypeCheck = sessionStorage['isMarketingBrandingOrDefault'] || null;
        this.locale = this._storageService.get('locale');
        if (this.locale == null || this.locale == '') {
            this.locale = 'en_US';
        }
        this.signOff_title = this.locale == 'en_US' ? 'Sign Off' : 'Salir';
        this.howCanWeHelpPost =
            this.locale == 'en_US' ? 'How can we help?' : '¿Cómo podemos ayudar?';
        this.howCanWeHelpURL = (this._isSSRApp ? this.citiUrl : this.csrUrl) + "/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Banner_v1.svg";
        this.navATMLangMobUrl = (this._isSSRApp ? this.citiUrl : this.csrUrl);
        this.setLoginStatus();
        this.colorByUserType();
        this._layOutService.postBrandingStorage.subscribe(res => {
            if (!!res) {
                this.sessionParams = this.getSPBS();
                this.colorByUserType();
            }
        }, err => {
            this.colorByUserType();
        });
        if (this.sessionParams && this.sessionParams['isFallBackLegacySignoff']) {
            this.isFallBackSign = this.sessionParams['isFallBackLegacySignoff'];
        }
        this.brandingService.signOn.subscribe(val => {
            this.showSignOn = val;
        });
        this.brandingService.movesignOn.subscribe(val => {
            this.moveSignOn = val;
            // this.showSignOn = val;
        });
        this.brandingService.homepagesignOn.subscribe(val => {
            this.homepageSignOn = val;
        });
        this.brandingService.interstitialsType.subscribe(val => {
            this.type = val;
        });
        //This opens the side panel if the session storage has an open side panel.
        if (window.sessionStorage.getItem('searchPanelOpen')) {
            this._layOutService.toggleSearchPanel.next(true);
        }
        this._layOutService.toggleSearchPanel.subscribe(searchVisible => {
            if (!searchVisible) {
                if (this._document.getElementById("personetics-citi-menu-browser") != null) {
                    this._document.getElementById("personetics-citi-menu-browser").focus();
                }
            }
        });
        // modify branding based on journey team request
        this.brandingService.modifyBranding.subscribe(val => {
            if (val === 'reset') {
                this.colorByUserType(val);
            }
            else if (val && this.enableOverride()) {
                this.colorByUserType(val);
            }
        });
    }
    // Header component handles opening the language change modal and switching languages
    onLangBtnClick(item) {
        this.langBtnClicked.emit(item);
    }
    getSPBS() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                if (sessionParams) {
                    return sessionParams;
                }
            }
            catch (err) {
                return false;
            }
        }
    }
    enableOverride() {
        const suppressUrl = [
            '/US/ag/account-opening', '/US/ag/easyaddbank/easyadd'
        ];
        let currentPageUrl = this._window.location.href;
        return suppressUrl.some(url => currentPageUrl.includes(url));
    }
    colorByUserType(customModifier) {
        if (customModifier && customModifier !== 'reset') {
            this.modifier = customModifier;
        }
        else if (!this.modifier || customModifier === 'reset') {
            this.modifier = this.brandingService.getBrandingModifier();
        }
        let possibleCustomerTypes = ["gold", "cpc", "priority", "privatebanking", "cpb"];
        if (this.sessionParams != undefined && possibleCustomerTypes.includes(this.sessionParams['userBranding'].toLowerCase())) {
            this.customerType = this.sessionParams['userBranding'].toLowerCase();
        }
        else if (possibleCustomerTypes.includes(this.modifier)) {
            this.customerType = this.modifier;
        }
        else {
            this.customerType = 'blue';
        }
    }
    setNavigationConfig(_config) {
        // Set up config object to temporarily hold our calculated values
        let navigationConfig = {};
        // If there is a valid config and a header object is defined
        if (_config && _config.header) {
            // If the menu bar should be shown...
            if (_config.header.navigation && _config.header.navigation.show) {
                // ...set it to display
                navigationConfig.showNavigation = true;
                if (_config.header.navigation.help) {
                    this.showHowCanWeHelp = _config.header.navigation.help.featureflag ? this._brandingEntitlementService.getNewEntitlementLogic(_config.header.navigation.help) : _config.header.navigation.help.show;
                    this.howCanWeHelp = _config.header.navigation.help.title;
                }
                if (_config.header.banner.easydeals) {
                    this.easydealsObj = _config.header.banner.easydeals;
                    this.easydealsexp = _config.header.banner.easydeals.show;
                    this.easydealsexp = this._brandingEntitlementService.getNewEntitlementLogic(this.easydealsObj, true, false);
                }
                // If the navigationItems value is an array and has at least one item...
                if (Array.isArray(_config.header.navigation.navigationItems) &&
                    _config.header.navigation.navigationItems.length > 0) {
                    // ...tell the menu to display the menu...
                    navigationConfig.showMenuNavigation = true;
                    // ...and provide the menu items to be displayed
                    navigationConfig.menuNavigationItems =
                        _config.header.navigation.navigationItems;
                    // Store sign off in a separate variable
                    this.signOffObj = _config.header.navigation.navigationItems.find(navItem => navItem.id === 'signOff');
                }
                // If the sign should show and has all required elements
                if (_config.header.navigation.sign &&
                    _config.header.navigation.sign.show) {
                    if (this.sessionParams) {
                        if (this.sessionParams['isFallBackLegacySignoff'] === 'Y') {
                            this.signOffUrl = _config.header.navigation.sign.signOffUrl;
                        }
                        else {
                            this.signOffRouterLink =
                                _config.header.navigation.sign.ngaSignOffUrl;
                            if (_config.header.navigation.sign.queryParams) {
                                this.signOffQueryParams =
                                    _config.header.navigation.sign.queryParams;
                            }
                        }
                    }
                    else {
                        this.signOffRouterLink =
                            _config.header.navigation.sign.ngaSignOffUrl;
                        if (_config.header.navigation.sign.queryParams) {
                            this.signOffQueryParams =
                                _config.header.navigation.sign.queryParams;
                        }
                    }
                    this.signOffWording = _config.header.navigation.sign.signOffWording;
                    this.signOnUrl = _config.header.navigation.sign.signOnUrl;
                    this.signOnWording = _config.header.navigation.sign.signOnWording;
                    this.homepageFallback = _config.header.navigation.sign.fallback;
                    if (_config.header.navigation.sign.signOnSSRRedirection) {
                        this.signOnSSRRedirection =
                            _config.header.navigation.sign.signOnSSRRedirection;
                    }
                    // If there is a modal object
                    if (_config.header.navigation.sign.modal) {
                        // Get the modal object
                        let modal = _config.header.navigation.sign.modal;
                        // If the modal has all the values we need
                        if (modal.title &&
                            modal.buttonText &&
                            modal.usernameName &&
                            modal.usernamePlaceholder &&
                            modal.passwordName &&
                            modal.passwordPlaceholder &&
                            modal.rememberIdText &&
                            modal.rememberIdName &&
                            modal.userIdBlankError &&
                            modal.userIdShortError &&
                            modal.passwordShortError &&
                            modal.passwordBlankError &&
                            modal.rememberText &&
                            modal.action &&
                            modal.forgotUser &&
                            modal.forgotPassword &&
                            modal.activateCard &&
                            modal.registerOnline) {
                            navigationConfig.showSign = true;
                            navigationConfig.showSignModal = true;
                            navigationConfig.signOnWording =
                                _config.header.navigation.sign.signOnWording;
                            navigationConfig.modalTitle = modal.title;
                            navigationConfig.submitButtonText = modal.buttonText;
                            navigationConfig.usernameName = modal.usernameName;
                            navigationConfig.usernamePlaceholder = modal.usernamePlaceholder;
                            navigationConfig.passwordName = modal.passwordName;
                            navigationConfig.passwordPlaceholder = modal.passwordPlaceholder;
                            navigationConfig.userIdMinChars = modal.userIdMinChars;
                            navigationConfig.userIdBlankError = modal.userIdBlankError;
                            navigationConfig.userIdShortError = modal.userIdShortError;
                            navigationConfig.passwordMinChars = modal.passwordMinChars;
                            navigationConfig.passwordBlankError = modal.passwordBlankError;
                            navigationConfig.passwordShortError = modal.passwordShortError;
                            navigationConfig.rememberIdText = modal.rememberIdText;
                            navigationConfig.rememberIdName = modal.rememberIdName;
                            navigationConfig.rememberText = modal.rememberText;
                            navigationConfig.action = modal.action;
                            navigationConfig.buttonText = modal.buttonText;
                            navigationConfig.forgotUser = modal.forgotUser;
                            navigationConfig.forgotPassword = modal.forgotPassword;
                            navigationConfig.activateCard = modal.activateCard;
                            navigationConfig.registerOnline = modal.registerOnline;
                            // If there is an existingUsers object and it has all the values we need
                            // to produce the existing users dropdown
                            if (modal.existingUsers &&
                                modal.existingUsers.addUserText &&
                                modal.existingUsers.deleteUserText &&
                                modal.existingUsers.deleteUserUrl) {
                                // Set the component to use the user select dropdown
                                navigationConfig.useUserSelect = true;
                                // Set the form to show the existing users dropdown
                                navigationConfig.showUserSelect = true;
                                for (let i = 0, j = modal.existingUsers.usernames.length; i < j; i++) {
                                    modal.existingUsers.usernames[i] = this.maskUsername(modal.existingUsers.usernames[i]);
                                }
                                this.modalData.addUserText = modal.existingUsers.addUserText;
                                this.modalData.deleteUserText =
                                    modal.existingUsers.deleteUserText;
                                this.modalData.deleteUserUrl =
                                    modal.existingUsers.deleteUserUrl;
                            }
                        }
                    }
                }
            }
            //Adding this code for PGL Supression of subtitles's
            if (navigationConfig.menuNavigationItems) {
                navigationConfig.menuNavigationItems.forEach(itm => {
                    if (!itm.title) {
                        itm.title = itm.completeTitle;
                    }
                    if (itm.navigationItems) {
                        itm.navigationItems.forEach(el => {
                            el.show = false;
                            el.items.forEach(disp => {
                                if (!disp.title) {
                                    disp.title = disp.completeTitle;
                                }
                                if (disp.show == true) {
                                    el.show = true;
                                }
                            });
                        });
                    }
                });
            }
            /*commented below code based on DRR-15792*/
            //  const accountInstanceId = this.brandingService.getAccountInstanceId();
            if (navigationConfig.menuNavigationItems) {
                for (let menuGroup of navigationConfig.menuNavigationItems) {
                    if (menuGroup.navigationItems) {
                        for (let navItems of menuGroup.navigationItems) {
                            if (navItems.url && navItems.routerLink) {
                                if (this._isSSRApp) {
                                    navItems.routerLink = '';
                                    navItems.queryParams = '';
                                    navItems.pageName = '';
                                }
                                else {
                                    navItems.url = '';
                                }
                            }
                            if (navItems.items) {
                                for (let item of navItems.items) {
                                    if (item.url && item.routerLink) {
                                        if (this._isSSRApp) {
                                            item.routerLink = '';
                                            item.queryParams = '';
                                            item.pageName = '';
                                        }
                                        else {
                                            item.url = '';
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (menuGroup.id === 'rewards') {
                        for (let navItems of menuGroup.navigationItems) {
                            for (let item of navItems.items) {
                                if (this.sessionParams) {
                                    if (item.url) {
                                        if (item.title.includes('Costco Cash')) {
                                            item.url = item.url.includes(this._brandingEntitlementService.getServiceLinksBean('costcoAccountId')) ? item.url : item.url + this._brandingEntitlementService.getServiceLinksBean('costcoAccountId');
                                        }
                                        else if (item.title.includes('Expedia')) {
                                            item.url = item.url.includes(this._brandingEntitlementService.getServiceLinksBean('expediaAccountId')) ? item.url : item.url + this._brandingEntitlementService.getServiceLinksBean('expediaAccountId');
                                        }
                                        else if (item.title.includes('Double Cash')) {
                                            item.url = item.url.includes(this._brandingEntitlementService.getServiceLinksBean('doubleCashAccountId')) ? item.url : item.url + this._brandingEntitlementService.getServiceLinksBean('doubleCashAccountId');
                                        }
                                        else if (item.title.includes('Custom Cash') || item.title.includes('Cash Rewards Personalizadas')) {
                                            item.url = item.url.includes(this._brandingEntitlementService.getServiceLinksBean('customCashAccountId')) ? item.url : item.url + this._brandingEntitlementService.getServiceLinksBean('customCashAccountId');
                                        }
                                        else if (item.featureflag === "ff_citiStrataCardBenefitsTopNav" ||
                                            item.featureflag === "ff_citiAAdvantageGlobeCardBenetisTopNav" ||
                                            item.featureflag === "ff_citiStrataEliteCardBenefitsTopNav") {
                                            const accountInstanceId = this.getAccountInstanceId(item.featureflag);
                                            if (item.featureflag === "ff_citiStrataCardBenefitsTopNav" || item.featureflag === "ff_citiAAdvantageGlobeCardBenetisTopNav") {
                                                item.url = item.url.includes(accountInstanceId) ? item.url : item.url + accountInstanceId;
                                            }
                                            if (item.show) {
                                                item.accountInstanceId = accountInstanceId;
                                                let accounts = this.sessionParams.accounts;
                                                let cardHolderType = this.sessionParams.cardHolderType;
                                                let mappedAccounts = this.filterAndMapCreditCardAccounts(cardHolderType, accounts);
                                                mappedAccounts.forEach(account => {
                                                    if (account.cardHolderType === "P" && item.accountInstanceId === account.accountInstanceId) {
                                                        item.show = true;
                                                    }
                                                    else if ((account.cardHolderType === "A" || account.cardHolderType.includes("AUTHORIZED")) && item.accountInstanceId === account.accountInstanceId) {
                                                        item.show = false;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else if (menuGroup.id === 'expProducts') {
                        // no good reason for below codes. Only added to accommodate business GBC-4561
                        if (this._window) {
                            let host = this._window.location.hostname;
                            if (host.includes('uat1') ||
                                host.includes('uat01') ||
                                host.includes('uat2') ||
                                host.includes('uat02') ||
                                host.includes('uat3') ||
                                host.includes('uat03')) {
                                if (host.includes('uat1') || host.includes('uat01'))
                                    host = 'https://test01.creditcards.citi.com';
                                else if (host.includes('uat2') || host.includes('uat02'))
                                    host = 'https://test02.creditcards.citi.com';
                                else if (host.includes('uat3') || host.includes('uat03'))
                                    host = 'https://test03.creditcards.citi.com';
                                if (host && menuGroup.navigationItems) {
                                    for (let navItems of menuGroup.navigationItems) {
                                        if (navItems.items) {
                                            for (let item of navItems.items) {
                                                if (item.subtitleId.includes('Credit')) {
                                                    if (item.url)
                                                        if (item.url.includes('https://www.citi.com')) {
                                                            item.url = item.url.replace('https://www.citi.com', '');
                                                            item.url = host + item.url;
                                                        }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Set the config for use by the dom (DOM will not show until this is set);
            this.config = navigationConfig;
            this.setCookiedUnameList();
        }
    }
    //The function returns the updated array of CREDITCARD accounts with the cardHolderType key added.
    filterAndMapCreditCardAccounts(cardHolderType, accounts) {
        // Step 1: Filter accounts with category 'CREDITCARD'
        const creditCardAccounts = accounts.filter(account => account.category === 'CREDITCARD');
        // Step 2: Split the cardHolderType string into an array
        const cardHolderTypes = cardHolderType.split('|');
        // Step 3: Map the filtered accounts and assign the corresponding cardHolderType
        return creditCardAccounts.map((account, index) => {
            account.cardHolderType = cardHolderTypes[index] || null; // Use null if no matching type exists
            return account;
        });
    }
    // This function retrieves the account instance ID based on the feature flag and adds it to specific links
    getAccountInstanceId(featureFlag) {
        // Logic to add account instance ID to links with specific feature flags
        let accountInstanceId = '';
        const account = this.sessionParams.accounts.find((res) => (res.pcodId === '408' && featureFlag === 'ff_citiStrataCardBenefitsTopNav') ||
            (res.pcodId === '430' && featureFlag === 'ff_citiAAdvantageGlobeCardBenetisTopNav') ||
            (res.pcodId === '920' && featureFlag === 'ff_citiStrataEliteCardBenefitsTopNav'));
        if (account) {
            accountInstanceId = account.accountInstanceId;
        }
        return accountInstanceId;
    }
    toggleSearch(event) {
        let prevSearchState = this._layOutService.toggleSearchPanel.getValue();
        this._layOutService.toggleSearchPanel.next(!prevSearchState);
        this.tagTrackingHelpOpenCloseSidePanel(!prevSearchState);
    }
    setLoginStatus() {
        // let brandingTypeCheck = sessionStorage['isMarketingBrandingOrDefault'] || null;
        this.sessionParams = this.getSessionParams();
        this.getLoggedInStatus();
    }
    // Creates an array of cookied usernames from username cookie and inserts into the json
    setCookiedUnameList() {
        if (this._storageService.get('username', StorageService.COOKIE) != null) {
            const userNameString = this._storageService.get('username', StorageService.COOKIE);
            const usernames = userNameString.split('|').splice(1);
            this.modalData.dropDownArray = [];
            this.modalData.dropDownArray = usernames;
            this.modalData.dropDownArray.push(this.modalData.addUserText);
            this.modalData.dropDownArray.push(this.modalData.deleteUserText);
        }
        else {
            this.config.showUserSelect = false;
            this.config.useUserSelect = false;
        }
    }
    // Gets the session parameters and parses them into a valid JavaScript object
    getSessionParams() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            this.colorByUserType();
            sessionParams = JSON.parse(sessionParams);
            return sessionParams !== null ? sessionParams : false;
        }
    }
    // Gets the logged in status of the user visiting the page and returns true or false
    getLoggedInStatus() {
        this.authService.getSessionObservable().subscribe(val => {
            this.isUserLoggedIn = !!val;
        });
    }
    maskUsername(username) {
        // Define the long and short masks
        let short = /(^.)(.{1,})(.$)/;
        let long = /(^..)(.{1,})(..$)/;
        // Get the mask that should be used
        let mask = username.length >= 7 ? long : short;
        username = username.replace(mask, (a, b, c, d) => {
            // Get the first part of the string
            let maskedString = b;
            // Add an x for every character between the first and last sections
            for (let i = 0, j = c.length; i < j; i++) {
                maskedString += '*';
            }
            // Add the last section
            maskedString += d;
            return maskedString;
        });
        return username;
    }
    onClick(event) {
        if (this.isMobile) {
            if (this.navBarMainUl &&
                this.menuIconMobile &&
                !this.navBarMainUl.nativeElement.contains(event.target) &&
                !this.menuIconMobile.nativeElement.contains(event.target)) {
                this.closeActiveMenu();
                this.resetMobileMenu();
                this.linkClicked = false;
            }
        }
    }
    onResize(event) {
        if (this._document.body.offsetWidth > 1120) {
            if (this._isMobile) {
                // remove mobile css classes when going back to desktop
                this.subMenuGroups.forEach(elem => {
                    elem.nativeElement.style.display = 'none';
                    this.renderer.removeClass(elem.nativeElement, 'openSideNav');
                    this.renderer.removeClass(elem.nativeElement, 'closeSideNav');
                });
            }
            this._isMobile = false;
            this.closeActiveMenu();
        }
        if (!this._isMobile && this._document.body.offsetWidth < 1120) {
            this._isMobile = true;
            this.closeActiveMenu(true);
            this.resetMobileMenu(true);
        }
    }
    resetMobileMenu(val) {
        // added optional val for mobile menu is auto closing on scroll
        if (val) {
            return;
        }
        let menuLink = this._document.getElementById('mobileMenuLink');
        if (menuLink)
            menuLink.style.borderBottom = 'none';
        this.mobileNavbarExpanded = false;
    }
    tagTrackingHelpOpenCloseSidePanel(panelState) {
        //false would mean the panel is closed
        if (panelState) {
            this._taggingService.triggerEventTagging('nonicms_content', "324ad0SearchPanelHowCanWeHelpShow");
        }
        else {
            this._taggingService.triggerEventTagging('nonicms_content', "324ad1SearchPanelHowCanWeHelpHide");
        }
    }
    exploretest(obj, event) {
        event.preventDefault();
        this.mapperService.brandingMap(obj);
        if (this.isMobile)
            this.mobileNavbarExpanded = false;
        if (!this.isMobile)
            this.isClose = true;
    }
    // This function get's called when we use enter for pressing Sign On (for Tab Mode)
    onSignonPress(event) {
        if (event.keyCode == 13) {
            this.signOnClick();
        }
    }
    // Functionality of Sign On click
    signOnClick() {
        const ssrHost = this.appConfigService.getnewCitiHostName();
        if (!this.signOnSSRRedirection) {
            this.showSignModal = !this.showSignModal;
        }
        else {
            if (this.isMobile) {
                (ssrHost + '/' === this._window.location.href && this.homepageFallback) ? this.homepageSignOnBtn() :
                    this._window.location.href = ssrHost + '/login';
            }
            else {
                this._window.location.href = ssrHost;
            }
        }
        let navigation_items = `9.1.0 Sign On::`;
        this.brandingTag.topNavTagWithNavItems(navigation_items);
    }
    homepageSignOnBtn() {
        this.brandingService.homepageSignOn(!this.homepageSignOn);
        this._layOutService.toggleSearchPanel.next(false);
    }
    // Open Menu and Close menu functionality in mobile mode for opening sub nav items.
    onMobileMenuClick(event, action) {
        //console.log('---event----',event, action);
        this.closeActiveMenu(true);
        if (this.isMobile) {
            this.subMenuGroups.forEach(elem => {
                this.renderer.removeClass(elem.nativeElement, 'openSideNav');
                this.renderer.addClass(elem.nativeElement, 'closeSideNav');
                elem.nativeElement.style.display = 'none';
                this.sideNavModel = false;
            });
        }
        if (action == 'click' || (event.keyCode == 13 && action == 'enterkey')) {
            this.mobileNavbarExpanded = !this.mobileNavbarExpanded;
        }
        let menuLink = this._document.getElementById('mobileMenuLink');
        if (this.mobileNavbarExpanded) {
            document
                .getElementById('mobileMenuLink')
                .setAttribute('aria-label', 'Close Menu');
            if (menuLink)
                menuLink.style.borderBottom = 'none';
        }
        else {
            document
                .getElementById('mobileMenuLink')
                .setAttribute('aria-label', 'Open Menu');
            if (menuLink)
                menuLink.style.borderBottom = 'none';
        }
    }
    // This method is added for closing of menu automatically once it focuses on How can we help button in RWD Mode.
    mobileCheck(event) {
        if (this.isMobile) {
            this.mobileNavbarExpanded = false;
            if (!this.mobileNavbarExpanded)
                document
                    .getElementById('mobileMenuLink')
                    .setAttribute('aria-label', 'Open Menu');
        }
    }
    closeActiveMenu(val) {
        // added optional val for mobile menu is auto closing on scroll
        if (val) {
            let domElementFound = this._document.getElementById(this.activeSubmenuId + 'subGroup' + this.activeMainLink);
            if (domElementFound)
                domElementFound.style.display = 'none';
            this.activeMainLink = 99999;
            this.activeSubmenuId = 'none';
        }
    }
    // This function is for opening submenu on click in web view
    onMouseClick(e, item, i) {
        let dynamicId = item.id + 'subGroup' + i;
        e.stopPropagation();
        if (dynamicId != null) {
            // get's called when clicked on mobile.
            if (this.isMobile) {
                this.subMenuGroups.forEach(elem => {
                    if (elem.nativeElement.id === dynamicId) {
                        this.renderer.addClass(elem.nativeElement, 'openSideNav');
                        this.renderer.removeClass(elem.nativeElement, 'closeSideNav');
                        this.sideNavModel = true;
                    }
                });
            }
            else {
                // tab functionality with NVDA is implemented here in web view.
                let domElementFound = document.getElementById(item.id + 'subGroup' + i);
                if (domElementFound) {
                    if (domElementFound.style.display == 'none') {
                        if (this.mainNavItemId &&
                            this.mainNavItemId != item.id + 'subGroup' + i) {
                            let subNavId = document.getElementById(this.subNavItemId);
                            if (subNavId) {
                                document.getElementById(this.subNavItemId).style.display =
                                    'none';
                            }
                        }
                        document.getElementById(item.id + 'subGroup' + i).style.display =
                            'block';
                        document
                            .getElementById(item.id + 'mainAnchor' + i)
                            .setAttribute('aria-expanded', 'true');
                    }
                    else {
                        document.getElementById(item.id + 'subGroup' + i).style.display =
                            'none';
                        document
                            .getElementById(item.id + 'mainAnchor' + i)
                            .setAttribute('aria-expanded', 'false');
                    }
                }
                this.mainNavItemId = item.id + 'mainAnchor' + i;
                this.subNavItemId = item.id + 'subGroup' + i;
                this.activeSubmenuId = item.id;
                this.activeMainLink = i;
            }
        }
        else if (dynamicId === null) {
            return;
        }
        else {
            if (!this.linkClicked) {
                this.linkClicked = !this.linkClicked;
                if (i !== this.activeMainLink && this.activeMainLink == 99999) {
                    this.activeMainLink = i;
                    this.activeSubmenuId = item.id;
                }
            }
        }
        if (this.isMobile) {
            this.onMouseEnter(item, i, true);
        }
    }
    routerCall(obj, submenuGroup, topIndex) {
        if (obj.eventType !== 'contextmenu') {
            if (this.isMobile)
                this.mobileNavbarExpanded = false;
            if (!this.isMobile)
                this.isClose = true;
        }
        let topNavItem = this.navData[topIndex];
        this.brandingTag.topNavigationTagging(obj, obj.submenuIndex, topIndex, topNavItem);
    }
    navigateToURL(obj, event) {
        event.preventDefault();
        this.mapperService.brandingMap(obj);
        if (this.isMobile) {
            this.routerCall("", "", "");
        }
    }
    onRightClick(obj, event) {
        if (event.type == 'contextmenu' || event.type == 'mouseover') {
            this.mapperService.modifyURLPrefixRightClick(event, obj.domainMap, obj);
        }
    }
    contextmenuTag(item) {
        const navigation_items = (item.title == 'Explore All Products & Offers') ? `4.6.1 Explore Products::${item.title}` : `8.1.0 ${item.title}::`;
        this.brandingTag.topNavTagWithNavItems(navigation_items);
    }
    onKeyPress(event, item, i) {
        if (event.keyCode == 13) {
            this.linkClicked = !this.linkClicked;
            this.onMouseEnter(item, i, true);
        }
    }
    // GBC-11137/11224 - make desktop dropdowns and mobile submenus dismissible via Esc key - WCAG 2.1 1.4.13 (AA)
    onEscapePress(event, item, i) {
        if (this.isMobile) {
            this.closeActiveMenu(true);
        }
        else {
            let domElementFound = document.getElementById(item.id + 'subGroup' + i);
            if (domElementFound && domElementFound.style.display != 'none') {
                document.getElementById(item.id + 'subGroup' + i).style.display =
                    'none';
                document
                    .getElementById(item.id + 'mainAnchor' + i)
                    .setAttribute('aria-expanded', 'false');
                this.activeMainLink = 99999;
                this.activeSubmenuId = 'none';
            }
        }
        if (document.getElementById(item.id + 'mainAnchor' + i))
            document.getElementById(item.id + 'mainAnchor' + i).focus();
    }
    nvdaUp(event, item, i) {
        let dom = this._document.getElementById(item.id + 'subGroup' + i);
        if (document.getElementById(item.id + 'mainAnchors' + i))
            document
                .getElementById(item.id + 'mainAnchors' + i)
                .setAttribute('aria-expanded', 'true');
        if (dom)
            dom.style.display = 'block';
        if (document.getElementById(item.id + 'mainAnchors' + i))
            document.getElementById(item.id + 'mainAnchors' + i).focus();
    }
    // added for mouse hover and tab functionality without NVDA is implemented
    onMouseEnter(item, i, fromMouseClick) {
        //console.log('---onMouseEnter---', item, i);
        if (!this.isMobile) {
            this.isClose = false;
        }
        let domElementFound = this._document.getElementById(item.id + 'subGroup' + i);
        if (!this.isMobile && !fromMouseClick) {
            //console.log('---not is mobile and not from mouse click---', item, i);
            if (i !== this.activeMainLink && this.activeMainLink == 99999) {
                if (domElementFound)
                    domElementFound.style.display = 'block';
                this.activeMainLink = i;
                this.activeSubmenuId = item.id;
                this.sideNavModel = true;
            }
            else if (i !== this.activeMainLink && this.activeMainLink !== 99999) {
                let subMenuAlreadyOpen = this._document.getElementById(this.activeSubmenuId + 'subGroup' + this.activeMainLink);
                if (!this.isMobile) {
                    if (subMenuAlreadyOpen)
                        subMenuAlreadyOpen.style.display = 'none';
                }
                if (domElementFound)
                    domElementFound.style.display = 'block';
                this.linkClicked = false;
                this.activeMainLink = i;
                this.activeSubmenuId = item.id;
            }
            else if (i == this.activeMainLink)
                return;
        }
        if (fromMouseClick) {
            //console.log('---from mouse click---');
            if (i !== this.activeMainLink) {
                //console.log('---acivie main link not equla to I---', this.activeMainLink, i);
                if (this.activeMainLink !== 99999) {
                    let subMenuAlreadyOpen = this._document.getElementById(this.activeSubmenuId + 'subGroup' + this.activeMainLink);
                    if (!this.isMobile) {
                        if (subMenuAlreadyOpen)
                            subMenuAlreadyOpen.style.display = 'none';
                    }
                }
                this.activeMainLink = i;
                this.activeSubmenuId = item.id;
                let domFocusFound = this._document.getElementById(item.id + 'mainAnchors' + i);
                if (domElementFound)
                    domElementFound.style.display = 'block';
                if (domFocusFound && this.focusCheck)
                    document.getElementById(item.id + 'mainAnchors' + i).focus();
            }
            else {
                // console.log('---from mouse click---else', this.isMobile);
                if (!this.isMobile) {
                    if (domElementFound)
                        domElementFound.style.display = 'none';
                }
                this.activeMainLink = 99999;
                this.activeSubmenuId = 'none';
            }
        }
        if (this.isMobile) {
            if (i !== this.activeMainLink) {
                // set focust to first element of submenu in mobile browser
                let domFocusFound = this._document.getElementById(item.id + 'mainAnchors' + i);
                if (domFocusFound && this.focusCheck)
                    document.getElementById(item.id + 'mainAnchors' + i).focus();
            }
        }
        this.tmxAndSitecatCheck(item);
        if (item.id === "rewards") {
            try {
                // Display new entry point with "New" tag in Post Log-in Top Nav for Multi Cards and MRC, MCC, and Single Card
                // Created an array of keys to check for 30-day logic to display a "NEW" tag for individual entry point
                const featureFlags = {
                    "ff_citiStrataEliteCardBenefitsTopNav": "newTagCitiStrata",
                    "ff_citiStrataCardBenefitsTopNav": "newTagCitiStrataCardsBenefits",
                    "ff_citiAAdvantageGlobeCardBenetisTopNav": "newTagCitiAaAdVantageGlobeMasterCard"
                };
                Object.entries(featureFlags).forEach(([flag, storageKey]) => {
                    if (this.sessionParams?.featureFlags?.[flag] === 'Y') {
                        this.checkFor30DayLogic(storageKey);
                    }
                });
            }
            catch (error) {
                console.error("An error occurred while setting newTagLastSeen:", error);
            }
        }
    }
    // This function checks for a 30-day logic for a NEW tag based on the storage key provided
    checkFor30DayLogic(storageKey) {
        this[storageKey] = false;
        const newTagLastSeen = this._storageService.get(storageKey, "localstorage");
        const currentDate = new Date();
        const targetDate = new Date("2025-10-18");
        currentDate.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);
        if (currentDate <= targetDate && (newTagLastSeen === null || (new Date(newTagLastSeen).setHours(0, 0, 0, 0) >= currentDate.getTime() - 30 * 24 * 60 * 60 * 1000 && new Date(newTagLastSeen).setHours(0, 0, 0, 0) <= currentDate.getTime()))) {
            this[storageKey] = true;
            if (newTagLastSeen === null) {
                this._storageService.set(storageKey, currentDate.toISOString().split('T')[0], "localstorage");
            }
        }
    }
    // This function is written for purposes of NVDA in RWD Mode.
    nvdaFunction(item, i, fromMouseClick) {
        let dom = this._document.getElementById(item.id + 'subGroup' + i);
        if (document.getElementById(item.id + 'mainAnchor' + i))
            document
                .getElementById(item.id + 'mainAnchor' + i)
                .setAttribute('aria-expanded', 'false');
        if (dom)
            dom.style.display = 'none';
        if (document.getElementById(item.id + 'mainAnchor' + i))
            document.getElementById(item.id + 'mainAnchor' + i).focus();
    }
    focusSet(event) {
        this.focusCheck = true;
    }
    onKeydownHandler(event) {
        if (this.isMobile)
            this.showSubMenu = true;
    }
    onFocusIn(item, i, event) {
        if (this.previousTab && this.previousTabIndex !== i) {
            //console.log('--- main  tab changd---', this.previousTab, this.previousTabIndex);
            let domElementFound = this._document.getElementById(this.previousTab.id + 'subGroup' + this.previousTabIndex);
            //console.log('--- domElementFound---', domElementFound);
            if (domElementFound) {
                domElementFound.style.display = 'none';
                // close submenu in mobile view
                if (this.isMobile) {
                    //console.log('---onfocusin--elementfound-- isMobile---',);
                    this.subMenuGroups.forEach(elem => {
                        this.renderer.removeClass(elem.nativeElement, 'openSideNav');
                        this.renderer.addClass(elem.nativeElement, 'closeSideNav');
                        elem.nativeElement.style.display = 'none';
                        this.sideNavModel = false;
                    });
                }
            }
        }
        this.previousTab = item;
        this.previousTabIndex = i;
    }
    onMouseLeave(item, i) {
        //console.log('---onMouseLeave---', item, i);
        if (!this.linkClicked && !this.isMobile) {
            let domElementFound = this._document.getElementById(item.id + 'subGroup' + i);
            if (domElementFound) {
                domElementFound.style.display = 'none';
                //console.log('---onMouseLeave   mobile found---', item, i);
                //domElementFound.classList.add('closeSideNav');
            }
            this.activeMainLink = 99999;
            this.activeSubmenuId = 'none';
        }
    }
    onClickMainMenu($event, item, i) {
        this.showSubMenu
            ? this.nvdaUp($event, item, i)
            : this.onMouseClick($event, item, i);
    }
    // menu functionality for RWD mode or mobile mode
    closeSideNav(e, item, i) {
        let dynamicId = item.id + 'subGroup' + i;
        this.subMenuGroups.forEach(elem => {
            if (elem.nativeElement.id === dynamicId) {
                this.renderer.addClass(elem.nativeElement, 'closeSideNav');
                this.renderer.removeClass(elem.nativeElement, 'openSideNav');
                this.sideNavModel = true;
            }
        });
        e.stopPropagation();
        this.sideNavModel = true;
        this.activeMainLink = i;
        this.activeSubmenuId = item.id;
    }
    tmxAndSitecatCheck(item) {
        if (item.id === 'profiles') {
            this._tmxService.getRequestParams();
        }
        if (item.id === 'productExplorer') {
            let siteCatData = {
                custLink: 'product explorer'
            };
            this._siteCatService.setSCPageData('click', siteCatData);
        }
    }
    deleteSPBSforSSRContainer(signOffURL) {
        let navigation_items = `9.1.0 Sign Off::`;
        this.brandingTag.topNavTagWithNavItems(navigation_items);
        this.mapperService.deleteSignOff(signOffURL);
    }
    getPath() {
        if (this._window) {
            let path = this._window.location.pathname;
            let query = this._window.location.search;
            if (query) {
                path += query;
            }
            return path;
        }
        return null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Navigation3Component, deps: [{ token: LayoutsService }, { token: DOCUMENT }, { token: i1$1.StorageService }, { token: WINDOW }, { token: i3$1.TMXService }, { token: i4.SiteCatalystService }, { token: BrandingService }, { token: BrandingMapService }, { token: BrandingEntitlementService }, { token: i3$1.AuthorizationService }, { token: i3.Router }, { token: i0.Renderer2 }, { token: i6.HttpService }, { token: i1$1.TaggingService }, { token: BrandingTaggingService }, { token: i1$1.AppConfigService }, { token: IS_SSRENDERED_APP, optional: true }, { token: SESSION_STORAGE }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: Navigation3Component, isStandalone: false, selector: "citi-navigation3", inputs: { brandingConfig: "brandingConfig" }, outputs: { langBtnClicked: "langBtnClicked" }, host: { listeners: { "window:click": "onClick($event)", "window:resize": "onResize($event)", "document:keydown.tab": "onKeydownHandler($event)" }, classAttribute: "citi-navigation" }, viewQueries: [{ propertyName: "navBarMainUl", first: true, predicate: ["navBarMainUl"], descendants: true }, { propertyName: "menuIconMobile", first: true, predicate: ["menuIconMobile"], descendants: true }, { propertyName: "subMenuGroups", predicate: ["subMenuGroups"], descendants: true }], ngImport: i0, template: "<div\n  role=\"navigation\"\n  aria-label=\"Main\"\n  class=\"navigationParent {{ customerType }}TopNavTheme\"\n  *ngIf=\"config?.showNavigation\"\n  [ngClass]=\"isUserLoggedIn ? 'postLogin' : 'preLogin'\"\n>\n  <div id=\"navigationLeft\">\n    <!-- Mobile Navigation Menu - Open/Close Button -->\n    <a\n      #menuIconMobile\n      *ngIf=\"isMobile && !type\"\n      role=\"button\"\n      aria-label=\"Menu\"\n      [attr.aria-expanded]=\"mobileNavbarExpanded ? true : false\"\n      class=\"menuLinkMobile\"\n      id=\"mobileMenuLink\"\n      tabindex=\"0\"\n      (click)=\"onMobileMenuClick($event, 'click')\"\n      (keypress)=\"onMobileMenuClick($event, 'enterkey')\"\n      [ngClass]=\"{ mobileMenuActiveBg: mobileNavbarExpanded }\"\n    ></a>\n\n    <!-- Main Navigation Links -->\n    <ul\n      #navBarMainUl\n      class=\"nav-bar-main-ul\"\n      [ngStyle]=\"{ display: !isMobile || mobileNavbarExpanded ? 'flex' : 'none', position: isMobile ? 'absolute' : 'static' }\"\n    >\n      <ng-container *ngFor=\"let item of navData; let i = index\">\n        <li\n          *ngIf=\"item.show && !(item.locale && item.locale!==locale) && item.id != 'signOff'\"\n          [id]=\"item.id + 'MainLI'\"\n          class=\"mainListItem\"\n          role=\"listitem\"\n          (focusin)=\"onFocusIn(item, i, false)\"\n          (mouseenter)=\"onMouseEnter(item, i, false)\"\n          (mouseleave)=\"onMouseLeave(item, i)\"\n        >\n          <!-- Mobile Button Icon (for ATM/Branch, Espanol, and Profiles) -->\n          <img\n            *ngIf=\"isMobile && item.image\"\n            class=\"mobileButtonIcon\"\n            aria-hidden=\"true\"\n            [src]=\"navATMLangMobUrl + item.image\"\n            [alt]=\"item.className\"\n          />\n\n          <!-- Main Navigation Categories - tabs on desktop that contain the dropdowns -->\n          <a\n            *ngIf=\"!item.routerLink && !item.url && item.id !== 'butlerEspanol'\"\n            [id]=\"item.id + 'mainAnchor' + i\"\n            [attr.role]=\"item.url ? 'link' : 'button'\"\n            [attr.aria-expanded]=\"\n              i == activeMainLink && !item.url\n                ? true\n                : i !== activeMainLink && item.url\n                ? null\n                : false\n            \"\n            tabindex=\"0\"\n            (click)=\"onClickMainMenu($event, item, i)\"\n            (keydown.enter)=\"focusSet($event)\"\n            (keypress)=\"onKeyPress($event, item, i)\"\n            [attr.href]=\"item.url\"\n            [attr.target]=\"item.target\"\n            [innerHtml]=\"item.title\"\n            class=\"main-links mobileRightChevron topNavTabs\"\n            [ngClass]=\"{ topNavHoveredState: hoveredTab === i }\"\n          ></a>\n\n          <!-- Navigation Buttons (Open an Account, Check Personal Loan Rate, ATM/Branch) -->\n          <a\n            (focus)=\"onMouseClick($event, item, i)\"\n            (focusout)=\"onMouseLeave(item, i)\"\n            *ngIf=\"(item.routerLink || item.url) && item.id !== 'butlerEspanol'\"\n            [id]=\"item.id + 'mainAnchor' + i\"\n            [innerHtml]=\"item.title\"\n            class=\"main-links mobileRightChevron topNavButton\"\n            [attr.href]=\"item.url ? item.url : item.routerLink\"\n            (click)=\"contextmenuTag(item);navigateToURL(item, $event)\"\n            (contextmenu)=\"contextmenuTag(item);onRightClick(item,$event)\"\n            (mouseover)=\"onRightClick(item,$event)\"\n          ></a>\n\n          <!-- Pre-Login Language Toggle (English/Spanish) Button -->\n          <button\n            [attr.lang]=\"item.locale == 'es_US' ? 'en' : 'es'\"\n            *ngIf=\"item.id === 'butlerEspanol' && item.locale===locale && isMobile\"\n            [innerHtml]=\"item.title\"\n            class=\"main-links langBtn\"\n            attr.data-target=\"#modal{{ i }}\"\n            [attr.aria-label]=\"item.locale == 'es_US' ? 'Click to change page language to English' : 'Haz clic para cambiar la p\u00E1gina al espa\u00F1ol'\"\n            (click)=\"onLangBtnClick(item)\"\n          ></button>\n\n          <!-- Desktop Dropdown + Mobile Submenu Container -->\n          <div\n            class=\"subMenuMainContainer\"\n            *ngIf=\"!item.routerLink && !item.url\"\n          >\n            <div\n              #subMenuGroups\n              class=\"subMenuGroupParent\"\n              [id]=\"item.id + 'subGroup' + i\"\n              *ngIf=\"item.navigationItems && item.navigationItems.length\"\n              [ngClass]=\"{ highlight: isClose, topNavDropdown: !isMobile }\"\n              (mouseover)=\"hoveredTab = i;\"\n              (mouseleave)=\"hoveredTab = -1;\"\n              (keyup.escape)=\"onEscapePress($event, item, i)\"\n            >\n              <!-- Flex container for dropdown/submenu -->\n              <div [ngClass]=\"isMobile ? 'flexColumnContainer' : 'flexContainer'\">\n                <!-- Mobile Submenu Navigation Title -->\n                <div\n                  class=\"subNavtitleMain\"\n                  *ngIf=\"isMobile\"\n                >\n                  <a\n                    tabindex=\"0\"\n                    [id]=\"item.id + 'mainAnchors' + i\"\n                    [attr.aria-label]=\"'Close ' + item.title + ' Menu'\"\n                    (click)=\"showSubMenu ? nvdaFunction(item, i, false) : closeSideNav($event, item, i)\"\n                    (keydown.enter)=\"nvdaFunction(item, i, false)\"\n                    class=\"subNavTitle\"\n                  >\n                    {{ item.title }}\n                  </a>\n                </div>\n\n                <!-- Mobile Explore All Products & Offers -->\n                <ng-container *ngIf=\"isMobile && item.id == 'expProducts' && easydealsexp\">\n                  <a\n                    (click)=\"exploretest(easydealsObj, $event);contextmenuTag(easydealsObj)\"\n                    class=\"ng-star-inserted btn btn-secondary easydealsmobile\"\n                    [attr.href]=\"easydealsObj.url ? easydealsObj.url : easydealsObj.routerLink\"\n                    [innerHtml]=\"easydealsObj.title\"\n                    (contextmenu)=\"onRightClick(easydealsObj,$event);contextmenuTag(easydealsObj)\"\n                    (mouseover)=\"onRightClick(easydealsObj,$event)\"\n                  >\n                  </a>\n                </ng-container>\n\n                <!-- Child Nav Group component - contains the navigation links -->\n                <child-nav-group3\n                  [userLoggedIn]=\"isUserLoggedIn\"\n                  *ngFor=\"let childNavGroup of item.navigationItems;let submenuIndex = index\"\n                  [childNavGroup]=\"childNavGroup\"\n                  [isMobile]=\"isMobile\"\n                  (childLinkClicked)=\"resetMobileMenu()\"\n                  (routerLinkClicked)=\"routerCall($event,submenuIndex,i)\"\n                  [newTagCitiStrata]=\"newTagCitiStrata\"\n                  [newTagCitiStrataCardsBenefits]=\"newTagCitiStrataCardsBenefits\"\n                  [newTagCitiAaAdVantageGlobeMasterCard]=\"newTagCitiAaAdVantageGlobeMasterCard\"\n                  [isExploreProducts]=\"item.id === 'expProducts'\"\n                  class=\"childNavGroup\"\n                  [ngStyle]=\"{ display: childNavGroup.show ? (isMobile ? 'block' : 'flex') : 'none' }\"\n                ></child-nav-group3>\n              </div>\n\n              <!-- Desktop Explore All Products & Offers -->\n              <ng-container *ngIf=\"item.id == 'expProducts' && !isMobile && easydealsexp\">\n                <a\n                  (click)=\"exploretest(easydealsObj, $event);contextmenuTag(easydealsObj)\"\n                  [attr.href]=\"easydealsObj.url ? easydealsObj.url : easydealsObj.routerLink\"\n                  (contextmenu)=\"onRightClick(easydealsObj,$event);contextmenuTag(easydealsObj)\"\n                  (mouseover)=\"onRightClick(easydealsObj,$event)\"\n                  class=\"ng-star-inserted easydeals\"\n                >\n                {{easydealsObj.title}}\n                <span class=\"easy-deals-icon\"></span>\n                </a>\n              </ng-container>\n            </div>\n          </div>\n        </li>\n      </ng-container>\n    </ul>\n  </div>\n\n  <div id=\"navigationRight\">\n    <!-- How can we help? Button -->\n    <button\n      *ngIf=\"!type && showHowCanWeHelp\"\n      type=\"button\"\n      name=\"how can we help button\"\n      class=\"main-links topNavButton howCanWeHelpButton {{ locale }}\"\n      (click)=\"toggleSearch($event)\"\n      (focusin)=\"mobileCheck($event)\"\n    >\n      {{ howCanWeHelpPost }}\n    </button>\n    <!-- Border between How can we help? and Sign On/Off buttons -->\n    <span\n      id=\"Howline\"\n      *ngIf=\"(!type && showHowCanWeHelp) && (showSignOn || (signOffObj && signOffObj.show))\"\n    ></span>\n\n    <!-- Sign Off Button -->\n    <a\n      *ngIf=\"signOffObj && signOffObj.show\"\n      [id]=\"signOffObj.id + 'mainAnchor'\"\n      class=\"main-links topNavButton\"\n      tabindex=\"0\"\n      [innerHtml]=\"signOffObj.title\"\n      (click)=\"deleteSPBSforSSRContainer(signOffObj)\"\n      (keydown.enter)=\"deleteSPBSforSSRContainer(signOffObj)\"\n      [attr.target]=\"signOffObj.target\"\n    ></a>\n\n    <!-- Sign On Button -->\n    <a\n      *ngIf=\"!isUserLoggedIn && showSignOn\"\n      role=\"button\"\n      [id]=\"isMobile ? 'signOnMobileALink' : 'signOnFocus'\"\n      class=\"main-links topNavButton\"\n      [ngClass]=\"{ signOnActive: homepageSignOn }\"\n      tabindex=\"0\"\n      [attr.aria-label]=\"homepageSignOn ? 'Close' : 'SignOn'\"\n      [innerHtml]=\"homepageSignOn ? '' : '&nbsp;'+ signOnWording + '&nbsp;'\"\n      (click)=\"signOnClick()\"\n      (keypress)=\"onSignonPress($event)\"\n    ></a>\n  </div>\n</div>\n\n<citi-nav-search [brandingConfig]=\"bannerConfig\"></citi-nav-search>", styles: [":host{overflow-x:hidden}a:focus{outline:-webkit-focus-ring-color auto 5px!important;outline-offset:-2px}.blueTopNavTheme{--navigation-bg-color: #F0F5F7;--navigation-hover-color: #5E676B;--text-color: #04208F;--text-hover-color: #4400CC;--header-color: #5E676B;--mobile-menu-color: #04208F;--mobile-button-text-color: #5E676B;--search-border-color: #5E676B;--blue-chevi-position: -105px -89px;--blue-search-position: -22px -83px;--blue-menu-open: -536px -72px;--blue-menu-close: -688px -72px}.goldTopNavTheme{--navigation-bg-color: #84682E;--navigation-hover-color: #056DAE}.priorityTopNavTheme{--navigation-bg-color: #091022;--navigation-hover-color: #0E2A48}.cpcTopNavTheme{--navigation-bg-color: #281814;--navigation-hover-color: #84682E}.privatebankingTopNavTheme,.cpbTopNavTheme{--navigation-bg-color: #0E0E0E;--navigation-hover-color: #666666}.navigationParent{width:100%;margin:0 auto;height:46px;position:relative;box-shadow:0 1px 10px #0000001f;background-color:var(--navigation-bg-color);display:flex;justify-content:space-between;white-space:nowrap}@media screen and (max-width: 1120px){.navigationParent{height:50px;padding:0}}#navigationRight{display:flex;padding-right:40px}@media screen and (max-width: 1120px){#navigationRight{padding-right:16px}}@media screen and (max-width: 400px){#navigationRight{padding-right:0}}#navigationRight .main-links{text-decoration:none;cursor:pointer;margin-left:-1px}@media screen and (max-width: 1120px){#navigationRight .main-links:hover,#navigationRight .main-links:focus{background-color:var(--navigation-hover-color);color:#fff}}.nav-bar-main-ul{margin-top:0;margin-bottom:1rem;padding-left:2rem}.nav-bar-main-ul a{text-decoration:none}@media screen and (max-width: 1120px){.nav-bar-main-ul{margin-top:-7px;width:100%;flex-direction:column}.nav-bar-main-ul .main-links{padding:0 56px;color:var(--text-color, #333);line-height:40px;position:relative;top:9%}}.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI #butlerATMmainAnchor5{display:none}@media screen and (max-width: 1119.9px){.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI #butlerATMmainAnchor5{display:block}}@media screen and (max-width: 1120px){.preLogin .nav-bar-main-ul{display:flex;padding-left:0;z-index:2;overflow-x:hidden;min-height:1000px;background:transparent}}.postLogin .nav-bar-main-ul{padding:0 0 0 20px}@media screen and (max-width: 1120px){.postLogin .nav-bar-main-ul{padding-top:20px;padding-left:0;overflow:hidden;background:#fff;height:560px;z-index:1}}.mainListItem{list-style:none}@media screen and (max-width: 1120px){.preLogin .mainListItem{border-bottom:5px solid #eee;height:56px;background-color:#fff;margin:-2px}}.main-links{display:block;padding:9px 20px 0;color:var(--text-color, #FFFFFF);line-height:30px;font-family:Interstate_Regular,sans-serif;font-size:inherit;height:100%;cursor:pointer}@media screen and (min-width: 1120px){.main-links:hover,.main-links:focus{background-color:var(--navigation-hover-color);color:#fff}}.langBtn{border:0;color:var(--mobile-button-text-color, #056dae)!important;background-color:transparent;text-align:left;width:100%;top:0!important}.subMenuMainContainer{display:block;position:relative}@media screen and (max-width: 1120px){.subMenuMainContainer{position:absolute;z-index:9;width:100%;top:0}}.subMenuGroupParent{display:none;background:#fff;z-index:1;position:absolute;width:auto;left:0;box-shadow:0 2px 7px 2px #00000020}@media screen and (max-width: 1120px){.subMenuGroupParent{position:static;box-shadow:none;padding-left:0}}@media screen and (max-width: 1120px){.mobileRightChevron:after{content:\"\";background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:-105px -89px;background-repeat:no-repeat;font-size:18px;position:absolute;top:10px;right:15px;width:20px;height:20px}}.flexContainer{display:flex;padding:16px 20px 0}.flexColumnContainer{position:relative;margin-top:0;background:#fff;min-height:450px}.mobileMenuActiveBg{background:var(--mobile-menu-color, #056dae);background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg)!important;background-position:-764px -72px!important}.highlight{right:auto;display:none!important}.menuLinkMobile{display:inline-block;width:58px;height:100%;margin:0;border-bottom:none;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:var(--blue-menu-open, -612px -72px);background-repeat:no-repeat}@media screen and (max-width: 280px){.menuLinkMobile{padding:0;width:46px}}.signOnActive{width:73.3px;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-repeat:no-repeat;background-position:var(--blue-menu-close, -764px -72px)}.signOnActive:hover{background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-repeat:no-repeat;background-position:-764px -72px}.signOnActive:focus:not(:hover){background-color:transparent!important}@media screen and (min-width: 1120px) and (max-width: 1280px){button.en_US{font-size:0px!important}}@media screen and (min-width: 1120px) and (max-width: 1400px){button.es_US{font-size:0px!important}}.howCanWeHelpButton{display:flex;align-items:center;padding:11px 15px 11px 17px;background-color:var(--navigation-bg-color);border:none;margin-right:-1px}.howCanWeHelpButton:before{content:\"\";width:24px;height:24px;margin-right:10px;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:var(--blue-search-position, -478px -83px);background-repeat:no-repeat}.howCanWeHelpButton:hover+#Howline,.howCanWeHelpButton:focus+#Howline{visibility:hidden}.howCanWeHelpButton:hover:before,.howCanWeHelpButton:focus:before{filter:brightness(0) invert(1)}.howCanWeHelpButton:focus{outline:-webkit-focus-ring-color auto 5px!important}@media screen and (max-width: 280px){.howCanWeHelpButton{right:68px}.howCanWeHelpButton::ng-deep button{padding:11px 9px 0 0;font-size:15px}.howCanWeHelpButton::ng-deep button:before{margin-right:1px}}@media screen and (max-width: 360px){.howCanWeHelpButton{font-size:11px!important}}@media only screen and (min-device-width: 568px) and (max-device-width: 1120px){.howCanWeHelpButton{padding:0 20px!important}}#Howline{border-right:1px solid var(--search-border-color, #fff);margin:9px 0}.subNavtitleMain{width:90%;border-bottom:1px solid #eee;height:4em;margin-left:21px}.subNavTitle{position:absolute;left:52px;color:var(--mobile-button-text-color, #333);top:19px;width:90%;padding-bottom:8px;font-weight:600;cursor:pointer;font-family:Interstate_Light,sans-serif}.subNavTitle:hover,.subNavTitle:focus{color:var(--mobile-button-text-color, #333)}.subNavTitle:before{content:\"\";background-image:url(/citi-branding-assets/images/chevronLeft.svg);background-repeat:no-repeat;position:absolute;top:5px;left:-33px;width:20px;height:20px}.closeSideNav{display:block;width:100%;height:100%;z-index:9;position:absolute;transform:translate(100%);transition:.5s ease-in}.openSideNav{display:block;width:100%;height:100%;z-index:9;position:absolute;transform:translate(0);transition:.5s ease-in}.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI a{color:var(--mobile-button-text-color, #056dae)}@media screen and (max-width: 1120px){.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI a:after{display:none}}.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .subMenuMainContainer{position:absolute!important}@media screen and (min-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .subMenuMainContainer{left:5%}}@media screen and (min-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .child-nav-group3{display:flex;flex-direction:column;width:auto!important}}@media screen and (max-width: 1119.9px){.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .child-nav-group3 .subMenuGroupTitle{line-height:4em;padding-left:8%;border-bottom:1px solid #eee;margin-left:15px;margin-right:26px}}.postLogin .nav-bar-main-ul ::ng-deep #profilesNavMainLI{display:none}.postLogin .nav-bar-main-ul ::ng-deep #profilesNavMainLI #profilesNavmainAnchor5{color:var(--mobile-button-text-color, #333)!important}@media screen and (max-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #profilesNavMainLI{display:block}}.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI{display:none}.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI a{color:var(--mobile-button-text-color, #333)!important}.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI a:after{display:none}@media screen and (max-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI{display:block}}@media screen and (min-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #pntMainLI .subMenuGroupParent .child-nav-group3{display:flex;flex-direction:column}}@media screen and (min-width: 1120px) and (-ms-high-contrast: none),(-ms-high-contrast: active){.postLogin .nav-bar-main-ul ::ng-deep #pntMainLI .subMenuGroupParent{min-height:310px}}.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a{padding-right:40px}@media screen and (min-width: 1120px){.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a:after,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:after{content:\"\";background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:var(--blue-chevi-position, -413px -88px);background-repeat:no-repeat;font-size:18px;position:absolute;top:17px;margin-left:9px;width:20px;height:20px}.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a:hover:after,.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a:focus:after,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:hover:after,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:focus:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:hover:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:focus:after{filter:brightness(0) invert(1)}}@media screen and (max-width: 1119.9px){.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a{text-align:center}.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:after{display:none}}.mobileButtonIcon{position:absolute;background-repeat:no-repeat;z-index:1;object-fit:none;width:45px;height:45px}.preLogin .mobileButtonIcon{padding-top:9px;padding-left:15px}.postLogin .mobileButtonIcon{padding-left:16px;padding-top:8px}.blueTopNavTheme #butlerATMMainLI img{object-position:-170px -19px}#butlerATMMainLI img{object-position:-170px -95px}#profilesNavMainLI img{object-position:-94px -20px}#ATMNavMainLI img{object-position:-170px -19px}.blueTopNavTheme #butlerEspanolMainLI img{object-position:-248px -18px}#butlerEspanolMainLI img{object-position:-248px -94px}.easydeals{display:inline-flex;align-items:center;float:right;font-weight:700;margin-right:30px;padding-right:15px;padding-bottom:22px;color:var(--text-color, #056dae)}.easydeals:active{box-shadow:none}.easydeals .easy-deals-icon{display:inline-block;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-repeat:no-repeat;background-position:var(--blue-chevi-position, -105px -89px);width:8px;height:14px;margin-left:6px}.blueTopNavTheme .easydeals:hover,.blueTopNavTheme .easydeals:focus{filter:brightness(0) saturate(100%) invert(13%) sepia(96%) saturate(7460%) hue-rotate(266.5deg) brightness(73%) contrast(130%)}.easydealsmobile{padding:0 0 0 8%;color:var(--text-color, #056dae);font-weight:600;margin-left:15px;margin-right:26px;line-height:4em;width:95%;border-bottom:1px solid #eee}.easydealsmobile:active{box-shadow:none}.easydealsmobile:hover,.easydealsmobile:focus{color:var(--text-hover-color, #034c81);text-decoration:underline}@media screen and (min-width: 1120px){.topNavTabs{border-radius:8px 8px 0 0;height:46px}}.topNavButton{border-radius:8px}.topNavDropdown{border-radius:0 0 8px 8px;clip-path:inset(0px -10px -10px -10px);-webkit-clip-path:inset(0px -10px -10px -10px)}@media screen and (min-width: 1120px){.childNavGroup{padding:0 40px 0 0}.childNavGroup:last-child{padding-right:0}}@media screen and (max-width: 1120px){.childNavGroup:nth-child(2){padding-top:12px}}@media screen and (min-width: 1120px){.topNavHoveredState{background-color:var(--navigation-hover-color);color:#fff!important}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: ChildNavGroup3Component, selector: "child-nav-group3, [child-nav-group3]", inputs: ["childNavGroup", "isMobile", "newTagCitiStrata", "newTagCitiStrataCardsBenefits", "newTagCitiAaAdVantageGlobeMasterCard", "isExploreProducts", "getUserTypeFromNav", "userLoggedIn", "navData"], outputs: ["childLinkClicked", "routerLinkClicked"] }, { kind: "component", type: NavSearchComponent, selector: "citi-nav-search", inputs: ["brandingConfig"], outputs: ["openSearchDroor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Navigation3Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-navigation3', standalone: false, host: { class: 'citi-navigation' }, template: "<div\n  role=\"navigation\"\n  aria-label=\"Main\"\n  class=\"navigationParent {{ customerType }}TopNavTheme\"\n  *ngIf=\"config?.showNavigation\"\n  [ngClass]=\"isUserLoggedIn ? 'postLogin' : 'preLogin'\"\n>\n  <div id=\"navigationLeft\">\n    <!-- Mobile Navigation Menu - Open/Close Button -->\n    <a\n      #menuIconMobile\n      *ngIf=\"isMobile && !type\"\n      role=\"button\"\n      aria-label=\"Menu\"\n      [attr.aria-expanded]=\"mobileNavbarExpanded ? true : false\"\n      class=\"menuLinkMobile\"\n      id=\"mobileMenuLink\"\n      tabindex=\"0\"\n      (click)=\"onMobileMenuClick($event, 'click')\"\n      (keypress)=\"onMobileMenuClick($event, 'enterkey')\"\n      [ngClass]=\"{ mobileMenuActiveBg: mobileNavbarExpanded }\"\n    ></a>\n\n    <!-- Main Navigation Links -->\n    <ul\n      #navBarMainUl\n      class=\"nav-bar-main-ul\"\n      [ngStyle]=\"{ display: !isMobile || mobileNavbarExpanded ? 'flex' : 'none', position: isMobile ? 'absolute' : 'static' }\"\n    >\n      <ng-container *ngFor=\"let item of navData; let i = index\">\n        <li\n          *ngIf=\"item.show && !(item.locale && item.locale!==locale) && item.id != 'signOff'\"\n          [id]=\"item.id + 'MainLI'\"\n          class=\"mainListItem\"\n          role=\"listitem\"\n          (focusin)=\"onFocusIn(item, i, false)\"\n          (mouseenter)=\"onMouseEnter(item, i, false)\"\n          (mouseleave)=\"onMouseLeave(item, i)\"\n        >\n          <!-- Mobile Button Icon (for ATM/Branch, Espanol, and Profiles) -->\n          <img\n            *ngIf=\"isMobile && item.image\"\n            class=\"mobileButtonIcon\"\n            aria-hidden=\"true\"\n            [src]=\"navATMLangMobUrl + item.image\"\n            [alt]=\"item.className\"\n          />\n\n          <!-- Main Navigation Categories - tabs on desktop that contain the dropdowns -->\n          <a\n            *ngIf=\"!item.routerLink && !item.url && item.id !== 'butlerEspanol'\"\n            [id]=\"item.id + 'mainAnchor' + i\"\n            [attr.role]=\"item.url ? 'link' : 'button'\"\n            [attr.aria-expanded]=\"\n              i == activeMainLink && !item.url\n                ? true\n                : i !== activeMainLink && item.url\n                ? null\n                : false\n            \"\n            tabindex=\"0\"\n            (click)=\"onClickMainMenu($event, item, i)\"\n            (keydown.enter)=\"focusSet($event)\"\n            (keypress)=\"onKeyPress($event, item, i)\"\n            [attr.href]=\"item.url\"\n            [attr.target]=\"item.target\"\n            [innerHtml]=\"item.title\"\n            class=\"main-links mobileRightChevron topNavTabs\"\n            [ngClass]=\"{ topNavHoveredState: hoveredTab === i }\"\n          ></a>\n\n          <!-- Navigation Buttons (Open an Account, Check Personal Loan Rate, ATM/Branch) -->\n          <a\n            (focus)=\"onMouseClick($event, item, i)\"\n            (focusout)=\"onMouseLeave(item, i)\"\n            *ngIf=\"(item.routerLink || item.url) && item.id !== 'butlerEspanol'\"\n            [id]=\"item.id + 'mainAnchor' + i\"\n            [innerHtml]=\"item.title\"\n            class=\"main-links mobileRightChevron topNavButton\"\n            [attr.href]=\"item.url ? item.url : item.routerLink\"\n            (click)=\"contextmenuTag(item);navigateToURL(item, $event)\"\n            (contextmenu)=\"contextmenuTag(item);onRightClick(item,$event)\"\n            (mouseover)=\"onRightClick(item,$event)\"\n          ></a>\n\n          <!-- Pre-Login Language Toggle (English/Spanish) Button -->\n          <button\n            [attr.lang]=\"item.locale == 'es_US' ? 'en' : 'es'\"\n            *ngIf=\"item.id === 'butlerEspanol' && item.locale===locale && isMobile\"\n            [innerHtml]=\"item.title\"\n            class=\"main-links langBtn\"\n            attr.data-target=\"#modal{{ i }}\"\n            [attr.aria-label]=\"item.locale == 'es_US' ? 'Click to change page language to English' : 'Haz clic para cambiar la p\u00E1gina al espa\u00F1ol'\"\n            (click)=\"onLangBtnClick(item)\"\n          ></button>\n\n          <!-- Desktop Dropdown + Mobile Submenu Container -->\n          <div\n            class=\"subMenuMainContainer\"\n            *ngIf=\"!item.routerLink && !item.url\"\n          >\n            <div\n              #subMenuGroups\n              class=\"subMenuGroupParent\"\n              [id]=\"item.id + 'subGroup' + i\"\n              *ngIf=\"item.navigationItems && item.navigationItems.length\"\n              [ngClass]=\"{ highlight: isClose, topNavDropdown: !isMobile }\"\n              (mouseover)=\"hoveredTab = i;\"\n              (mouseleave)=\"hoveredTab = -1;\"\n              (keyup.escape)=\"onEscapePress($event, item, i)\"\n            >\n              <!-- Flex container for dropdown/submenu -->\n              <div [ngClass]=\"isMobile ? 'flexColumnContainer' : 'flexContainer'\">\n                <!-- Mobile Submenu Navigation Title -->\n                <div\n                  class=\"subNavtitleMain\"\n                  *ngIf=\"isMobile\"\n                >\n                  <a\n                    tabindex=\"0\"\n                    [id]=\"item.id + 'mainAnchors' + i\"\n                    [attr.aria-label]=\"'Close ' + item.title + ' Menu'\"\n                    (click)=\"showSubMenu ? nvdaFunction(item, i, false) : closeSideNav($event, item, i)\"\n                    (keydown.enter)=\"nvdaFunction(item, i, false)\"\n                    class=\"subNavTitle\"\n                  >\n                    {{ item.title }}\n                  </a>\n                </div>\n\n                <!-- Mobile Explore All Products & Offers -->\n                <ng-container *ngIf=\"isMobile && item.id == 'expProducts' && easydealsexp\">\n                  <a\n                    (click)=\"exploretest(easydealsObj, $event);contextmenuTag(easydealsObj)\"\n                    class=\"ng-star-inserted btn btn-secondary easydealsmobile\"\n                    [attr.href]=\"easydealsObj.url ? easydealsObj.url : easydealsObj.routerLink\"\n                    [innerHtml]=\"easydealsObj.title\"\n                    (contextmenu)=\"onRightClick(easydealsObj,$event);contextmenuTag(easydealsObj)\"\n                    (mouseover)=\"onRightClick(easydealsObj,$event)\"\n                  >\n                  </a>\n                </ng-container>\n\n                <!-- Child Nav Group component - contains the navigation links -->\n                <child-nav-group3\n                  [userLoggedIn]=\"isUserLoggedIn\"\n                  *ngFor=\"let childNavGroup of item.navigationItems;let submenuIndex = index\"\n                  [childNavGroup]=\"childNavGroup\"\n                  [isMobile]=\"isMobile\"\n                  (childLinkClicked)=\"resetMobileMenu()\"\n                  (routerLinkClicked)=\"routerCall($event,submenuIndex,i)\"\n                  [newTagCitiStrata]=\"newTagCitiStrata\"\n                  [newTagCitiStrataCardsBenefits]=\"newTagCitiStrataCardsBenefits\"\n                  [newTagCitiAaAdVantageGlobeMasterCard]=\"newTagCitiAaAdVantageGlobeMasterCard\"\n                  [isExploreProducts]=\"item.id === 'expProducts'\"\n                  class=\"childNavGroup\"\n                  [ngStyle]=\"{ display: childNavGroup.show ? (isMobile ? 'block' : 'flex') : 'none' }\"\n                ></child-nav-group3>\n              </div>\n\n              <!-- Desktop Explore All Products & Offers -->\n              <ng-container *ngIf=\"item.id == 'expProducts' && !isMobile && easydealsexp\">\n                <a\n                  (click)=\"exploretest(easydealsObj, $event);contextmenuTag(easydealsObj)\"\n                  [attr.href]=\"easydealsObj.url ? easydealsObj.url : easydealsObj.routerLink\"\n                  (contextmenu)=\"onRightClick(easydealsObj,$event);contextmenuTag(easydealsObj)\"\n                  (mouseover)=\"onRightClick(easydealsObj,$event)\"\n                  class=\"ng-star-inserted easydeals\"\n                >\n                {{easydealsObj.title}}\n                <span class=\"easy-deals-icon\"></span>\n                </a>\n              </ng-container>\n            </div>\n          </div>\n        </li>\n      </ng-container>\n    </ul>\n  </div>\n\n  <div id=\"navigationRight\">\n    <!-- How can we help? Button -->\n    <button\n      *ngIf=\"!type && showHowCanWeHelp\"\n      type=\"button\"\n      name=\"how can we help button\"\n      class=\"main-links topNavButton howCanWeHelpButton {{ locale }}\"\n      (click)=\"toggleSearch($event)\"\n      (focusin)=\"mobileCheck($event)\"\n    >\n      {{ howCanWeHelpPost }}\n    </button>\n    <!-- Border between How can we help? and Sign On/Off buttons -->\n    <span\n      id=\"Howline\"\n      *ngIf=\"(!type && showHowCanWeHelp) && (showSignOn || (signOffObj && signOffObj.show))\"\n    ></span>\n\n    <!-- Sign Off Button -->\n    <a\n      *ngIf=\"signOffObj && signOffObj.show\"\n      [id]=\"signOffObj.id + 'mainAnchor'\"\n      class=\"main-links topNavButton\"\n      tabindex=\"0\"\n      [innerHtml]=\"signOffObj.title\"\n      (click)=\"deleteSPBSforSSRContainer(signOffObj)\"\n      (keydown.enter)=\"deleteSPBSforSSRContainer(signOffObj)\"\n      [attr.target]=\"signOffObj.target\"\n    ></a>\n\n    <!-- Sign On Button -->\n    <a\n      *ngIf=\"!isUserLoggedIn && showSignOn\"\n      role=\"button\"\n      [id]=\"isMobile ? 'signOnMobileALink' : 'signOnFocus'\"\n      class=\"main-links topNavButton\"\n      [ngClass]=\"{ signOnActive: homepageSignOn }\"\n      tabindex=\"0\"\n      [attr.aria-label]=\"homepageSignOn ? 'Close' : 'SignOn'\"\n      [innerHtml]=\"homepageSignOn ? '' : '&nbsp;'+ signOnWording + '&nbsp;'\"\n      (click)=\"signOnClick()\"\n      (keypress)=\"onSignonPress($event)\"\n    ></a>\n  </div>\n</div>\n\n<citi-nav-search [brandingConfig]=\"bannerConfig\"></citi-nav-search>", styles: [":host{overflow-x:hidden}a:focus{outline:-webkit-focus-ring-color auto 5px!important;outline-offset:-2px}.blueTopNavTheme{--navigation-bg-color: #F0F5F7;--navigation-hover-color: #5E676B;--text-color: #04208F;--text-hover-color: #4400CC;--header-color: #5E676B;--mobile-menu-color: #04208F;--mobile-button-text-color: #5E676B;--search-border-color: #5E676B;--blue-chevi-position: -105px -89px;--blue-search-position: -22px -83px;--blue-menu-open: -536px -72px;--blue-menu-close: -688px -72px}.goldTopNavTheme{--navigation-bg-color: #84682E;--navigation-hover-color: #056DAE}.priorityTopNavTheme{--navigation-bg-color: #091022;--navigation-hover-color: #0E2A48}.cpcTopNavTheme{--navigation-bg-color: #281814;--navigation-hover-color: #84682E}.privatebankingTopNavTheme,.cpbTopNavTheme{--navigation-bg-color: #0E0E0E;--navigation-hover-color: #666666}.navigationParent{width:100%;margin:0 auto;height:46px;position:relative;box-shadow:0 1px 10px #0000001f;background-color:var(--navigation-bg-color);display:flex;justify-content:space-between;white-space:nowrap}@media screen and (max-width: 1120px){.navigationParent{height:50px;padding:0}}#navigationRight{display:flex;padding-right:40px}@media screen and (max-width: 1120px){#navigationRight{padding-right:16px}}@media screen and (max-width: 400px){#navigationRight{padding-right:0}}#navigationRight .main-links{text-decoration:none;cursor:pointer;margin-left:-1px}@media screen and (max-width: 1120px){#navigationRight .main-links:hover,#navigationRight .main-links:focus{background-color:var(--navigation-hover-color);color:#fff}}.nav-bar-main-ul{margin-top:0;margin-bottom:1rem;padding-left:2rem}.nav-bar-main-ul a{text-decoration:none}@media screen and (max-width: 1120px){.nav-bar-main-ul{margin-top:-7px;width:100%;flex-direction:column}.nav-bar-main-ul .main-links{padding:0 56px;color:var(--text-color, #333);line-height:40px;position:relative;top:9%}}.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI #butlerATMmainAnchor5{display:none}@media screen and (max-width: 1119.9px){.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI #butlerATMmainAnchor5{display:block}}@media screen and (max-width: 1120px){.preLogin .nav-bar-main-ul{display:flex;padding-left:0;z-index:2;overflow-x:hidden;min-height:1000px;background:transparent}}.postLogin .nav-bar-main-ul{padding:0 0 0 20px}@media screen and (max-width: 1120px){.postLogin .nav-bar-main-ul{padding-top:20px;padding-left:0;overflow:hidden;background:#fff;height:560px;z-index:1}}.mainListItem{list-style:none}@media screen and (max-width: 1120px){.preLogin .mainListItem{border-bottom:5px solid #eee;height:56px;background-color:#fff;margin:-2px}}.main-links{display:block;padding:9px 20px 0;color:var(--text-color, #FFFFFF);line-height:30px;font-family:Interstate_Regular,sans-serif;font-size:inherit;height:100%;cursor:pointer}@media screen and (min-width: 1120px){.main-links:hover,.main-links:focus{background-color:var(--navigation-hover-color);color:#fff}}.langBtn{border:0;color:var(--mobile-button-text-color, #056dae)!important;background-color:transparent;text-align:left;width:100%;top:0!important}.subMenuMainContainer{display:block;position:relative}@media screen and (max-width: 1120px){.subMenuMainContainer{position:absolute;z-index:9;width:100%;top:0}}.subMenuGroupParent{display:none;background:#fff;z-index:1;position:absolute;width:auto;left:0;box-shadow:0 2px 7px 2px #00000020}@media screen and (max-width: 1120px){.subMenuGroupParent{position:static;box-shadow:none;padding-left:0}}@media screen and (max-width: 1120px){.mobileRightChevron:after{content:\"\";background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:-105px -89px;background-repeat:no-repeat;font-size:18px;position:absolute;top:10px;right:15px;width:20px;height:20px}}.flexContainer{display:flex;padding:16px 20px 0}.flexColumnContainer{position:relative;margin-top:0;background:#fff;min-height:450px}.mobileMenuActiveBg{background:var(--mobile-menu-color, #056dae);background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg)!important;background-position:-764px -72px!important}.highlight{right:auto;display:none!important}.menuLinkMobile{display:inline-block;width:58px;height:100%;margin:0;border-bottom:none;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:var(--blue-menu-open, -612px -72px);background-repeat:no-repeat}@media screen and (max-width: 280px){.menuLinkMobile{padding:0;width:46px}}.signOnActive{width:73.3px;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-repeat:no-repeat;background-position:var(--blue-menu-close, -764px -72px)}.signOnActive:hover{background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-repeat:no-repeat;background-position:-764px -72px}.signOnActive:focus:not(:hover){background-color:transparent!important}@media screen and (min-width: 1120px) and (max-width: 1280px){button.en_US{font-size:0px!important}}@media screen and (min-width: 1120px) and (max-width: 1400px){button.es_US{font-size:0px!important}}.howCanWeHelpButton{display:flex;align-items:center;padding:11px 15px 11px 17px;background-color:var(--navigation-bg-color);border:none;margin-right:-1px}.howCanWeHelpButton:before{content:\"\";width:24px;height:24px;margin-right:10px;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:var(--blue-search-position, -478px -83px);background-repeat:no-repeat}.howCanWeHelpButton:hover+#Howline,.howCanWeHelpButton:focus+#Howline{visibility:hidden}.howCanWeHelpButton:hover:before,.howCanWeHelpButton:focus:before{filter:brightness(0) invert(1)}.howCanWeHelpButton:focus{outline:-webkit-focus-ring-color auto 5px!important}@media screen and (max-width: 280px){.howCanWeHelpButton{right:68px}.howCanWeHelpButton::ng-deep button{padding:11px 9px 0 0;font-size:15px}.howCanWeHelpButton::ng-deep button:before{margin-right:1px}}@media screen and (max-width: 360px){.howCanWeHelpButton{font-size:11px!important}}@media only screen and (min-device-width: 568px) and (max-device-width: 1120px){.howCanWeHelpButton{padding:0 20px!important}}#Howline{border-right:1px solid var(--search-border-color, #fff);margin:9px 0}.subNavtitleMain{width:90%;border-bottom:1px solid #eee;height:4em;margin-left:21px}.subNavTitle{position:absolute;left:52px;color:var(--mobile-button-text-color, #333);top:19px;width:90%;padding-bottom:8px;font-weight:600;cursor:pointer;font-family:Interstate_Light,sans-serif}.subNavTitle:hover,.subNavTitle:focus{color:var(--mobile-button-text-color, #333)}.subNavTitle:before{content:\"\";background-image:url(/citi-branding-assets/images/chevronLeft.svg);background-repeat:no-repeat;position:absolute;top:5px;left:-33px;width:20px;height:20px}.closeSideNav{display:block;width:100%;height:100%;z-index:9;position:absolute;transform:translate(100%);transition:.5s ease-in}.openSideNav{display:block;width:100%;height:100%;z-index:9;position:absolute;transform:translate(0);transition:.5s ease-in}.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI a{color:var(--mobile-button-text-color, #056dae)}@media screen and (max-width: 1120px){.preLogin .nav-bar-main-ul ::ng-deep #butlerATMMainLI a:after{display:none}}.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .subMenuMainContainer{position:absolute!important}@media screen and (min-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .subMenuMainContainer{left:5%}}@media screen and (min-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .child-nav-group3{display:flex;flex-direction:column;width:auto!important}}@media screen and (max-width: 1119.9px){.postLogin .nav-bar-main-ul ::ng-deep #expProductsMainLI .child-nav-group3 .subMenuGroupTitle{line-height:4em;padding-left:8%;border-bottom:1px solid #eee;margin-left:15px;margin-right:26px}}.postLogin .nav-bar-main-ul ::ng-deep #profilesNavMainLI{display:none}.postLogin .nav-bar-main-ul ::ng-deep #profilesNavMainLI #profilesNavmainAnchor5{color:var(--mobile-button-text-color, #333)!important}@media screen and (max-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #profilesNavMainLI{display:block}}.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI{display:none}.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI a{color:var(--mobile-button-text-color, #333)!important}.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI a:after{display:none}@media screen and (max-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #ATMNavMainLI{display:block}}@media screen and (min-width: 1120px){.postLogin .nav-bar-main-ul ::ng-deep #pntMainLI .subMenuGroupParent .child-nav-group3{display:flex;flex-direction:column}}@media screen and (min-width: 1120px) and (-ms-high-contrast: none),(-ms-high-contrast: active){.postLogin .nav-bar-main-ul ::ng-deep #pntMainLI .subMenuGroupParent{min-height:310px}}.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a{padding-right:40px}@media screen and (min-width: 1120px){.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a:after,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:after{content:\"\";background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-position:var(--blue-chevi-position, -413px -88px);background-repeat:no-repeat;font-size:18px;position:absolute;top:17px;margin-left:9px;width:20px;height:20px}.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a:hover:after,.preLogin .nav-bar-main-ul ::ng-deep #navOpenAccMainLI a:focus:after,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:hover:after,.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:focus:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:hover:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:focus:after{filter:brightness(0) invert(1)}}@media screen and (max-width: 1119.9px){.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a{text-align:center}.postLogin .nav-bar-main-ul ::ng-deep #openAccPostMainLI a:after,.postLogin .nav-bar-main-ul ::ng-deep #checkPersonalLoanMainLI a:after{display:none}}.mobileButtonIcon{position:absolute;background-repeat:no-repeat;z-index:1;object-fit:none;width:45px;height:45px}.preLogin .mobileButtonIcon{padding-top:9px;padding-left:15px}.postLogin .mobileButtonIcon{padding-left:16px;padding-top:8px}.blueTopNavTheme #butlerATMMainLI img{object-position:-170px -19px}#butlerATMMainLI img{object-position:-170px -95px}#profilesNavMainLI img{object-position:-94px -20px}#ATMNavMainLI img{object-position:-170px -19px}.blueTopNavTheme #butlerEspanolMainLI img{object-position:-248px -18px}#butlerEspanolMainLI img{object-position:-248px -94px}.easydeals{display:inline-flex;align-items:center;float:right;font-weight:700;margin-right:30px;padding-right:15px;padding-bottom:22px;color:var(--text-color, #056dae)}.easydeals:active{box-shadow:none}.easydeals .easy-deals-icon{display:inline-block;background-image:url(/CBOL/IA/Angular/assets/Citi_Icon_Sprite_Nav_v2.svg);background-repeat:no-repeat;background-position:var(--blue-chevi-position, -105px -89px);width:8px;height:14px;margin-left:6px}.blueTopNavTheme .easydeals:hover,.blueTopNavTheme .easydeals:focus{filter:brightness(0) saturate(100%) invert(13%) sepia(96%) saturate(7460%) hue-rotate(266.5deg) brightness(73%) contrast(130%)}.easydealsmobile{padding:0 0 0 8%;color:var(--text-color, #056dae);font-weight:600;margin-left:15px;margin-right:26px;line-height:4em;width:95%;border-bottom:1px solid #eee}.easydealsmobile:active{box-shadow:none}.easydealsmobile:hover,.easydealsmobile:focus{color:var(--text-hover-color, #034c81);text-decoration:underline}@media screen and (min-width: 1120px){.topNavTabs{border-radius:8px 8px 0 0;height:46px}}.topNavButton{border-radius:8px}.topNavDropdown{border-radius:0 0 8px 8px;clip-path:inset(0px -10px -10px -10px);-webkit-clip-path:inset(0px -10px -10px -10px)}@media screen and (min-width: 1120px){.childNavGroup{padding:0 40px 0 0}.childNavGroup:last-child{padding-right:0}}@media screen and (max-width: 1120px){.childNavGroup:nth-child(2){padding-top:12px}}@media screen and (min-width: 1120px){.topNavHoveredState{background-color:var(--navigation-hover-color);color:#fff!important}}\n"] }]
        }], ctorParameters: () => [{ type: LayoutsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$1.StorageService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i3$1.TMXService }, { type: i4.SiteCatalystService }, { type: BrandingService }, { type: BrandingMapService }, { type: BrandingEntitlementService }, { type: i3$1.AuthorizationService }, { type: i3.Router }, { type: i0.Renderer2 }, { type: i6.HttpService }, { type: i1$1.TaggingService }, { type: BrandingTaggingService }, { type: i1$1.AppConfigService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }], propDecorators: { langBtnClicked: [{
                type: Output
            }], navBarMainUl: [{
                type: ViewChild,
                args: ['navBarMainUl']
            }], menuIconMobile: [{
                type: ViewChild,
                args: ['menuIconMobile']
            }], subMenuGroups: [{
                type: ViewChildren,
                args: ['subMenuGroups']
            }], brandingConfig: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['window:click', ['$event']]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.tab', ['$event']]
            }] } });
function routerCall(val) {
    throw new Error('Function not implemented.');
}

class SmartBannerComponent {
    get isDevice() {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }
    // #region
    // #region ========== Constructor / Lifecycle Hooks ========== //
    constructor(_modalSharedService, _taggingService) {
        this._modalSharedService = _modalSharedService;
        this._taggingService = _taggingService;
        this.isCitiMobile = false;
        /**
         * @property closeIcon
         * @description emits when the close button is clicked
         */
        this.closeIcon = new EventEmitter();
        /**
         * @property useChange
         * @description emits when the Use button is clicked
         * @twoway false.
         */
        this.useChange = new EventEmitter();
    }
    ngOnInit() {
        this.sub$ = this._modalSharedService.dialogState$.subscribe(isOpen => {
            this.isCitiMobile = isOpen;
        });
        if (this.isDevice) {
            this._taggingService.triggerPageTagging('nonicms_content', true, '648aEnableCustomSmartBannerDisplayed');
        }
    }
    // #region
    // #region ========== Public Methods ========== //
    onGoClick() {
        this._modalSharedService.openDialog();
        this._taggingService.triggerEventTagging('nonicms_content', '648a2EnableCustomSmartBannerCTAClicked');
        this.useChange.emit();
    }
    onCloseSmartBanner() {
        this._taggingService.triggerEventTagging('nonicms_content', '648a2EnableCustomSmartBannerCTACloseIconClicked');
        this.closeIcon.emit();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartBannerComponent, deps: [{ token: i1$1.ModalSharedService }, { token: i1$1.TaggingService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SmartBannerComponent, isStandalone: false, selector: "citi-smart-banner", inputs: { smartBannerContent: "smartBannerContent", deviceRating: "deviceRating" }, outputs: { closeIcon: "closeIcon", useChange: "useChange" }, ngImport: i0, template: `
    <div role="banner" class="smart-banner">
      <div class="close-icon-wrap">
        <button
          class="icon-btn"
          type="button"
          aria-label="close"
          (click)="onCloseSmartBanner()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="m12.787 12 9.05-9.05a.557.557 0 0 0-.787-.787L12 11.213l-9.05-9.05a.557.557 0 0 0-.787.787l9.05 9.05-9.05 9.05a.557.557 0 0 0 .787.787l9.05-9.05 9.05 9.05a.557.557 0 0 0 .787-.787L12.787 12Z"
              fill="#fff"
            ></path>
          </svg>
        </button>
      </div>
      <div class="citi-logo-wrap">
        <img
          src="/CBOL/IA/Angular/assets/smart-banner-citiLogo.svg"
          alt="citi logo"
        />
      </div>
      <div class="banner-content-wrap">
        <div class="banner-header" role="heading" aria-level="1">
          {{ smartBannerContent?.smartBannerTitle }}
        </div>
        <div class="banner-content">
          <p class="paragraph">
            Millions use our app, rating it
            <ng-container>{{ deviceRating }}</ng-container> stars. Try it today
            to see why.
          </p>
        </div>
      </div>
      <div>
        <button class="go-btn" type="button" (click)="onGoClick()">
          Go
        </button>
      </div>
    </div>
  `, isInline: true, styles: [".smart-banner{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:center;height:76px;padding:8px 16px;background-color:#333;gap:8px}.close-icon-wrap{width:20px;height:20px}.close-icon-wrap .icon-btn{border:none;background-color:inherit;padding:0;width:20px;height:20px}.citi-logo-wrap img{width:64px;height:32px;flex-shrink:0}.banner-content-wrap{align-self:stretch}.banner-content-wrap .banner-header{color:var(--basic-colors-zero, #fff);font-size:16px;font-style:normal;font-weight:700;line-height:24px}.banner-content-wrap .paragraph{color:var(--basic-colors-one, #fff);font-size:12px;font-style:normal;font-weight:300;line-height:18px;margin:0}.go-btn{height:40px;min-width:60px;padding:8px 12px;border-radius:8px;justify-content:center;align-items:center;background-color:#fff;color:#056dae;border:1px solid;font-size:16px;font-style:normal;font-weight:700;line-height:24px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SmartBannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-smart-banner', standalone: false, template: `
    <div role="banner" class="smart-banner">
      <div class="close-icon-wrap">
        <button
          class="icon-btn"
          type="button"
          aria-label="close"
          (click)="onCloseSmartBanner()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="m12.787 12 9.05-9.05a.557.557 0 0 0-.787-.787L12 11.213l-9.05-9.05a.557.557 0 0 0-.787.787l9.05 9.05-9.05 9.05a.557.557 0 0 0 .787.787l9.05-9.05 9.05 9.05a.557.557 0 0 0 .787-.787L12.787 12Z"
              fill="#fff"
            ></path>
          </svg>
        </button>
      </div>
      <div class="citi-logo-wrap">
        <img
          src="/CBOL/IA/Angular/assets/smart-banner-citiLogo.svg"
          alt="citi logo"
        />
      </div>
      <div class="banner-content-wrap">
        <div class="banner-header" role="heading" aria-level="1">
          {{ smartBannerContent?.smartBannerTitle }}
        </div>
        <div class="banner-content">
          <p class="paragraph">
            Millions use our app, rating it
            <ng-container>{{ deviceRating }}</ng-container> stars. Try it today
            to see why.
          </p>
        </div>
      </div>
      <div>
        <button class="go-btn" type="button" (click)="onGoClick()">
          Go
        </button>
      </div>
    </div>
  `, styles: [".smart-banner{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:center;height:76px;padding:8px 16px;background-color:#333;gap:8px}.close-icon-wrap{width:20px;height:20px}.close-icon-wrap .icon-btn{border:none;background-color:inherit;padding:0;width:20px;height:20px}.citi-logo-wrap img{width:64px;height:32px;flex-shrink:0}.banner-content-wrap{align-self:stretch}.banner-content-wrap .banner-header{color:var(--basic-colors-zero, #fff);font-size:16px;font-style:normal;font-weight:700;line-height:24px}.banner-content-wrap .paragraph{color:var(--basic-colors-one, #fff);font-size:12px;font-style:normal;font-weight:300;line-height:18px;margin:0}.go-btn{height:40px;min-width:60px;padding:8px 12px;border-radius:8px;justify-content:center;align-items:center;background-color:#fff;color:#056dae;border:1px solid;font-size:16px;font-style:normal;font-weight:700;line-height:24px}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ModalSharedService }, { type: i1$1.TaggingService }], propDecorators: { smartBannerContent: [{
                type: Input
            }], deviceRating: [{
                type: Input
            }], closeIcon: [{
                type: Output
            }], useChange: [{
                type: Output
            }] } });

class HeaderComponent {
    constructor(_appConfigService, brandingService, _ngZone, _router, _modalSharedService, cd, _smartBannerSharedService, _taggingService, _contentStorageService, _contentService, _window, _isSSRApp, _platformId, _document, _sessionStorage) {
        this._appConfigService = _appConfigService;
        this.brandingService = brandingService;
        this._ngZone = _ngZone;
        this._router = _router;
        this._modalSharedService = _modalSharedService;
        this.cd = cd;
        this._smartBannerSharedService = _smartBannerSharedService;
        this._taggingService = _taggingService;
        this._contentStorageService = _contentStorageService;
        this._contentService = _contentService;
        this._window = _window;
        this._isSSRApp = _isSSRApp;
        this._platformId = _platformId;
        this._document = _document;
        this._sessionStorage = _sessionStorage;
        this.hideSmartBanner = false;
        this.hideBanner2 = true;
        this.isMobile = false;
        this.isCitiMobile = false;
        this.showHeader = true;
        this.isPreLogin = true;
        this.showLangModal = false;
        this.isBrowser = isPlatformBrowser(this._platformId);
        /* added below code for performance improvement GBC-4240 */
        if (this.isBrowser && this._appConfigService.getBusinessId() !== 'USMKT') {
            /* const headElement = this._document.querySelector('head');
            const bootstrapScript = this._document.createElement('script');
            const src =
              window.location.hostname === 'online.citi.com' ||
                window.location.hostname === 'www.citi.com'
                ? 'https://nexus.ensighten.com/citi/na_prod/Bootstrap.js'
                : 'https://nexus.ensighten.com/citi/na_stage/Bootstrap.js';
            bootstrapScript.setAttribute('src', src);
            bootstrapScript.setAttribute('async', 'true');
            bootstrapScript.setAttribute('defer', 'true');
            headElement.appendChild(bootstrapScript); */
            this.loadExternalLibrary();
        }
        /* GBC-4240 end */
        // Intialize branding config for SSR client to avoid blank page on homepage
        if (this._isSSRApp && this.isBrowser) {
            this.brandingConfig = ssrnewbase.data;
            console.log('branding intialized on ssr client in header.component', this.brandingConfig);
        }
    }
    async loadExternalLibrary() {
        try {
            const syncLoadLinks = {
                bootstrap: (window.location.hostname === 'online.citi.com' || window.location.hostname === 'www.citi.com') ? 'https://nexus.ensighten.com/citi/na_prod/Bootstrap.js' : 'https://nexus.ensighten.com/citi/na_stage/Bootstrap.js',
                tagging: window.location.hostname === 'online.citi.com' ? 'https://online.citi.com/CBOL/taggingTransformation/tagging.min.js' : (window.location.hostname.includes('online.citi.com') && window.location.origin === this._appConfigService.getcsrHostName()) ? this._appConfigService.getcsrHostName() + '/CBOL/taggingTransformation/tagging.min.js' : ''
            };
            let scripts = [
                syncLoadLinks.bootstrap,
                syncLoadLinks.tagging,
            ];
            await Promise.all(scripts.map((url, index) => this.loadScript(url, index)));
            window.dispatchEvent(new Event('scripts-loaded'));
        }
        catch (e) {
            console.info('external library load failed.');
        }
    }
    loadScript(url, index) {
        return new Promise((resolve, reject) => {
            const scriptExist = this._document.querySelector(`#external-${index}`);
            if (scriptExist) {
                return;
            }
            ;
            // Create the script
            const script = this._document.createElement('script');
            script.src = url;
            script.id = 'external-' + index;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = (e) => reject(e);
            this._document.getElementsByTagName('head')[0].appendChild(script);
        });
    }
    get coMobile() {
        this._isMobile = this._window && this._window.innerWidth < 1440;
        return this._isMobile;
    }
    ngOnInit() {
        this.currentPath = this.getPath();
        this.getShareData();
        // Get data from the branding service, ssr skelheader logo set
        this.staticSkelHeaderCitiLogoImgPath =
            '/CBOL/IA/Angular/assets/citiredesign.svg';
        this.brandingService.dataUpdate.subscribe(data => {
            this.detectMobile();
            this.brandingConfig = data;
            // enable header toggling logic via branding service
            if (this.brandingConfig['header'].hasOwnProperty('show')) {
                this.showHeader = this.brandingConfig.header.show;
            }
            if (this.brandingConfig.header.banner.buttonsData) {
                for (const obj of this.brandingConfig.header.banner.buttonsData) {
                    if (obj.routerLink && obj.url) {
                        if (this._isSSRApp) {
                            obj.routerLink = '';
                        }
                        else {
                            obj.url = '';
                        }
                    }
                }
            }
            console.log('branding data received from branding service inside headr.component', this.brandingConfig);
        });
        // This is implemented for Cobranding Microsite - for Change in header size.
        this.brandingService.headerSize.subscribe(val => {
            this.showHeaderSize = val;
        });
        this.prePostLogin();
        /* Subscribe to any future QuickAction copy updates from the smartBanner service */
        this._smartBannerSharedService.qAcontentObs$.subscribe(data => {
            this.updateSmartBannerData();
        });
    }
    ngOnDestroy() {
        this._smartBannerSharedService.qAcontentObs$.unsubscribe();
    }
    prePostLogin() {
        if (sessionStorage.getItem('sessionPostBrandingStorage') &&
            sessionStorage.getItem('sessionPostBrandingStorage') !== 'null' &&
            sessionStorage.getItem('sessionPostBrandingStorage') !== null) {
            this.isPreLogin = false;
        }
        else {
            this.isPreLogin = true;
        }
    }
    skipToMain() {
        const firstHeader = document
            .getElementById('routerOutlet')
            .nextElementSibling.querySelectorAll('h1, h2')[0];
        firstHeader.setAttribute('id', 'mainContent');
        firstHeader.setAttribute('tabindex', '-1');
        firstHeader.addEventListener('focusout', function (event) {
            firstHeader.removeAttribute('tabindex');
        });
        let route = this._router.url;
        if (route.includes('#mainContent')) {
            route = route.replace('#mainContent', '');
        }
        this.skipLinkPath = '/US/ag' + route + '#mainContent';
    }
    // Added this method in order to overcome NVDA issue related to Skip to Main Content Link for angular pages.
    skipToMainContent() {
        let route = this._document.location.href;
        if (route.includes('#maincontent')) {
            route = route.replace('#maincontent', '');
        }
        this.skipLinkPath = route + '#maincontent';
    }
    getShareData() {
        this.sub$ = this._modalSharedService.dialogState$.subscribe(isOpen => {
            this.isCitiMobile = isOpen;
        });
        this.sub$ = this._smartBannerSharedService.smartBannerState$.subscribe(isOpen => {
            this.hideSmartBanner = isOpen;
        });
        this.sub$ = this._smartBannerSharedService.bannerState$.subscribe(isHide => {
            this.hideBanner2 = isHide;
        });
    }
    /*  Execute updateSmartBannerData when session is postLogin and when smartBannerContent is undefined   */
    getSmartBanner() {
        this.updateSmartBannerData();
        return (this.hideBanner2 = false, this.hideSmartBanner = true);
    }
    /* To update the smartBannerContent when data is available */
    updateSmartBannerData() {
        this.prePostLogin();
        if (this.isPreLogin !== true) {
            const appId = 'quickaction';
            this.smartBannerContent = this._contentStorageService.get(appId, 'copy', 'SmartBanner');
            this.ratingAndroid = this.smartBannerContent?.ratingAndroid;
            this.ratingIOS = this.smartBannerContent?.ratingIOS;
        }
    }
    getBanner2() {
        return (this.hideBanner2 = true, this.hideSmartBanner = false);
    }
    get isEligibleRout() {
        const suppressUrl = [
            '/US/ag/reward/citishopenroll',
            '/US/ag/reward/citishopenroll/card',
            '/US/ag/reward/citishopenroll/card/tandc'
        ];
        // tslint:disable-next-line:prefer-const
        let currentPageUrl = this._window.location.href;
        return suppressUrl.some(url => currentPageUrl.includes(url));
    }
    get isSmartBanner() {
        const sessionParams = this._sessionStorage.getItem('sessionPostBrandingStorage');
        const SPBS = JSON.parse(sessionParams);
        const customersDataString = sessionStorage.getItem('smartBanner');
        return ((SPBS?.featureFlags?.ff_smartBanner === 'Y') && (customersDataString == null) && (this.isDevice) && (!this.isEligibleRout));
    }
    get isDevice() {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }
    get isAndroid() {
        return /(android)/i.test(navigator.userAgent);
    }
    get isIOS() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    detectMobile() {
        if (this.isSmartBanner) {
            this.getSmartBanner();
        }
        else {
            this.getBanner2();
        }
    }
    deviceRating() {
        let rating;
        switch (this.isDevice) {
            case this.isIOS:
                rating = this.ratingIOS;
                break;
            case this.isAndroid:
                rating = this.ratingAndroid;
                break;
            default:
                rating = Math.min(this.ratingIOS, this.ratingAndroid);
        }
        return rating;
    }
    openCitiMobileModal() {
        this._modalSharedService.openDialog();
        this.cd.detectChanges();
        this._taggingService.triggerPageTagging('nonicms_content', true, '381hDashboard2Modal');
    }
    closeBanner() {
        sessionStorage.setItem('smartBanner', 'check');
        this.hideSmartBanner = false;
        this.hideBanner2 = true;
    }
    changeLocale(_locale, item) {
        const maxAge = 60 * 60 * 24 * 365;
        const path = '/';
        const domain = '.citi.com';
        this._document.cookie = `locale=${_locale};Domain=${domain};Max-Age=${maxAge}; Path=${path}`;
        if (_locale == 'en_US') {
            if (this._window)
                this._window.location.href = this.currentPath;
        }
    }
    ;
    getPath() {
        if (this._window) {
            let path = this._window.location.pathname;
            let query = this._window.location.search;
            if (query) {
                path += query;
            }
            return path;
        }
        return null;
    }
    onLangBtnClicked(item) {
        this.langItem = item;
        if (this.langItem.speedbump) {
            this.showLangModal = true;
        }
        else if (this.langItem.urlSuffix) {
            this.changeLocale('en_US', item);
        }
        else {
            return;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HeaderComponent, deps: [{ token: i1$1.AppConfigService }, { token: BrandingService }, { token: i0.NgZone }, { token: i3.Router }, { token: i1$1.ModalSharedService }, { token: i0.ChangeDetectorRef }, { token: SmartBannerSharedService }, { token: i1$1.TaggingService }, { token: i6.ContentStorageService }, { token: i6.ContentService }, { token: WINDOW }, { token: IS_SSRENDERED_APP, optional: true }, { token: PLATFORM_ID }, { token: DOCUMENT }, { token: SESSION_STORAGE }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: HeaderComponent, isStandalone: false, selector: "citi-header", ngImport: i0, template: "<a\n  class=\"alternateSkipNav\"\n  aria-live=\"assertive\"\n  [href]=\"skipLinkPath\"\n  (click)=\"skipToMainContent()\"\n  >Skip to Content</a\n>\n<div class=\"header\" *ngIf=\"showHeader\">\n  <div\n    class=\"primary-header\"\n    [ngClass]=\"{ coBranding: !coMobile && showHeaderSize }\"\n  >\n    <citi-banner2\n      *ngIf=\"hideBanner2\"\n      [brandingConfig]=\"brandingConfig\"\n      (langBtnClicked)=\"onLangBtnClicked($event)\"\n    ></citi-banner2>\n\n    <citi-smart-banner\n      *ngIf=\"hideSmartBanner\"\n      [smartBannerContent]=\"smartBannerContent\"\n      [deviceRating]=\"deviceRating()\"\n      (closeIcon)=\"closeBanner()\"\n      (useChange)=\"openCitiMobileModal()\"\n    ></citi-smart-banner>\n\n    <citi-navigation3 [brandingConfig]=\"brandingConfig\" (langBtnClicked)=\"onLangBtnClicked($event)\"></citi-navigation3>\n\n    <citi-modal\n      class=\"cbolui-ddl-pre\"\n      *ngIf=\"langItem && langItem.speedbump\"\n      [primaryButtonText]=\"langItem.speedbump.buttonText ? langItem.speedbump.buttonText : 'Continue'\"\n      [primaryButtonTarget]=\"langItem.speedbump.buttonTarget ? langItem.speedbump.buttonTarget : '_blank'\"\n      [(show)]=\"showLangModal\"\n      [primaryButtonUrl]=\"langItem.speedbump.urlSuffix ? currentPath : langItem.speedbump.url\"\n      (primaryButtonClick)=\"changeLocale('es_US', langItem)\"\n    >\n      <div\n        title=\"{{ langItem.speedbump.header }}\"\n        role=\"heading\"\n        aria-level=\"1\"\n        [attr.lang]=\"langItem.locale == 'es_US' ? 'en' : 'es'\"\n      >{{ langItem.speedbump.header }}</div>\n      <p [innerHtml]=\"langItem.speedbump.copy\"></p>\n    </citi-modal>\n  </div>\n</div>\n <div *ngIf=\"!isBrowser\" class=\"skelheaderssr\">\n  <ng-container>\n    <div class=\"float-container\">\n      <div class=\"flex-container\">\n        <div class=\"flex-child\" style=\"flex-basis: 9%;\">\n          <div\n            class=\"skelheaderlogo skelheaderlogoimg\"\n            tabindex=\"0\"\n            alt=\"\"\n          ></div>\n        </div>\n      </div>\n      <div\n        class=\"loader Skelnavbarssr\"\n        tabindex=\"0\"\n        role=\"progressbar\"\n        aria-busy=\"true\"\n        aria-valuemin=\"0\"\n        aria-valuemax=\"100\"\n        aria-label=\"Content is loading\"\n      ></div>\n    </div>\n  </ng-container>\n</div>\n", styles: [".primary-header{position:relative;z-index:9999}.alternateSkipNav{position:absolute;transform:translateY(-100%);padding:3px}.alternateSkipNav:focus{transform:translateY(0);position:relative!important}.coBranding{max-width:1440px;margin:0 auto}.skelheaderssr{width:100%;height:134px}.skelheaderlogoimg{max-width:88px;max-height:88px}.Skelnavbarssr{width:100%;height:46px;border-radius:0!important}.loader{position:relative;background-color:#ccc;overflow:hidden;border-radius:8px}.loader:after{display:block;content:\"\";position:absolute;width:100%;height:100%;transform:translate(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.4),transparent);animation:loading 2s infinite}@keyframes loading{to{transform:translate(100%)}}.skelheaderlogoimg{width:72px;height:72px}.skelheaderlogo{text-align:center;width:88px;height:88px;float:left;margin-left:40px}.seo-hidden{clip:rect(0px,0px,0px,0px)!important;overflow:hidden;width:0;height:0;opacity:0;position:absolute;outline:0;-webkit-appearance:none}@media screen and (max-width: 989px){.skelheaderlogo{margin-left:0!important}.skelheaderssr{width:100%;height:122px}.skelheaderlogo{text-align:center;width:72px;height:72px}.skelheaderlogoimg{width:72px;height:72px}.Skelnavbarssr{width:100%;height:50px;border-radius:0!important}}@media screen and (max-width: 700px){citi-modal ::ng-deep .modal{top:13%}}@media screen and (min-width: 1024px) and (max-width: 1112px){citi-modal ::ng-deep .modal{margin-top:12%!important}}@media screen and (min-width: 700px) and (max-width: 1112px){::ng-deep .modal-dialog{width:84%!important}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$1.ModalComponent, selector: "citi-modal", inputs: ["scrollable", "htmlContent", "ariaRole", "footerContent", "idStr", "title", "primaryButtonUrl", "primaryButtonTarget", "primaryButtonText", "showCancelButton", "footerProjection", "disablePrimaryButton", "disableCloseButton", "closeOnBgClick", "cancelButtonText", "openerSelector", "show", "closeButtonIdStr"], outputs: ["primaryButtonClick", "secondaryButtonClick", "closeButtonClick", "showChange", "onHide"] }, { kind: "component", type: Banner2Component, selector: "citi-banner2", inputs: ["brandingConfig"], outputs: ["langBtnClicked"] }, { kind: "component", type: Navigation3Component, selector: "citi-navigation3", inputs: ["brandingConfig"], outputs: ["langBtnClicked"] }, { kind: "component", type: SmartBannerComponent, selector: "citi-smart-banner", inputs: ["smartBannerContent", "deviceRating"], outputs: ["closeIcon", "useChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-header', standalone: false, template: "<a\n  class=\"alternateSkipNav\"\n  aria-live=\"assertive\"\n  [href]=\"skipLinkPath\"\n  (click)=\"skipToMainContent()\"\n  >Skip to Content</a\n>\n<div class=\"header\" *ngIf=\"showHeader\">\n  <div\n    class=\"primary-header\"\n    [ngClass]=\"{ coBranding: !coMobile && showHeaderSize }\"\n  >\n    <citi-banner2\n      *ngIf=\"hideBanner2\"\n      [brandingConfig]=\"brandingConfig\"\n      (langBtnClicked)=\"onLangBtnClicked($event)\"\n    ></citi-banner2>\n\n    <citi-smart-banner\n      *ngIf=\"hideSmartBanner\"\n      [smartBannerContent]=\"smartBannerContent\"\n      [deviceRating]=\"deviceRating()\"\n      (closeIcon)=\"closeBanner()\"\n      (useChange)=\"openCitiMobileModal()\"\n    ></citi-smart-banner>\n\n    <citi-navigation3 [brandingConfig]=\"brandingConfig\" (langBtnClicked)=\"onLangBtnClicked($event)\"></citi-navigation3>\n\n    <citi-modal\n      class=\"cbolui-ddl-pre\"\n      *ngIf=\"langItem && langItem.speedbump\"\n      [primaryButtonText]=\"langItem.speedbump.buttonText ? langItem.speedbump.buttonText : 'Continue'\"\n      [primaryButtonTarget]=\"langItem.speedbump.buttonTarget ? langItem.speedbump.buttonTarget : '_blank'\"\n      [(show)]=\"showLangModal\"\n      [primaryButtonUrl]=\"langItem.speedbump.urlSuffix ? currentPath : langItem.speedbump.url\"\n      (primaryButtonClick)=\"changeLocale('es_US', langItem)\"\n    >\n      <div\n        title=\"{{ langItem.speedbump.header }}\"\n        role=\"heading\"\n        aria-level=\"1\"\n        [attr.lang]=\"langItem.locale == 'es_US' ? 'en' : 'es'\"\n      >{{ langItem.speedbump.header }}</div>\n      <p [innerHtml]=\"langItem.speedbump.copy\"></p>\n    </citi-modal>\n  </div>\n</div>\n <div *ngIf=\"!isBrowser\" class=\"skelheaderssr\">\n  <ng-container>\n    <div class=\"float-container\">\n      <div class=\"flex-container\">\n        <div class=\"flex-child\" style=\"flex-basis: 9%;\">\n          <div\n            class=\"skelheaderlogo skelheaderlogoimg\"\n            tabindex=\"0\"\n            alt=\"\"\n          ></div>\n        </div>\n      </div>\n      <div\n        class=\"loader Skelnavbarssr\"\n        tabindex=\"0\"\n        role=\"progressbar\"\n        aria-busy=\"true\"\n        aria-valuemin=\"0\"\n        aria-valuemax=\"100\"\n        aria-label=\"Content is loading\"\n      ></div>\n    </div>\n  </ng-container>\n</div>\n", styles: [".primary-header{position:relative;z-index:9999}.alternateSkipNav{position:absolute;transform:translateY(-100%);padding:3px}.alternateSkipNav:focus{transform:translateY(0);position:relative!important}.coBranding{max-width:1440px;margin:0 auto}.skelheaderssr{width:100%;height:134px}.skelheaderlogoimg{max-width:88px;max-height:88px}.Skelnavbarssr{width:100%;height:46px;border-radius:0!important}.loader{position:relative;background-color:#ccc;overflow:hidden;border-radius:8px}.loader:after{display:block;content:\"\";position:absolute;width:100%;height:100%;transform:translate(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.4),transparent);animation:loading 2s infinite}@keyframes loading{to{transform:translate(100%)}}.skelheaderlogoimg{width:72px;height:72px}.skelheaderlogo{text-align:center;width:88px;height:88px;float:left;margin-left:40px}.seo-hidden{clip:rect(0px,0px,0px,0px)!important;overflow:hidden;width:0;height:0;opacity:0;position:absolute;outline:0;-webkit-appearance:none}@media screen and (max-width: 989px){.skelheaderlogo{margin-left:0!important}.skelheaderssr{width:100%;height:122px}.skelheaderlogo{text-align:center;width:72px;height:72px}.skelheaderlogoimg{width:72px;height:72px}.Skelnavbarssr{width:100%;height:50px;border-radius:0!important}}@media screen and (max-width: 700px){citi-modal ::ng-deep .modal{top:13%}}@media screen and (min-width: 1024px) and (max-width: 1112px){citi-modal ::ng-deep .modal{margin-top:12%!important}}@media screen and (min-width: 700px) and (max-width: 1112px){::ng-deep .modal-dialog{width:84%!important}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.AppConfigService }, { type: BrandingService }, { type: i0.NgZone }, { type: i3.Router }, { type: i1$1.ModalSharedService }, { type: i0.ChangeDetectorRef }, { type: SmartBannerSharedService }, { type: i1$1.TaggingService }, { type: i6.ContentStorageService }, { type: i6.ContentService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }] });

class SomComponent {
    constructor() { }
    set somData(value) {
        this.somContent = value;
    }
    set navDataForSOM(value) {
        console.log(value);
        this.finalSOMdata = value;
        this.finalSOMdata.forEach((som) => {
            console.log("som data down below");
            console.log(som.somData);
        });
    }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SomComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SomComponent, isStandalone: false, selector: "citi-som", inputs: { somData: "somData", navDataForSOM: "navDataForSOM" }, ngImport: i0, template: "<ng-container>\n  <div id=\"main\">\n    <div id=\"content\">\n      <div id=\"imageContainer\">\n        <img\n          src=\"\"\n          alt=\"\"\n          [id]=\"\"\n        >\n      </div>\n      <div id=\"contentContainer\">\n        <h1>{{somContent.som.title}}</h1>\n        <p>{{somContent.som.details}}</p>\n        <a\n          href=\"\"\n          [innerHtml]=\"somContent.som.learnMore\"\n        ></a>\n      </div>\n    </div>\n  </div>\n</ng-container>\n", styles: ["#main{width:100%;height:100%}#main #content{display:flex;flex-direction:column;width:400px}@media screen and (max-with: 1120px){#main #content{flex-direction:row}}#main #content #imageContainer{width:157px;height:98px;background:red}@media screen and (min-width: 1120px){#main #content #imageContainer{width:157px;height:98px}}@media screen and (max-with: 1119.9px){#main #content #imageContainer{width:128px;height:80px}}#main #content #contentContainer{width:94%}@media screen and (max-width: 1119.9px){#main #content #contentContainer{padding-left:31px}}@media screen and (min-width: 1120px){#main #content #contentContainer h1{line-height:3em!important;margin-bottom:0;font-size:20px;color:#002d72}}@media screen and (max-width: 1119.9px){#main #content #contentContainer h1{font-size:16px;color:#002d72;font-family:Interstate_Bold,sans-serif}}@media screen and (min-width: 1120px){#main #content #contentContainer p{font-size:16px;color:#333}}@media screen and (max-width: 1119.9px){#main #content #contentContainer p{display:none}}@media screen and (min-width: 1120px){#main #content #contentContainer a{font-size:14px;color:#056dae}}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SomComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-som', standalone: false, template: "<ng-container>\n  <div id=\"main\">\n    <div id=\"content\">\n      <div id=\"imageContainer\">\n        <img\n          src=\"\"\n          alt=\"\"\n          [id]=\"\"\n        >\n      </div>\n      <div id=\"contentContainer\">\n        <h1>{{somContent.som.title}}</h1>\n        <p>{{somContent.som.details}}</p>\n        <a\n          href=\"\"\n          [innerHtml]=\"somContent.som.learnMore\"\n        ></a>\n      </div>\n    </div>\n  </div>\n</ng-container>\n", styles: ["#main{width:100%;height:100%}#main #content{display:flex;flex-direction:column;width:400px}@media screen and (max-with: 1120px){#main #content{flex-direction:row}}#main #content #imageContainer{width:157px;height:98px;background:red}@media screen and (min-width: 1120px){#main #content #imageContainer{width:157px;height:98px}}@media screen and (max-with: 1119.9px){#main #content #imageContainer{width:128px;height:80px}}#main #content #contentContainer{width:94%}@media screen and (max-width: 1119.9px){#main #content #contentContainer{padding-left:31px}}@media screen and (min-width: 1120px){#main #content #contentContainer h1{line-height:3em!important;margin-bottom:0;font-size:20px;color:#002d72}}@media screen and (max-width: 1119.9px){#main #content #contentContainer h1{font-size:16px;color:#002d72;font-family:Interstate_Bold,sans-serif}}@media screen and (min-width: 1120px){#main #content #contentContainer p{font-size:16px;color:#333}}@media screen and (max-width: 1119.9px){#main #content #contentContainer p{display:none}}@media screen and (min-width: 1120px){#main #content #contentContainer a{font-size:14px;color:#056dae}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { somData: [{
                type: Input
            }], navDataForSOM: [{
                type: Input
            }] } });

class brandingRefreshLoad {
    constructor(brandingService, _sessionStorage, router, route, http) {
        this.brandingService = brandingService;
        this._sessionStorage = _sessionStorage;
        this.router = router;
        this.route = route;
        this.http = http;
        this.browserConfigServiceEndpoint = '/digital/customerEntitlement/browser/branding';
    }
    //other relkated funtion
    getSPBS() {
        let sessionParams = this._sessionStorage
            ? this._sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                if (sessionParams) {
                    return sessionParams;
                }
            }
            catch (err) {
                return false;
            }
        }
    }
    brandingRefreshLoad() {
        return this.http
            .get(this.browserConfigServiceEndpoint, {
            params: {
                entitlementRefresh: true
            }
        })
            .pipe(map((res) => {
            // this.extractSessionPostData(res);
            // this.establishCookiePackage();
            return true;
        }), catchError((err) => {
            const paramMap = {
                tenantId: this.route.snapshot.url,
                errorPage: 'Y'
            };
            this.router.navigate(['/sign-off'], { queryParams: paramMap });
            return throwError(err);
        }));
    }
    debcardact() {
        this.brandingService.onDataReady.subscribe(() => {
            const data = this.brandingService.getData();
            this.sessionParams = this.getSPBS();
            if (this.sessionParams && this.sessionParams?.featureFlags?.ff_retailLimitedAccessLogin === "Y") {
                data.footer.butler.show = false;
                data.footer.navigation.show = false;
                data.footer.badgeNavigation.show = false;
                data.footer.subNavigation.show = false;
                data.footer.subFooter.show = false;
                data.footer.disclaimer.show = false;
                this.brandingService.setData(data);
            }
            else {
                if (Object.keys(data.header).length > 0 && Object.keys(data.footer).length > 0) {
                    data.footer.butler.show = true;
                    data.footer.navigation.show = true;
                    data.footer.badgeNavigation.show = true;
                    data.footer.subNavigation.show = true;
                    data.footer.subFooter.show = true;
                    data.footer.disclaimer.show = true;
                }
                this.brandingService.setData(data);
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: brandingRefreshLoad, deps: [{ token: BrandingService }, { token: SESSION_STORAGE }, { token: i3.Router }, { token: i3.ActivatedRoute }, { token: i6.HttpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: brandingRefreshLoad }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: brandingRefreshLoad, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: BrandingService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i6.HttpService }] });

const SERVICES = [
    BrandingTypeService,
    CobrandingService,
    BrandingMapService,
    BrandingTaggingService,
    BrandingEntitlementService,
    DatePipe
];
const MODULES$1 = [
    CommonModule,
    RouterModule,
    A11yModule,
    Modal,
    CTA,
    Dropdown2,
];
const COMPONENTS$1 = [
    ProfileNavComponent,
    HeaderComponent,
    Banner2Component,
    SmartSearchComponent,
    Navigation3Component,
    ChildNavGroup3Component,
    SomComponent,
    NavSearchComponent,
    SmartBannerComponent
];
class CitiBrandingModule {
    static forRoot() {
        return {
            ngModule: CitiBrandingModule,
            providers: [CobrandingService, BrandingMapService, BrandingTaggingService]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiBrandingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: CitiBrandingModule, declarations: [ProfileNavComponent,
            HeaderComponent,
            Banner2Component,
            SmartSearchComponent,
            Navigation3Component,
            ChildNavGroup3Component,
            SomComponent,
            NavSearchComponent,
            SmartBannerComponent], imports: [CommonModule,
            RouterModule,
            A11yModule,
            Modal,
            CTA,
            Dropdown2], exports: [ProfileNavComponent,
            HeaderComponent,
            Banner2Component,
            SmartSearchComponent,
            Navigation3Component,
            ChildNavGroup3Component,
            SomComponent,
            NavSearchComponent,
            SmartBannerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiBrandingModule, providers: [
            BrandingTypeService,
            DatePipe,
            SESSION_STORAGE_PROVIDER,
            brandingRefreshLoad
        ], imports: [MODULES$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiBrandingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1],
                    declarations: [...COMPONENTS$1],
                    exports: [...COMPONENTS$1],
                    providers: [
                        BrandingTypeService,
                        DatePipe,
                        SESSION_STORAGE_PROVIDER,
                        brandingRefreshLoad
                    ]
                }]
        }] });

class CitiFeedbackComponent {
    constructor() {
        this.icon = 'assets/feedback.png';
        this.showFeedback = true;
    }
    ngOnInit() {
        this.showFeedback = true;
    }
    // Opens the feedback window
    openFeedback(event) {
        OOo.oo_launch(event, 'oo_feedback');
    }
    expandFeedback(event) {
        this.showFeedback = false;
    }
    closeFeedback(event) {
        this.showFeedback = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiFeedbackComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: CitiFeedbackComponent, isStandalone: false, selector: "citi-feedback", ngImport: i0, template: "<!-- <div class=\"feedbackDesktop\" (click)=\"openFeedback($event)\" (keyup.enter)=\"openFeedback($event)\" (mouseleave)=\"closeFeedback($event)\"\n  ariaDescription=\"Opens in new window\">\n  <div class=\"olUp olUpNewIcon\" role=\"complementary\" *ngIf=\"showFeedback\" tabindex='0'>\n    <img alt=\"feedback icon\" [src]='icon' />\n    <div class=\"feedbackText\">Feedback</div>\n  </div>\n  <div class=\"olOver\" *ngIf=\"!showFeedback\">\n    <span>\n      Click here to\n      <br>\n      rate this\n      <br>\n      page\n    </span>\n  </div>\n</div>\n\n<div id=\"feedbackMobile\" class=\"oo_feedback_float \">\n  <a class=\"olUp\" (click)=\"openFeedback($event)\" tabindex=\"0\">Feedback</a>\n</div> -->\n", styles: [".feedback{font:12px Tahoma,Arial,Helvetica,sans-serif;text-align:center;width:80px!important;height:50px!important;border:1px solid #ccc!important;border-radius:7px!important;cursor:pointer!important;background-color:#f5f5f5!important;font-weight:700}img{position:relative;margin-bottom:5px;cursor:pointer}.olUp{text-align:center;position:relative;filter:alpha(opacity=100);opacity:1;transition:opacity .5s;-moz-transition:opacity .5s;-webkit-transition:opacity .5s;-o-transition:opacity .5s;padding-top:6px}.olUpNewIcon{position:fixed;top:61%;right:0;margin-top:60px}.olOver{display:block;height:100%;width:100%;top:0;left:0;filter:alpha(opacity=0);transition:opacity .5s;-moz-transition:opacity .5s;-webkit-transition:opacity .5s;-o-transition:opacity .5s;padding:4px;font-size:11px;border-radius:7px!important;background:#fff}.feedbackText{text-indent:-9999px}@media (max-width: 991px){.feedbackDesktop{display:none}#feedbackMobile{margin:0 -20px!important;cursor:pointer;background:#666}.oo_feedback_float .olUp{background:url(/assets/feedback_plus.png) 2% 6px no-repeat;display:block;font-family:Interstate_Bold;font-size:16px;color:#fff}}@media (min-width: 991.9px){#feedbackMobile{display:none}}@media print{.appbody{min-width:992px}.oo_feedback_float,.olUp{display:none!important}}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiFeedbackComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-feedback', standalone: false, template: "<!-- <div class=\"feedbackDesktop\" (click)=\"openFeedback($event)\" (keyup.enter)=\"openFeedback($event)\" (mouseleave)=\"closeFeedback($event)\"\n  ariaDescription=\"Opens in new window\">\n  <div class=\"olUp olUpNewIcon\" role=\"complementary\" *ngIf=\"showFeedback\" tabindex='0'>\n    <img alt=\"feedback icon\" [src]='icon' />\n    <div class=\"feedbackText\">Feedback</div>\n  </div>\n  <div class=\"olOver\" *ngIf=\"!showFeedback\">\n    <span>\n      Click here to\n      <br>\n      rate this\n      <br>\n      page\n    </span>\n  </div>\n</div>\n\n<div id=\"feedbackMobile\" class=\"oo_feedback_float \">\n  <a class=\"olUp\" (click)=\"openFeedback($event)\" tabindex=\"0\">Feedback</a>\n</div> -->\n", styles: [".feedback{font:12px Tahoma,Arial,Helvetica,sans-serif;text-align:center;width:80px!important;height:50px!important;border:1px solid #ccc!important;border-radius:7px!important;cursor:pointer!important;background-color:#f5f5f5!important;font-weight:700}img{position:relative;margin-bottom:5px;cursor:pointer}.olUp{text-align:center;position:relative;filter:alpha(opacity=100);opacity:1;transition:opacity .5s;-moz-transition:opacity .5s;-webkit-transition:opacity .5s;-o-transition:opacity .5s;padding-top:6px}.olUpNewIcon{position:fixed;top:61%;right:0;margin-top:60px}.olOver{display:block;height:100%;width:100%;top:0;left:0;filter:alpha(opacity=0);transition:opacity .5s;-moz-transition:opacity .5s;-webkit-transition:opacity .5s;-o-transition:opacity .5s;padding:4px;font-size:11px;border-radius:7px!important;background:#fff}.feedbackText{text-indent:-9999px}@media (max-width: 991px){.feedbackDesktop{display:none}#feedbackMobile{margin:0 -20px!important;cursor:pointer;background:#666}.oo_feedback_float .olUp{background:url(/assets/feedback_plus.png) 2% 6px no-repeat;display:block;font-family:Interstate_Bold;font-size:16px;color:#fff}}@media (min-width: 991.9px){#feedbackMobile{display:none}}@media print{.appbody{min-width:992px}.oo_feedback_float,.olUp{display:none!important}}\n"] }]
        }], ctorParameters: () => [] });

class CitiFeedbackModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiFeedbackModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: CitiFeedbackModule, declarations: [CitiFeedbackComponent], imports: [CommonModule], exports: [CitiFeedbackComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiFeedbackModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiFeedbackModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CitiFeedbackComponent],
                    exports: [CitiFeedbackComponent]
                }]
        }] });

class CitiRouteDetectionService {
    constructor(_injector) {
        this._injector = _injector;
    }
    /*
     * The function is used to notify the interceptor to do the neccessary work before loading the current route
     */
    notifyInterceptor(_path) {
        this.interceptorList.forEach(interceptorCls => {
            try {
                this._injector.get(interceptorCls).trigger(_path);
            }
            catch (err) {
                console.log('CbolRouteDetectionService', err);
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetectionService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetectionService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetectionService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.Injector }] });

class CitiRouteDetectorComponent {
    constructor(_router, _cbolRouteDetectionService) {
        this.routeDetectionConfig = [];
        _router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(event => {
            _cbolRouteDetectionService.interceptorList = this.routeDetectionConfig;
            _cbolRouteDetectionService.notifyInterceptor(event['url']);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetectorComponent, deps: [{ token: i3.Router }, { token: CitiRouteDetectionService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: CitiRouteDetectorComponent, isStandalone: false, selector: "citi-route-detector", inputs: { routeDetectionConfig: ["route-detection-config", "routeDetectionConfig"] }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-route-detector',
                    standalone: false,
                    template: ''
                }]
        }], ctorParameters: () => [{ type: i3.Router }, { type: CitiRouteDetectionService }], propDecorators: { routeDetectionConfig: [{
                type: Input,
                args: ['route-detection-config']
            }] } });

class CbolRouteDummyInterceptorService {
    trigger(path) {
        console.log('CbolRouteDummyInterceptorService', path);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolRouteDummyInterceptorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolRouteDummyInterceptorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolRouteDummyInterceptorService, decorators: [{
            type: Injectable
        }] });

class CitiRouteDetector {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetector, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetector, declarations: [CitiRouteDetectorComponent], exports: [CitiRouteDetectorComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetector, providers: [
            CitiRouteDetectionService,
            {
                provide: 'CbolRouteDummyInterceptorService',
                useClass: CbolRouteDummyInterceptorService
            }
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiRouteDetector, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [CitiRouteDetectorComponent],
                    exports: [CitiRouteDetectorComponent],
                    providers: [
                        CitiRouteDetectionService,
                        {
                            provide: 'CbolRouteDummyInterceptorService',
                            useClass: CbolRouteDummyInterceptorService
                        }
                    ]
                }]
        }] });

class CdsThemingService {
    constructor(appConfigService, brandingService, _web, _rendererFactory) {
        this.appConfigService = appConfigService;
        this.brandingService = brandingService;
        this._web = _web;
        this._rendererFactory = _rendererFactory;
        this.themingBlue = "cbolui-cds-blue"; // Default
        this.themingGold = "cbolui-cds-gold";
        this.themingCPC = "cbolui-cds-cpc";
        this.themingPriority = "cbolui-cds-priority";
        this.themingVisId = "cbolui-cds-vis-id";
        this.cdsThemeChanged = new EventEmitter();
        this.homeDepot = "cbolui-cds-home-depot"; //CRS Partner Theme
        this.sunoco = "cbolui-cds-sunoco"; //CRS Partner Theme
        this.tractorSupply = "cbolui-cds-sunoco"; //CRS Partner Theme
        this.whiteLabel = "cbolui-cds-white-label"; //CRS Parter Theme
        this.themeElement = null; // Theme Specific CSS Element
        this._renderer = this._rendererFactory.createRenderer(null, null);
    }
    initCdsTheme(partnerId) {
        const theme = this.getCustomerType(partnerId);
        console.log('CDS THEME: ', theme);
        this.setTheme(theme);
    }
    /**
    * To determine the theme for a customer based on their branding or partner ID.
    * The function accepts an optional partnerId parameter of type string and
    * returns a string representing the theme.
    */
    getCustomerType(partnerId) {
        let spbs = JSON.parse(window.sessionStorage.getItem('sessionPostBrandingStorage'));
        let userBranding = spbs?.userBranding;
        let modifier = this.brandingService.getBrandingModifier();
        let theme = '';
        if (!!partnerId && partnerId != '') {
            if (partnerId.toUpperCase() === "HOMEDEPOT") {
                theme = this.homeDepot;
            }
            else if (partnerId.toUpperCase() === "SUNOCO") {
                theme = this.sunoco;
            }
            else if (partnerId.toUpperCase() === "TRACTORSUPPLY") {
                theme = this.tractorSupply;
            }
            else if (partnerId.toUpperCase() === "WHITELABEL") {
                theme = this.whiteLabel;
            }
            else {
                theme = this.themingBlue;
            }
        }
        else if (!!userBranding && userBranding != '') {
            if (userBranding === "Gold") {
                theme = this.themingGold;
            }
            else if (userBranding === "CPC") {
                theme = this.themingCPC;
            }
            else if (userBranding === "Priority") {
                theme = this.themingPriority;
            }
            else {
                theme = this.themingBlue;
            }
        }
        else {
            if (modifier === 'gold') {
                theme = this.themingGold;
            }
            else if (modifier === 'cpc') {
                theme = this.themingCPC;
            }
            else if (modifier === 'priority') {
                theme = this.themingPriority;
            }
            else {
                theme = this.themingBlue;
            }
        }
        return theme;
    }
    loadTheme(theme) {
        const standaloneThemes = [this.themingGold, this.themingCPC, this.themingPriority]; // List of themes with standalone CSS files  - TO DO: Add themingVisId once it's put to use
        const validStandaloneTheme = standaloneThemes.includes(theme);
        if (!validStandaloneTheme && this.themeElement) { // Remove existing theme CSS if it exists.
            this._web?.document?.head?.removeChild(this.themeElement);
            this.themeElement = null;
            this.previousTheme = null;
        }
        else if (validStandaloneTheme && theme !== this.previousTheme) { // New theme is set, remove old theme CSS and load new theme CSS
            let staticAssetsUrl = this.appConfigService.getConfig('customConfig')?.staticAssetsUrl || '';
            const themeCssHref = `${staticAssetsUrl}themes_${theme}.css`;
            const tick = new Date().getTime().toString().slice(0, 8); // add a timestamp to the end of the css file to force a reload
            if (this.themeElement) {
                this._web?.document?.head?.removeChild(this.themeElement);
            }
            this.themeElement = this._renderer.createElement('link');
            this.themeElement.rel = 'stylesheet';
            this.themeElement.href = `${themeCssHref}?v=${tick}`;
            this._renderer.appendChild(this._web.document.head, this.themeElement);
            this.previousTheme = theme;
        }
    }
    getTheme() {
        return this.theme;
    }
    setTheme(theme) {
        this.theme = theme;
        // If useStandaloneThemes is enabled in the app config, load the correct standalone CSS file. Journey teams can set this value to true as they adopt this functionality going forward.
        if (this.appConfigService.getConfig('customConfig')?.useStandaloneThemes) {
            this.loadTheme(theme);
        }
        this.cdsThemeChanged.emit(this.theme);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CdsThemingService, deps: [{ token: i1$1.AppConfigService }, { token: BrandingService }, { token: i3$3.CdsWebService }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CdsThemingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CdsThemingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.AppConfigService }, { type: BrandingService }, { type: i3$3.CdsWebService }, { type: i0.RendererFactory2 }] });

/**
 * @Component: Simple Layout
 * @Section: GridLayouts
 * @Description: This is the layout component that allows you to create a simple layout, which just one content area
 * controlled compeletely by the application developer.
 */
class SimpleLayoutComponent {
    // Constructor
    constructor(layoutsService, appConfigService, brandingService, cdsThemingService) {
        this.layoutsService = layoutsService;
        this.appConfigService = appConfigService;
        this.brandingService = brandingService;
        this.cdsThemingService = cdsThemingService;
        this._fullbleed = false;
    }
    // After view init
    ngAfterViewInit() {
        if (this.cdsThemeEnabled) {
            // Enable CDS theming - service will set theme based on customer type or partner
            this.cdsThemingService.initCdsTheme();
        }
        else {
            // Reset theme
            this.cdsThemingService.setTheme(null);
        }
        // If no brandingType is defined
        if (!this.currentBrandingType) {
            this.brandingService.defaultBrandingSet = false;
            // Get the branding endpoint url from the app config service
            const defaultBrandingUrl = this.appConfigService.getConfig('customConfig').brandingEndpoint;
            // Stores the type of branding that should be loaded by default
            let brandingType;
            // If the default branding URL indicates that default branding should be loaded
            if (defaultBrandingUrl === '/api/brandingConfig' ||
                defaultBrandingUrl === 'default') {
                // We should load the default branding
                brandingType = 'default';
                // Otherwise
            }
            else {
                // We should load the servicing branding
                this.brandingService.defaultBrandingSet = true;
                brandingType = 'servicing';
            }
            // Tell the layouts service to load default branding
            this.layoutsService.changeBrandingType(brandingType);
        }
        // If we didnt get a page ID
        if (!this.currentPageId) {
            this.layoutsService.changePageId(false);
        }
        // If we didn't get a servicing type
        if (!this.currentServicingType) {
            this.layoutsService.changeServicingType(false);
        }
    }
    // On init
    ngOnInit() {
        /* Set the theme in the layout service */
        this.layoutsService.changeTheme(this.theme);
        /* Set the endpoint in the layout service */
        this.layoutsService.changeEndpoint(this.endpoint);
        /* Set the responsive in the layout service */
        this.layoutsService.changeResponsive(this.responsive);
        /* Set the width in the layout service */
        this.layoutsService.changeWidth(this.width);
        /* Set the singleBreakpoint in the layout service */
        this.layoutsService.changeSingleBreakpoint(this.singleBreakpoint);
        /* Set the default value for fullbleed */
        this.layoutsService.changeFullbleed(this._fullbleed);
        /* Subscribe to any future theme updates in the layout service */
        this.layoutsService.themeChanged.subscribe(theme => {
            /* Set the theme in the layout service */
            this.theme = theme;
        });
        /* Subscribe to any future endpoint updates in the layout service */
        this.layoutsService.endpointChanged.subscribe(endpoint => {
            /* Set the theme in the layout service */
            this.endpoint = endpoint;
        });
        /* Subscribe to any future responsive updates in the layout service */
        this.layoutsService.responsiveChanged.subscribe(responsive => {
            /* Set the theme in the layout service */
            this.responsive = responsive;
        });
        /* Subscribe to any future width updates in the layout service */
        this.layoutsService.widthChanged.subscribe(width => {
            /* Set the width in the layout service */
            this.width = width;
        });
        /* Subscribe to any future single breakpoint updates in the layout service */
        this.layoutsService.singleBreakpointChanged.subscribe(singleBreakpoint => {
            /* Set the single breakpoint property in the layout service */
            this.singleBreakpoint = singleBreakpoint;
        });
    }
    /**
     * @Property: pageId
     * @Description: The unique pageId for the current page.  Used by smart assist
     * @Type: String
     */
    set pageId(id) {
        // If we got a valid id
        if (typeof id === 'string' && id.length) {
            // Set the current page id
            this.currentPageId = id;
            // Update the page id on the layouts service
            this.layoutsService.changePageId(id);
        }
    }
    /**
     * @Property: servicingType
     * @Description: The type that should be sent to the servicing branding micro-service
     * @Type: String
     */
    set servicingType(type) {
        // If we got a valid type
        if (typeof type === 'string' && type.length) {
            // Set the current servicing type
            this.currentServicingType = type;
            // Update the servicing type on the layouts service
            this.layoutsService.changeServicingType(type);
        }
    }
    /**
     * @Property: brandingType
     * @Description: The branding type that should be used for the layout
     * @Type: String (marketing | servicing)
     */
    set brandingType(type) {
        if (typeof type === 'string' && type.length) {
            this.currentBrandingType = type;
            this.layoutsService.changeBrandingType(type);
        }
    }
    /**
     * @Property: loading
     * @Description: Sets the app body loading property for the layout.
     * @Type: string
     */
    set loading(val) {
        /* Set the loading in the layout service */
        this.layoutsService.changeAppbodyLoading(val);
    }
    /**
     * @Property: prelogin
     * @Description: Sets the bootstrap theme to pre or post login.
     * @Type: boolean
     */
    set prelogin(val) {
        /* Sets the bootstrap theme to pre or post login. */
        this.layoutsService.changePrelogin(val);
    }
    /**
     * @Property: locale
     * @Description: Sets the lang attribute on the html tag.  Pass en for english, es for spanish.
     * @Type: boolean
     */
    set locale(val) {
        document.getElementsByTagName('html')[0].setAttribute('lang', val);
    }
    /**
     * @Property: fullbleed
     * @Description: Sets the fullbleed variable to add the css override via the parent layout
     * @Type: boolean
     */
    set fullbleed(val) {
        /* Sets the parent layout container do to use the fullbleed override. */
        this._fullbleed = val;
        this.layoutsService.changeFullbleed(val);
    }
    set waitMessage(message) {
        // This sets the message to be read by the JAMP when it is showing
        this.layoutsService.changeWaitMessage(message);
    }
    set readyMessage(message) {
        // This sets the message to be read by the JAMP when it is hidden
        this.layoutsService.changeReadyMessage(message);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SimpleLayoutComponent, deps: [{ token: LayoutsService }, { token: i1$1.AppConfigService }, { token: BrandingService }, { token: CdsThemingService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SimpleLayoutComponent, isStandalone: false, selector: "citi-simple-layout", inputs: { theme: "theme", endpoint: "endpoint", responsive: "responsive", width: "width", singleBreakpoint: "singleBreakpoint", cdsThemeEnabled: "cdsThemeEnabled", pageId: "pageId", servicingType: "servicingType", brandingType: "brandingType", loading: "loading", prelogin: "prelogin", locale: "locale", fullbleed: "fullbleed", waitMessage: "waitMessage", readyMessage: "readyMessage" }, ngImport: i0, template: "<ng-content></ng-content>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SimpleLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-simple-layout', standalone: false, template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: () => [{ type: LayoutsService }, { type: i1$1.AppConfigService }, { type: BrandingService }, { type: CdsThemingService }], propDecorators: { theme: [{
                type: Input
            }], endpoint: [{
                type: Input
            }], responsive: [{
                type: Input
            }], width: [{
                type: Input
            }], singleBreakpoint: [{
                type: Input
            }], cdsThemeEnabled: [{
                type: Input
            }], pageId: [{
                type: Input
            }], servicingType: [{
                type: Input
            }], brandingType: [{
                type: Input
            }], loading: [{
                type: Input
            }], prelogin: [{
                type: Input
            }], locale: [{
                type: Input
            }], fullbleed: [{
                type: Input
            }], waitMessage: [{
                type: Input
            }], readyMessage: [{
                type: Input
            }] } });

let browserRefresh = false;
class CDSService {
    constructor(router) {
        this.router = router;
        this._cdsEnabled = false;
        this.cdsFlagChanged = new EventEmitter();
        this.destroyed = new Subject();
        /* Subscribe to router events, filter for NavigationEnd events
            filter for events where the previous url is not equal to new url (distinguish between routing to differen features)
            if cds is enabled, disable cds (reset to the default value)*/
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), pairwise(), filter((events) => {
            console.log('CDS Service: Navigating away from page, checking url...', events[0].url.split('/'));
            return (events[0].url.split('/')[1] !==
                events[1].url.split('/')[1]);
        }), startWith('Initial call'), takeUntil(this.destroyed))
            .subscribe((events) => {
            if (!events[1]) {
                if (!events[1].url.includes("dashboard"))
                    this.disableCds();
            }
        });
    }
    enableCds() {
        this._cdsEnabled = true;
        this.emitChanges();
    }
    disableCds() {
        this._cdsEnabled = false;
        this.emitChanges();
    }
    toggleCds() {
        this._cdsEnabled = !this._cdsEnabled;
        this.emitChanges();
    }
    emitChanges() {
        this.cdsFlagChanged.emit(this._cdsEnabled);
    }
    getCdsEnabled() {
        return this._cdsEnabled;
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CDSService, deps: [{ token: i3.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CDSService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CDSService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i3.Router }] });

class FooterComponent {
    // Constructor
    constructor(brandingService, _brandingRefreshLoad, _document) {
        this.brandingService = brandingService;
        this._brandingRefreshLoad = _brandingRefreshLoad;
        this._document = _document;
        this.showFooter = true;
    }
    ngOnInit() {
        //debit card deactivation footer suppress
        this._brandingRefreshLoad.debcardact();
        //this.footerRefresh();
        // Get data from the branding service
        this.brandingService.dataUpdate.subscribe(data => {
            this.brandingConfig = data;
            // enable footer toggling logic via branding service
            if (this.brandingConfig["footer"].hasOwnProperty("show")) {
                this.showFooter = this.brandingConfig.footer.show;
            }
        });
    }
    ngAfterViewInit() {
        const nebulaBtn = this._document.querySelector('#nebula_div_btn');
        if (nebulaBtn) {
            //Feedback Axe issue- Medallia team fix
            nebulaBtn.removeAttribute('style');
            this._document
                .querySelector('#nebula_div_btn')
                .setAttribute('style', 'padding: 0px;bottom: 0px;right: 30px;border: none;z-index: 99999;position: fixed;cursor: pointer;line-height: 1px;margin-bottom: 5px;');
        }
    }
    footerRefresh() {
        this._brandingRefreshLoad.brandingRefreshLoad().subscribe(success => {
            console.log("Entitlement feature flags refresh API Success");
            this._brandingRefreshLoad.debcardact();
        }, error => {
            console.warn("Error: Refresh Failed");
            this._brandingRefreshLoad.debcardact();
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FooterComponent, deps: [{ token: BrandingService }, { token: brandingRefreshLoad }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.14", type: FooterComponent, isStandalone: true, selector: "citi-footer", ngImport: i0, template: "<div role=\"contentinfo\" class=\"footer\" *ngIf=\"showFooter\">\n  @defer (on viewport; prefetch on idle) {\n    <!-- <citi-footer-butler-bar\n        [brandingConfig]=\"brandingConfig\"\n      ></citi-footer-butler-bar> -->\n    <citi-footer-navigation\n      [brandingConfig]=\"brandingConfig\"\n    ></citi-footer-navigation>\n    <citi-social-media [brandingConfig]=\"brandingConfig\"></citi-social-media>\n    <citi-footer-sub-navigation\n      [brandingConfig]=\"brandingConfig\"\n    ></citi-footer-sub-navigation>\n    <citi-footer-disclaimer\n      [brandingConfig]=\"brandingConfig\"\n    ></citi-footer-disclaimer>\n    <citi-sub-footer [brandingConfig]=\"brandingConfig\"></citi-sub-footer>\n    <!-- <citi-footer-medallia-feedback></citi-footer-medallia-feedback> -->\n  } @placeholder {\n    <div style=\"height: 814px;\"></div>\n  }\n</div>", styles: [":host ::ng-deep .brandingSprite{background-repeat:no-repeat;cursor:pointer;display:inline-block}:host ::ng-deep .brandingSprite .equalHousing,:host ::ng-deep .brandingSprite .fdic{cursor:default!important}:host ::ng-deep .footer{position:initial;background:#333}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog{margin:40px auto!important}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-header{padding:15px!important;min-height:16.5px}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-body{padding-right:40px;padding-left:40px}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-footer{padding:40px 15px 15px!important;text-align:right;border-top:1px solid #e5e5e5;width:100%;border:none!important}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-footer citi-cta ::ng-deep a{color:#fff;border-color:#056dae;background:#056dae;line-height:46px;border-width:2px;border-style:solid;margin:20px 20px 0 0;min-width:220px;position:relative;line-height:34px;vertical-align:middle;text-align:center;font-size:16px;font-size:1rem;font-family:Interstate_Bold,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-weight:700;border-radius:6px;display:inline-block;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 20px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media screen and (max-width: 800px){#nebula_div_btn{display:none}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], deferBlockDependencies: [() => [Promise.resolve().then(function () { return navigation_component; }).then(m => m.FooterNavigationComponent), Promise.resolve().then(function () { return subNavigation_component; }).then(m => m.SubNavigationComponent), Promise.resolve().then(function () { return disclaimer_component; }).then(m => m.DisclaimerBrandingComponent), Promise.resolve().then(function () { return socialMedia_component; }).then(m => m.SocialMediaComponent), Promise.resolve().then(function () { return subFooter_component; }).then(m => m.SubFooterComponent)]] }); }
}
i0.ɵɵngDeclareClassMetadataAsync({ minVersion: "18.0.0", version: "19.2.14", ngImport: i0, type: FooterComponent, resolveDeferredDeps: () => [Promise.resolve().then(function () { return navigation_component; }).then(m => m.FooterNavigationComponent), Promise.resolve().then(function () { return subNavigation_component; }).then(m => m.SubNavigationComponent), Promise.resolve().then(function () { return disclaimer_component; }).then(m => m.DisclaimerBrandingComponent), Promise.resolve().then(function () { return socialMedia_component; }).then(m => m.SocialMediaComponent), Promise.resolve().then(function () { return subFooter_component; }).then(m => m.SubFooterComponent)], resolveMetadata: (FooterNavigationComponent, SubNavigationComponent, DisclaimerBrandingComponent, SocialMediaComponent, SubFooterComponent) => ({ decorators: [{
                type: Component,
                args: [{ selector: 'citi-footer', standalone: true, imports: [
                            CommonModule,
                            FooterNavigationComponent,
                            SubNavigationComponent,
                            DisclaimerBrandingComponent,
                            SocialMediaComponent,
                            SubFooterComponent
                        ], template: "<div role=\"contentinfo\" class=\"footer\" *ngIf=\"showFooter\">\n  @defer (on viewport; prefetch on idle) {\n    <!-- <citi-footer-butler-bar\n        [brandingConfig]=\"brandingConfig\"\n      ></citi-footer-butler-bar> -->\n    <citi-footer-navigation\n      [brandingConfig]=\"brandingConfig\"\n    ></citi-footer-navigation>\n    <citi-social-media [brandingConfig]=\"brandingConfig\"></citi-social-media>\n    <citi-footer-sub-navigation\n      [brandingConfig]=\"brandingConfig\"\n    ></citi-footer-sub-navigation>\n    <citi-footer-disclaimer\n      [brandingConfig]=\"brandingConfig\"\n    ></citi-footer-disclaimer>\n    <citi-sub-footer [brandingConfig]=\"brandingConfig\"></citi-sub-footer>\n    <!-- <citi-footer-medallia-feedback></citi-footer-medallia-feedback> -->\n  } @placeholder {\n    <div style=\"height: 814px;\"></div>\n  }\n</div>", styles: [":host ::ng-deep .brandingSprite{background-repeat:no-repeat;cursor:pointer;display:inline-block}:host ::ng-deep .brandingSprite .equalHousing,:host ::ng-deep .brandingSprite .fdic{cursor:default!important}:host ::ng-deep .footer{position:initial;background:#333}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog{margin:40px auto!important}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-header{padding:15px!important;min-height:16.5px}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-body{padding-right:40px;padding-left:40px}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-footer{padding:40px 15px 15px!important;text-align:right;border-top:1px solid #e5e5e5;width:100%;border:none!important}citi-social-media ::ng-deep .social .content .socialItems citi-modal ::ng-deep .modal .modal-dialog .modal-content .modal-footer citi-cta ::ng-deep a{color:#fff;border-color:#056dae;background:#056dae;line-height:46px;border-width:2px;border-style:solid;margin:20px 20px 0 0;min-width:220px;position:relative;line-height:34px;vertical-align:middle;text-align:center;font-size:16px;font-size:1rem;font-family:Interstate_Bold,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-weight:700;border-radius:6px;display:inline-block;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 20px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media screen and (max-width: 800px){#nebula_div_btn{display:none}}\n"] }]
            }], ctorParameters: () => [{ type: BrandingService }, { type: brandingRefreshLoad }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }], propDecorators: null }) });

/**
 * @Component: Parent Layout
 * @Section: GridLayouts
 * @Description: This is the parent layout component that includes the branding and has child layouts that the app team adds
 */
class ParentLayoutComponent {
    constructor(_taggingService, layoutsService, _sanitizer, _cdsService, _cdsThemingService, _contentService, _contentStorageService, _modalSharedService, _smartBannerSharedService, cd, _document) {
        this._taggingService = _taggingService;
        this.layoutsService = layoutsService;
        this._sanitizer = _sanitizer;
        this._cdsService = _cdsService;
        this._cdsThemingService = _cdsThemingService;
        this._contentService = _contentService;
        this._contentStorageService = _contentStorageService;
        this._modalSharedService = _modalSharedService;
        this._smartBannerSharedService = _smartBannerSharedService;
        this.cd = cd;
        this._document = _document;
        this.suppressJamp = false;
        this.prelogin = false;
        this.fullbleed = false;
        this.containerClasses = ['citi-container', 'cbolui-ddl'];
        this.containerOuterClasses = ['citi-outer-container'];
        this.manualOverride = false;
        this.showSearchPanel = false;
        this.elementsFound = false;
        this._cdsEnabled = false;
        this.isCitiMobile = false;
        this.isSmartBanner = false;
        this.isLoggedIn = false; // gets true value after login
    }
    ngOnInit() {
        this.sub$ = this._modalSharedService.dialogState$.subscribe(isOpen => {
            this.isCitiMobile = isOpen;
        });
        this.theme = this.layoutsService.theme;
        this.endpoint = this.layoutsService.endpoint;
        this.responsive = this.layoutsService.responsive;
        this.singleBreakpoint = this.layoutsService.singleBreakpoint;
        this.fullpageLoading = this.layoutsService.fullpageLoading;
        this.appbodyLoading = this.layoutsService.appbodyLoading;
        this.suppressJamp = this.layoutsService.suppressJamp;
        this.fullbleed = this.layoutsService.fullbleed;
        this.updateContainerClasses();
        this.layoutsService.clearClasses.subscribe(bool => {
            this.manualOverride = true;
            this.containerOuterClasses = ['citi-outer-container', 'cbolui-cds'];
        });
        this.layoutsService.releaseManualControl.subscribe(bool => {
            this.manualOverride = false;
            this.updateContainerClasses();
        });
        this._cdsService.cdsFlagChanged.subscribe(cdsEnabled => {
            this.manualOverride = cdsEnabled;
            this._cdsEnabled = cdsEnabled;
            cdsEnabled
                ? (this.containerOuterClasses = ['citi-outer-container', 'cbolui-cds'])
                : this.updateContainerClasses();
            /* Adds CDS Theme Class */
            if (!!this.cdsTheme && this.cdsTheme != '') {
                this.containerOuterClasses.push(this.cdsTheme);
            }
        });
        /* Subscribe to any future theme updates in the layout service */
        this.layoutsService.themeChanged.subscribe(theme => {
            /* Set the theme in the layout service */
            this.theme = theme;
            this.updateContainerClasses();
        });
        /* Subscribe to any future CDS theme updates in the layout service */
        this._cdsThemingService.cdsThemeChanged.subscribe(theme => {
            this.cdsTheme = theme;
            this.updateContainerClasses();
        });
        /* Subscribe to any future endpoint updates in the layout service */
        this.layoutsService.endpointChanged.subscribe(endpoint => {
            /* Set the theme in the layout service */
            this.endpoint = endpoint;
        });
        /* Subscribe to any future responsive flag updates in the layout service */
        this.layoutsService.responsiveChanged.subscribe(responsive => {
            /* Set the theme in the layout service */
            this.responsive = responsive;
            this.updateContainerClasses();
        });
        /* Subscribe to any future width flag updates in the layout service */
        this.layoutsService.widthChanged.subscribe(width => {
            /* Set the width in the layout container classes */
            this.width = width;
            this.updateContainerClasses();
        });
        /* Subscribe to any future singleBreakpoint flag updates in the layout service */
        this.layoutsService.singleBreakpointChanged.subscribe(singleBreakpoint => {
            /* Set the singleBreakpoint in the layout container classes */
            this.singleBreakpoint = singleBreakpoint;
        });
        /* Subscribe to any future loading flag updates in the layout service */
        this.layoutsService.fullpageLoadingChanged.subscribe(fullpageLoading => {
            /* Set the loading in the layout container classes */
            this.fullpageLoading = fullpageLoading;
        });
        /* Subscribe to any future loading flag updates in the layout service */
        this.layoutsService.appbodyLoadingChanged.subscribe(appbodyLoading => {
            /* Set the loading in the layout container classes */
            this.appbodyLoading = appbodyLoading;
        });
        /* Subscribe to any future suppress jamp updates in the layout service */
        this.layoutsService.suppressJampChanged.subscribe(suppressJamp => {
            /* Set the suppressJamp in the layout container classes */
            this.suppressJamp = suppressJamp;
        });
        /* Subscribe to any future prelogin flag updates in the layout service */
        this.layoutsService.preloginChanged.subscribe(prelogin => {
            this.prelogin = prelogin;
            this.updateContainerClasses();
        });
        /* Subscribe to any future fullbleed updates in the layout service */
        this.layoutsService.fullbleedChanged.subscribe(fullbleed => {
            this.fullbleed = fullbleed;
            this.updateContainerClasses();
        });
        /* Subscribe to any future QuickAction copy updates from the smartBanner service */
        this.qAData$ = this._smartBannerSharedService.qAcontentObs$.subscribe(data => {
            const appId = 'quickaction';
            this.qaCitiMobileContent = this._contentStorageService.get(appId, 'copy', 'QACitiMobileApp');
        });
        this.layoutsService.waitMessageChanged.subscribe((message) => {
            if (typeof message == 'string' && message.length) {
                this.waitMessage = message;
            }
        });
        this.layoutsService.readyMessageChanged.subscribe((message) => {
            if (typeof message == 'string' && message.length) {
                this.readyMessage = message;
            }
        });
        //Toggle intelligent search panel
        this.layoutsService.toggleSearchPanel.subscribe(toggleSearch => {
            this.showSearchPanel = toggleSearch;
        });
        this.layoutsService.postBrandingStorage.asObservable().subscribe(res => {
            if (res) {
                this.getCitiMobileContent();
            }
        });
    }
    ngOnDestroy() {
        this.sub$.unsubscribe();
        this.qAData$.unsubscribe();
    }
    getCitiMobileContent() {
        if (!this.isLoggedIn) {
            this._smartBannerSharedService.getQAData();
        }
        this.isLoggedIn = true;
    }
    toggleSearchPanel() {
        this.layoutsService.toggleSearchPanel.next(false);
    }
    tagCloseSearchPanel() {
        this._taggingService.triggerEventTagging('nonicms_content', '324ad1SearchPanelHowCanWeHelpHide');
    }
    resetContainerClasses() {
        this.containerClasses = ['citi-container', 'cbolui-ddl'];
        this.containerOuterClasses = ['citi-outer-container'];
    }
    updateContainerClasses() {
        if (!this.manualOverride) {
            this.resetContainerClasses();
            /* Set classes to be added to the container */
            this.theme == 'gray'
                ? this.containerClasses.push('theme-gray')
                : this.containerClasses.push('theme-light');
            this.responsive == 'false'
                ? this.containerOuterClasses.push('cbolui-non-responsive')
                : this.containerOuterClasses.push('cbolui-responsive');
            this.responsive == 'false'
                ? this.containerClasses.push('container')
                : null;
            if (typeof this.prelogin == 'boolean') {
                this.prelogin != true
                    ? this.containerOuterClasses.push('cbolui-ddl-post')
                    : this.containerOuterClasses.push('cbolui-ddl-pre');
            }
            else if (typeof this.prelogin == 'string') {
                this.prelogin != 'true'
                    ? this.containerOuterClasses.push('cbolui-ddl-post')
                    : this.containerOuterClasses.push('cbolui-ddl-pre');
            }
        }
        if (this.fullbleed) {
            this.containerClasses.push('fullbleedFix');
        }
        else {
            const index = this.containerClasses.indexOf('fullbleedFix');
            if (index > -1) {
                this.containerClasses.splice(index, 1);
            }
        }
        /* Adds CDS Theme Class */
        if (!!this.cdsTheme && this.cdsTheme != '') {
            if (!this.containerOuterClasses.includes(this.cdsTheme)) {
                this.containerOuterClasses.push(this.cdsTheme);
            }
        }
        else {
            this.containerOuterClasses = this.containerOuterClasses.filter(str => !str.includes('cbolui-cds-'));
        }
    }
    getContentWidth() {
        if (this.responsive == 'false') {
            const newWidth = 'width:' + this.width + 'px !important';
            return this._sanitizer.bypassSecurityTrustStyle(newWidth);
        }
    }
    // TODO: find an alternate solution ... this is slowing us down - Nate May
    ngAfterViewChecked() {
        // THIS IS A GLOBAL FUNCTION TO REMOVE OUTLINE FROM ALL CLICKED BUTTONS AND ANCHORS
        // THIS IS TO COMPLY WITH DDL DESIGN STANDARDS
        if (!this.elementsFound) {
            setTimeout(() => {
                // MEASURED PERFORMANCE: 0.25ms AVERAGE EXECUTION TIME
                // PLEASE MEASURE ALL CHANGES AGAINST THIS TO ENSURE FAST EXECUTION OF FUNCTION
                // Get all of the buttons in an array of HTML elements
                const buttons = [].slice.call(this._document.getElementsByTagName('button'));
                // Get all of the anchors in an array of HTML elements
                const anchors = [].slice.call(this._document.getElementsByTagName('a'));
                // Create an array with all buttons and anchors
                const elements = buttons.concat(anchors);
                // If we found some elements
                if (elements.length) {
                    // Let the function know we found some elements so it doesnt keep looking
                    this.elementsFound = true;
                    // Loop over all of our elements (do NOT use a for each here please)
                    for (let i = 0, j = elements.length; i < j; i++) {
                        // Attach an event listener for mouseup to each of the elements
                        elements[i].addEventListener('mouseup', function () {
                            // Set the outline to none
                            this.style.outline = 'none';
                        });
                    }
                }
            }, 100);
        }
    }
    onCloseModal() {
        this._modalSharedService.closeDialog();
        this._smartBannerSharedService.closeSmartBanner();
        this.isSmartBanner = false;
        this._smartBannerSharedService.setBanner(true);
        sessionStorage.setItem('smartBanner', 'check');
        this.isCitiMobile = false;
        this.cd.detectChanges();
        this._taggingService.triggerEventTagging('nonicms_content', '381h3Dashboard2ModalCTABtnlick');
    }
    onCloseIconModal() {
        this._modalSharedService.closeDialog();
        this.isCitiMobile = false;
        this.cd.detectChanges();
        this._taggingService.triggerEventTagging('nonicms_content', '381h2Dashboard2ModalInteractionClick');
    }
    onUseAppNavigate() {
        window.open('https://citimobile.app.link/SH53EInzUEb', '_blank');
        this._taggingService.triggerEventTagging('nonicms_content', '381h3Dashboard2ModalCTAClick');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ParentLayoutComponent, deps: [{ token: i1$1.TaggingService }, { token: LayoutsService }, { token: i3$2.DomSanitizer }, { token: CDSService }, { token: CdsThemingService }, { token: i6.ContentService }, { token: i6.ContentStorageService }, { token: i1$1.ModalSharedService }, { token: SmartBannerSharedService }, { token: i0.ChangeDetectorRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ParentLayoutComponent, isStandalone: false, selector: "citi-parent-layout", ngImport: i0, template: "<div [ngClass]=\"containerOuterClasses\">\n  <citi-header></citi-header>\n  <div id=\"maincontent\" [ngClass]=\"{ 'citi-panel-wrapper': showSearchPanel }\">\n    <div [ngClass]=\"{ 'content-panel': showSearchPanel }\">\n      <citi-jamp\n        *ngIf=\"fullpageLoading && !suppressJamp\"\n        visible=\"true\"\n        pagelevel=\"true\"\n        pagelevel=\"true\"\n        [waitMessage]=\"waitMessage\"\n        [readyMessage]=\"readyMessage\"\n      ></citi-jamp>\n\n      <div [ngClass]=\"containerClasses\" [attr.style]=\"getContentWidth()\">\n        <citi-jamp\n          *ngIf=\"!fullpageLoading && appbodyLoading\"\n          visible=\"true\"\n        ></citi-jamp>\n\n        <div\n          class=\"appbody\"\n          *ngIf=\"!(fullpageLoading || appbodyLoading) || suppressJamp\"\n        >\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n    <div *ngIf=\"showSearchPanel\" class=\"search-panel\">\n      <citi-smart-search\n        (closeSearchDroor)=\"[toggleSearchPanel(), tagCloseSearchPanel()]\"\n      ></citi-smart-search>\n    </div>\n  <ng-container *ngIf=\"isLoggedIn\">\n      <qa-citi-mobile-modal\n      [showCitiMobile]=\"isCitiMobile\"\n      [qaCitiMobileContent]=\"qaCitiMobileContent\"\n      (notNowCloseModal)=\"onCloseModal()\"\n      (closeCitiModalIcon)=\"onCloseIconModal()\"\n      (useAppNavigate)=\"onUseAppNavigate()\"\n    ></qa-citi-mobile-modal>\n  </ng-container>\n  </div>\n  <citi-footer></citi-footer>\n</div>\n", styles: [".citi-outer-container ::ng-deep *{box-sizing:border-box}.citi-container{padding:40px 20px 0;max-width:1440px;margin:0 auto;min-height:650px}.fullbleedFix{margin:0;padding:0;max-width:100%}:host ::ng-deep .fullbleedFix .row{margin-left:0;margin-right:0}.citi-panel-wrapper{display:flex}.citi-panel-wrapper .content-panel{flex:3 0 0}.citi-panel-wrapper .search-panel{flex:1 0 0;border-left:1px solid rgb(214,214,214);background-color:#fff}.cbolui-cds ::ng-deep .citi-panel-wrapper .citi-search-panel .row{display:block!important;margin-left:-10px!important;margin-right:-10px!important}::ng-deep .citi-panel-wrapper .content-panel citi-hero>section{width:100%!important;left:0!important}@media screen and (max-width: 991.9px){.citi-panel-wrapper .search-panel{background-color:#fff!important}.citi-panel-wrapper .content-panel{display:none}}@media screen and (max-width: 768px){.citi-panel-wrapper .search-panel{width:100%;height:300%;background-color:#fff!important}.citi-panel-wrapper .content-panel{display:none}}@media (min-width: 768px) and (max-width: 1450px){.citi-panel-wrapper ::ng-deep .dashboard-container quick-action,.citi-panel-wrapper ::ng-deep .dashboard-container dashboard-recent-activity-tile,.citi-panel-wrapper ::ng-deep .dashboard-container dashboard-fico-tile{width:100%!important;display:flow-root!important}.citi-panel-wrapper ::ng-deep .dashboard-container .selected-account-arrow{left:262px!important}.citi-panel-wrapper ::ng-deep .dashboard-container .left-field{max-width:300px!important;flex:0 0 300px!important}.citi-panel-wrapper ::ng-deep .dashboard-container .center-field{max-width:calc(100vw - 648px)!important}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: HeaderComponent, selector: "citi-header" }, { kind: "component", type: SmartSearchComponent, selector: "citi-smart-search", inputs: ["isVisitor", "settings", "injectSearchFallback"], outputs: ["closeSearchDroor"] }, { kind: "component", type: i1$1.JampComponent, selector: "citi-jamp", inputs: ["useGif", "visible", "pagelevel", "htmlContent", "additionalCssClasses", "waitMessage", "readyMessage", "isCenterAligned"] }, { kind: "component", type: i1$1.QaCitiMobileModal, selector: "qa-citi-mobile-modal", inputs: ["showCitiMobile", "quickHref", "qaCitiMobileContent", "selectedView", "productName"], outputs: ["useAppNavigate", "notNowCloseModal", "emitTaggingForQRcodeCTA", "closeCitiModalIcon"] }, { kind: "component", type: FooterComponent, selector: "citi-footer" }], animations: [
            trigger('showSearchPanelAnimation', [
                state('open', style({
                    opacity: 1,
                    transform: 'translate3d(0,0,0)'
                })),
                state('closed', style({
                    opacity: 0,
                    transform: 'translate3d(100%,0,0)'
                })),
                transition('open => closed', [animate('400ms ease-in-out')]),
                transition('closed => open', [animate('400ms ease-in-out')])
            ])
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ParentLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-parent-layout', standalone: false, animations: [
                        trigger('showSearchPanelAnimation', [
                            state('open', style({
                                opacity: 1,
                                transform: 'translate3d(0,0,0)'
                            })),
                            state('closed', style({
                                opacity: 0,
                                transform: 'translate3d(100%,0,0)'
                            })),
                            transition('open => closed', [animate('400ms ease-in-out')]),
                            transition('closed => open', [animate('400ms ease-in-out')])
                        ])
                    ], template: "<div [ngClass]=\"containerOuterClasses\">\n  <citi-header></citi-header>\n  <div id=\"maincontent\" [ngClass]=\"{ 'citi-panel-wrapper': showSearchPanel }\">\n    <div [ngClass]=\"{ 'content-panel': showSearchPanel }\">\n      <citi-jamp\n        *ngIf=\"fullpageLoading && !suppressJamp\"\n        visible=\"true\"\n        pagelevel=\"true\"\n        pagelevel=\"true\"\n        [waitMessage]=\"waitMessage\"\n        [readyMessage]=\"readyMessage\"\n      ></citi-jamp>\n\n      <div [ngClass]=\"containerClasses\" [attr.style]=\"getContentWidth()\">\n        <citi-jamp\n          *ngIf=\"!fullpageLoading && appbodyLoading\"\n          visible=\"true\"\n        ></citi-jamp>\n\n        <div\n          class=\"appbody\"\n          *ngIf=\"!(fullpageLoading || appbodyLoading) || suppressJamp\"\n        >\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n    <div *ngIf=\"showSearchPanel\" class=\"search-panel\">\n      <citi-smart-search\n        (closeSearchDroor)=\"[toggleSearchPanel(), tagCloseSearchPanel()]\"\n      ></citi-smart-search>\n    </div>\n  <ng-container *ngIf=\"isLoggedIn\">\n      <qa-citi-mobile-modal\n      [showCitiMobile]=\"isCitiMobile\"\n      [qaCitiMobileContent]=\"qaCitiMobileContent\"\n      (notNowCloseModal)=\"onCloseModal()\"\n      (closeCitiModalIcon)=\"onCloseIconModal()\"\n      (useAppNavigate)=\"onUseAppNavigate()\"\n    ></qa-citi-mobile-modal>\n  </ng-container>\n  </div>\n  <citi-footer></citi-footer>\n</div>\n", styles: [".citi-outer-container ::ng-deep *{box-sizing:border-box}.citi-container{padding:40px 20px 0;max-width:1440px;margin:0 auto;min-height:650px}.fullbleedFix{margin:0;padding:0;max-width:100%}:host ::ng-deep .fullbleedFix .row{margin-left:0;margin-right:0}.citi-panel-wrapper{display:flex}.citi-panel-wrapper .content-panel{flex:3 0 0}.citi-panel-wrapper .search-panel{flex:1 0 0;border-left:1px solid rgb(214,214,214);background-color:#fff}.cbolui-cds ::ng-deep .citi-panel-wrapper .citi-search-panel .row{display:block!important;margin-left:-10px!important;margin-right:-10px!important}::ng-deep .citi-panel-wrapper .content-panel citi-hero>section{width:100%!important;left:0!important}@media screen and (max-width: 991.9px){.citi-panel-wrapper .search-panel{background-color:#fff!important}.citi-panel-wrapper .content-panel{display:none}}@media screen and (max-width: 768px){.citi-panel-wrapper .search-panel{width:100%;height:300%;background-color:#fff!important}.citi-panel-wrapper .content-panel{display:none}}@media (min-width: 768px) and (max-width: 1450px){.citi-panel-wrapper ::ng-deep .dashboard-container quick-action,.citi-panel-wrapper ::ng-deep .dashboard-container dashboard-recent-activity-tile,.citi-panel-wrapper ::ng-deep .dashboard-container dashboard-fico-tile{width:100%!important;display:flow-root!important}.citi-panel-wrapper ::ng-deep .dashboard-container .selected-account-arrow{left:262px!important}.citi-panel-wrapper ::ng-deep .dashboard-container .left-field{max-width:300px!important;flex:0 0 300px!important}.citi-panel-wrapper ::ng-deep .dashboard-container .center-field{max-width:calc(100vw - 648px)!important}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.TaggingService }, { type: LayoutsService }, { type: i3$2.DomSanitizer }, { type: CDSService }, { type: CdsThemingService }, { type: i6.ContentService }, { type: i6.ContentStorageService }, { type: i1$1.ModalSharedService }, { type: SmartBannerSharedService }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

const MODULES = [CommonModule, CitiBrandingModule, JAMP, QaCitiMobileModalModule, FooterComponent];
const COMPONENTS = [
    SimpleLayoutComponent,
    ParentLayoutComponent
];
class Layouts {
    static forRoot() {
        return {
            ngModule: Layouts,
            providers: [LayoutsService, CDSService]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Layouts, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: Layouts, declarations: [SimpleLayoutComponent,
            ParentLayoutComponent], imports: [CommonModule, CitiBrandingModule, JAMP, QaCitiMobileModalModule, FooterComponent], exports: [SimpleLayoutComponent,
            ParentLayoutComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Layouts, providers: [ValidationService], imports: [MODULES] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Layouts, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES],
                    declarations: [...COMPONENTS],
                    exports: [...COMPONENTS],
                    providers: [ValidationService]
                }]
        }] });

class Utils {
    constructor() {
        // Determins if a string is valid
        this.isValidString = function (string) {
            if (string && typeof string === 'string' && string.length > 0) {
                return true;
            }
            else {
                return false;
            }
        };
        // This function determines if there is a valid social (facebook etc)
        // settings object in the social object it is passed
        this.hasValidSocialObject = function (social) {
            // Get the keys of the social object
            // This is used to loop over the object
            var socialKeys = Object.keys(social);
            // For each social object
            for (var i = 0, j = socialKeys.length; i < j; i++) {
                // Get the social object
                var socialObject = social[socialKeys[i]];
                // If it has a type of object
                // (this is a sanity check against the show: true/false value)
                if (typeof socialObject === 'object') {
                    // If it should be shown
                    if (this.isValidSocialObject(socialObject)) {
                        // Stop and return true since we found a valid object
                        return true;
                    }
                }
            }
        };
        // This function checks to see if a social object should be displayed
        this.isValidSocialObject = function (social) {
            // And if it should be shown
            if (social.show &&
                this.isValidString(social.header) &&
                this.isValidString(social.copy) &&
                this.isValidString(social.buttonText)) {
                // Stop and return true since we found a valid object
                return true;
            }
        };
    }
}

/**
 * @Component: Footer Navigation

 * @Section: Navigation
 * @Description: This component generates the navigation and location finder section of the footer.
 */
class FooterNavigationComponent {
    // commented for GBC-2325
    // currentDate = new Date();
    constructor(_window, _appConfigService, utils, element, _router, brandingService, mapperService, brandingTag, layoutsService, _isSSRApp) {
        this._window = _window;
        this._appConfigService = _appConfigService;
        this.utils = utils;
        this.element = element;
        this._router = _router;
        this.brandingService = brandingService;
        this.mapperService = mapperService;
        this.brandingTag = brandingTag;
        this.layoutsService = layoutsService;
        this._isSSRApp = _isSSRApp;
        this.csrHostname = this._appConfigService.getcsrHostName();
        this.citiUrl = this._appConfigService.getnewCitiHostName();
        this.aemHostname = this._appConfigService.getAEMConfig();
        //Holds the JD Power logo Modals
        this.showJDPowerModal = [];
        // Holds the state of modals
        this.showModal = [];
        // commented for GBC-2325
        // cDate and sDate variables are for california privacy hub under help and support footer link
        //cDate: any;
        //sDate = '2020-01-01';
        // Array that holds if a section should be open or not
        this.sections = [];
        // Toggles a section to be open or not
        this.toggleSection = function (index) {
            this.sections[index] = !this.sections[index];
        };
        // Gets the window dimensions and sets isMobile
        this.getMobile = function () {
            this.isMobile = this._window && this._window.innerWidth <= 990;
        };
        this.getLocValue = function () {
            return this.locInput.value;
        };
        this.submitLocationFinder = function () {
            // this.locationFinderForm.submit();
            if (this.locInput.value) {
                this._router.navigateByUrl('/citibank-location-finder;address=' + this.locInput.value);
            }
            else {
                this._router.navigateByUrl('/citibank-location-finder;address=');
            }
        };
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setNavigationConfig = function (_config) {
            // Set up config object to temporarily hold our calculated values
            let navigationConfig = {};
            // If there is a valid config and a footer object is defined
            if (_config && _config.footer) {
                // If the butler bar should be shown
                if (_config.footer.navigation && _config.footer.navigation.show) {
                    // If there is a footer navigation sections array and it has at least one section
                    if (_config.footer.navigation.sections &&
                        _config.footer.navigation.sections.length) {
                        // Provide the sections to the config object
                        navigationConfig.sections = _config.footer.navigation.sections;
                        // Show the navigation
                        navigationConfig.showNavigation = true;
                        for (var i = 0, j = navigationConfig.sections.length; i < j; i++) {
                            var section = navigationConfig.sections[i];
                            for (var x = 0, y = section.links.length; x < y; x++) {
                                // Get a reference to the link
                                var link = section.links[x];
                                /* commented for GBC-2325
                                              // Need to display california privacy hub only from Jan 1st 2020
                                              if(this.cDate < this.sDate && section.links[x].title === "California Privacy Hub") {
                                                  for(var z = 0; z < section.links.length; z++) {
                                                      if(section.links[z].title === "California Privacy Hub") {
                                                          section.links.splice(z,1);
                                                      }
                                                  }
                                              }
                                              */
                                // If the link has a speedbump and the speedbump has all necessary properties
                                if (link.speedbump &&
                                    link.speedbump.header &&
                                    link.speedbump.copy &&
                                    link.speedbump.url) {
                                    // Set the link the show the speedbump
                                    link.showSpeedbump = true;
                                }
                            }
                        }
                    }
                }
                // If the butler bar should be shown
                if (_config.footer.locationFinder && _config.footer.locationFinder.show) {
                    if (_config.footer.locationFinder.action &&
                        _config.footer.locationFinder.placeholder &&
                        _config.footer.locationFinder.title &&
                        _config.footer.locationFinder.addressInputName &&
                        _config.footer.locationFinder.submitButtonText) {
                        navigationConfig.show = true;
                        navigationConfig.title = _config.footer.locationFinder.title;
                        navigationConfig.action = _config.footer.locationFinder.action;
                        navigationConfig.addressInputName =
                            _config.footer.locationFinder.addressInputName;
                        navigationConfig.submitButtonText =
                            _config.footer.locationFinder.submitButtonText;
                        navigationConfig.placeholder =
                            _config.footer.locationFinder.placeholder;
                    }
                }
                var subFooterConfig = {};
                // If the images should be shown
                if (_config.footer.subFooter?.images?.show) {
                    // Set the images to show
                    subFooterConfig.showImages = true;
                    // If there is a fdic image url
                    if (_config.footer.subFooter.images.fdic &&
                        _config.footer.subFooter.images.fdic.url) {
                        // Provide the fdic image url
                        subFooterConfig.fdicImageUrl =
                            (this._isSSRApp ? this.citiUrl : this.csrHostname) + _config.footer.subFooter.images.fdic.url;
                    }
                    // If there is an equal housing image url
                    if (_config.footer.subFooter.images.equalHousing.url) {
                        // Provide the equal housing image url
                        const domain = _config?.footer?.subFooter?.images?.equalHousing?.url.includes("cfs") ? this.aemHostname.aemServerUrl : (this._isSSRApp ? this.citiUrl : this.csrHostname);
                        subFooterConfig.equalHousingImageUrl = domain + _config.footer.subFooter.images.equalHousing.url;
                        ;
                    }
                    // To check FDIC to be shown or not
                    if (_config.footer.subFooter.images.fdic) {
                        // Provide the fdic show
                        subFooterConfig.fdicShow = _config.footer.subFooter.images.fdic.show;
                    }
                }
                // Set the config for use by the dom (DOM will not show until this is set);
                this.config = navigationConfig;
                this.fdichomeConfig = subFooterConfig;
                //Mod Fed URL Change
                if (this.modFedCheck()) {
                    if (navigationConfig.sections) {
                        for (let menuGroup of navigationConfig.sections) {
                            if (menuGroup.links) {
                                for (let navItems of menuGroup.links) {
                                    if (navItems.id == 'navContactUs') {
                                        if (navItems.url) {
                                            if (navItems.url.includes('https://online.citi.com/US/ag')) {
                                                navItems.url = navItems.url.replace('https://online.citi.com/US/ag', 'https://online.citi.com/US/nga');
                                                navItems.domainMap = "mfe";
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
        // commented for GBC-2325 add below datepipe instance in the constructor
        // , private datePipe: DatePipe
        // this.cDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    }
    // On init
    ngOnInit() {
        // Deferring footer load on screen viewport
        this.brandingService.notifyFooterLoad();
        // Bind to window resize to set isMobile
        if (this._window)
            this._window.onresize = e => {
                this.getMobile();
            };
        // Get initial ismobile
        this.getMobile();
        //This is implemented for journey teams to toggle links on/off
        this.brandingService.footerLinks.subscribe(val => {
            this.showFooterLinks = val;
        });
        this.showBrandingSSR = this._isSSRApp;
    }
    //Throttling Mechanism for Module Federation Redirection
    modFedCheck() {
        if (this._window) {
            console.log("Module federation check for contact us redirection");
            let contactus_flag = false;
            const sessionStorage = this._window.sessionStorage;
            let postBrandingStorage = sessionStorage.getItem('sessionPostBrandingStorage');
            if (postBrandingStorage) {
                postBrandingStorage = JSON.parse(postBrandingStorage);
                const feature_flags = postBrandingStorage?.featureFlags;
                if (feature_flags !== null && feature_flags.ff_modFedThrottleContactUs === "Y") {
                    contactus_flag = true;
                }
            }
            console.log("contactus flag value", contactus_flag);
            return contactus_flag;
        }
    }
    navigateToURL(obj, event, linkPos, sectionTitle, sectionPos) {
        event.preventDefault();
        this.brandingTag.footerNavigationTagging(sectionPos, linkPos, sectionTitle.title, obj.title);
        this.mapperService.brandingMap(obj);
    }
    onRightClick(obj, event, linkPos, sectionTitle, sectionPos) {
        if (event.type == 'contextmenu' || event.type == 'mouseover') {
            if (event.type === 'contextmenu') {
                this.brandingTag.footerNavigationTagging(sectionPos, linkPos, sectionTitle.title, obj.title);
            }
            this.mapperService.modifyURLPrefixRightClick(event, obj.domainMap, obj);
        }
    }
    taggingEqualHousing() {
        this.brandingTag.footerNavigationTagging(5, 0, '', 'Equal Housing Lender');
    }
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.setNavigationConfig(_config);
        }
    }
    showSecondModal(url) {
        if (url) {
            this.showJDPowerModal[0] = false;
            this.showJDPowerModal[1] = false;
        }
        else {
            this.showJDPowerModal[0] = false;
            this.showJDPowerModal[1] = true;
        }
    }
    // This function toggles the search panel when "Help & FAQs" link is clicked
    toggleSearchPanel() {
        let currentSearchState = this.layoutsService.toggleSearchPanel.getValue();
        this.layoutsService.toggleSearchPanel.next(!currentSearchState);
        // When opening search panel from the footer, scroll to top of page
        if (!currentSearchState) {
            this._window.scrollTo(0, 0);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FooterNavigationComponent, deps: [{ token: WINDOW }, { token: i1$1.AppConfigService }, { token: Utils }, { token: i0.ElementRef }, { token: i3.Router }, { token: BrandingService }, { token: BrandingMapService }, { token: BrandingTaggingService }, { token: LayoutsService }, { token: IS_SSRENDERED_APP, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: FooterNavigationComponent, isStandalone: true, selector: "citi-footer-navigation", inputs: { brandingConfig: "brandingConfig" }, providers: [Utils], viewQueries: [{ propertyName: "locationFinderForm", first: true, predicate: ["locationFinderForm"], descendants: true }, { propertyName: "locInput", first: true, predicate: ["locInput"], descendants: true }], ngImport: i0, template: "<div\n  class=\"navigation\"\n  *ngIf=\"config && config.showNavigation\"\n>\n  <div class=\"content\">\n    <div\n      role=\"group\"\n      class=\"section {{ sections[i] ? 'open' : '' }} {{\n        i == config.sections.length - 1 ? 'last' : ''\n      }}\"\n      *ngFor=\"let section of config.sections; let i = index\"\n    >\n      <div\n        role=\"heading\"\n        aria-level=\"2\"\n        class=\"title\"\n        id=\"nav-list-header{{ i }}\"\n        [innerHtml]=\"section.title\"\n        *ngIf=\"showFooterLinks\"\n      ></div>\n      <button\n        type=\"button\"\n        class=\"title\"\n        (click)=\"toggleSection(i)\"\n        attr.aria-controls=\"list{{ i }}\"\n        [attr.aria-expanded]=\"sections[i] ? true : false\"\n        [innerHtml]=\"section.title\"\n        *ngIf=\"showFooterLinks\"\n      ></button>\n      <ul\n        id=\"list{{ i }}\"\n        [attr.aria-labelledby]=\"'nav-list-header' + i\"\n        [attr.aria-hidden]=\"isMobile ? (sections[i] ? false : true) : false\"\n        *ngIf=\"showFooterLinks\"\n      >\n        <li\n          *ngFor=\"let link of section.links; let j = index\"\n          id=\"{{ link.id }}\"\n        >\n          <citi-cta\n            *ngIf=\"link.url || link.routerLink\"\n            type=\"tertiary\"\n            [value]=\"link.title\"\n            [tabIndex]=\"isMobile && !sections[i] ? -1 : null\"\n            [target]=\"link.target ? link.target : '_self'\"\n            [href]=\"link.id != 'navHelpFAQs' ? link.url || link.routerLink : null\"\n            (click)=\"link.showSpeedbump\n              ? (showModal[j] = !showModal[j])\n              : link.id == 'navHelpFAQs'\n              ? toggleSearchPanel()\n              : navigateToURL(link, $event, j, section, i)\"\n            (mouseover)=\"onRightClick(link, $event, j, section, i)\"\n            (contextmenu)=\"onRightClick(link, $event, j, section, i)\"\n          >\n          </citi-cta>\n        </li>\n      </ul>\n    </div>\n    <div class=\"section\">\n      <div\n        class=\"images\"\n        *ngIf=\"fdichomeConfig.showImages\"\n      >\n        <div *ngIf=\"fdichomeConfig.fdicShow\">\n          <span\n            class=\"brandingSprite fdic\"\n            id=\"fdicSprite\"\n            alt=\"Member FDIC\"\n          ><img\n              [src]=\"fdichomeConfig.fdicImageUrl\"\n              alt=\"Member FDIC\"\n            /></span>\n        </div>\n        <div *ngIf=\"fdichomeConfig.equalHousingImageUrl\">\n          <span\n            class=\"brandingSprite equalHousing\"\n            alt=\"Equal housing lender\"\n          >\n            <img\n              [attr.src]=\"fdichomeConfig.equalHousingImageUrl\"\n              id=\"homeSprite\"\n              alt=\"Equal Housing Lender\"\n              (click)=\"taggingEqualHousing()\"\n            />\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".navigation{background:#333;padding-bottom:20px}.navigation #homeSprite{object-fit:none;object-position:-221px -25px;width:29px;height:30px}@media (max-width: 990px){.navigation{padding-bottom:0}}.navigation>.content{width:100%;max-width:1440px;margin:0 auto;padding:40px 6.667% 0;display:flex;justify-content:space-between}@media (max-width: 990px){.navigation>.content{display:block;padding:7px 5% 0}}.navigation>.content .section{flex:1;width:16.6666%;padding-right:20px}@media (max-width: 990px){.navigation>.content .section{width:100%;padding-right:20px}}.navigation>.content .section:last-child{padding-right:0;padding-left:20px;flex:0}.navigation>.content .section .title{color:#fff;font-family:Interstate_Regular,sans-serif;font-size:14px;line-height:20px;font-weight:700;padding:0;margin-top:0;margin-bottom:16px;background:transparent;border:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}@media (max-width: 990px){.navigation>.content .section .title{margin:0;padding:20px 0;position:relative}.navigation>.content .section .title:after{content:\"\";width:20px;height:20px;position:absolute;right:-15px;top:calc(50% - 10px);background:transparent url(/citi-branding-assets/images/arrow-btn-down-white-sm.png) no-repeat center center;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-transition:all .18s linear;-moz-transition:all .18s linear;-ms-transition:all .18s linear;-o-transition:all .18s linear;transition:all .18s linear;-moz-transform:rotate(0deg);-webkit-transform:rotate(0deg);-o-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0)}}.navigation>.content .section.open button.title:after{-webkit-transition:all .18s linear;-moz-transition:all .18s linear;-ms-transition:all .18s linear;-o-transition:all .18s linear;transition:all .18s linear;-moz-transform:rotate(-180deg);-webkit-transform:rotate(-180deg);-o-transform:rotate(-180deg);-ms-transform:rotate(-180deg);transform:rotate(-180deg)}.navigation>.content .section button.title{text-align:left;width:100%;display:none}@media (max-width: 990px){.navigation>.content .section button.title{padding-left:0;padding-right:0}}.navigation>.content .section ul{margin:0;padding:0}@media (max-width: 990px){.navigation>.content .section ul{padding-left:0;padding-right:0;max-height:0;overflow:hidden;-webkit-transition:max-height .18s ease-in-out;-moz-transition:max-height .18s ease-in-out;-ms-transition:max-height .18s ease-in-out;-o-transition:max-height .18s ease-in-out;transition:max-height .18s ease-in-out}}.navigation>.content .section ul li{list-style-type:none;font-size:12px;line-height:18px}.navigation>.content .section ul li citi-cta ::ng-deep a,.navigation>.content .section ul li citi-cta ::ng-deep button{font-size:12px;line-height:18px;font-weight:300;text-align:initial!important;color:#fff;text-decoration:none;white-space:normal;text-align:left;margin-right:0;background-color:transparent;border-color:transparent;font-family:Interstate_Light,sans-serif;padding:6px 20px 6px 0}@media (max-width: 990px){.navigation>.content .section ul li citi-cta ::ng-deep a,.navigation>.content .section ul li citi-cta ::ng-deep button{display:inline-block;padding:10px 0}.navigation>.content .section ul li citi-cta ::ng-deep a:first-child,.navigation>.content .section ul li citi-cta ::ng-deep button:first-child{padding-top:0}}.navigation>.content .section ul li citi-cta ::ng-deep a:hover,.navigation>.content .section ul li citi-cta ::ng-deep button:hover{text-decoration:underline}@media (max-width: 990px){.navigation>.content .section{border-top:1px solid #666}.navigation>.content .section:first-child,.navigation>.content .section:last-child{border:none}.navigation>.content .section.last{border-bottom:1px solid #666}.navigation>.content .section button.title{display:block}.navigation>.content .section div.title{display:none}.navigation>.content .section.open ul{max-height:500px;-webkit-transition:max-height .18s ease-in-out;-moz-transition:max-height .18s ease-in-out;-ms-transition:max-height .18s ease-in-out;-o-transition:max-height .18s ease-in-out;transition:max-height .18s ease-in-out}}.navigation>.content .section .images{padding-top:7px;float:right}.navigation>.content .section .images div{float:left}.navigation>.content .section .images .fdic{background-size:70px;height:30px;margin-right:15px}.navigation>.content .section .images .fdic:last-child{margin-right:0}.navigation>.content .section .images .fdic{background-position:0 79%;width:49px}.navigation>.content .section .images .fdic img{width:49px}@media (max-width: 990px){.navigation>.content .section .images{float:none;margin-bottom:42px}}.navigation>.content .badgeSection{line-height:0px;width:16.6666%;padding-left:20px;padding-top:-3px;float:left}@media (max-width: 990px){.navigation>.content .badgeSection{width:100%}}.navigation>.content .badgeSection .registerMark{font-size:12px}.navigation>.content .badgeSection:last-child{padding-right:0}.navigation>.content .badgeSection button{padding:none;border:none;padding:0;margin-bottom:2px}.navigation>.content .badgeSection button:focus{border:1px dotted #fff!important}.navigation>.content .badgeSection .appBadge0{height:40px;width:118px}.navigation>.content .badgeSection .appBadge1{height:40px;width:118px}.navigation>.content .badgeSection button.jdpower{background:none}.navigation>.content .badgeSection img.jdpowerimg{height:110px!important}.navigation>.content .badgeSection .jdpowerlink:hover{cursor:pointer}.navigation>.content .badgeSection .jdpowerlink{text-indent:291px}.navigation>.content .badgeSection .jdpowermp{margin-bottom:-23px;display:inline}.navigation>.content .badgeSection .jdpowermp+a{cursor:pointer}.navigation>.content .badgeSection ul{margin-top:5px;margin-bottom:16px;margin-left:-48px}.navigation>.content .badgeSection ul img{width:118px;height:40px;cursor:pointer}@media (max-width: 990px){.navigation>.content .badgeSection ul img{cursor:pointer}}.navigation>.content .badgeSection .title{color:#fff;font-family:Interstate_Bold,sans-serif;padding:0 5px 5px 0;margin-bottom:0;background:transparent;border:none;font-size:14px;line-height:24px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}@media (max-width: 990px){.navigation>.content .badgeSection .title{padding:10px 0 0 2px;position:relative}}@media (max-width: 990px){.navigation>.content .location-finder{padding:19px 0 24px}}.navigation>.content .location-finder>.content h3{color:#fff;font-family:Interstate_Bold,sans-serif;padding:0 5px 16px 0;margin-bottom:0;background:transparent;border:none;font-size:14px;line-height:24px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}@media (max-width: 990px){.navigation>.content .location-finder>.content h3{padding-bottom:17px}}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form .form-group{margin-bottom:0;float:none;display:block;width:100%;padding-right:0;padding-left:0}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep{display:contents}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep .form-group{float:none;display:block;width:100%}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep label{color:#fff;display:none}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep input{display:block;width:140px;height:36px}@media (max-width: 990px){.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep input{width:100%}}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep input[placeholder]{font-family:Interstate_LightItalic,sans-serif;font-size:12px;color:#666;letter-spacing:0;line-height:18px;font-family:Interstate_Regular;font-style:italic;padding-left:10px}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-cta ::ng-deep button{min-width:auto;float:none;margin-bottom:0;width:140px;height:36px;font-family:Interstate_Regular,sans-serif;font-size:14px;color:#fff;letter-spacing:0;text-align:center;line-height:15px;margin-top:8.1px;font-weight:100}@media (max-width: 990px){.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-cta ::ng-deep button{width:100%}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CTA }, { kind: "component", type: i1$1.CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FooterNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-footer-navigation', standalone: true, imports: [
                        CommonModule,
                        CTA
                    ], providers: [Utils], template: "<div\n  class=\"navigation\"\n  *ngIf=\"config && config.showNavigation\"\n>\n  <div class=\"content\">\n    <div\n      role=\"group\"\n      class=\"section {{ sections[i] ? 'open' : '' }} {{\n        i == config.sections.length - 1 ? 'last' : ''\n      }}\"\n      *ngFor=\"let section of config.sections; let i = index\"\n    >\n      <div\n        role=\"heading\"\n        aria-level=\"2\"\n        class=\"title\"\n        id=\"nav-list-header{{ i }}\"\n        [innerHtml]=\"section.title\"\n        *ngIf=\"showFooterLinks\"\n      ></div>\n      <button\n        type=\"button\"\n        class=\"title\"\n        (click)=\"toggleSection(i)\"\n        attr.aria-controls=\"list{{ i }}\"\n        [attr.aria-expanded]=\"sections[i] ? true : false\"\n        [innerHtml]=\"section.title\"\n        *ngIf=\"showFooterLinks\"\n      ></button>\n      <ul\n        id=\"list{{ i }}\"\n        [attr.aria-labelledby]=\"'nav-list-header' + i\"\n        [attr.aria-hidden]=\"isMobile ? (sections[i] ? false : true) : false\"\n        *ngIf=\"showFooterLinks\"\n      >\n        <li\n          *ngFor=\"let link of section.links; let j = index\"\n          id=\"{{ link.id }}\"\n        >\n          <citi-cta\n            *ngIf=\"link.url || link.routerLink\"\n            type=\"tertiary\"\n            [value]=\"link.title\"\n            [tabIndex]=\"isMobile && !sections[i] ? -1 : null\"\n            [target]=\"link.target ? link.target : '_self'\"\n            [href]=\"link.id != 'navHelpFAQs' ? link.url || link.routerLink : null\"\n            (click)=\"link.showSpeedbump\n              ? (showModal[j] = !showModal[j])\n              : link.id == 'navHelpFAQs'\n              ? toggleSearchPanel()\n              : navigateToURL(link, $event, j, section, i)\"\n            (mouseover)=\"onRightClick(link, $event, j, section, i)\"\n            (contextmenu)=\"onRightClick(link, $event, j, section, i)\"\n          >\n          </citi-cta>\n        </li>\n      </ul>\n    </div>\n    <div class=\"section\">\n      <div\n        class=\"images\"\n        *ngIf=\"fdichomeConfig.showImages\"\n      >\n        <div *ngIf=\"fdichomeConfig.fdicShow\">\n          <span\n            class=\"brandingSprite fdic\"\n            id=\"fdicSprite\"\n            alt=\"Member FDIC\"\n          ><img\n              [src]=\"fdichomeConfig.fdicImageUrl\"\n              alt=\"Member FDIC\"\n            /></span>\n        </div>\n        <div *ngIf=\"fdichomeConfig.equalHousingImageUrl\">\n          <span\n            class=\"brandingSprite equalHousing\"\n            alt=\"Equal housing lender\"\n          >\n            <img\n              [attr.src]=\"fdichomeConfig.equalHousingImageUrl\"\n              id=\"homeSprite\"\n              alt=\"Equal Housing Lender\"\n              (click)=\"taggingEqualHousing()\"\n            />\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".navigation{background:#333;padding-bottom:20px}.navigation #homeSprite{object-fit:none;object-position:-221px -25px;width:29px;height:30px}@media (max-width: 990px){.navigation{padding-bottom:0}}.navigation>.content{width:100%;max-width:1440px;margin:0 auto;padding:40px 6.667% 0;display:flex;justify-content:space-between}@media (max-width: 990px){.navigation>.content{display:block;padding:7px 5% 0}}.navigation>.content .section{flex:1;width:16.6666%;padding-right:20px}@media (max-width: 990px){.navigation>.content .section{width:100%;padding-right:20px}}.navigation>.content .section:last-child{padding-right:0;padding-left:20px;flex:0}.navigation>.content .section .title{color:#fff;font-family:Interstate_Regular,sans-serif;font-size:14px;line-height:20px;font-weight:700;padding:0;margin-top:0;margin-bottom:16px;background:transparent;border:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}@media (max-width: 990px){.navigation>.content .section .title{margin:0;padding:20px 0;position:relative}.navigation>.content .section .title:after{content:\"\";width:20px;height:20px;position:absolute;right:-15px;top:calc(50% - 10px);background:transparent url(/citi-branding-assets/images/arrow-btn-down-white-sm.png) no-repeat center center;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-transition:all .18s linear;-moz-transition:all .18s linear;-ms-transition:all .18s linear;-o-transition:all .18s linear;transition:all .18s linear;-moz-transform:rotate(0deg);-webkit-transform:rotate(0deg);-o-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0)}}.navigation>.content .section.open button.title:after{-webkit-transition:all .18s linear;-moz-transition:all .18s linear;-ms-transition:all .18s linear;-o-transition:all .18s linear;transition:all .18s linear;-moz-transform:rotate(-180deg);-webkit-transform:rotate(-180deg);-o-transform:rotate(-180deg);-ms-transform:rotate(-180deg);transform:rotate(-180deg)}.navigation>.content .section button.title{text-align:left;width:100%;display:none}@media (max-width: 990px){.navigation>.content .section button.title{padding-left:0;padding-right:0}}.navigation>.content .section ul{margin:0;padding:0}@media (max-width: 990px){.navigation>.content .section ul{padding-left:0;padding-right:0;max-height:0;overflow:hidden;-webkit-transition:max-height .18s ease-in-out;-moz-transition:max-height .18s ease-in-out;-ms-transition:max-height .18s ease-in-out;-o-transition:max-height .18s ease-in-out;transition:max-height .18s ease-in-out}}.navigation>.content .section ul li{list-style-type:none;font-size:12px;line-height:18px}.navigation>.content .section ul li citi-cta ::ng-deep a,.navigation>.content .section ul li citi-cta ::ng-deep button{font-size:12px;line-height:18px;font-weight:300;text-align:initial!important;color:#fff;text-decoration:none;white-space:normal;text-align:left;margin-right:0;background-color:transparent;border-color:transparent;font-family:Interstate_Light,sans-serif;padding:6px 20px 6px 0}@media (max-width: 990px){.navigation>.content .section ul li citi-cta ::ng-deep a,.navigation>.content .section ul li citi-cta ::ng-deep button{display:inline-block;padding:10px 0}.navigation>.content .section ul li citi-cta ::ng-deep a:first-child,.navigation>.content .section ul li citi-cta ::ng-deep button:first-child{padding-top:0}}.navigation>.content .section ul li citi-cta ::ng-deep a:hover,.navigation>.content .section ul li citi-cta ::ng-deep button:hover{text-decoration:underline}@media (max-width: 990px){.navigation>.content .section{border-top:1px solid #666}.navigation>.content .section:first-child,.navigation>.content .section:last-child{border:none}.navigation>.content .section.last{border-bottom:1px solid #666}.navigation>.content .section button.title{display:block}.navigation>.content .section div.title{display:none}.navigation>.content .section.open ul{max-height:500px;-webkit-transition:max-height .18s ease-in-out;-moz-transition:max-height .18s ease-in-out;-ms-transition:max-height .18s ease-in-out;-o-transition:max-height .18s ease-in-out;transition:max-height .18s ease-in-out}}.navigation>.content .section .images{padding-top:7px;float:right}.navigation>.content .section .images div{float:left}.navigation>.content .section .images .fdic{background-size:70px;height:30px;margin-right:15px}.navigation>.content .section .images .fdic:last-child{margin-right:0}.navigation>.content .section .images .fdic{background-position:0 79%;width:49px}.navigation>.content .section .images .fdic img{width:49px}@media (max-width: 990px){.navigation>.content .section .images{float:none;margin-bottom:42px}}.navigation>.content .badgeSection{line-height:0px;width:16.6666%;padding-left:20px;padding-top:-3px;float:left}@media (max-width: 990px){.navigation>.content .badgeSection{width:100%}}.navigation>.content .badgeSection .registerMark{font-size:12px}.navigation>.content .badgeSection:last-child{padding-right:0}.navigation>.content .badgeSection button{padding:none;border:none;padding:0;margin-bottom:2px}.navigation>.content .badgeSection button:focus{border:1px dotted #fff!important}.navigation>.content .badgeSection .appBadge0{height:40px;width:118px}.navigation>.content .badgeSection .appBadge1{height:40px;width:118px}.navigation>.content .badgeSection button.jdpower{background:none}.navigation>.content .badgeSection img.jdpowerimg{height:110px!important}.navigation>.content .badgeSection .jdpowerlink:hover{cursor:pointer}.navigation>.content .badgeSection .jdpowerlink{text-indent:291px}.navigation>.content .badgeSection .jdpowermp{margin-bottom:-23px;display:inline}.navigation>.content .badgeSection .jdpowermp+a{cursor:pointer}.navigation>.content .badgeSection ul{margin-top:5px;margin-bottom:16px;margin-left:-48px}.navigation>.content .badgeSection ul img{width:118px;height:40px;cursor:pointer}@media (max-width: 990px){.navigation>.content .badgeSection ul img{cursor:pointer}}.navigation>.content .badgeSection .title{color:#fff;font-family:Interstate_Bold,sans-serif;padding:0 5px 5px 0;margin-bottom:0;background:transparent;border:none;font-size:14px;line-height:24px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}@media (max-width: 990px){.navigation>.content .badgeSection .title{padding:10px 0 0 2px;position:relative}}@media (max-width: 990px){.navigation>.content .location-finder{padding:19px 0 24px}}.navigation>.content .location-finder>.content h3{color:#fff;font-family:Interstate_Bold,sans-serif;padding:0 5px 16px 0;margin-bottom:0;background:transparent;border:none;font-size:14px;line-height:24px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}@media (max-width: 990px){.navigation>.content .location-finder>.content h3{padding-bottom:17px}}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form .form-group{margin-bottom:0;float:none;display:block;width:100%;padding-right:0;padding-left:0}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep{display:contents}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep .form-group{float:none;display:block;width:100%}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep label{color:#fff;display:none}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep input{display:block;width:140px;height:36px}@media (max-width: 990px){.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep input{width:100%}}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-input ::ng-deep input[placeholder]{font-family:Interstate_LightItalic,sans-serif;font-size:12px;color:#666;letter-spacing:0;line-height:18px;font-family:Interstate_Regular;font-style:italic;padding-left:10px}.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-cta ::ng-deep button{min-width:auto;float:none;margin-bottom:0;width:140px;height:36px;font-family:Interstate_Regular,sans-serif;font-size:14px;color:#fff;letter-spacing:0;text-align:center;line-height:15px;margin-top:8.1px;font-weight:100}@media (max-width: 990px){.navigation>.content .location-finder>.content citi-form-container ::ng-deep form citi-cta ::ng-deep button{width:100%}}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1$1.AppConfigService }, { type: Utils }, { type: i0.ElementRef }, { type: i3.Router }, { type: BrandingService }, { type: BrandingMapService }, { type: BrandingTaggingService }, { type: LayoutsService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }], propDecorators: { locationFinderForm: [{
                type: ViewChild,
                args: ['locationFinderForm']
            }], locInput: [{
                type: ViewChild,
                args: ['locInput']
            }], brandingConfig: [{
                type: Input
            }] } });

var navigation_component = /*#__PURE__*/Object.freeze({
    __proto__: null,
    FooterNavigationComponent: FooterNavigationComponent
});

/**
 * @Component: Footer Sub Navigation
 * @Section: Navigation
 * @Description: This component generates the secondary navigation, country selector, and feedback section of the footer.
 */
class SubNavigationComponent {
    constructor(_window, mapperService, _appConfig, brandingTag, _isSSRApp) {
        this._window = _window;
        this.mapperService = mapperService;
        this._appConfig = _appConfig;
        this.brandingTag = brandingTag;
        this._isSSRApp = _isSSRApp;
        // Holds the state of modals
        this.showModal = false;
        this.modalOpen = true;
        // Array that holds if a section should be open or not
        this.sections = [];
        // Toggles a section to be open or not
        this.toggleSection = function (index) {
            this.sections[index] = !this.sections[index];
        };
        // Submits the country finder
        this.submit = () => {
            if (this._window)
                this._window.location.href = this.countryUrl;
        };
        // Opens the feedback window
        this.openFeedback = function (event) {
            // OOo.oo_launch(event, 'oo_feedback');
            if (this._window && this._window['citiLocale'] === 'es_US') {
                KAMPYLE_ONSITE_SDK.showForm(263);
            }
            else {
                KAMPYLE_ONSITE_SDK.showForm(262);
            }
        };
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setNavigationConfig = function (_config) {
            // Set up config object to temporarily hold our calculated values
            var subNavigationConfig = {};
            // If there is a valid config and a footer object is defined
            if (_config && _config.footer) {
                // If the butler bar should be shown
                if (_config.footer.subNavigation && _config.footer.subNavigation.show) {
                    // Set the Sub Navigation to show
                    subNavigationConfig.showSubNavigation = true;
                    // Copyright Logic
                    if (_config.footer.subNavigation.copyright &&
                        _config.footer.subNavigation.copyright.show &&
                        typeof _config.footer.subNavigation.copyright.text !== 'undefined') {
                        // Set the copyright to show
                        subNavigationConfig.showCopyright = true;
                        // Provide the copyright text
                        // subNavigationConfig.copyright = _config.footer.subNavigation.copyright.text;
                        var year = new Date().getFullYear();
                        subNavigationConfig.copyright = '&copy; ' + year + ' Citigroup Inc';
                    }
                    // Navigation Logic
                    if (_config.footer.subNavigation.navigation &&
                        _config.footer.subNavigation.navigation.show &&
                        typeof _config.footer.subNavigation.navigation.links !==
                            'undefined' &&
                        _config.footer.subNavigation.navigation.links.length) {
                        // Set the navigation to show
                        subNavigationConfig.showNavigation = true;
                        // Provide the links
                        subNavigationConfig.links =
                            _config.footer.subNavigation.navigation.links;
                        // Loop over the links
                        for (var i = 0, j = subNavigationConfig.links.length; i < j; i++) {
                            // Get a reference to the link
                            var link = subNavigationConfig.links[i];
                            // If the link has a speedbump and the speedbump has all necessary properties
                            if (link.speedbump &&
                                link.speedbump.header &&
                                link.speedbump.copy &&
                                link.speedbump.url) {
                                // Set the link the show the speedbump
                                link.showSpeedbump = true;
                            }
                        }
                    }
                    // Country Selector Logic
                    if (_config.footer.subNavigation.countrySelector &&
                        _config.footer.subNavigation.countrySelector.show &&
                        typeof _config.footer.subNavigation.countrySelector.text !==
                            'undefined' &&
                        typeof _config.footer.subNavigation.countrySelector.title !==
                            'undefined' &&
                        typeof _config.footer.subNavigation.countrySelector.currentCountry !==
                            'undefined' &&
                        typeof _config.footer.subNavigation.countrySelector.countries !==
                            'undefined' &&
                        _config.footer.subNavigation.countrySelector.countries.length &&
                        _config.footer.subNavigation.countrySelector.wording &&
                        _config.footer.subNavigation.countrySelector.ariaDescribedBy &&
                        _config.footer.subNavigation.countrySelector.dropdownLabel) {
                        // Set the country selector to show
                        subNavigationConfig.showCountrySelector = true;
                        // Provide the title
                        subNavigationConfig.countrySelectorTitle =
                            _config.footer.subNavigation.countrySelector.title;
                        // Provide the text
                        subNavigationConfig.countrySelectorText =
                            _config.footer.subNavigation.countrySelector.text;
                        // Provide the wording
                        subNavigationConfig.wording =
                            _config.footer.subNavigation.countrySelector.wording;
                        // Provide the aria description
                        subNavigationConfig.ariaDescription =
                            _config.footer.subNavigation.countrySelector.ariaDescribedBy;
                        // Provide the dropdown label
                        subNavigationConfig.dropdownLabel =
                            _config.footer.subNavigation.countrySelector.dropdownLabel;
                        // Provide the current country
                        subNavigationConfig.country =
                            _config.footer.subNavigation.countrySelector.currentCountry;
                        // Provide the list of countries to choose from
                        subNavigationConfig.countrySelectorCountries =
                            _config.footer.subNavigation.countrySelector.countries;
                        // Look for the current country and set it appropriately
                        for (var i = 0, j = subNavigationConfig.countrySelectorCountries.length; i < j; i++) {
                            // If the current country title in the loop matches the current session country
                            if (subNavigationConfig.countrySelectorCountries[i].title ===
                                subNavigationConfig.country) {
                                // Set the country url to the appropriate country's url
                                this.countryUrl =
                                    subNavigationConfig.countrySelectorCountries[i].url;
                            }
                        }
                    }
                    // Feedback Logic
                    if (_config.footer.subNavigation.showFeedback &&
                        _config.footer.subNavigation.feedbackWording) {
                        // Set the feedback button to show
                        subNavigationConfig.showFeedback = true;
                        // Provide the wording
                        subNavigationConfig.feedbackWording =
                            _config.footer.subNavigation.feedbackWording;
                    }
                    // Non-Fatal Error Logic
                    if (_config.footer.butler &&
                        _config.footer.butler.navigation &&
                        _config.footer.butler.navigation.show &&
                        _config.footer.butler.navigation.navigationItems &&
                        _config.footer.butler.navigation.navigationItems.length) {
                        // Set the sub-navigation to have a single border
                        subNavigationConfig.singleBorder = true;
                    }
                }
                // Set the config for use by the dom (DOM will not show until this is set);
                this.config = subNavigationConfig;
            }
        };
        this.csrHostname = this._appConfig.getcsrHostName();
        this.showBrandingSSR = this._isSSRApp;
    }
    navigateToURL(obj, event, linkPos) {
        this.brandingTag.footerNavigationTagging(7, linkPos, 'Sub-header', obj.title);
        event.preventDefault();
        this.mapperService.brandingMap(obj);
    }
    onRightClick(obj, event, linkPos) {
        if (event.type == 'contextmenu' || event.type == 'mouseover') {
            if (event.type === 'contextmenu') {
                this.brandingTag.footerNavigationTagging(7, linkPos, 'Sub-header', obj.title);
            }
            this.mapperService.modifyURLPrefixRightClick(event, obj.domainMap, obj);
        }
    }
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.setNavigationConfig(_config);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SubNavigationComponent, deps: [{ token: WINDOW }, { token: BrandingMapService }, { token: i1$1.AppConfigService }, { token: BrandingTaggingService }, { token: IS_SSRENDERED_APP, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SubNavigationComponent, isStandalone: true, selector: "citi-footer-sub-navigation", inputs: { brandingConfig: "brandingConfig" }, ngImport: i0, template: "<div\n  class=\"sub-navigation\"\n  *ngIf=\"config && config.showSubNavigation\"\n>\n  <div\n    class=\"content\"\n    [ngClass]=\"config.singleBorder ? 'singleBorder' : ''\"\n  >\n\n    <p\n      class=\"copyright\"\n      [innerHtml]=\"config.copyright\"\n      *ngIf=\"config.showCopyright\"\n    ></p>\n    <ul *ngIf=\"config.showNavigation\">\n      <li\n        *ngFor=\"let link of config.links; let i = index\"\n        id=\"{{ link.id }}\"\n      >\n        <citi-cta\n          *ngIf=\"link.id != 'countryAndJurisdictions' && ((link.title && link.id) || (link.title && link.speedbump))\"\n          type=\"tertiary\"\n          [href]=\"link.url || link.routerLink\"\n          [value]=\"link.title\"\n          [dataTarget]=\"link.target\"\n          (click)=\"navigateToURL(link, $event,i)\"\n          (mouseover)=\"onRightClick(link,$event, i)\"\n          (contextmenu)=\"onRightClick(link,$event, i)\"\n        ></citi-cta>\n        <span\n          class=\"staticLinks\"\n          *ngIf=\"!link.id && !link.speedbump\"\n          [innerHtml]=\"link.title\"\n        ></span>\n      </li>\n    </ul>\n\n    <div\n      class=\"feedback\"\n      *ngIf=\"config.showFeedback\"\n    >\n      <citi-cta\n        href=\"\"\n        (click)=\"openFeedback($event)\"\n        class=\"feedbackLink\"\n        type=\"tertiary\"\n        [value]=\"config.feedbackWording\"\n        ariaDescription=\"Opens in new window\"\n      ></citi-cta>\n    </div>\n  </div>\n</div>", styles: ["li#subnavAccessibility{margin-right:20px!important}.jurisdictionLink{color:#fff;font-size:12px;font-family:Interstate_Light,sans-serif;font-weight:400}.jurisButton::ng-deep button{font-weight:700!important;padding-right:0!important}.sub-navigation{background-color:#333;font-size:12px;margin:0 auto 24px;padding:0 6.667%;max-width:1440px}@media (max-width: 990px){.sub-navigation{padding:0 5%}}.sub-navigation *{margin:0}.sub-navigation .content{height:68px;padding:20px 0;border:1px solid #666;border-width:1px 0 1px 0}.sub-navigation .content.singleBorder{border-width:2px 0 0 0}@media (max-width: 990px){.sub-navigation .content{height:auto;clear:left}}.sub-navigation .content .copyright{display:inline-block;font-family:Interstate_Bold,sans-serif;font-size:12px;color:#fff}.sub-navigation .content ul{margin:0;padding:0;display:inline-block}.sub-navigation .content ul li{display:inline-block;margin-right:auto}.sub-navigation .content ul li span.staticLinks{font-size:12px;color:#fff}.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{color:#fff;font-size:12px;text-decoration:none;background-color:transparent;border-color:transparent;font-family:Interstate_Light,sans-serif}.sub-navigation .content ul li citi-cta ::ng-deep a:hover,.sub-navigation .content ul li citi-cta ::ng-deep button:hover{text-decoration:underline}.sub-navigation .content ul li:nth-last-child(2){margin-right:6px}.sub-navigation .content ul li:nth-last-child(2) citi-cta ::ng-deep button:hover{text-decoration:none}.sub-navigation .content .feedback citi-cta ::ng-deep button:hover{text-decoration:underline}.sub-navigation .content .country-selector{display:inline-block}.sub-navigation .content .country-selector>.title,.sub-navigation .content .country-selector>citi-cta ::ng-deep{color:#fff;background-color:transparent}.sub-navigation .content .country-selector>.title a,.sub-navigation .content .country-selector>.title button,.sub-navigation .content .country-selector>citi-cta ::ng-deep a,.sub-navigation .content .country-selector>citi-cta ::ng-deep button{color:#fff}.sub-navigation .content .country-selector citi-modal label{font-size:12px;margin-top:20px}.sub-navigation .content .country-selector citi-modal ::ng-deep citi-dropdown ::ng-deep .form-group{width:100%;margin-bottom:0}.sub-navigation .content p.speedBumpCopy{padding:10px;font-weight:400}.sub-navigation .content span.selectCountry{font-size:12px;padding:12px;top:18px}.sub-navigation .content .feedback{float:right;position:relative;top:3px}.sub-navigation .content .feedback citi-cta ::ng-deep button{background-color:transparent;border:none;color:#fff;padding:0;margin:-20px;font-size:12px;text-decoration:none}.sub-navigation .content .feedback citi-cta ::ng-deep button:after{content:\" \";padding-left:15px;margin-left:5px;background-size:83% 80%;background-position-y:2px}@media (max-width: 990px){.sub-navigation .content .copyright,.sub-navigation .content ul,.sub-navigation .content .country-selector,.sub-navigation .content .feedback{float:none;display:block;margin:0 0 10px}.sub-navigation .content .copyright:last-child,.sub-navigation .content ul:last-child,.sub-navigation .content .country-selector:last-child,.sub-navigation .content .feedback:last-child{margin-bottom:0}.sub-navigation .content>ul li{display:block;margin-bottom:5px}.sub-navigation .content>ul li:last-child{margin-bottom:0}}citi-modal ::ng-deep .modal-dialog{margin:40px auto!important}@media screen and (min-width: 990px) and (max-width: 1217px){.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{padding:6px 3px;margin-right:0}}@media screen and (min-width: 1218px) and (max-width: 1356px){.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{padding:6px 10px;margin-right:0}}@media screen and (min-width: 1357px){.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{padding:6px 20px;margin-right:0}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CTA }, { kind: "component", type: i1$1.CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SubNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-footer-sub-navigation', standalone: true, imports: [
                        CommonModule,
                        CTA
                    ], template: "<div\n  class=\"sub-navigation\"\n  *ngIf=\"config && config.showSubNavigation\"\n>\n  <div\n    class=\"content\"\n    [ngClass]=\"config.singleBorder ? 'singleBorder' : ''\"\n  >\n\n    <p\n      class=\"copyright\"\n      [innerHtml]=\"config.copyright\"\n      *ngIf=\"config.showCopyright\"\n    ></p>\n    <ul *ngIf=\"config.showNavigation\">\n      <li\n        *ngFor=\"let link of config.links; let i = index\"\n        id=\"{{ link.id }}\"\n      >\n        <citi-cta\n          *ngIf=\"link.id != 'countryAndJurisdictions' && ((link.title && link.id) || (link.title && link.speedbump))\"\n          type=\"tertiary\"\n          [href]=\"link.url || link.routerLink\"\n          [value]=\"link.title\"\n          [dataTarget]=\"link.target\"\n          (click)=\"navigateToURL(link, $event,i)\"\n          (mouseover)=\"onRightClick(link,$event, i)\"\n          (contextmenu)=\"onRightClick(link,$event, i)\"\n        ></citi-cta>\n        <span\n          class=\"staticLinks\"\n          *ngIf=\"!link.id && !link.speedbump\"\n          [innerHtml]=\"link.title\"\n        ></span>\n      </li>\n    </ul>\n\n    <div\n      class=\"feedback\"\n      *ngIf=\"config.showFeedback\"\n    >\n      <citi-cta\n        href=\"\"\n        (click)=\"openFeedback($event)\"\n        class=\"feedbackLink\"\n        type=\"tertiary\"\n        [value]=\"config.feedbackWording\"\n        ariaDescription=\"Opens in new window\"\n      ></citi-cta>\n    </div>\n  </div>\n</div>", styles: ["li#subnavAccessibility{margin-right:20px!important}.jurisdictionLink{color:#fff;font-size:12px;font-family:Interstate_Light,sans-serif;font-weight:400}.jurisButton::ng-deep button{font-weight:700!important;padding-right:0!important}.sub-navigation{background-color:#333;font-size:12px;margin:0 auto 24px;padding:0 6.667%;max-width:1440px}@media (max-width: 990px){.sub-navigation{padding:0 5%}}.sub-navigation *{margin:0}.sub-navigation .content{height:68px;padding:20px 0;border:1px solid #666;border-width:1px 0 1px 0}.sub-navigation .content.singleBorder{border-width:2px 0 0 0}@media (max-width: 990px){.sub-navigation .content{height:auto;clear:left}}.sub-navigation .content .copyright{display:inline-block;font-family:Interstate_Bold,sans-serif;font-size:12px;color:#fff}.sub-navigation .content ul{margin:0;padding:0;display:inline-block}.sub-navigation .content ul li{display:inline-block;margin-right:auto}.sub-navigation .content ul li span.staticLinks{font-size:12px;color:#fff}.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{color:#fff;font-size:12px;text-decoration:none;background-color:transparent;border-color:transparent;font-family:Interstate_Light,sans-serif}.sub-navigation .content ul li citi-cta ::ng-deep a:hover,.sub-navigation .content ul li citi-cta ::ng-deep button:hover{text-decoration:underline}.sub-navigation .content ul li:nth-last-child(2){margin-right:6px}.sub-navigation .content ul li:nth-last-child(2) citi-cta ::ng-deep button:hover{text-decoration:none}.sub-navigation .content .feedback citi-cta ::ng-deep button:hover{text-decoration:underline}.sub-navigation .content .country-selector{display:inline-block}.sub-navigation .content .country-selector>.title,.sub-navigation .content .country-selector>citi-cta ::ng-deep{color:#fff;background-color:transparent}.sub-navigation .content .country-selector>.title a,.sub-navigation .content .country-selector>.title button,.sub-navigation .content .country-selector>citi-cta ::ng-deep a,.sub-navigation .content .country-selector>citi-cta ::ng-deep button{color:#fff}.sub-navigation .content .country-selector citi-modal label{font-size:12px;margin-top:20px}.sub-navigation .content .country-selector citi-modal ::ng-deep citi-dropdown ::ng-deep .form-group{width:100%;margin-bottom:0}.sub-navigation .content p.speedBumpCopy{padding:10px;font-weight:400}.sub-navigation .content span.selectCountry{font-size:12px;padding:12px;top:18px}.sub-navigation .content .feedback{float:right;position:relative;top:3px}.sub-navigation .content .feedback citi-cta ::ng-deep button{background-color:transparent;border:none;color:#fff;padding:0;margin:-20px;font-size:12px;text-decoration:none}.sub-navigation .content .feedback citi-cta ::ng-deep button:after{content:\" \";padding-left:15px;margin-left:5px;background-size:83% 80%;background-position-y:2px}@media (max-width: 990px){.sub-navigation .content .copyright,.sub-navigation .content ul,.sub-navigation .content .country-selector,.sub-navigation .content .feedback{float:none;display:block;margin:0 0 10px}.sub-navigation .content .copyright:last-child,.sub-navigation .content ul:last-child,.sub-navigation .content .country-selector:last-child,.sub-navigation .content .feedback:last-child{margin-bottom:0}.sub-navigation .content>ul li{display:block;margin-bottom:5px}.sub-navigation .content>ul li:last-child{margin-bottom:0}}citi-modal ::ng-deep .modal-dialog{margin:40px auto!important}@media screen and (min-width: 990px) and (max-width: 1217px){.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{padding:6px 3px;margin-right:0}}@media screen and (min-width: 1218px) and (max-width: 1356px){.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{padding:6px 10px;margin-right:0}}@media screen and (min-width: 1357px){.sub-navigation .content ul li citi-cta ::ng-deep a,.sub-navigation .content ul li citi-cta ::ng-deep button{padding:6px 20px;margin-right:0}}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: BrandingMapService }, { type: i1$1.AppConfigService }, { type: BrandingTaggingService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }], propDecorators: { brandingConfig: [{
                type: Input
            }] } });

var subNavigation_component = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SubNavigationComponent: SubNavigationComponent
});

/**
 * @Component: Footer Disclaimer
 * @Section: Navigation
 * @Description: This component generates the disclaimer section in the footer.
 */
class DisclaimerBrandingComponent {
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.setDisclaimerConfig(_config);
        }
    }
    constructor(brandingTag) {
        this.brandingTag = brandingTag;
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setDisclaimerConfig = function (_config) {
            // Set up config object to temporarily hold our calculated values
            var disclaimerConfig = {};
            // If there is a valid config and a footer object is defined
            if (_config && _config.footer) {
                // If the butler bar should be shown
                if (_config.footer.disclaimer && _config.footer.disclaimer.show) {
                    // If there is a footer disclaimer sections array and it has at least one section
                    if (_config.footer.disclaimer.text) {
                        // Set the disclaimer to show
                        disclaimerConfig.showDisclaimer = true;
                        // Provide the sections to the config object
                        disclaimerConfig.text = _config.footer.disclaimer.text;
                    }
                }
                // Set the config for use by the dom (DOM will not show until this is set);
                this.config = disclaimerConfig;
            }
        };
        //
    }
    onClickTag(event) {
        const container = this.disclaimerContainer.nativeElement;
        const links = Array.from(container.getElementsByTagName('a'));
        if (links) {
            const clickedLinkIndex = [...links].indexOf(event.target);
            const clickedLinkText = links[clickedLinkIndex].innerHTML;
            this.brandingTag.footerNavigationTagging(8, clickedLinkIndex, 'Important Legal Disclosures & Information', clickedLinkText);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DisclaimerBrandingComponent, deps: [{ token: BrandingTaggingService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: DisclaimerBrandingComponent, isStandalone: true, selector: "citi-footer-disclaimer", inputs: { brandingConfig: "brandingConfig" }, viewQueries: [{ propertyName: "disclaimerContainer", first: true, predicate: ["disclaimerContainer"], descendants: true }], ngImport: i0, template: "<div\n  class=\"disclaimer\"\n  *ngIf=\"config && config.showDisclaimer\"\n>\n  <div class=\"content\">\n    <div\n      class=\"text\"\n      #disclaimerContainer\n      (click)=\"onClickTag($event)\"\n      [innerHtml]=\"config.text\"\n    ></div>\n  </div>\n</div>", styles: [".disclaimer{background:#333;padding-bottom:12px}.disclaimer .content{width:100%;max-width:1440px;margin:0 auto;padding:0 6.667%}@media (max-width: 990px){.disclaimer .content{padding:0 5%}}.disclaimer .content ::ng-deep h4{font-family:Interstate_Bold,sans-serif;font-size:12px;color:#fff;line-height:16px}.disclaimer .content ::ng-deep .wealth-tiles-disclaimer{padding:1rem 3rem 1.13rem 1rem;font-size:12px;letter-spacing:1.5px;line-height:18px;border:1.5px solid;font-family:Interstate_Bold,sans-serif}.disclaimer .content ::ng-deep .wealth-tiles-disclaimer2 a{line-height:24px;font-family:Interstate_Bold,sans-serif;text-decoration:underline}.disclaimer .content ::ng-deep p,.disclaimer .content ::ng-deep a{font-family:Interstate_Light,sans-serif;font-size:12px;color:#f4f4f4;letter-spacing:0;line-height:18px}.disclaimer .content ::ng-deep .link{text-decoration:underline}.disclaimer .content .text{font-size:12px;color:#fff}.disclaimer .content .text p{max-height:100%}.disclaimer .content .text p:last-child{margin-bottom:0}.disclaimer .content .text a{color:#fff}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DisclaimerBrandingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-footer-disclaimer', standalone: true, imports: [
                        CommonModule
                    ], template: "<div\n  class=\"disclaimer\"\n  *ngIf=\"config && config.showDisclaimer\"\n>\n  <div class=\"content\">\n    <div\n      class=\"text\"\n      #disclaimerContainer\n      (click)=\"onClickTag($event)\"\n      [innerHtml]=\"config.text\"\n    ></div>\n  </div>\n</div>", styles: [".disclaimer{background:#333;padding-bottom:12px}.disclaimer .content{width:100%;max-width:1440px;margin:0 auto;padding:0 6.667%}@media (max-width: 990px){.disclaimer .content{padding:0 5%}}.disclaimer .content ::ng-deep h4{font-family:Interstate_Bold,sans-serif;font-size:12px;color:#fff;line-height:16px}.disclaimer .content ::ng-deep .wealth-tiles-disclaimer{padding:1rem 3rem 1.13rem 1rem;font-size:12px;letter-spacing:1.5px;line-height:18px;border:1.5px solid;font-family:Interstate_Bold,sans-serif}.disclaimer .content ::ng-deep .wealth-tiles-disclaimer2 a{line-height:24px;font-family:Interstate_Bold,sans-serif;text-decoration:underline}.disclaimer .content ::ng-deep p,.disclaimer .content ::ng-deep a{font-family:Interstate_Light,sans-serif;font-size:12px;color:#f4f4f4;letter-spacing:0;line-height:18px}.disclaimer .content ::ng-deep .link{text-decoration:underline}.disclaimer .content .text{font-size:12px;color:#fff}.disclaimer .content .text p{max-height:100%}.disclaimer .content .text p:last-child{margin-bottom:0}.disclaimer .content .text a{color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: BrandingTaggingService }], propDecorators: { disclaimerContainer: [{
                type: ViewChild,
                args: ['disclaimerContainer']
            }], brandingConfig: [{
                type: Input
            }] } });

var disclaimer_component = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DisclaimerBrandingComponent: DisclaimerBrandingComponent
});

class SocialMediaComponent {
    constructor(_window, _appConfigService, utils, element, _router, brandingService, brandingTag, _storageService, _platformId, _isSSRApp) {
        this._window = _window;
        this._appConfigService = _appConfigService;
        this.utils = utils;
        this.element = element;
        this._router = _router;
        this.brandingService = brandingService;
        this.brandingTag = brandingTag;
        this._storageService = _storageService;
        this._platformId = _platformId;
        this._isSSRApp = _isSSRApp;
        // Holds the state of modals
        this.showModal = [];
        this.showSocialModal = [];
        // Array that holds if a section should be open or not
        this.sections = [];
        /* Close the modal when the user continues to the location of the speedbump */
        this.closeModal = function (index) {
            if (this.showModal.length > index) {
                this.showModal[index] = false;
            }
        };
        // Toggles a section to be open or not
        this.toggleSection = function (index) {
            this.sections[index] = !this.sections[index];
        };
        // Gets the window dimensions and sets isMobile
        this.getMobile = function () {
            this.isMobile = this._window && this._window.innerWidth <= 990;
        };
        this.localeSuffix = "";
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setNavigationConfig = function (_config) {
            // Set up config object to temporarily hold our calculated values
            let badgeNavigationConfig = {};
            // If there is a valid config and a footer object is defined
            if (_config && _config.footer) {
                // If there is a footer badgeNavigation badgeSections array and it has at least one section
                if (_config.footer.badgeNavigation &&
                    _config.footer.badgeNavigation.show &&
                    _config.footer.badgeNavigation.badgeSections &&
                    _config.footer.badgeNavigation.badgeSections.length) {
                    badgeNavigationConfig.showBadgeNav = true;
                    // Provide the badgeSections to the config object
                    badgeNavigationConfig.badgeSections =
                        _config.footer.badgeNavigation.badgeSections;
                    // Show the badgeNavigation
                    badgeNavigationConfig.showNavigation = true;
                    for (var k = 0, l = badgeNavigationConfig.badgeSections.length; k < l; k++) {
                        var badgeSection = badgeNavigationConfig.badgeSections[k];
                        for (var x = 0, y = badgeSection.links.length; x < y; x++) {
                            // Get a reference to the link
                            var link = badgeSection.links[x];
                            if (_config.footer.badgeNavigation.badgeSections) {
                                var badgeSection = badgeNavigationConfig.badgeSections[k];
                                var link = badgeSection.links[x];
                                _config.footer.badgeNavigation.badgeSections[k].links[x].imageUrl = _config?.footer?.badgeNavigation?.badgeSections[k]?.links[x]?.imageUrl.includes("cfs") ?
                                    this.aemUrl.aemServerUrl + _config.footer.badgeNavigation.badgeSections[k].links[x].imageUrl :
                                    (this.showBrandingSSR ? this.citiUrl : this.csrUrl) + this.brandingService.stripAssetHostName(_config.footer.badgeNavigation.badgeSections[k].links[x].imageUrl);
                            }
                            // If the link has a speedbump and the speedbump has all necessary properties
                            if (link.speedbump &&
                                link.speedbump.header &&
                                link.speedbump.copy &&
                                link.speedbump.url) {
                                // Set the link the show the speedbump
                                link.showSpeedbump = true;
                            }
                        }
                    }
                    // Set the config for use by the dom (DOM will not show until this is set);
                    this.badgeConfig = badgeNavigationConfig;
                }
            }
            console.log('Badge Sections', this.badgeConfig);
        };
        this.isBrowser = isPlatformBrowser(this._platformId);
        this.csrUrl = this._appConfigService.getcsrHostName();
        this.citiUrl = this._appConfigService.getnewCitiHostName();
        this.aemUrl = this._appConfigService.getAEMConfig();
        this.showBrandingSSR = this._isSSRApp;
    }
    // On init
    ngOnInit() {
        // Bind to window resize to set isMobile
        if (this._window)
            this._window.onresize = e => {
                this.getMobile();
            };
        // This is implemented for journey teams to toggle on/off footer logos.
        this.brandingService.footerLogos.subscribe(val => {
            this.showFooterLogos = val;
        });
        // Get initial ismobile
        this.getMobile();
        if (this._storageService.get('locale') === 'es_US') {
            this.localeSuffix = '_es_US';
        }
    }
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.setNavigationConfig(_config);
        }
    }
    modalClicked(link, i, j, sectionTitle) {
        if (sectionTitle.title == "badge") {
            this.brandingTag.footerNavigationTagging(6, (i + j), 'Mobile App', link.label);
        }
        if (sectionTitle.title == "socialmedia") {
            this.brandingTag.footerNavigationTagging(6, (i + j), 'Social', link.name.charAt(0).toUpperCase() + link.name.slice(1));
        }
        this.obj = link;
        this.obj.showModal = true;
        this.brandingService.emitSocialMediaLinks(link);
    }
    emitContinue(link) {
        console.log("Continue click url emit");
        this.brandingService.emitSocialMediaContinueLinks(link);
    }
    closeButtonClick(e) {
        this.obj = {};
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SocialMediaComponent, deps: [{ token: WINDOW }, { token: i1$1.AppConfigService }, { token: Utils }, { token: i0.ElementRef }, { token: i3.Router }, { token: BrandingService }, { token: BrandingTaggingService }, { token: i1$1.StorageService }, { token: PLATFORM_ID }, { token: IS_SSRENDERED_APP, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SocialMediaComponent, isStandalone: true, selector: "citi-social-media", inputs: { brandingConfig: "brandingConfig" }, providers: [Utils], ngImport: i0, template: "<div\n  class=\"social\"\n  *ngIf=\"badgeConfig && badgeConfig.showBadgeNav && showFooterLogos\"\n>\n  <div class=\"content\">\n    <ul\n      *ngFor=\"let item of badgeConfig.badgeSections; let i = index\"\n      class=\"socialIcons\"\n    >\n      <li *ngFor=\"let link of item.links; let j = index\">\n        <button\n          *ngIf=\"link.title !== 'JDPowerLogo' && isBrowser\"\n          [ngClass]=\"\n            link.imageUrl ? link.imageUrl : link.name + ' brandingSprite'\n          \"\n          (click)=\"modalClicked(link, i, j, item)\"\n          [attr.aria-label]=\"link.label ? link.label : link.name\"\n          attr.data-target=\"#modal{{ i }}{{ j }}\"\n        >\n          <img\n            [id]=\"link.title ? link.title : link.name\"\n            [attr.src]=\"link.imageUrl\"\n            [alt]=\"link.name\"\n            [ngClass]=\"link.title ? link.title : link.name\"\n          />\n        </button>\n        <citi-modal\n          class=\"cbolui-ddl-pre\"\n          idStr=\"modal{{ i }}{{ j }}\"\n          [primaryButtonText]=\"\n            link.speedbump.buttonText\n              ? link.speedbump['buttonText' + localeSuffix]\n              : 'Continue'\n          \"\n          primaryButtonTarget=\"_blank\"\n          [(show)]=\"link.showModal\"\n          (primaryButtonClick)=\"emitContinue(link)\"\n          [primaryButtonUrl]=\"link.speedbump.url\"\n          (closeButtonClick)=\"closeButtonClick($event)\"\n        >\n          <div title>{{ link.speedbump['header' + localeSuffix] }}</div>\n          <p [innerHtml]=\"link.speedbump['copy' + localeSuffix]\"></p>\n        </citi-modal>\n      </li>\n    </ul>\n  </div>\n</div>", styles: [".social{background:#333}.social .content{width:100%;max-width:1440px;margin:0 auto;padding:20px 6.667%;display:flex;justify-content:space-between}@media (max-width: 990px){.social .content{width:100%;display:block;margin:0 auto;padding-left:5%;padding-right:5%;padding-bottom:12px}}.social .content .JDPowerDownloadText{display:none}@media (max-width: 990px){.social .content .JDPowerDownloadText{display:block;padding-top:19px}.social .content .JDPowerDownloadText a{font-size:12px;color:#fff;width:288px;height:16px;align-self:center}}.social .content .registerMark{font-size:14px}.social .content ul{margin:0;padding:0}.social .content .socialIcons{display:flex;padding-bottom:10px;list-style-type:none}.social .content .socialIcons .JDPowerDownloadText{display:none}@media (max-width: 990px){.social .content .socialIcons .JDPowerDownloadText{display:block;padding-top:19px}.social .content .socialIcons .JDPowerDownloadText a{font-size:12px;color:#fff;width:288px;height:16px;align-self:center}}.social .content .socialIcons li{padding-right:24px}@media (max-width: 990px){.social .content .socialIcons li{padding-right:15px}}.social .content .socialIcons li button{background:transparent;border:none;padding:0;cursor:pointer}.social .content .socialIcons li .JDContainer{display:flex}.social .content .socialIcons li .JDContainer button{padding-right:24px}.social .content .socialIcons li .JDContainer a{font-size:14px;color:#fff;width:361px;height:18px;align-self:center}@media (max-width: 990px){.social .content .socialIcons li .JDContainer a{display:none}}.social .content .socialIcons li:last-child{padding-right:0}.social .content #Appstore{object-fit:none;object-position:-299px -20px;width:120px;height:40px}.social .content #Googleplay{object-fit:none;object-position:-468px -20px;width:137px;height:40px}.social .content #facebook{object-fit:none;object-position:-162px -32px;width:10px;height:16px}.social .content #twitter,.social .content #x{object-fit:none;object-position:-93px -32px;width:20px;height:16px}.social .content #youtube{object-fit:none;object-position:-20px -32px;width:23px;height:16px}.social .content .CitiLogo{background-repeat:no-repeat;background-size:cover;width:52px;height:30px}.social .content .Appstore{width:117px;height:40.1px;background-position:0px 0px}@media (max-width: 990px){.social .content .Appstore{width:102px;height:36px}}.social .content .Googleplay{width:130px;height:40.1px;background-position:0px -45px}@media (max-width: 990px){.social .content .Googleplay{width:117px;height:36px;background-position:0px -41px}}.social .content .JDPowerLogo{width:40px;height:40.1px}@media (max-width: 990px){.social .content .JDPowerLogo{width:35.6px;height:36px;margin-right:0}}.social .content .facebook{width:9px;height:16px}.social .content .twitter,.social .content .x{width:22px;height:16px}.social .content .youtube{width:24px;height:16px}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: Modal }, { kind: "component", type: i1$1.ModalComponent, selector: "citi-modal", inputs: ["scrollable", "htmlContent", "ariaRole", "footerContent", "idStr", "title", "primaryButtonUrl", "primaryButtonTarget", "primaryButtonText", "showCancelButton", "footerProjection", "disablePrimaryButton", "disableCloseButton", "closeOnBgClick", "cancelButtonText", "openerSelector", "show", "closeButtonIdStr"], outputs: ["primaryButtonClick", "secondaryButtonClick", "closeButtonClick", "showChange", "onHide"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SocialMediaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-social-media', standalone: true, imports: [
                        CommonModule,
                        Modal
                    ], providers: [Utils], template: "<div\n  class=\"social\"\n  *ngIf=\"badgeConfig && badgeConfig.showBadgeNav && showFooterLogos\"\n>\n  <div class=\"content\">\n    <ul\n      *ngFor=\"let item of badgeConfig.badgeSections; let i = index\"\n      class=\"socialIcons\"\n    >\n      <li *ngFor=\"let link of item.links; let j = index\">\n        <button\n          *ngIf=\"link.title !== 'JDPowerLogo' && isBrowser\"\n          [ngClass]=\"\n            link.imageUrl ? link.imageUrl : link.name + ' brandingSprite'\n          \"\n          (click)=\"modalClicked(link, i, j, item)\"\n          [attr.aria-label]=\"link.label ? link.label : link.name\"\n          attr.data-target=\"#modal{{ i }}{{ j }}\"\n        >\n          <img\n            [id]=\"link.title ? link.title : link.name\"\n            [attr.src]=\"link.imageUrl\"\n            [alt]=\"link.name\"\n            [ngClass]=\"link.title ? link.title : link.name\"\n          />\n        </button>\n        <citi-modal\n          class=\"cbolui-ddl-pre\"\n          idStr=\"modal{{ i }}{{ j }}\"\n          [primaryButtonText]=\"\n            link.speedbump.buttonText\n              ? link.speedbump['buttonText' + localeSuffix]\n              : 'Continue'\n          \"\n          primaryButtonTarget=\"_blank\"\n          [(show)]=\"link.showModal\"\n          (primaryButtonClick)=\"emitContinue(link)\"\n          [primaryButtonUrl]=\"link.speedbump.url\"\n          (closeButtonClick)=\"closeButtonClick($event)\"\n        >\n          <div title>{{ link.speedbump['header' + localeSuffix] }}</div>\n          <p [innerHtml]=\"link.speedbump['copy' + localeSuffix]\"></p>\n        </citi-modal>\n      </li>\n    </ul>\n  </div>\n</div>", styles: [".social{background:#333}.social .content{width:100%;max-width:1440px;margin:0 auto;padding:20px 6.667%;display:flex;justify-content:space-between}@media (max-width: 990px){.social .content{width:100%;display:block;margin:0 auto;padding-left:5%;padding-right:5%;padding-bottom:12px}}.social .content .JDPowerDownloadText{display:none}@media (max-width: 990px){.social .content .JDPowerDownloadText{display:block;padding-top:19px}.social .content .JDPowerDownloadText a{font-size:12px;color:#fff;width:288px;height:16px;align-self:center}}.social .content .registerMark{font-size:14px}.social .content ul{margin:0;padding:0}.social .content .socialIcons{display:flex;padding-bottom:10px;list-style-type:none}.social .content .socialIcons .JDPowerDownloadText{display:none}@media (max-width: 990px){.social .content .socialIcons .JDPowerDownloadText{display:block;padding-top:19px}.social .content .socialIcons .JDPowerDownloadText a{font-size:12px;color:#fff;width:288px;height:16px;align-self:center}}.social .content .socialIcons li{padding-right:24px}@media (max-width: 990px){.social .content .socialIcons li{padding-right:15px}}.social .content .socialIcons li button{background:transparent;border:none;padding:0;cursor:pointer}.social .content .socialIcons li .JDContainer{display:flex}.social .content .socialIcons li .JDContainer button{padding-right:24px}.social .content .socialIcons li .JDContainer a{font-size:14px;color:#fff;width:361px;height:18px;align-self:center}@media (max-width: 990px){.social .content .socialIcons li .JDContainer a{display:none}}.social .content .socialIcons li:last-child{padding-right:0}.social .content #Appstore{object-fit:none;object-position:-299px -20px;width:120px;height:40px}.social .content #Googleplay{object-fit:none;object-position:-468px -20px;width:137px;height:40px}.social .content #facebook{object-fit:none;object-position:-162px -32px;width:10px;height:16px}.social .content #twitter,.social .content #x{object-fit:none;object-position:-93px -32px;width:20px;height:16px}.social .content #youtube{object-fit:none;object-position:-20px -32px;width:23px;height:16px}.social .content .CitiLogo{background-repeat:no-repeat;background-size:cover;width:52px;height:30px}.social .content .Appstore{width:117px;height:40.1px;background-position:0px 0px}@media (max-width: 990px){.social .content .Appstore{width:102px;height:36px}}.social .content .Googleplay{width:130px;height:40.1px;background-position:0px -45px}@media (max-width: 990px){.social .content .Googleplay{width:117px;height:36px;background-position:0px -41px}}.social .content .JDPowerLogo{width:40px;height:40.1px}@media (max-width: 990px){.social .content .JDPowerLogo{width:35.6px;height:36px;margin-right:0}}.social .content .facebook{width:9px;height:16px}.social .content .twitter,.social .content .x{width:22px;height:16px}.social .content .youtube{width:24px;height:16px}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1$1.AppConfigService }, { type: Utils }, { type: i0.ElementRef }, { type: i3.Router }, { type: BrandingService }, { type: BrandingTaggingService }, { type: i1$1.StorageService }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }], propDecorators: { brandingConfig: [{
                type: Input
            }] } });

var socialMedia_component = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SocialMediaComponent: SocialMediaComponent
});

/**
 * @Component: Footer SubFooter
 * @Section: Navigation
 * @Description: This component generates the footer section of the footer.
 */
class SubFooterComponent {
    constructor(appConfigService, brandingService) {
        this.appConfigService = appConfigService;
        this.brandingService = brandingService;
        //To check if progressiveLogo image available or not
        this.isProgressiveLogo = false;
        // This function takes the BrandingConfig object and translates it to config DOM
        // This step is not necessary, but keeps the DOM markup semantic and un-bloated
        // and keeps most of the logic in the controller instead of the view
        this.setDisclaimerConfig = function (_config) {
            // Set up config object to temporarily hold our calculated values
            var subFooterConfig = {};
            // If there is a valid config and a footer object is defined
            if (_config && _config.footer) {
                // If the butler bar should be shown
                if (_config.footer.subFooter && _config.footer.subFooter.show) {
                    // Set the sub-footer to show
                    subFooterConfig.showSubFooter = true;
                    // If the site version should be shown
                    if (_config.footer.subFooter.version) {
                        // Set the version to show
                        subFooterConfig.showVersion = true;
                        // Provide the version
                        subFooterConfig.version = _config.footer.subFooter.version;
                    }
                    if (_config.footer.subFooter.images) {
                        // Set the image to show
                        subFooterConfig.showimages = true;
                        if (_config.footer.subFooter.images.progressiveLogoImageMobile.url) {
                            this.isProgressiveLogo = true;
                            const domain = _config?.footer?.subFooter?.images?.progressiveLogoImageMobile?.url.includes("cfs") ? this.aemUrl.aemServerUrl : (this._isSSRApp ? this.citiUrl : this.csrUrl);
                            subFooterConfig.imagesurlmobile = domain + _config.footer.subFooter.images.progressiveLogoImageMobile.url;
                            subFooterConfig.imagesurldesktop = domain + _config.footer.subFooter.images.progressiveLogoImageDesktop.url;
                        }
                    }
                    // If the images should be shown
                    if (_config.footer.subFooter.images.show) {
                        // Set the images to show
                        subFooterConfig.showImages = true;
                        // If there is a fdic image url
                        if (_config.footer.subFooter.images.fdic &&
                            _config.footer.subFooter.images.fdic.url) {
                            // Provide the fdic image url
                            subFooterConfig.fdicImageUrl =
                                (this._isSSRApp ? this.citiUrl : this.csrUrl) + _config.footer.subFooter.images.fdic.url;
                        }
                        // If there is an equal housing image url
                        if (_config.footer.subFooter.images.equalHousing.url) {
                            // Provide the equal housing image url
                            const domain = _config?.footer?.subFooter?.images?.equalHousing?.url.includes("cfs") ? this.aemUrl.aemServerUrl : (this._isSSRApp ? this.citiUrl : this.csrUrl);
                            subFooterConfig.equalHousingImageUrl = domain + _config.footer.subFooter.images.equalHousing.url;
                        }
                        // To check FDIC to be shown or not
                        if (_config.footer.subFooter.images.fdic &&
                            _config.footer.subFooter.images.fdic.show) {
                            // Provide the fdic show
                            subFooterConfig.fdicShow =
                                (this._isSSRApp ? this.citiUrl : this.csrUrl) + _config.footer.subFooter.images.fdic.show;
                        }
                    }
                }
                // Set the config for use by the dom (DOM will not show until this is set);
                this.config = subFooterConfig;
            }
        };
        this.csrUrl = this.appConfigService.getcsrHostName();
        this.citiUrl = this.appConfigService.getnewCitiHostName();
        this.aemUrl = this.appConfigService.getAEMConfig();
    }
    /**
     * @Property: brandingConfig
     * @Description: This is a reference to the branding config JSON object retrieved from the branding API.
     * @Type: String
     */
    set brandingConfig(_config) {
        if (_config) {
            this.setDisclaimerConfig(_config);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SubFooterComponent, deps: [{ token: i1$1.AppConfigService }, { token: BrandingService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SubFooterComponent, isStandalone: true, selector: "citi-sub-footer", inputs: { brandingConfig: "brandingConfig" }, ngImport: i0, template: "<div class=\"sub-footer\" *ngIf=\"config && config.showSubFooter\">\n  <div class=\"content\">\n    <span id=\"cbol-footer-server\" *ngIf=\"config.showVersion\">\n      {{ config.version }}</span\n    >\n  </div>\n  <div [class.footerLogo]=\"isProgressiveLogo\" *ngIf=\"config.showimages\">\n      \n    <img class=\"imgBottomCitiLogo_Mobile\" [src]=\"config.imagesurlmobile\" alt=\"Citi Banner\" aria-label=\"Citi Banner\"/>\n    <img class=\"imgBottomCitiLogo_Desktop\" [src]=\"config.imagesurldesktop\" alt=\"Citi Banner\" aria-label=\"Citi Banner\"/>\n  \n</div>\n</div>\n", styles: [".sub-footer{background:#333}.sub-footer .imgBottomCitiLogo_Mobile{margin-left:8px;justify-content:center;align-items:center;gap:8px}@media (max-width: 768px){.sub-footer .imgBottomCitiLogo_Mobile{display:block;width:100%}}@media screen and (min-width: 768px){.sub-footer .imgBottomCitiLogo_Mobile{display:none}}.sub-footer .imgBottomCitiLogo_Desktop{align-items:flex-start;align-self:stretch;margin-left:35px;margin-bottom:20px}@media (max-width: 768px){.sub-footer .imgBottomCitiLogo_Desktop{display:none}}@media screen and (min-width: 768px){.sub-footer .imgBottomCitiLogo_Desktop{display:block;width:100%}}.sub-footer .content{color:#fff;font-size:12px;width:100%;max-width:1440px;margin:0 auto;padding:20px}.sub-footer .content .images{float:right}.sub-footer .content .images .fdic,.sub-footer .content .images .equalHousing{cursor:default!important;background-size:70px;height:30px;margin-right:15px}.sub-footer .content .images .fdic:last-child,.sub-footer .content .images .equalHousing:last-child{margin-right:0}@media (max-width: 990px){.sub-footer .content .images{padding:42px 5% 0}}.sub-footer .content .images #cbol-footer-server{display:inherit;float:left}.sub-footer .footerLogo{width:88px;height:56.799px;display:flex;flex-direction:column}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SubFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-sub-footer', standalone: true, imports: [
                        CommonModule
                    ], template: "<div class=\"sub-footer\" *ngIf=\"config && config.showSubFooter\">\n  <div class=\"content\">\n    <span id=\"cbol-footer-server\" *ngIf=\"config.showVersion\">\n      {{ config.version }}</span\n    >\n  </div>\n  <div [class.footerLogo]=\"isProgressiveLogo\" *ngIf=\"config.showimages\">\n      \n    <img class=\"imgBottomCitiLogo_Mobile\" [src]=\"config.imagesurlmobile\" alt=\"Citi Banner\" aria-label=\"Citi Banner\"/>\n    <img class=\"imgBottomCitiLogo_Desktop\" [src]=\"config.imagesurldesktop\" alt=\"Citi Banner\" aria-label=\"Citi Banner\"/>\n  \n</div>\n</div>\n", styles: [".sub-footer{background:#333}.sub-footer .imgBottomCitiLogo_Mobile{margin-left:8px;justify-content:center;align-items:center;gap:8px}@media (max-width: 768px){.sub-footer .imgBottomCitiLogo_Mobile{display:block;width:100%}}@media screen and (min-width: 768px){.sub-footer .imgBottomCitiLogo_Mobile{display:none}}.sub-footer .imgBottomCitiLogo_Desktop{align-items:flex-start;align-self:stretch;margin-left:35px;margin-bottom:20px}@media (max-width: 768px){.sub-footer .imgBottomCitiLogo_Desktop{display:none}}@media screen and (min-width: 768px){.sub-footer .imgBottomCitiLogo_Desktop{display:block;width:100%}}.sub-footer .content{color:#fff;font-size:12px;width:100%;max-width:1440px;margin:0 auto;padding:20px}.sub-footer .content .images{float:right}.sub-footer .content .images .fdic,.sub-footer .content .images .equalHousing{cursor:default!important;background-size:70px;height:30px;margin-right:15px}.sub-footer .content .images .fdic:last-child,.sub-footer .content .images .equalHousing:last-child{margin-right:0}@media (max-width: 990px){.sub-footer .content .images{padding:42px 5% 0}}.sub-footer .content .images #cbol-footer-server{display:inherit;float:left}.sub-footer .footerLogo{width:88px;height:56.799px;display:flex;flex-direction:column}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.AppConfigService }, { type: BrandingService }], propDecorators: { brandingConfig: [{
                type: Input
            }] } });

var subFooter_component = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SubFooterComponent: SubFooterComponent
});

/*
 * Public API Surface of citi-common-modules
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Banner2Component, BrandingEntitlementService, BrandingMapService, BrandingService, BrandingTaggingService, CDSService, CbolRouteDummyInterceptorService, CdsThemingService, ChildNavGroup3Component, CitiBrandingModule, CitiFeedbackComponent, CitiFeedbackModule, CitiRouteDetectionService, CitiRouteDetector, CitiRouteDetectorComponent, CobrandingService, DisclaimerBrandingComponent, FooterComponent, FooterNavigationComponent, HeaderComponent, Layouts, LayoutsService, NavSearchComponent, Navigation3Component, ParentLayoutComponent, ProfileNavComponent, SimpleLayoutComponent, SmartBannerComponent, SmartBannerSharedService, SmartSearchComponent, SocialMediaComponent, SomComponent, SubFooterComponent, SubNavigationComponent, browserRefresh };
